import { sectionType } from '@/views/website/products/components/description/common/types';
import { rgbToHex } from '../utils';
import { extractContainerFuild } from './snippets-el/container-fuild';
import { extractButtonBasic } from '../../ui-modules/button-primary/extract-update.js';
import { extractDividerPrimary } from '../../ui-modules/divider-primary/extract-update.js';
import { extractAccordionPrimary } from '../../ui-modules/accordion-primary/extract-update.js';

export const extractDataAttributesFromHTML = {
  sectionCustomizeCard(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      enableAnchor: false,
      accrodion: {
        show: false,
        title: '',
        description: '',
      },
      topPadding: true,
      bottomPadding: true,
    };

    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'card-container': {
          const background = el.getAttribute('data-background');
          result[key] = background ? background : '#ffffff';
          const paginationActiveColor = el.getAttribute('data-pagination-active-color');
          result['pagination-active-color'] = paginationActiveColor ? paginationActiveColor : '#000000';
          const paginationInactiveColor = el.getAttribute('data-pagination-inactive-color');
          result['pagination-inactive-color'] = paginationInactiveColor ? paginationInactiveColor : '#cccccc';

          result.topPadding = el.getAttribute('data-top-padding') === 'true';
          result.bottomPadding = el.getAttribute('data-bottom-padding') === 'true';
          break;
        }
        case 'card-item-content': {
          const order = el.getAttribute('data-order');
          result[key] = order ? Number(order) : 1;
          const styleCenterY = el.getAttribute('data-style-center-y');
          result['style-center-y'] = styleCenterY ? styleCenterY === 'true' : false;
          break;
        }
        case 'card-item-image': {
          const order = el.getAttribute('data-order');
          result[key] = order ? Number(order) : 2;
          break;
        }
        case 'card-btn-row': {
          const showBtn = el.getAttribute('data-show-btn');
          result[key] = showBtn ? showBtn === 'true' : false;
          break;
        }
        case 'card-rated-row': {
          const showRating = el.getAttribute('data-show-rating');
          result[key] = showRating ? showRating === 'true' : false;
          break;
        }
        case 'card-btn': {
          result[key] = {
            text: el.textContent.trim(),
            url: el.getAttribute('href') || '',
            background: el.getAttribute('data-background') || el.style.backgroundColor || '#2d3436',
            color: el.getAttribute('data-color') || el.style.color || '#ffffff',
          };
          break;
        }
        // case 'card-content': {
        //   result[key] = el.innerHTML.trim()
        //   break
        // }
        case 'card-image': {
          result[key] = el.getAttribute('src') || '';
          break;
        }
        case 'sub-btn': {
          result[key] = el.textContent.trim();
          break;
        }
        case 'rating-stars': {
          const value = el.getAttribute('data-value');
          result[key] = value ? Number(value) : 5;
          break;
        }
        case 'rating-text': {
          result[key] = el.textContent.trim();
          break;
        }
        case 'container-page': {
          result[key] = {};
          const showStyle = el.getAttribute('data-show-style');
          result[key]['show-style'] = showStyle ? showStyle === 'true' : false;
          const background = el.getAttribute('data-background');
          result[key]['background'] = background ? background : '#ffffff';
          break;
        }
        case 'card-title': {
          result[key] = el.innerHTML.trim();
          break;
        }
        case 'card-description': {
          result[key] = el.innerHTML.trim();
          const textColor = el.getAttribute('data-text-color');
          result['text-color'] = textColor ? textColor : '';
          break;
        }
        case 'card-survay': {
          const showSurvay = el.getAttribute('data-show-survay');
          result[key] = showSurvay ? showSurvay === 'true' : false;
          const elItems = el.querySelectorAll('[data-attribute="item-survay"]');
          const itemsSurvay = Array.from(elItems).map(item => {
            const percent = +item.querySelector('[data-attribute="percent-survay"]')?.textContent.trim() || 0;
            const description = item.querySelector('[data-attribute="description-survay"]')?.textContent.trim() || '';
            return {
              percent,
              description,
            };
          });
          result['items-survay'] = itemsSurvay;
          break;
        }
        case 'card-accordion': {
          const showAccordion = el.getAttribute('data-show-accordion');
          result.accrodion.show = showAccordion ? showAccordion === 'true' : false;
          const title = el.querySelector('[data-attribute="accordion-title-text"]')?.textContent.trim() || '';
          result.accrodion.title = title;
          const description = el.querySelector('[data-attribute="accordion-text"]')?.textContent.trim() || '';
          result.accrodion.description = description;
          break;
        }
        default:
          break;
      }
    });

    return result;
  },
  sectionCardWithSurvey(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      topPadding: true,
      bottomPadding: true,
    };

    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'card-container': {
          const background = el.getAttribute('data-background');
          result[key] = background ? background : '#ffffff';
          result.topPadding = el.getAttribute('data-top-padding') === 'true';
          result.bottomPadding = el.getAttribute('data-bottom-padding') === 'true';
          break;
        }
        case 'card-item-content': {
          const order = el.getAttribute('data-order');
          result[key] = order ? Number(order) : 1;
          const styleCenterY = el.getAttribute('data-style-center-y');
          result['style-center-y'] = styleCenterY ? styleCenterY === 'true' : false;
          break;
        }
        case 'card-item-image': {
          const order = el.getAttribute('data-order');
          result[key] = order ? Number(order) : 2;
          break;
        }
        case 'card-btn-row': {
          const showBtn = el.getAttribute('data-show-btn');
          result[key] = showBtn ? showBtn === 'true' : false;
          break;
        }
        case 'card-rated-row': {
          const showRating = el.getAttribute('data-show-rating');
          result[key] = showRating ? showRating === 'true' : false;
          break;
        }
        case 'card-btn': {
          result[key] = {
            text: el.textContent.trim(),
            url: el.getAttribute('href') || '',
            background: el.getAttribute('data-background') || el.style.backgroundColor || '#2d3436',
            color: el.getAttribute('data-color') || el.style.color || '#ffffff',
          };
          break;
        }
        // case 'card-content': {
        //   result[key] = el.innerHTML.trim()
        //   break
        // }
        case 'card-image': {
          result[key] = el.getAttribute('src') || '';
          break;
        }
        case 'sub-btn': {
          result[key] = el.textContent.trim();
          break;
        }
        case 'rating-stars': {
          const value = el.getAttribute('data-value');
          result[key] = value ? Number(value) : 5;
          break;
        }
        case 'rating-text': {
          result[key] = el.textContent.trim();
          break;
        }
        case 'container-page': {
          result[key] = {};
          const showStyle = el.getAttribute('data-show-style');
          result[key]['show-style'] = showStyle ? showStyle === 'true' : false;
          const background = el.getAttribute('data-background');
          result[key]['background'] = background ? background : '#ffffff';
          break;
        }
        case 'card-title': {
          result[key] = el.innerHTML.trim();
          break;
        }
        case 'card-description': {
          result[key] = el.innerHTML.trim();
          result['text-color'] = el.getAttribute('data-text-color');
          break;
        }
        case 'card-survay': {
          const showSurvay = el.getAttribute('data-show-survay');
          result[key] = showSurvay ? showSurvay === 'true' : false;
          const elItems = el.querySelectorAll('[data-attribute="item-survay"]');
          const itemsSurvay = Array.from(elItems).map(item => {
            const percent = +item.querySelector('[data-attribute="percent-survay"]')?.textContent.trim() || 0;
            const description = item.querySelector('[data-attribute="description-survay"]')?.textContent.trim() || '';
            return {
              percent,
              description,
            };
          });
          result['items-survay'] = itemsSurvay;
          break;
        }
        default:
          break;
      }
    });

    return result;
  },
  sectionFreestyle(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {};

    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';
      // const contentEl = sectionEl.querySelector('[data-attribute="content"]')
      const wrapContentEl = sectionEl.querySelector('[data-attribute="wrap-content"]');

      result.topPadding = wrapContentEl.getAttribute('data-top-padding') === 'true' ? true : false;
      result.bottomPadding = wrapContentEl.getAttribute('data-bottom-padding') === 'true' ? true : false;
      result.layoutFullWidth = wrapContentEl.getAttribute('data-layout-full-width') === 'true' ? true : false;
      result.spacingHorizontal = wrapContentEl.getAttribute('data-spacing-horizontal') === 'true' ? true : false;
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'content': {
          result[key] = el.innerHTML.trim();
          result['text-color'] = el.getAttribute('data-text-color') || el.style.color || '';
          break;
        }
        case 'wrap-content': {
          result['background-color'] = el.getAttribute('data-background') || el.style.backgroundColor || '';
          break;
        }
        default:
          break;
      }
    });

    return result;
  },
  sectionProductGrid(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {};

    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'product-grid-container': {
          result['text-color'] = el.getAttribute('data-text-color') || el.style.color;
          result['background-color'] = el.getAttribute('data-background') || el.style.backgroundColor;
          result.topPadding = el.getAttribute('data-top-padding') === 'true' ? true : false;
          result.bottomPadding = el.getAttribute('data-bottom-padding') === 'true' ? true : false;
          break;
        }
        case 'title-grid': {
          result[key] = el.textContent.trim();
          break;
        }
        case 'rating-stars': {
          const value = el.getAttribute('data-value');
          const showRating = el.getAttribute('data-show-rating');
          if (showRating) result['data-show-rating'] = showRating === 'true' ? true : false;
          result[key] = value ? Number(value) : 5;
          break;
        }
        case 'rating-text': {
          result[key] = el.textContent.trim();
          break;
        }
        case 'body-grid': {
          const items = el.querySelectorAll('[data-attribute="item-product"]');

          result[key] = Array.from(items).map(item => {
            const product = {};
            const img = item.querySelector('[data-attribute="product-image"]');
            const content = item.querySelector('[data-attribute="product-content"]');

            product.image = img ? img.getAttribute('src') : '';
            product.content = content ? content.innerHTML.trim() : '';
            product.url = item.getAttribute('href') || '';

            return product;
          });
          break;
        }
        default:
          break;
      }
    });
    return result;
  },
  sectionSatelliteGrid(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const dividerPrimary = extractDividerPrimary(htmlString);
    const result = {
      'items-satellite': [],
      topPadding: true,
      bottomPadding: true,
      dividerPrimary: dividerPrimary,
    };
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'satellite-grid-container': {
          result['text-color'] = el.getAttribute('data-text-color') || el.style.color;
          result['background-color'] = el.getAttribute('data-background') || el.style.backgroundColor;
          result.topPadding = el.getAttribute('data-top-padding') === 'true' ? true : false;
          result.bottomPadding = el.getAttribute('data-bottom-padding') === 'true' ? true : false;
          break;
        }
        case 'main-title-satellite': {
          result[key] = el.innerHTML.trim();
          break;
        }

        case 'items-left':
        case 'items-right': {
          const items = el.querySelectorAll('[data-attribute="item-satellite"]');
          const itemsSatellite = Array.from(items).map(item => {
            const satellite = {};
            const img = item.querySelector('[data-attribute="satellite-image"]');
            const title = item.querySelector('[data-attribute="title-satellite"]');
            const description = item.querySelector('[data-attribute="description-satellite"]');

            satellite.image = img ? img.getAttribute('src') : '';
            satellite.title = title ? title.textContent.trim() : '';
            satellite.description = description ? description.textContent.trim() : '';

            return satellite;
          });
          result['items-satellite'] = [...result['items-satellite'], ...itemsSatellite];
          break;
        }
        case 'items-center': {
          const item = el.querySelector('[data-attribute="item-satellite"]');
          if (item) {
            const img = item.querySelector('[data-attribute="satellite-image"]');
            result['main-image-satellite'] = img ? img.getAttribute('src') : '';
          }
          break;
        }
        default:
          break;
      }
    });
    return result;
  },
  sectionQuestionFaq(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      'items-question-faq': [],
    };
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'question-faq-container': {
          result['text-color'] = el.getAttribute('data-text-color') || el.style.color;
          result['background-color'] = el.getAttribute('data-background') || el.style.backgroundColor;
          result['hover-background-color'] = el.getAttribute('data-hover-background') || '#f9fafb';
          result.topPadding = el.getAttribute('data-top-padding') === 'true' ? true : false;
          result.bottomPadding = el.getAttribute('data-bottom-padding') === 'true' ? true : false;
          break;
        }
        case 'title-question-faq': {
          result[key] = el.textContent.trim();
          break;
        }
        case 'wrap-item-question-faq': {
          const items = el.querySelectorAll('[data-attribute="item-question-faq"]');
          const itemsQuestionFaq = Array.from(items).map(item => {
            const question = item.querySelector('[data-attribute="accordion-title"]');
            const answer = item.querySelector('[data-attribute="accordion-content"]');
            return {
              question: question.textContent.trim(),
              answer: answer.innerHTML.trim(),
            };
          });
          result['items-question-faq'] = [...result['items-question-faq'], ...itemsQuestionFaq];
          break;
        }
        case 'item-question-faq': {
          result['border-color'] = el.getAttribute('data-border-color') || el.style.borderColor || '#e5e7eb';
          break;
        }
        default:
          break;
      }
    });
    return result;
  },
  sectionIconWithText(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = { 'items-icon-with-text': [] };
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'icon-with-text-container': {
          result['text-color'] = el.getAttribute('data-text-color') || el.style.color;
          result['background-color'] = el.getAttribute('data-background') || el.style.backgroundColor;
          break;
        }
        case 'list-icon-with-text': {
          const items = el.querySelectorAll('[data-attribute="item-icon-with-text"]');
          const itemsIconWithText = Array.from(items).map(item => {
            const img = item.querySelector('[data-attribute="icon-item"]');
            const title = item.querySelector('[data-attribute="title-item"]');
            return {
              img: img ? img.getAttribute('src') : '',
              title: title ? title.textContent.trim() : '',
            };
          });
          result['items-icon-with-text'] = [...result['items-icon-with-text'], ...itemsIconWithText];
          break;
        }
        default:
          break;
      }
    });
    return result;
  },
  sectionCardDualImg(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      'card-btn': {},
      ['list-image']: [],
      topPadding: true,
      bottomPadding: true,
    };
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'card-container': {
          result['background-color'] = el.getAttribute('data-background') || el.style.backgroundColor;
          result['text-color'] = el.getAttribute('data-text-color') || el.style.color;
          result.topPadding = el.getAttribute('data-top-padding') === 'true' ? true : false;
          result.bottomPadding = el.getAttribute('data-bottom-padding') === 'true' ? true : false;
          break;
        }
        case 'card-title': {
          result[key] = el.textContent.trim();
          break;
        }
        case 'card-description': {
          result[key] = el.innerHTML.trim();
          break;
        }
        case 'card-btn-row': {
          const value = el.getAttribute('data-show-btn');
          result[key] = value ? value === 'true' : false;
          break;
        }
        case 'card-btn': {
          result[key].url = el.getAttribute('href') || '';
          result[key].text = el.textContent.trim() || '';
          result[key].background = el.getAttribute('data-background') || el.style.backgroundColor || '#2d3436';
          result[key].color = el.getAttribute('data-color') || el.style.color || '#FFFFFF';
          break;
        }
        case 'list-image': {
          const items = el.querySelectorAll('[data-attribute="card-image"]');
          const itemsImage = Array.from(items).map(img => {
            return {
              image: img ? img.getAttribute('src') : '',
            };
          });
          result['list-image'] = [...result['list-image'], ...itemsImage];
          break;
        }
        case 'card-item-content': {
          const order = el.getAttribute('data-order');
          result[key] = order ? Number(order) : 1;
          break;
        }
        case 'card-item-image': {
          const order = el.getAttribute('data-order');
          result[key] = order ? Number(order) : 2;
          break;
        }
        default:
          break;
      }
    });
    return result;
  },
  sectionFindAnswer(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      'card-btn': {},
      topPadding: true,
      bottomPadding: true,
    };
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';
    }
    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'card-container': {
          result['background-color'] = el.getAttribute('data-background') || el.style.backgroundColor;
          result['text-color'] = el.getAttribute('data-text-color') || el.style.color;
          result.topPadding = el.getAttribute('data-top-padding') === 'true' ? true : false;
          result.bottomPadding = el.getAttribute('data-bottom-padding') === 'true' ? true : false;
          break;
        }
        case 'card-title': {
          result[key] = el.textContent.trim();
          break;
        }
        case 'card-description': {
          result[key] = el.innerHTML.trim();
          break;
        }
        case 'card-btn-row': {
          const value = el.getAttribute('data-show-btn');
          result[key] = value ? value === 'true' : false;
          break;
        }
        case 'card-btn': {
          result[key].url = el.getAttribute('href') || '';
          result[key].text = el.textContent.trim() || '';
          result[key].background = el.getAttribute('data-background') || el.style.backgroundColor || '';
          result[key].color = el.getAttribute('data-color') || el.style.color || '';
          result[key].border = el.getAttribute('data-border') || el.style.borderColor || '#2d3436';
          break;
        }
      }
    });
    return result;
  },
  sectionTextCarousel(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      'list-item': [],
      breakpoints: {
        mobile: {
          slidesPerView: 1,
        },
        tablet: {
          slidesPerView: 1,
        },
        desktop: {
          slidesPerView: 3,
        },
      },
      topPadding: true,
      bottomPadding: true,
    };
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';

      // Extract breakpoints from section element
      const mobileSlides = sectionEl.getAttribute('data-breakpoint-mobile-slides');
      const tabletSlides = sectionEl.getAttribute('data-breakpoint-tablet-slides');
      const desktopSlides = sectionEl.getAttribute('data-breakpoint-desktop-slides');

      if (mobileSlides) {
        result.breakpoints.mobile = {
          slidesPerView: parseInt(mobileSlides, 10) || 1,
        };
      }
      if (tabletSlides) {
        result.breakpoints.tablet = {
          slidesPerView: parseInt(tabletSlides, 10) || 1,
        };
      }
      if (desktopSlides) {
        result.breakpoints.desktop = {
          slidesPerView: parseInt(desktopSlides, 10) || 3,
        };
      }
    }
    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'card-container': {
          result[key] = el.getAttribute('data-background');
          result['text-color'] = el.getAttribute('data-text-color') || el.style.color;
          result['pagination-active-color'] = el.getAttribute('data-pagination-active-color') || '#000000';
          result['pagination-inactive-color'] = el.getAttribute('data-pagination-inactive-color') || '#cccccc';
          result['background-item-color'] = el.getAttribute('data-background-item-color') || '#ffffff';
          result['text-item-color'] = el.getAttribute('data-text-item-color') || '#000000';
          result.topPadding = el.getAttribute('data-top-padding') === 'true' ? true : false;
          result.bottomPadding = el.getAttribute('data-bottom-padding') === 'true' ? true : false;
          break;
        }
        case 'card-title': {
          result[key] = el.textContent.trim();
          break;
        }
        case 'list-item': {
          const items = el.querySelectorAll('[data-attribute="content"]');
          const itemsTextCarousel = Array.from(items).map(item => {
            return {
              content: item.innerHTML.trim(),
            };
          });
          result['list-item'] = [...result['list-item'], ...itemsTextCarousel];
          break;
        }
      }
    });
    return result;
  },
  sectionHeading(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {};
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';
    }
    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'card-container': {
          result[key] = el.getAttribute('data-background');
          break;
        }
        case 'card-title': {
          result[key] = el.textContent.trim();
          result['text-color'] = el.getAttribute('data-text-color') || el.style.color || '#ffffff';
          break;
        }
        case 'card-description': {
          result[key] = el.textContent.trim();
          result['text-color'] = el.getAttribute('data-text-color') || el.style.color || '#ffffff';
          break;
        }
        default:
          break;
      }
    });
    return result;
  },
  sectionCardSmoking(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      topPadding: true,
      bottomPadding: true,
    };
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';
    }
    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'card-container': {
          result[key] = el.getAttribute('data-background');
          result.topPadding = el.getAttribute('data-top-padding') === 'true' ? true : false;
          result.bottomPadding = el.getAttribute('data-bottom-padding') === 'true' ? true : false;
          break;
        }
        case 'card-item-content': {
          const order = el.getAttribute('data-order');
          result[key] = order ? Number(order) : 1;
          break;
        }
        case 'card-item-image': {
          const order = el.getAttribute('data-order');
          result[key] = order ? Number(order) : 2;
          break;
        }
        case 'card-content': {
          const background = el.getAttribute('data-background');
          result[key] = background ? background : '#000000';
          break;
        }
        case 'card-title': {
          result[key] = el.innerHTML.trim();
          result['text-color'] = el.getAttribute('data-text-color') || el.style.color || '#ffffff';
          break;
        }
        case 'card-description': {
          result[key] = el.innerHTML.trim();
          result['text-color'] = el.getAttribute('data-text-color') || el.style.color || '#ffffff';
          break;
        }
        case 'card-image': {
          const img = el.getAttribute('src');
          result[key] = img ? img : '';
          break;
        }
        default:
          break;
      }
    });
    return result;
  },
  sectionReviewGrid(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Review Grid Section',
      'title-review': 'Testimonials',
      'card-background-color': '#f6f6f6',
      'show-more-text': 'Show more',
      'show-less-text': 'Show less',
      'line-clamp': 4,
      'body-review': [],
      'background-color': '',
      'card-text-color': '#000000',
      'button-text-color': '#ffffff',
      'button-background-color': '#000000',
      'title-color': '',
      'pagination-active-color': '#000000',
      'pagination-inactive-color': '#cccccc',
      breakpoints: {
        mobile: {
          slidesPerView: 1,
        },
        tablet: {
          slidesPerView: 2,
        },
        desktop: {
          slidesPerView: 3,
        },
      },
      topPadding: true,
      bottomPadding: true,
    };
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Review Grid Section';

      // Extract breakpoints from section element
      const mobileSlides = sectionEl.getAttribute('data-breakpoint-mobile-slides');
      const tabletSlides = sectionEl.getAttribute('data-breakpoint-tablet-slides');
      const desktopSlides = sectionEl.getAttribute('data-breakpoint-desktop-slides');

      if (mobileSlides) {
        result.breakpoints.mobile = {
          slidesPerView: parseInt(mobileSlides, 10) || 1,
        };
      }
      if (tabletSlides) {
        result.breakpoints.tablet = {
          slidesPerView: parseInt(tabletSlides, 10) || 2,
        };
      }
      if (desktopSlides) {
        result.breakpoints.desktop = {
          slidesPerView: parseInt(desktopSlides, 10) || 3,
        };
      }
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'review-grid-container': {
          result['card-background-color'] = el.getAttribute('data-card-background-color') || '#f6f6f6';
          result['card-text-color'] = el.getAttribute('data-card-text-color') || el.style.color || '#000000';
          result['show-more-text'] = el.getAttribute('data-show-more-text') || 'Show more';
          result['show-less-text'] = el.getAttribute('data-show-less-text') || 'Show less';
          result['line-clamp'] = parseInt(el.getAttribute('data-line-clamp')) || 4;
          result['background-color'] = el.getAttribute('data-background-color') || el.style.backgroundColor;
          result['pagination-active-color'] = el.getAttribute('data-pagination-active-color') || '#000000';
          result['pagination-inactive-color'] = el.getAttribute('data-pagination-inactive-color') || '#cccccc';
          result.topPadding = el.getAttribute('data-top-padding') === 'true' ? true : false;
          result.bottomPadding = el.getAttribute('data-bottom-padding') === 'true' ? true : false;
          break;
        }
        case 'show-more-btn': {
          result['button-text-color'] = el.getAttribute('data-button-text-color') || el.style.color || '#ffffff';
          result['button-background-color'] =
            el.getAttribute('data-button-background-color') || el.style.backgroundColor || '#000000';
          break;
        }
        case 'title-review': {
          result[key] = el.textContent.trim();
          result['title-color'] = el.getAttribute('data-title-color') || el.style.color;
          break;
        }
        case 'item-review': {
          const reviewerAvatar = el.querySelector('[data-attribute="reviewer-avatar"]');
          const reviewerName = el.querySelector('[data-attribute="reviewer-name"]');
          const ratingStars = el.querySelector('[data-attribute="rating-stars"]');
          const reviewContent = el.querySelector('[data-attribute="review-content"]');

          const reviewItem = {
            avatar: reviewerAvatar ? reviewerAvatar.getAttribute('src') : '',
            name: reviewerName ? reviewerName.textContent.trim() : '',
            rating: ratingStars ? parseInt(ratingStars.getAttribute('data-value')) || 5 : 5,
            content: reviewContent ? reviewContent.innerHTML.trim() : '',
          };
          result['body-review'].push(reviewItem);
          break;
        }
      }
    });

    return result;
  },
  sectionReviewGrid02(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Review Grid Section 02',
      'title-review': '',
      'card-background-color': '#FFFFFF',
      'body-review': [],
      'background-color': '#FFF7F5',
      'card-text-color': '#000000',
      breakpoints: {
        mobile: {
          slidesPerView: 1,
        },
        tablet: {
          slidesPerView: 2,
        },
        desktop: {
          slidesPerView: 3,
        },
      },
      topPadding: true,
      bottomPadding: true,
    };
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Review Grid Section 02';

      // Extract breakpoints from section element
      const mobileSlides = sectionEl.getAttribute('data-breakpoint-mobile-slides');
      const tabletSlides = sectionEl.getAttribute('data-breakpoint-tablet-slides');
      const desktopSlides = sectionEl.getAttribute('data-breakpoint-desktop-slides');

      if (mobileSlides) {
        result.breakpoints.mobile = {
          slidesPerView: parseInt(mobileSlides, 10) || 1,
        };
      }
      if (tabletSlides) {
        result.breakpoints.tablet = {
          slidesPerView: parseInt(tabletSlides, 10) || 2,
        };
      }
      if (desktopSlides) {
        result.breakpoints.desktop = {
          slidesPerView: parseInt(desktopSlides, 10) || 3,
        };
      }
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'review-grid-container': {
          result['card-background-color'] = el.getAttribute('data-card-background-color') || '#FFFFFF';
          result['card-text-color'] = el.getAttribute('data-card-text-color') || el.style.color || '#000000';
          result['background-color'] = el.getAttribute('data-background-color') || '#FFF7F5';
          result.topPadding = el.getAttribute('data-top-padding') === 'true' ? true : false;
          result.bottomPadding = el.getAttribute('data-bottom-padding') === 'true' ? true : false;
          break;
        }
        case 'title-review': {
          result[key] = el.innerHTML.trim();
          break;
        }
        case 'item-review': {
          const reviewerAvatar = el.querySelector('[data-attribute="reviewer-avatar"]');
          const reviewerName = el.querySelector('[data-attribute="reviewer-name"]');
          const ratingStars = el.querySelector('[data-attribute="rating-stars"]');
          const reviewContent = el.querySelector('[data-attribute="review-content"]');

          const reviewItem = {
            avatar: reviewerAvatar ? reviewerAvatar.getAttribute('src') : '',
            name: reviewerName ? reviewerName.textContent.trim() : '',
            rating: ratingStars ? parseInt(ratingStars.getAttribute('data-value')) || 5 : 5,
            content: reviewContent ? reviewContent.innerHTML.trim() : '',
          };
          result['body-review'].push(reviewItem);
          break;
        }
      }
    });

    return result;
  },
  sectionReviewGridKindLokal(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Review Grid Kind Lokal Section',
      'title-review': 'Our Happy Stories',
      'card-background-color': '#f6f6f6',
      'card-text-color': '#000000',
      'body-review': [],
      'title-color': '',
      'background-color': '',
      'pagination-active-color': '#000000',
      'pagination-inactive-color': '#cccccc',
      breakpoints: {
        mobile: {
          slidesPerView: 1,
        },
        tablet: {
          slidesPerView: 2,
        },
        desktop: {
          slidesPerView: 3,
        },
      },
      topPadding: true,
      bottomPadding: true,
    };
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';

      // Extract breakpoints from section element
      const mobileSlides = sectionEl.getAttribute('data-breakpoint-mobile-slides');
      const tabletSlides = sectionEl.getAttribute('data-breakpoint-tablet-slides');
      const desktopSlides = sectionEl.getAttribute('data-breakpoint-desktop-slides');

      if (mobileSlides) {
        result.breakpoints.mobile = {
          slidesPerView: parseInt(mobileSlides, 10) || 1,
        };
      }
      if (tabletSlides) {
        result.breakpoints.tablet = {
          slidesPerView: parseInt(tabletSlides, 10) || 2,
        };
      }
      if (desktopSlides) {
        result.breakpoints.desktop = {
          slidesPerView: parseInt(desktopSlides, 10) || 3,
        };
      }
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'review-grid-kind-lokal-container': {
          result['card-background-color'] = el.getAttribute('data-card-background-color') || '#f6f6f6';
          result['card-text-color'] = el.getAttribute('data-card-text-color') || el.style.color || '#000000';
          result['background-color'] = el.getAttribute('data-background-color') || el.style.backgroundColor;
          result['pagination-active-color'] = el.getAttribute('data-pagination-active-color') || '#000000';
          result['pagination-inactive-color'] = el.getAttribute('data-pagination-inactive-color') || '#cccccc';
          result.topPadding = el.getAttribute('data-top-padding') === 'true' ? true : false;
          result.bottomPadding = el.getAttribute('data-bottom-padding') === 'true' ? true : false;
          break;
        }
        case 'title-review': {
          result[key] = el.textContent.trim();
          result['title-color'] = el.getAttribute('data-title-color') || el.style.color || '';
          break;
        }
        case 'item-review': {
          const reviewImage = el.querySelector('[data-attribute="review-image"]');
          const reviewerName = el.querySelector('[data-attribute="review-name"]');
          const reviewQuote = el.querySelector('[data-attribute="review-content"]');
          const ratingStars = el.querySelector('[data-attribute="wrap-stars"]');

          const reviewItem = {
            image: reviewImage ? reviewImage.getAttribute('src') : '',
            quote: reviewQuote ? reviewQuote.innerHTML.trim() : '',
            name: reviewerName ? reviewerName.textContent.trim() : '',
            rating: ratingStars ? parseInt(ratingStars.getAttribute('data-value')) || 5 : 5,
          };
          result['body-review'].push(reviewItem);
          break;
        }
      }
    });

    return result;
  },
  sectionMarqueeBasicText(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Marquee Basic Text Section',
      'list-item': [],
    };
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'marquee-basic-text-container': {
          result['background'] = el.getAttribute('data-background');
          result['color'] = el.getAttribute('data-color');
          break;
        }
        case 'grid-group': {
          const elFirstGroup = el.querySelector('[data-attribute="wrap-item"]');
          const itemsFirstGroup = elFirstGroup.querySelectorAll('[data-attribute="item-text"]');
          const itemsFirstGroupText = Array.from(itemsFirstGroup).map(item => {
            return {
              text: item.textContent.trim(),
            };
          });
          result['list-item'].push(...itemsFirstGroupText);
          break;
        }
        default:
          break;
      }
    });

    return result;
  },
  sectionTextSurvey(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      listItem: [],
      topPadding: true,
      bottomPadding: true,
    };
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'card-container': {
          result[key] = el.getAttribute('data-background');
          result['text-color'] = el.getAttribute('data-text-color') || el.style.color || '#000000';
          result['background-color'] = el.getAttribute('data-background-color') || el.style.backgroundColor || '';
          result.topPadding = el.getAttribute('data-top-padding') === 'true' ? true : false;
          result.bottomPadding = el.getAttribute('data-bottom-padding') === 'true' ? true : false;
          break;
        }
        case 'card-left': {
          const order = el.getAttribute('data-order');
          result[key] = order ? Number(order) : 1;
          break;
        }
        case 'card-right': {
          const order = el.getAttribute('data-order');
          result[key] = order ? Number(order) : 2;
          break;
        }
        case 'card-title': {
          result[key] = el.innerHTML.trim();
          break;
        }
        case 'card-survay': {
          const colorPercent = el.getAttribute('data-color-percent');
          result['colorPercent'] = colorPercent ? colorPercent : '#000000';
          break;
        }
        case 'item-survay': {
          result['border-color'] = el.getAttribute('data-border-color') || el.style.borderColor || '#e5e7eb';
          const percentSurvay = el.querySelector('[data-attribute="percent-survay"]');
          const descriptionSurvay = el.querySelector('[data-attribute="description-survay"]');
          const percent = percentSurvay ? +percentSurvay.textContent.trim() || 0 : 0;
          const description = descriptionSurvay ? descriptionSurvay.textContent.trim() : '';
          const itemSurvay = {
            percent: percent,
            description: description,
          };
          result['listItem'].push(itemSurvay);
          break;
        }
        default:
          break;
      }
    });

    return result;
  },
  sectionCompareTwoImg(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      imageBefore: {},
      imageAfter: {},
    };
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';
    }
    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'card-left': {
          const order = el.getAttribute('data-order');
          result[key] = order ? Number(order) : 1;
          break;
        }
        case 'card-right': {
          const order = el.getAttribute('data-order');
          result[key] = order ? Number(order) : 2;
          break;
        }
        case 'card-title': {
          result[key] = el.innerHTML.trim();
          result['title-color'] = el.getAttribute('data-title-color') || el.style.color;
          break;
        }
        case 'card-container': {
          result['background-color'] = el.getAttribute('data-background-color') || el.style.backgroundColor || '';
          break;
        }
        case 'image-before': {
          const img = el.getAttribute('src');
          result.imageBefore.img = img;
          break;
        }
        case 'image-after': {
          const img = el.getAttribute('src');
          result.imageAfter.img = img;
          break;
        }
        case 'before': {
          const background = el.getAttribute('data-background');
          const color = el.getAttribute('data-color');
          const text = el.textContent.trim();
          result.imageBefore.bgDecor = background ? background : '#000000';
          result.imageBefore.colorDecor = color ? color : '#000000';
          result.imageBefore.text = text ? text : '';
          break;
        }
        case 'after': {
          const background = el.getAttribute('data-background');
          const color = el.getAttribute('data-color');
          const text = el.textContent.trim();
          result.imageAfter.bgDecor = background ? background : '#000000';
          result.imageAfter.colorDecor = color ? color : '#000000';
          result.imageAfter.text = text ? text : '';
          break;
        }
      }
    });
    return result;
  },
  sectionCardCompareYuri(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Card Compare Yuri Section',
      enableAnchor: false,
      topPadding: true,
      bottomPadding: true,
      background: '#FFFFFF',
      textColor: '#000000',
      enableContainerPage: false,
      backgroundContainer: '#FFFFFF',
      showTitle: true,
      titleCard: '',
      maxWidth: 700,
      enableBorder: true,
      borderColor: '#e5e7eb',
      imageBefore: {
        img: '',
        text: 'Before',
        bgDecor: '#17d4f4',
        colorDecor: '#ffffff',
      },
      imageAfter: {
        img: '',
        text: 'After',
        bgDecor: '#17d4f4',
        colorDecor: '#ffffff',
      },
      explication: '',
      showExplication: true,
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      result.enableAnchor = sectionEl.getAttribute('data-enable-anchor') === 'true';
      result.title = sectionEl.getAttribute('data-title') || result.title;
    }

    const cardContainer = doc.querySelector('[data-attribute="card-container"]');
    if (cardContainer) {
      result.topPadding = cardContainer.getAttribute('data-top-padding') === 'true';
      result.bottomPadding = cardContainer.getAttribute('data-bottom-padding') === 'true';
      result.background = cardContainer.getAttribute('data-background') || '#FFFFFF';
      result.textColor = cardContainer.getAttribute('data-text-color') || '#000000';
    }

    const containerPage = doc.querySelector('[data-attribute="container-page"]');
    if (containerPage) {
      result.enableContainerPage = containerPage.getAttribute('data-enable-style') === 'true';
      result.backgroundContainer = containerPage.getAttribute('data-background-container') || '#FFFFFF';
    }

    const cardWrapper = doc.querySelector('[data-attribute="wrap-card"]');
    if (cardWrapper) {
      const maxWidth = Number(cardWrapper.getAttribute('data-max-width'));
      result.maxWidth = Number.isFinite(maxWidth) && maxWidth > 0 ? maxWidth : result.maxWidth;
      result.enableBorder = cardWrapper.getAttribute('data-enable-border') !== 'false';
      result.borderColor = cardWrapper.getAttribute('data-color-border') || result.borderColor;
    }

    const titleCard = doc.querySelector('[data-attribute="title-card"]');
    if (titleCard) {
      result.showTitle = titleCard.getAttribute('data-show') !== 'false';
      result.titleCard = titleCard.innerHTML.trim();
    }

    const beforeImage = doc.querySelector('[data-attribute="image-before"]');
    if (beforeImage) {
      result.imageBefore.img = beforeImage.getAttribute('src') || '';
    }

    const afterImage = doc.querySelector('[data-attribute="image-after"]');
    if (afterImage) {
      result.imageAfter.img = afterImage.getAttribute('src') || '';
    }

    const beforeDecor = doc.querySelector('[data-attribute="before"]');
    if (beforeDecor) {
      result.imageBefore.bgDecor = beforeDecor.getAttribute('data-background') || result.imageBefore.bgDecor;
      result.imageBefore.colorDecor = beforeDecor.getAttribute('data-color') || result.imageBefore.colorDecor;
      result.imageBefore.text = beforeDecor.textContent.trim() || result.imageBefore.text;
    }

    const afterDecor = doc.querySelector('[data-attribute="after"]');
    if (afterDecor) {
      result.imageAfter.bgDecor = afterDecor.getAttribute('data-background') || result.imageAfter.bgDecor;
      result.imageAfter.colorDecor = afterDecor.getAttribute('data-color') || result.imageAfter.colorDecor;
      result.imageAfter.text = afterDecor.textContent.trim() || result.imageAfter.text;
    }

    const explication = doc.querySelector('[data-attribute="explication"]');
    if (explication) {
      result.explication = explication.innerHTML.trim();
      result.showExplication = explication.getAttribute('data-show') === 'true';
    }

    return result;
  },
  sectionCardTimelineYuri(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Card Timeline Yuri Section',
      enableAnchor: false,
      topPadding: true,
      bottomPadding: true,
      background: '#FFFFFF',
      textColor: '#000000',
      enableContainerPage: false,
      backgroundContainer: '#FFFFFF',
      showTitle: true,
      titleCard: '',
      listShow: true,
      highlightColor: '#e64c4c',
      listItem: [],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      result.enableAnchor = sectionEl.getAttribute('data-enable-anchor') === 'true';
      result.title = sectionEl.getAttribute('data-title') || result.title;
    }

    const cardContainer = doc.querySelector('[data-attribute="card-container"]');
    if (cardContainer) {
      result.topPadding = cardContainer.getAttribute('data-top-padding') === 'true';
      result.bottomPadding = cardContainer.getAttribute('data-bottom-padding') === 'true';
      result.background = cardContainer.getAttribute('data-background') || '#FFFFFF';
      result.textColor = cardContainer.getAttribute('data-text-color') || '#000000';
    }

    const containerPage = doc.querySelector('[data-attribute="container-page"]');
    if (containerPage) {
      result.enableContainerPage = containerPage.getAttribute('data-enable-style') === 'true';
      result.backgroundContainer = containerPage.getAttribute('data-background-container') || '#FFFFFF';
    }

    const titleCard = doc.querySelector('[data-attribute="title-card"]');
    if (titleCard) {
      result.showTitle = titleCard.getAttribute('data-show') !== 'false';
      result.titleCard = titleCard.innerHTML.trim();
    }

    const listItem = doc.querySelector('[data-attribute="list-item"]');
    if (listItem) {
      result.listShow = listItem.getAttribute('data-show') !== 'false';
      result.highlightColor = listItem.getAttribute('data-color-highlight') || '#e64c4c';
      result.listItem = Array.from(listItem.querySelectorAll('[data-attribute="item-timeline"]')).map(item => ({
        node: item.querySelector('[data-attribute="timeline-node"]')?.textContent.trim() || '',
        content: item.querySelector('[data-attribute="timeline-content"]')?.innerHTML.trim() || '',
      }));
    }

    return result;
  },
  sectionCardSliderYuri(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Card Slider Yuri Section',
      enableAnchor: false,
      topPadding: true,
      bottomPadding: true,
      background: '#FFFFFF',
      textColor: '#000000',
      enableContainerPage: false,
      backgroundContainer: '#FFFFFF',
      showTitle: true,
      titleCard: '',
      listShow: true,
      colPerView: 3,
      listItem: [],
      decorBottomShow: true,
      decorBottomColor: '#ffffff',
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      result.enableAnchor = sectionEl.getAttribute('data-enable-anchor') === 'true';
      result.title = sectionEl.getAttribute('data-title') || result.title;
    }

    const cardContainer = doc.querySelector('[data-attribute="card-container"]');
    if (cardContainer) {
      result.topPadding = cardContainer.getAttribute('data-top-padding') === 'true';
      result.bottomPadding = cardContainer.getAttribute('data-bottom-padding') === 'true';
      result.background = cardContainer.getAttribute('data-background') || '#FFFFFF';
      result.textColor = cardContainer.getAttribute('data-text-color') || '#000000';
    }

    const containerPage = doc.querySelector('[data-attribute="container-page"]');
    if (containerPage) {
      result.enableContainerPage = containerPage.getAttribute('data-enable-style') === 'true';
      result.backgroundContainer = containerPage.getAttribute('data-background-container') || '#FFFFFF';
    }

    const titleCard = doc.querySelector('[data-attribute="title-card"]');
    if (titleCard) {
      result.showTitle = titleCard.getAttribute('data-show') !== 'false';
      result.titleCard = titleCard.innerHTML.trim();
    }

    const listWrap = doc.querySelector('[data-attribute="list-item"]');
    if (listWrap) {
      result.listShow = listWrap.getAttribute('data-show') !== 'false';
      const colPerView = Number(listWrap.getAttribute('data-col-per-view'));
      result.colPerView = Number.isFinite(colPerView) && colPerView > 0 ? colPerView : result.colPerView;
      result.listItem = Array.from(listWrap.querySelectorAll('[data-attribute="item"]')).map(item => ({
        image: item.querySelector('[data-attribute="image-item"]')?.getAttribute('src') || '',
        content: item.querySelector('[data-attribute="content-item"]')?.innerHTML.trim() || '',
      }));
    }

    const decorBottom = doc.querySelector('[data-attribute="decor-bottom"]');
    if (decorBottom) {
      result.decorBottomShow = decorBottom.getAttribute('data-show') !== 'false';
      result.decorBottomColor = decorBottom.getAttribute('data-color') || '#ffffff';
    }

    return result;
  },
  sectionCardStatisticsYuri(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Card Statistics Yuri Section',
      enableAnchor: false,
      topPadding: true,
      bottomPadding: true,
      background: '#FFFFFF',
      textColor: '#000000',
      enableContainerPage: false,
      backgroundContainer: '#FFFFFF',
      showTitle: true,
      titleCard: '',
      listShow: true,
      listItem: [],
      showHint: true,
      contentHint: '',
      iconHint: '',
      highlightColor: '#000000',
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      result.enableAnchor = sectionEl.getAttribute('data-enable-anchor') === 'true';
      result.title = sectionEl.getAttribute('data-title') || result.title;
    }

    const cardContainer = doc.querySelector('[data-attribute="card-container"]');
    if (cardContainer) {
      result.topPadding = cardContainer.getAttribute('data-top-padding') === 'true';
      result.bottomPadding = cardContainer.getAttribute('data-bottom-padding') === 'true';
      result.background = cardContainer.getAttribute('data-background') || '#FFFFFF';
      result.textColor = cardContainer.getAttribute('data-text-color') || '#000000';
    }

    const containerPage = doc.querySelector('[data-attribute="container-page"]');
    if (containerPage) {
      result.enableContainerPage = containerPage.getAttribute('data-enable-style') === 'true';
      result.backgroundContainer = containerPage.getAttribute('data-background-container') || '#FFFFFF';
    }

    const titleCard = doc.querySelector('[data-attribute="title-card"]');
    if (titleCard) {
      result.showTitle = titleCard.getAttribute('data-show') !== 'false';
      result.titleCard = titleCard.innerHTML.trim();
    }

    const listWrap = doc.querySelector('[data-attribute="list-item"]');
    if (listWrap) {
      result.listShow = listWrap.getAttribute('data-show') !== 'false';
      result.listItem = Array.from(listWrap.querySelectorAll('[data-attribute="item"]')).map(item => ({
        value: item.querySelector('[data-attribute="value-item"]')?.textContent.trim() || '',
        content: item.querySelector('[data-attribute="content-item"]')?.innerHTML.trim() || '',
      }));
      result.highlightColor = listWrap.getAttribute('data-color-highlight') || '#000000';
    }

    const hintBlock = doc.querySelector('[data-attribute="hint-block"]');
    if (hintBlock) {
      result.showHint = hintBlock.getAttribute('data-show') !== 'false';
      result.contentHint = hintBlock.querySelector('[data-attribute="content-hint"]')?.innerHTML.trim() || '';
      result.iconHint = hintBlock.querySelector('[data-attribute="icon-item"]')?.getAttribute('src') || '';
    }

    return result;
  },
  sectionReviewSliderYuri(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Review Slider Yuri Section',
      enableAnchor: false,
      topPadding: true,
      bottomPadding: true,
      background: '#FFFFFF',
      textColor: '#000000',
      enableContainerPage: false,
      backgroundContainer: '#FFFFFF',
      highlightColor: '#cb6387',

      showRatedBlock: true,
      ratingValue: '',
      showTitle: true,
      titleCard: '',
      colPerView: 3,
      spaceBetween: 16,
      productReview: {
        image: '',
        productName: '',
        currentPrice: '',
        oldPrice: '',
      },
      listItem: [],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      result.enableAnchor = sectionEl.getAttribute('data-enable-anchor') === 'true';
      result.title = sectionEl.getAttribute('data-title') || result.title;
    }

    const cardContainer = doc.querySelector('[data-attribute="card-container"]');
    if (cardContainer) {
      result.topPadding = cardContainer.getAttribute('data-top-padding') === 'true';
      result.bottomPadding = cardContainer.getAttribute('data-bottom-padding') === 'true';
      result.background = cardContainer.getAttribute('data-background') || '#FFFFFF';
      result.textColor = cardContainer.getAttribute('data-text-color') || '#000000';
    }

    const containerPage = doc.querySelector('[data-attribute="container-page"]');
    if (containerPage) {
      result.enableContainerPage = containerPage.getAttribute('data-enable-style') === 'true';
      result.backgroundContainer = containerPage.getAttribute('data-background-container') || '#FFFFFF';
    }

    const wrapCard = doc.querySelector('[data-attribute="wrap-card"]');
    if (wrapCard) {
      result.highlightColor = wrapCard.getAttribute('data-color-highlight') || '#cb6387';
    }

    const blockRated = doc.querySelector('[data-attribute="block-rated"]');
    if (blockRated) {
      result.showRatedBlock = blockRated.getAttribute('data-show') !== 'false';
      result.ratingValue = blockRated.querySelector('[data-attribute="rating-value"]')?.innerHTML.trim() || '';
    }

    const titleCard = doc.querySelector('[data-attribute="card-title"]');
    if (titleCard) {
      result.showTitle = titleCard.getAttribute('data-show') !== 'false';
      result.titleCard = titleCard.innerHTML.trim();
    }

    const productReview = doc.querySelector('[data-attribute="product-review"]');
    if (productReview) {
      result.productReview.image =
        productReview.querySelector('[data-attribute="product-image"]')?.getAttribute('src') || '';
      result.productReview.productName =
        productReview.querySelector('[data-attribute="product-name"]')?.textContent.trim() || '';
      result.productReview.currentPrice =
        productReview.querySelector('[data-attribute="current-price"]')?.textContent.trim() || '';
      result.productReview.oldPrice =
        productReview.querySelector('[data-attribute="old-price"]')?.textContent.trim() || '';
    }

    const listWrap = doc.querySelector('[data-attribute="list-item"]');
    if (listWrap) {
      const colPerView = Number(listWrap.getAttribute('data-col-per-view'));
      const spaceBetween = Number(listWrap.getAttribute('data-space-between'));
      result.colPerView = Number.isFinite(colPerView) && colPerView > 0 ? colPerView : 3;
      result.spaceBetween = Number.isFinite(spaceBetween) && spaceBetween >= 0 ? spaceBetween : 16;

      result.listItem = Array.from(listWrap.querySelectorAll('[data-attribute="item"]')).map(item => {
        const starValue = parseInt(
          item.querySelector('[data-attribute="star-item"]')?.getAttribute('data-value') || '5',
          10,
        );
        return {
          reviewImage: item.querySelector('[data-attribute="review-image"]')?.getAttribute('src') || '',
          starValue: Number.isNaN(starValue) ? 5 : Math.min(Math.max(starValue, 1), 5),
          reviewerName: item.querySelector('[data-attribute="reviewer-name"]')?.textContent.trim() || '',
          purchaseDate:
            item
              .querySelector('[data-attribute="insert-product-reivew"]')
              ?.getAttribute('data-purchase-date')
              ?.trim() || '',
          contentReview: item.querySelector('[data-attribute="content-review"]')?.innerHTML.trim() || '',
        };
      });
    }

    return result;
  },
  sectionCardWithTableCompare(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      listItem: [],
      'table-body': {},
      columnCount: 2,
      topPadding: true,
      bottomPadding: true,
    };
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'card-container': {
          result[key] = el.getAttribute('data-background');
          result['text-color'] = el.getAttribute('data-text-color') || el.style.color || '#000000';
          result['background-color'] = el.getAttribute('data-background-color') || el.style.backgroundColor || '';
          result.topPadding = el.getAttribute('data-top-padding') === 'true' ? true : false;
          result.bottomPadding = el.getAttribute('data-bottom-padding') === 'true' ? true : false;
          break;
        }
        case 'card-title': {
          result[key] = el.innerHTML.trim();
          break;
        }
        case 'card-left': {
          const order = el.getAttribute('data-order');
          result[key] = order ? Number(order) : 1;
          break;
        }
        case 'card-right': {
          const order = el.getAttribute('data-order');
          result[key] = order ? Number(order) : 2;
          const columnCount = el.getAttribute('data-colum-perview');
          result.columnCount = columnCount ? Number(columnCount) : 2;
          break;
        }
        case 'first-title': {
          result[key] = el.textContent.trim();
          break;
        }
        case 'second-title': {
          result[key] = el.textContent.trim();
          break;
        }
        case 'third-title': {
          result[key] = el.textContent.trim();
          break;
        }
        case 'table-body': {
          const background = el.getAttribute('data-background');
          const color = el.getAttribute('data-color');
          result['table-body'] = {
            background: background,
            color: color,
          };
          break;
        }
        case 'table-row': {
          const elComparisonContent = el.querySelector('[data-attribute="comparison-content"]');
          const elFirstTd = el.querySelector('[data-attribute="first-td"]');
          const elSecondTd = el.querySelector('[data-attribute="second-td"]');
          const elThirdTd = el.querySelector('[data-attribute="third-td"]');
          const comparisonContent = elComparisonContent ? elComparisonContent.textContent.trim() : '';
          const firstTd = elFirstTd?.getAttribute('data-value') === 'true' ? true : false;
          const secondTd = elSecondTd?.getAttribute('data-value') === 'true' ? true : false;
          const thirdTd = elThirdTd?.getAttribute('data-value') === 'true' ? true : false;
          const tableRow = {
            comparisonContent: comparisonContent,
            firstTd: firstTd,
            secondTd: secondTd,
            thirdTd: thirdTd,
          };
          result['listItem'].push(tableRow);
          break;
        }
      }
    });
    return result;
  },
  sectionBannerSlider(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      'list-item': [],
      'text-color': '',
      'background-color': '',
      'button-text-color': '#ffffff',
      'button-background-color': '#000000',
      'pagination-active-color': '#000000',
      'pagination-inactive-color': '#cccccc',
      topPadding: true,
      bottomPadding: true,
    };
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';
    }

    // Extract container colors
    const containerEl = doc.querySelector('[data-attribute="card-container"]');
    if (containerEl) {
      result['background-color'] =
        containerEl.getAttribute('data-background-color') || containerEl.style.backgroundColor || '';
      result['button-text-color'] = containerEl.getAttribute('data-button-text-color') || '#ffffff';
      result['button-background-color'] = containerEl.getAttribute('data-button-background-color') || '#000000';
      result['pagination-active-color'] = containerEl.getAttribute('data-pagination-active-color') || '#000000';
      result['pagination-inactive-color'] = containerEl.getAttribute('data-pagination-inactive-color') || '#cccccc';
      result['text-color'] = containerEl.getAttribute('data-text-color') || '#ffffff';
      result.topPadding = containerEl.getAttribute('data-top-padding') === 'true' ? true : false;
      result.bottomPadding = containerEl.getAttribute('data-bottom-padding') === 'true' ? true : false;
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'container-page': {
          result[key] = el.getAttribute('data-show-style') === 'true' ? true : false;
          break;
        }
        case 'list-item': {
          const elItems = el.querySelectorAll('[data-attribute="item"]');
          elItems.forEach(elItem => {
            const elImageBanner = elItem.querySelector('[data-attribute="image-banner"]');
            const elTextBanner = elItem.querySelector('[data-attribute="text-banner"]');
            const elButtonBannerWrap = elItem.querySelector('[data-attribute="button-banner"]');
            const elButtonLink = elItem.querySelector('[data-attribute="button-link"]');
            const elOverlaySlide = elItem.querySelector('[data-attribute="overlay-slide"]');

            const imageBanner = elImageBanner ? elImageBanner.getAttribute('src') : '';
            const textBanner = {
              text: elTextBanner ? elTextBanner.innerHTML.trim() : '',
              showText: elTextBanner ? elTextBanner.getAttribute('data-show-text') === 'true' : false,
            };
            const buttonBanner = {
              text: elButtonLink ? elButtonLink.textContent.trim() : '',
              showBtn: elButtonBannerWrap ? elButtonBannerWrap.getAttribute('data-show-button') === 'true' : false,
              link: elButtonLink ? elButtonLink.getAttribute('href') : '',
              background: elButtonLink ? elButtonLink.getAttribute('data-background') : '',
              color: elButtonLink ? elButtonLink.getAttribute('data-color') : '',
            };

            const overlaySlide = {
              showOverlay: elOverlaySlide ? elOverlaySlide.getAttribute('data-show-overlay') === 'true' : false,
              opacity: elOverlaySlide ? elOverlaySlide.getAttribute('data-opacity') : '',
            };

            const itemBanner = {
              image: imageBanner,
              textBanner: textBanner,
              button: buttonBanner,
              overlay: overlaySlide,
            };
            result['list-item'].push(itemBanner);
          });

          break;
        }
      }
    });
    return result;
  },
  sectionIconWithTextSlider(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      'list-item': [],
    };
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'card-container': {
          result[key] = el.getAttribute('data-background');
          result['pagination-active-color'] = el.getAttribute('data-pagination-active-color') || '';
          result['pagination-inactive-color'] = el.getAttribute('data-pagination-inactive-color') || '';
          break;
        }
        case 'text-icon': {
          result['text-color'] = el.getAttribute('data-text-color') || el.style.color;
          break;
        }
        case 'list-item': {
          const elItems = el.querySelectorAll('[data-attribute="item"]');
          elItems.forEach(elItem => {
            const elImageIcon = elItem.querySelector('[data-attribute="image-icon"]');
            const elTextIcon = elItem.querySelector('[data-attribute="text-icon"]');
            const imageIcon = elImageIcon ? elImageIcon.getAttribute('src') : '';
            const textIcon = elTextIcon ? elTextIcon.innerHTML.trim() : '';
            const itemIcon = {
              image: imageIcon,
              text: textIcon,
            };
            result['list-item'].push(itemIcon);
          });
          break;
        }
        default:
          break;
      }
    });
    return result;
  },
  sectionSubscribeEmail(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      'text-color': '#000000',
      'border-color': '#000000',
      topPadding: true,
      bottomPadding: true,
    };
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';
    }

    // Extract container colors
    const containerEl = doc.querySelector('[data-attribute="card-container"]');
    if (containerEl) {
      result['text-color'] = containerEl.getAttribute('data-text-color') || containerEl.style.color || '#000000';
      result['border-color'] = containerEl.getAttribute('data-border-color') || '#000000';
      result.topPadding = containerEl.getAttribute('data-top-padding') === 'true' ? true : false;
      result.bottomPadding = containerEl.getAttribute('data-bottom-padding') === 'true' ? true : false;
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'card-container': {
          result[key] = el.getAttribute('data-background');
          break;
        }
        case 'title-card': {
          result[key] = el.textContent.trim();
          break;
        }
        case 'description-card': {
          result[key] = el.textContent.trim();
          break;
        }
        default:
          break;
      }
    });
    return result;
  },
  sectionCardSona(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      'card-container': '',
      'card-item-image': '',
      'card-item-content': '',
      'card-image': '',
      'card-title': '',
      'card-description': '',
      'style-center-y': true,
      'text-color': '#000000',
      'button-text-color': '#ffffff',
      buttonCard: {
        show: true,
        background: '#000000',
        color: '#FFFFFF',
        radius: 0,
        text: '',
        link: '',
      },
      topPadding: true,
      bottomPadding: true,
    };
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';
    }

    // Extract container colors
    const containerEl = doc.querySelector('[data-attribute="card-container"]');
    if (containerEl) {
      result['text-color'] = containerEl.getAttribute('data-text-color') || containerEl.style.color || '#000000';
      result['button-text-color'] = containerEl.getAttribute('data-button-text-color') || '#ffffff';
      result.topPadding = containerEl.getAttribute('data-top-padding') === 'true' ? true : false;
      result.bottomPadding = containerEl.getAttribute('data-bottom-padding') === 'true' ? true : false;
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'card-container': {
          result[key] = el.getAttribute('data-background');
          break;
        }
        case 'card-item-image': {
          result[key] = Number(el.getAttribute('data-order'));
          break;
        }
        case 'card-item-content': {
          result[key] = Number(el.getAttribute('data-order'));
          const styleCenterY = el.getAttribute('data-style-center-y') === 'true' ? true : false;
          result['style-center-y'] = styleCenterY;
          break;
        }
        case 'card-image': {
          const img = el.getAttribute('src');
          result[key] = img ? img : '';
          break;
        }
        case 'card-title': {
          result[key] = el.innerHTML.trim();
          break;
        }
        case 'card-description': {
          result[key] = el.innerHTML.trim();
          break;
        }
        case 'card-btn-row': {
          const showBtn = el.getAttribute('data-show-btn') === 'true' ? true : false;
          const elBtn = el.querySelector('[data-attribute="card-btn"]');
          const background = elBtn ? elBtn.getAttribute('data-background') : '';
          const color = elBtn ? elBtn.getAttribute('data-color') : '';
          const radius = elBtn ? elBtn.getAttribute('data-radius') : '';
          const text = elBtn ? elBtn.textContent.trim() : '';
          const link = elBtn ? elBtn.getAttribute('href') : '';
          result.buttonCard = {
            show: showBtn,
            background: background,
            color: color,
            radius: radius,
            text: text,
            link: link,
          };
          break;
        }
        default:
          break;
      }
    });
    return result;
  },
  sectionTinoGrid(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: '',
      itemBackground: '',
      'title-section': '',
      showText: true,
      breakpoints: {
        mobile: {
          slidesPerView: 1,
        },
        tablet: {
          slidesPerView: 2,
        },
        desktop: {
          slidesPerView: 3,
        },
      },
      listItem: [],
      buttonViewAll: {
        show: true,
        background: '#000000',
        color: '#FFFFFF',
        radius: 0,
        text: '',
        link: '',
      },
      topPadding: true,
      bottomPadding: true,
    };
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';

      // Extract breakpoints from section element
      const mobileSlides = sectionEl.getAttribute('data-breakpoint-mobile-slides');
      const tabletSlides = sectionEl.getAttribute('data-breakpoint-tablet-slides');
      const desktopSlides = sectionEl.getAttribute('data-breakpoint-desktop-slides');

      // Handle new format (mobile, tablet, desktop)
      if (mobileSlides) {
        result.breakpoints.mobile = {
          slidesPerView: parseInt(mobileSlides, 10) || 1,
        };
      }
      if (tabletSlides) {
        result.breakpoints.tablet = {
          slidesPerView: parseInt(tabletSlides, 10) || 2,
        };
      }
      if (desktopSlides) {
        result.breakpoints.desktop = {
          slidesPerView: parseInt(desktopSlides, 10) || 3,
        };
      }
    }
    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'title-section': {
          result[key] = el.textContent.trim();
          break;
        }
        case 'body-grid': {
          result.itemBackground = el.getAttribute('data-item-bg');
          result.itemTextColor = el.getAttribute('data-item-text-color');
          break;
        }
        case 'product-grid-container': {
          result.textColor = el.getAttribute('data-text-color') || el.style.color;
          result.backgroundColor = el.getAttribute('data-background') || el.style.backgroundColor;
          const paginationActiveColor = el.getAttribute('data-pagination-active-color');
          result['pagination-active-color'] = paginationActiveColor ? paginationActiveColor : '#000000';
          const paginationInactiveColor = el.getAttribute('data-pagination-inactive-color');
          result['pagination-inactive-color'] = paginationInactiveColor ? paginationInactiveColor : '#cccccc';
          result.topPadding = el.getAttribute('data-top-padding') === 'true' ? true : false;
          result.bottomPadding = el.getAttribute('data-bottom-padding') === 'true' ? true : false;
          break;
        }
        case 'list-item': {
          const items = el.querySelectorAll('[data-attribute="item-slide"]');
          items.forEach(elItem => {
            const elItemProduct = elItem.querySelector('[data-attribute="item-product"]');
            const elImgItem = elItem.querySelector('[data-attribute="product-image"]');
            const elProductContent = elItem.querySelector('[data-attribute="product-content"]');

            const url = elItemProduct ? elItemProduct.getAttribute('href') : '';
            const img = elImgItem ? elImgItem.getAttribute('src') : '';
            const content = elProductContent ? elProductContent.innerHTML.trim() : '';

            // Check if text is shown for this item
            if (elProductContent) {
              const isHidden =
                elProductContent.style.display === 'none' || elProductContent.getAttribute('data-hide-text') === 'true';
              if (isHidden) {
                result.showText = false;
              }
            }

            const item = {
              url: url,
              image: img,
              content: content,
            };

            result.listItem.push(item);
          });
          break;
        }
        case 'row-btn': {
          const elBtn = el.querySelector('[data-attribute="btn-view-all"]');
          result.buttonViewAll = {
            show: el.getAttribute('data-show-btn') === 'true' ? true : false,
            background: elBtn ? elBtn.getAttribute('data-background') : '',
            color: elBtn ? elBtn.getAttribute('data-color') : '',
            radius: elBtn ? elBtn.getAttribute('data-radius') : '',
            text: elBtn ? elBtn.textContent.trim() : '',
            link: elBtn ? elBtn.getAttribute('href') : '',
          };
          break;
        }
        default:
          break;
      }
    });
    return result;
  },
  sectionFaqGrid(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: '',
      backgroundContainer: '',
      backgroundItems: '',
      titleFaq: '',
      listItem: [
        // {
        //   background: '',
        //   question: '',
        //   answer: ''
        // }
      ],
      topPadding: true,
      bottomPadding: true,
    };
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';
    }
    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'faq-grid-container-fluid': {
          result['backgroundContainer'] = el.getAttribute('data-background');
          result.topPadding = el.getAttribute('data-top-padding') === 'true' ? true : false;
          result.bottomPadding = el.getAttribute('data-bottom-padding') === 'true' ? true : false;
          break;
        }
        case 'title-faq-grid': {
          result['titleFaq'] = el.textContent.trim();
          break;
        }
        case 'list-item': {
          const elWrapItem = el.querySelectorAll('[data-attribute="item-wapper"]');
          const backgroundItems = el.getAttribute('data-background-items');
          result['backgroundItems'] = backgroundItems ? backgroundItems : '';
          elWrapItem.forEach(elItem => {
            const elQuestion = elItem.querySelector('[data-attribute="title-item-question"]');
            const elAnswer = elItem.querySelector('[data-attribute="answer-content"]');
            const question = elQuestion ? elQuestion.textContent.trim() : '';
            const answer = elAnswer ? elAnswer.innerHTML.trim() : '';
            result['listItem'].push({
              background: backgroundItems,
              question: question,
              answer: answer,
            });
          });
          break;
        }
        default:
          break;
      }
    });
    return result;
  },
  sectionFaqGrid02(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: '',
      colors: {
        backgroundContainer: '',
        backgroundFaqItem: '',
        backgroundFaqItemContent: '',
        textFaqItem: '',
      },
      titleFaq: '',
      listItem: [
        // {
        //   background: '',
        //   backgroundContent: '',
        //   question: '',
        //   answer: ''
        // }
      ],
      topPadding: true,
      bottomPadding: true,
      containerFullWidth: false,
    };
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';
    }
    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'faq-grid-container-fluid': {
          result.colors.backgroundContainer = el.getAttribute('data-background') || '#ffffff';
          result.topPadding = el.getAttribute('data-top-padding') === 'true' ? true : false;
          result.bottomPadding = el.getAttribute('data-bottom-padding') === 'true' ? true : false;
          result.containerFullWidth = el.getAttribute('data-container-full-width') === 'true' ? true : false;
          break;
        }
        case 'title-faq-grid': {
          result['titleFaq'] = el.innerHTML.trim();
          break;
        }
        case 'list-item': {
          const elWrapItem = el.querySelectorAll('[data-attribute="item-wapper"]');
          result.colors.backgroundFaqItem = el.getAttribute('data-background-faq-item') || '#F3F4F6';
          result.colors.backgroundFaqItemContent = el.getAttribute('data-background-faq-item-content') || '#E5E7EB';
          result.colors.textFaqItem = el.getAttribute('data-text-faq-item-color') || '#000000';
          elWrapItem.forEach(elItem => {
            const elQuestion = elItem.querySelector('[data-attribute="title-item-question"]');
            const elAnswer = elItem.querySelector('[data-attribute="answer-content"]');
            const question = elQuestion ? elQuestion.textContent.trim() : '';
            const answer = elAnswer ? elAnswer.innerHTML.trim() : '';
            result['listItem'].push({
              question: question,
              answer: answer,
            });
          });
          break;
        }
        default:
          break;
      }
    });
    return result;
  },
  sectionFaqGrid03(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: '',
      colors: {
        backgroundContainer: '',
        backgroundFaqItem: '',
        textFaqItem: '',
      },
      titleFaq: '',
      listItem: [
        // {
        //   background: '',
        //   question: '',
        //   answer: ''
        // }
      ],
      topPadding: true,
      bottomPadding: true,
      containerFullWidth: false,
    };
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';
    }
    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'faq-grid-container-fluid': {
          result.colors.backgroundContainer = el.getAttribute('data-background') || '#F5F5F5';
          result.topPadding = el.getAttribute('data-top-padding') === 'true' ? true : false;
          result.bottomPadding = el.getAttribute('data-bottom-padding') === 'true' ? true : false;
          result.containerFullWidth = el.getAttribute('data-container-full-width') === 'true' ? true : false;
          break;
        }
        case 'title-faq-grid': {
          result['titleFaq'] = el.innerHTML.trim();
          break;
        }
        case 'list-item': {
          const elWrapItem = el.querySelectorAll('[data-attribute="item-wapper"]');
          result.colors.backgroundFaqItem = el.getAttribute('data-background-faq-item') || '#FFFFFF';
          result.colors.textFaqItem = el.getAttribute('data-text-faq-item-color') || '#000000';
          elWrapItem.forEach(elItem => {
            const elQuestion = elItem.querySelector('[data-attribute="title-item-question"]');
            const elAnswer = elItem.querySelector('[data-attribute="answer-content"]');
            const question = elQuestion ? elQuestion.textContent.trim() : '';
            const answer = elAnswer ? elAnswer.innerHTML.trim() : '';
            result['listItem'].push({
              question: question,
              answer: answer,
            });
          });
          break;
        }
        default:
          break;
      }
    });
    return result;
  },
  sectionFaqGrid04(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: '',
      colors: {
        backgroundContainer: '',
        backgroundFaqItem: '',
        textFaqItem: '',
        borderFaqItem: '',
      },
      titleFaq: '',
      listItem: [
        // {
        //   background: '',
        //   question: '',
        //   answer: ''
        // }
      ],
      topPadding: true,
      bottomPadding: true,
      containerFullWidth: false,
    };
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';
    }
    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'faq-grid-container-fluid': {
          result.colors.backgroundContainer = el.getAttribute('data-background') || '#F7F8F9';
          result.topPadding = el.getAttribute('data-top-padding') === 'true' ? true : false;
          result.bottomPadding = el.getAttribute('data-bottom-padding') === 'true' ? true : false;
          result.containerFullWidth = el.getAttribute('data-container-full-width') === 'true' ? true : false;
          break;
        }
        case 'title-faq-grid': {
          result['titleFaq'] = el.innerHTML.trim();
          break;
        }
        case 'list-item': {
          const elWrapItem = el.querySelectorAll('[data-attribute="item-wapper"]');
          result.colors.backgroundFaqItem = el.getAttribute('data-background-faq-item') || '';
          result.colors.textFaqItem = el.getAttribute('data-text-faq-item-color') || '#000000';
          result.colors.borderFaqItem = el.getAttribute('data-border-faq-item') || '#d3d3d3';
          elWrapItem.forEach(elItem => {
            const elQuestion = elItem.querySelector('[data-attribute="title-item-question"]');
            const elAnswer = elItem.querySelector('[data-attribute="answer-content"]');
            const question = elQuestion ? elQuestion.textContent.trim() : '';
            const answer = elAnswer ? elAnswer.innerHTML.trim() : '';
            result['listItem'].push({
              question: question,
              answer: answer,
            });
          });
          break;
        }
        default:
          break;
      }
    });
    return result;
  },
  sectionCardVideoSlider(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: '',
      'card-container': '',
      topPadding: true,
      bottomPadding: true,
      autoPlayVideo: false,
      muted: false,
      header: {
        show: false,
        content: '',
      },
      btnPlayVideo: {
        background: '#000000',
        color: '#FFFFFF',
      },
      breakpoints: {
        mobile: {
          slidesPerView: 1,
        },
        tablet: {
          slidesPerView: 2,
        },
        desktop: {
          slidesPerView: 5,
        },
      },
      listItem: [],
    };

    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';

      // Extract breakpoints from section element
      const mobileSlides = sectionEl.getAttribute('data-breakpoint-mobile-slides');
      const tabletSlides = sectionEl.getAttribute('data-breakpoint-tablet-slides');
      const desktopSlides = sectionEl.getAttribute('data-breakpoint-desktop-slides');

      if (mobileSlides) {
        result.breakpoints.mobile = {
          slidesPerView: parseInt(mobileSlides, 10) || 1,
        };
      }
      if (tabletSlides) {
        result.breakpoints.tablet = {
          slidesPerView: parseInt(tabletSlides, 10) || 2,
        };
      }
      if (desktopSlides) {
        result.breakpoints.desktop = {
          slidesPerView: parseInt(desktopSlides, 10) || 5,
        };
      }
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'card-container': {
          const background = el.getAttribute('data-background');
          result[key] = background ? background : '#ffffff';
          result.topPadding = el.getAttribute('data-top-padding') === 'true' ? true : false;
          result.bottomPadding = el.getAttribute('data-bottom-padding') === 'true' ? true : false;
          break;
        }
        case 'card-header': {
          result.header.content = el.innerHTML.trim();
          result.header.show = el.getAttribute('data-show') === 'true' ? true : false;
          break;
        }
        case 'list-item': {
          const bgPlayVideo = el.getAttribute('data-bg-play-video');
          const colorPlayVideo = el.getAttribute('data-color-play-video');
          result.autoPlayVideo = el.getAttribute('data-auto-play-video') === 'true';
          result.muted = el.getAttribute('data-muted') === 'true';
          result.btnPlayVideo = {
            background: bgPlayVideo ? bgPlayVideo : '#000000',
            color: colorPlayVideo ? colorPlayVideo : '#FFFFFF',
          };
          el.querySelectorAll('[data-attribute="item"]').forEach(item => {
            result.listItem.push({
              video: item.querySelector('[data-attribute="card-video"]')?.getAttribute('src') || '',
            });
          });
          break;
        }
        default:
          break;
      }
    });

    return result;
  },
  sectionCardVideo(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      topPadding: true,
      bottomPadding: true,
    };

    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'card-container': {
          const background = el.getAttribute('data-background');
          result[key] = background ? background : '#ffffff';
          const paginationActiveColor = el.getAttribute('data-pagination-active-color');
          result['pagination-active-color'] = paginationActiveColor ? paginationActiveColor : '#000000';
          const paginationInactiveColor = el.getAttribute('data-pagination-inactive-color');
          result['pagination-inactive-color'] = paginationInactiveColor ? paginationInactiveColor : '#cccccc';
          result.topPadding = el.getAttribute('data-top-padding') === 'true' ? true : false;
          result.bottomPadding = el.getAttribute('data-bottom-padding') === 'true' ? true : false;
          break;
        }
        case 'card-item-content': {
          const order = el.getAttribute('data-order');
          result[key] = order ? Number(order) : 1;
          const styleCenterY = el.getAttribute('data-style-center-y');
          result['style-center-y'] = styleCenterY ? styleCenterY === 'true' : false;
          break;
        }
        case 'card-item-image': {
          const order = el.getAttribute('data-order');
          result[key] = order ? Number(order) : 2;
          break;
        }
        case 'card-btn-row': {
          const showBtn = el.getAttribute('data-show-btn');
          result[key] = showBtn ? showBtn === 'true' : false;
          break;
        }
        case 'card-rated-row': {
          const showRating = el.getAttribute('data-show-rating');
          result[key] = showRating ? showRating === 'true' : false;
          break;
        }
        case 'card-btn': {
          result[key] = {
            text: el.textContent.trim(),
            url: el.getAttribute('href') || '',
            background: el.getAttribute('data-background') || el.style.backgroundColor || '#2d3436',
            color: el.getAttribute('data-color') || el.style.color || '#ffffff',
            radius: el.getAttribute('data-radius') || el.style.borderRadius || '0',
          };
          break;
        }
        // case 'card-content': {
        //   result[key] = el.innerHTML.trim()
        //   break
        // }
        case 'wrap-img': {
          result['wrap-img-radius'] = el.getAttribute('data-radius') || el.style.borderRadius || '0';
          break;
        }
        case 'card-video': {
          result[key] = el.getAttribute('src') || '';
          break;
        }
        case 'sub-btn': {
          result[key] = el.textContent.trim();
          break;
        }
        case 'rating-stars': {
          const value = el.getAttribute('data-value');
          result[key] = value ? Number(value) : 5;
          break;
        }
        case 'rating-text': {
          result[key] = el.textContent.trim();
          break;
        }
        case 'container-page': {
          result[key] = {};
          const showStyle = el.getAttribute('data-show-style');
          result[key]['show-style'] = showStyle ? showStyle === 'true' : false;
          const background = el.getAttribute('data-background');
          result[key]['background'] = background ? background : '#ffffff';
          break;
        }
        case 'card-title': {
          result[key] = el.innerHTML.trim();
          break;
        }
        case 'card-description': {
          result[key] = el.innerHTML.trim();
          const textColor = el.getAttribute('data-text-color');
          result['text-color'] = textColor ? textColor : '';
          break;
        }
        case 'card-survay': {
          const showSurvay = el.getAttribute('data-show-survay');
          result[key] = showSurvay ? showSurvay === 'true' : false;
          const elItems = el.querySelectorAll('[data-attribute="item-survay"]');
          const itemsSurvay = Array.from(elItems).map(item => {
            const percent = +item.querySelector('[data-attribute="percent-survay"]')?.textContent.trim() || 0;
            const description = item.querySelector('[data-attribute="description-survay"]')?.textContent.trim() || '';
            return {
              percent,
              description,
            };
          });
          result['items-survay'] = itemsSurvay;
          break;
        }
        default:
          break;
      }
    });

    return result;
  },
  sectionCardAccordions(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      accordions: {
        show: false,
        listItem: [
          // {
          //   title: '',
          //   content: '',
          // },
        ],
        topPadding: true,
        bottomPadding: true,
      },
    };

    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'card-container': {
          const background = el.getAttribute('data-background');
          result[key] = background ? background : '#ffffff';
          const paginationActiveColor = el.getAttribute('data-pagination-active-color');
          result['pagination-active-color'] = paginationActiveColor ? paginationActiveColor : '#000000';
          const paginationInactiveColor = el.getAttribute('data-pagination-inactive-color');
          result['pagination-inactive-color'] = paginationInactiveColor ? paginationInactiveColor : '#cccccc';
          result.topPadding = el.getAttribute('data-top-padding') === 'true';
          result.bottomPadding = el.getAttribute('data-bottom-padding') === 'true';
          break;
        }
        case 'card-item-content': {
          const order = el.getAttribute('data-order');
          result[key] = order ? Number(order) : 1;
          const styleCenterY = el.getAttribute('data-style-center-y');
          result['style-center-y'] = styleCenterY ? styleCenterY === 'true' : false;
          break;
        }
        case 'card-item-image': {
          const order = el.getAttribute('data-order');
          result[key] = order ? Number(order) : 2;
          break;
        }
        case 'card-btn-row': {
          const showBtn = el.getAttribute('data-show-btn');
          result[key] = showBtn ? showBtn === 'true' : false;
          break;
        }
        case 'card-rated-row': {
          const showRating = el.getAttribute('data-show-rating');
          result[key] = showRating ? showRating === 'true' : false;
          break;
        }
        case 'card-btn': {
          result[key] = {
            text: el.textContent.trim(),
            url: el.getAttribute('href') || '',
            background: el.getAttribute('data-background') || el.style.backgroundColor || '#2d3436',
            color: el.getAttribute('data-color') || el.style.color || '#ffffff',
          };
          break;
        }
        // case 'card-content': {
        //   result[key] = el.innerHTML.trim()
        //   break
        // }
        case 'card-image': {
          result[key] = el.getAttribute('src') || '';
          break;
        }
        case 'sub-btn': {
          result[key] = el.textContent.trim();
          break;
        }
        case 'rating-stars': {
          const value = el.getAttribute('data-value');
          result[key] = value ? Number(value) : 5;
          break;
        }
        case 'rating-text': {
          result[key] = el.textContent.trim();
          break;
        }
        case 'container-page': {
          result[key] = {};
          const showStyle = el.getAttribute('data-show-style');
          result[key]['show-style'] = showStyle ? showStyle === 'true' : false;
          const background = el.getAttribute('data-background');
          result[key]['background'] = background ? background : '#ffffff';
          break;
        }
        case 'card-title': {
          result[key] = el.innerHTML.trim();
          break;
        }
        case 'card-description': {
          result[key] = el.innerHTML.trim();
          const textColor = el.getAttribute('data-text-color');
          result['text-color'] = textColor ? textColor : '';
          break;
        }
        case 'card-survay': {
          const showSurvay = el.getAttribute('data-show-survay');
          result[key] = showSurvay ? showSurvay === 'true' : false;
          const elItems = el.querySelectorAll('[data-attribute="item-survay"]');
          const itemsSurvay = Array.from(elItems).map(item => {
            const percent = +item.querySelector('[data-attribute="percent-survay"]')?.textContent.trim() || 0;
            const description = item.querySelector('[data-attribute="description-survay"]')?.textContent.trim() || '';
            return {
              percent,
              description,
            };
          });
          result['items-survay'] = itemsSurvay;
          break;
        }
        case 'card-accordions': {
          const showAccordion = el.getAttribute('data-show-accordion');
          result.accordions.show = showAccordion ? showAccordion === 'true' : false;
          const elItems = el.querySelectorAll('[data-attribute="card-accordion"]');
          const itemsAccordions = Array.from(elItems).map(item => {
            const title = item.querySelector('[data-attribute="accordion-title"]')?.textContent.trim() || '';
            const content = item.querySelector('[data-attribute="accordion-content"]')?.textContent.trim() || '';
            return {
              title,
              content,
            };
          });
          result.accordions.listItem = itemsAccordions;
          break;
        }
        default:
          break;
      }
    });

    return result;
  },
  sectionMarqueeTino(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      sectionBackground: '',
      sectionTitle: '',
      sectionDescription: '',
      lineStroke: {
        show: false,
        width: 100,
        color: '#000000',
      },
      listItem: [
        // {
        //   imgSrc: "",
        //   htmlText: "",
        // }
      ],
      topPadding: true,
      bottomPadding: true,
    };
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'card-container': {
          result['sectionBackground'] = el.getAttribute('data-background') || el.style.backgroundColor || '#ffffff';
          result['topPadding'] = el.getAttribute('data-top-padding') === 'true' ? true : false;
          result['bottomPadding'] = el.getAttribute('data-bottom-padding') === 'true' ? true : false;
          break;
        }
        case 'title': {
          result['sectionTitle'] = el.textContent.trim();
          break;
        }
        case 'description': {
          result['sectionDescription'] = el.textContent.trim();
          break;
        }
        case 'line-stroke': {
          result['lineStroke'].show = el.getAttribute('data-enable-line') === 'true' ? true : false;
          result['lineStroke'].width = el.getAttribute('data-width') ? Number(el.getAttribute('data-width')) : 100;
          result['lineStroke'].color = el.getAttribute('data-color') || '#000000';
          break;
        }
        case 'list-item': {
          const elItems = el.querySelectorAll('[data-attribute="track"]');
          const items = Array.from(elItems).map(item => {
            const image = item.querySelector('[data-attribute="image-item"]');
            const imgSrc = image ? image.getAttribute('src') : '';
            const texthtml = item.querySelector('[data-attribute="text-item"]');
            return {
              image: imgSrc,
              htmlText: texthtml ? texthtml.innerHTML.trim() : '',
            };
          });
          result['listItem'] = items;
          break;
        }
        default:
          break;
      }
    });
    return result;
  },
  sectionMarqueeImage(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: '',
      sectionBackground: '',
      listItem: [
        // {
        //   image: "",
        //   htmlText: "",
        // }
      ],
    };
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'card-container': {
          result['sectionBackground'] = el.getAttribute('data-background') || el.style.backgroundColor || '#ffffff';
          break;
        }
        case 'list-item': {
          const elItems = el.querySelectorAll('[data-attribute="track"]');
          const items = Array.from(elItems).map(item => {
            const image = item.querySelector('[data-attribute="image-item"]');
            const imgSrc = image ? image.getAttribute('src') : '';
            return {
              image: imgSrc,
            };
          });
          result['listItem'] = items;
          break;
        }
        default:
          break;
      }
    });
    return result;
  },
  sectionMarqueeYuri(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Marquee Yuri Section',
      enableAnchor: false,
      topPadding: true,
      bottomPadding: true,
      background: '#FFFFFF',
      textColor: '#000000',
      enableContainerPage: false,
      backgroundContainer: '#FFFFFF',
      highlightColor: '#cb6387',

      titleCard: '',
      showTitle: true,
      listItem: [],
    };
    const sectionEl = doc.querySelector('[data-section]');
    const elements = doc.querySelectorAll('[data-attribute]');

    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Marquee Yuri Section';
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'card-container': {
          result.topPadding = el.getAttribute('data-top-padding') === 'true' ? true : false;
          result.bottomPadding = el.getAttribute('data-bottom-padding') === 'true' ? true : false;
          result.background = el.getAttribute('data-background') || '#FFFFFF';
          result.textColor = el.getAttribute('data-text-color') || '#000000';
          break;
        }
        case 'container-page': {
          result.enableContainerPage = el.getAttribute('data-enable-style') === 'true' ? true : false;
          result.backgroundContainer = el.getAttribute('data-background-container') || '#FFFFFF';
          break;
        }
        case 'title-card': {
          result.titleCard = el.innerHTML.trim();
          result.showTitle = el.getAttribute('data-show') === 'true' ? true : false;
          break;
        }
        case 'list-item': {
          result.highlightColor = el.getAttribute('data-highlight-color') || '#cb6387';
          const elItems = el.querySelectorAll('[data-attribute="wrap-item-marquee"]');
          result.listItem = Array.from(elItems).map(item => {
            const contentItem = item.querySelector('[data-attribute="content-item"]');
            return {
              text: contentItem ? contentItem.textContent.trim() : '',
            };
          });
          break;
        }
        default:
          break;
      }
    });

    if (!result.listItem.length) {
      result.listItem = [{ text: 'Overnight Hydration' }];
    }

    return result;
  },
  sectionTabs(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: '',
      containerBackground: '',
      headerColor: '',
      headerPosition: '',
      listTab: [
        {
          title: '',
          content: '',
        },
      ],
      topPadding: true,
      bottomPadding: true,
    };
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'wrapper-container': {
          result['containerBackground'] = el.getAttribute('data-background') || el.style.backgroundColor || '#ffffff';
          result['topPadding'] = el.getAttribute('data-top-padding') === 'true' ? true : false;
          result['bottomPadding'] = el.getAttribute('data-bottom-padding') === 'true' ? true : false;
          break;
        }
        case 'list-tab-header': {
          // result['listTabHeader'] = el.innerHTML.trim()
          result['headerColor'] = el.getAttribute('data-color') || '#8e1d08';
          result['headerPosition'] = el.getAttribute('data-position') || 'left';
          const elTabContent = doc.querySelector('[data-attribute="list-tab-content"]');
          const elItems = el.querySelectorAll('[data-attribute="tab-header-item"]');
          const items = Array.from(elItems).map(item => {
            const tabIndex = item.getAttribute('data-tab');
            const tabTitle = item.textContent.trim();
            const tabContent = elTabContent?.querySelector(`[data-tab="${tabIndex}"]`)?.innerHTML.trim() || '';
            return {
              title: tabTitle,
              content: tabContent,
            };
          });
          result['listTab'] = items;
          break;
        }

        default:
          break;
      }
    });
    return result;
  },
  sectionCardFeeSizeImg(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      backgroundColor: '',
      backgroundImage: {
        enable: false,
        image: '',
      },
      overlay: {
        enable: false,
        opacity: 0.2,
      },
      dataImg: {
        order: 1,
        image: '',
        enable: true,
      },
      dataContent: {
        order: 2,
        content: '',
      },
      topPadding: true,
      bottomPadding: true,
    };
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';
    }
    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'wrapper-container': {
          const backgroundColor = el.getAttribute('data-background-color') || el.style.backgroundColor || '#ffffff';
          const backgroundImage = el.getAttribute('data-background-img') || '';

          result['backgroundColor'] = backgroundColor ? backgroundColor : '#ffffff';
          const enableBackgroundImage = el.getAttribute('data-enable-background-image') === 'true' ? true : false;
          result['backgroundImage'].enable = enableBackgroundImage ? enableBackgroundImage : false;

          if (enableBackgroundImage) {
            result['backgroundImage'].image = backgroundImage;
          } else {
            result['backgroundImage'].image = '';
          }
          result['topPadding'] = el.getAttribute('data-top-padding') === 'true' ? true : false;
          result['bottomPadding'] = el.getAttribute('data-bottom-padding') === 'true' ? true : false;

          result['overlay'].enable = el.getAttribute('data-overlay-enable') === 'true' ? true : false;
          if (result['overlay'].enable) {
            const overlayColor = el.style.getPropertyValue('--overlay-color');
            if (overlayColor) {
              const opacityMatch = overlayColor.match(/rgba\(\d+,\s*\d+,\s*\d+,\s*([\d.]+)\)/);
              result['overlay'].opacity = opacityMatch ? parseFloat(opacityMatch[1]) : 0.2;
            } else {
              result['overlay'].opacity = 0.2;
            }
          } else {
            result['overlay'].opacity = 0.2;
          }
          break;
        }
        case 'wrap-image': {
          result['dataImg'].order = el.getAttribute('data-order') ? Number(el.getAttribute('data-order')) : 1;
          result['dataImg'].enable = el.getAttribute('data-image-enable') !== 'false';
          break;
        }
        case 'image': {
          const image = el.getAttribute('src');
          result['dataImg'].image = image ? image : '';
          break;
        }
        case 'card-content': {
          result['dataContent'].order = el.getAttribute('data-order') ? Number(el.getAttribute('data-order')) : 2;
          result['dataContent'].content = el.innerHTML.trim();
          break;
        }
        default:
          break;
      }
    });
    return result;
  },
  sectionTableKubo(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: '',
      backgroundColor: '',
      backgroundImage: {
        enable: false,
        image: '',
      },
      titleContent: '',
      tableKubo: '',
      topPadding: true,
      bottomPadding: true,
      borderSpacingVertical: 0,
      borderSpacingHorizontal: 0,
    };
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';
    }
    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'wrapper-container': {
          const backgroundColor = el.getAttribute('data-background-color') || el.style.backgroundColor || '#ffffff';
          const backgroundImage = el.getAttribute('data-background-img') || '';

          result['backgroundColor'] = backgroundColor ? backgroundColor : '#ffffff';
          const enableBackgroundImage = el.getAttribute('data-enable-background-image') === 'true' ? true : false;
          result['backgroundImage'].enable = enableBackgroundImage ? enableBackgroundImage : false;

          if (enableBackgroundImage) {
            result['backgroundImage'].image = backgroundImage;
          } else {
            result['backgroundImage'].image = '';
          }
          result['topPadding'] = el.getAttribute('data-top-padding') === 'true' ? true : false;
          result['bottomPadding'] = el.getAttribute('data-bottom-padding') === 'true' ? true : false;

          break;
        }
        case 'title-content': {
          result['titleContent'] = el.innerHTML.trim();
          break;
        }
        case 'table-kubo': {
          result['tableKubo'] = el.innerHTML.trim();
          break;
        }
        default:
          break;
      }
    });
    const tableKuboEl = doc.querySelector('[data-attribute="table-kubo"] table');
    if (tableKuboEl) {
      result['borderSpacingVertical'] = tableKuboEl.getAttribute('data-border-spacing-vertical')
        ? Number(tableKuboEl.getAttribute('data-border-spacing-vertical'))
        : 0;
      result['borderSpacingHorizontal'] = tableKuboEl.getAttribute('data-border-spacing-horizontal')
        ? Number(tableKuboEl.getAttribute('data-border-spacing-horizontal'))
        : 10;
    }
    return result;
  },
  sectionItemsGrid(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: '',
      backgroundColor: '',
      backgroundImage: {
        enable: false,
        image: '',
      },
      titleContent: '',
      listItem: [
        // {
        //   image: '',
        //   htmlText: '',
        // }
      ],
      paginationActiveColor: '#000000',
      paginationInactiveColor: '#cccccc',
      breakpoints: {
        mobile: {
          slidesPerView: 1,
        },
        tablet: {
          slidesPerView: 3,
        },
        desktop: {
          slidesPerView: 5,
        },
      },
      topPadding: true,
      bottomPadding: true,
    };
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';
    }

    // Extract breakpoints from section element
    const mobileSlides = sectionEl.getAttribute('data-breakpoint-mobile-slides');
    const tabletSlides = sectionEl.getAttribute('data-breakpoint-tablet-slides');
    const desktopSlides = sectionEl.getAttribute('data-breakpoint-desktop-slides');

    if (mobileSlides) {
      result.breakpoints.mobile = {
        slidesPerView: mobileSlides ? parseInt(mobileSlides, 10) : 1,
      };
    }
    if (tabletSlides) {
      result.breakpoints.tablet = {
        slidesPerView: tabletSlides ? parseInt(tabletSlides, 10) : 3,
      };
    }
    if (desktopSlides) {
      result.breakpoints.desktop = {
        slidesPerView: desktopSlides ? parseInt(desktopSlides, 10) : 5,
      };
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'wrapper-container': {
          const backgroundColor = el.getAttribute('data-background-color') || el.style.backgroundColor || '#ffffff';
          const backgroundImage = el.getAttribute('data-background-img') || '';

          result['backgroundColor'] = backgroundColor ? backgroundColor : '#ffffff';
          const enableBackgroundImage = el.getAttribute('data-enable-background-image') === 'true' ? true : false;
          result['backgroundImage'].enable = enableBackgroundImage ? enableBackgroundImage : false;

          if (enableBackgroundImage) {
            result['backgroundImage'].image = backgroundImage;
          } else {
            result['backgroundImage'].image = '';
          }
          result['topPadding'] = el.getAttribute('data-top-padding') === 'true' ? true : false;
          result['bottomPadding'] = el.getAttribute('data-bottom-padding') === 'true' ? true : false;
          result['paginationActiveColor'] = el.getAttribute('data-pagination-active-color') || '#000000';
          result['paginationInactiveColor'] = el.getAttribute('data-pagination-inactive-color') || '#cccccc';
          break;
        }
        case 'title-content': {
          result['titleContent'] = el.innerHTML.trim();
          break;
        }
        case 'list-item': {
          const elItems = el.querySelectorAll('[data-attribute="item"]');
          const items = Array.from(elItems).map(item => {
            const elImage = item.querySelector('[data-attribute="image-item"]');
            const imgSrc = elImage ? elImage.getAttribute('src') : '';
            const texthtml = item.querySelector('[data-attribute="text-item"]');
            const htmlText = texthtml ? texthtml.innerHTML.trim() : '';
            return {
              image: imgSrc,
              htmlText: htmlText,
            };
          });
          result['listItem'] = items;
          break;
        }
        default:
          break;
      }
    });
    return result;
  },
  sectionItemsGrid02(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Items Grid Section 02',
      enableAnchor: false,
      backgroundColor: '#F7F8F9',
      textColor: '#000000',
      titleContent: '',
      listItem: [],
      topPadding: true,
      bottomPadding: true,
      containerFullWidth: true,
      itemsPerRow: {
        mobile: 2,
        desktop: 5,
      },
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      result.enableAnchor = sectionEl.getAttribute('data-enable-anchor') === 'true';
      const title = sectionEl.getAttribute('data-title');
      result.title = title || result.title;
    }

    const elements = doc.querySelectorAll('[data-attribute]');
    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'wrapper-container': {
          result.backgroundColor = el.getAttribute('data-background-color') || '#F7F8F9';
          result.textColor = el.getAttribute('data-text-color') || '#000000';
          result.topPadding = el.getAttribute('data-top-padding') === 'true';
          result.bottomPadding = el.getAttribute('data-bottom-padding') === 'true';
          break;
        }
        case 'wrapper-content': {
          result.containerFullWidth = el.getAttribute('data-container-full-width') === 'true' ? true : false;
          break;
        }
        case 'title-content': {
          result.titleContent = el.innerHTML.trim();
          break;
        }
        case 'list-item': {
          result.itemsPerRow.mobile = el.getAttribute('data-items-per-row-mobile')
            ? Number(el.getAttribute('data-items-per-row-mobile'))
            : 2;
          result.itemsPerRow.desktop = el.getAttribute('data-items-per-row-desktop')
            ? Number(el.getAttribute('data-items-per-row-desktop'))
            : 5;
          const elItems = el.querySelectorAll('[data-attribute="item"]');
          result.listItem = Array.from(elItems).map(item => {
            const elImage = item.querySelector('[data-attribute="image-item"]');
            const imgSrc = elImage ? elImage.getAttribute('src') : '';
            const textEl = item.querySelector('[data-attribute="text-item"]');
            const htmlText = textEl ? textEl.innerHTML.trim() : '';
            return { image: imgSrc, htmlText };
          });
          break;
        }
        default:
          break;
      }
    });
    return result;
  },
  sectionBannerB1(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Banner B1 Section',
      textColor: '#ffffff',
      contentAlign: 'left',
      padding: {
        top: true,
        bottom: true,
      },
      overlay: {
        color: '#000000',
        opacity: 0,
      },
      background: {
        color: '',
        img: '',
        imgMobile: '',
        opacity: 0,
      },
      titleBanner: {
        show: false,
        text: '',
      },
      contentBanner: {
        show: false,
        text: '',
      },
      button: {
        text: '',
        show: false,
        link: '',
        background: '',
        color: '',
        subButton: '',
      },
      rating: {
        show: false,
        value: 5,
        text: '',
      },
      tag: {
        background: '',
        show: false,
        text: '',
      },
      features: {
        colPerView: 4,
        show: false,
        items: [],
      },
    };
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'wrapper-container': {
          const bgColor = el.getAttribute('data-background-color') || '#ffffff';
          const paddingTop = el.getAttribute('data-top-padding') === 'true' ? true : false;
          const paddingBottom = el.getAttribute('data-bottom-padding') === 'true' ? true : false;
          result.padding = {
            top: paddingTop,
            bottom: paddingBottom,
          };
          result.background = {
            color: bgColor,
          };
          result.textColor = el.getAttribute('data-text-color') || '#ffffff';
          break;
        }
        case 'wrap-content': {
          const contentAlign = el.getAttribute('data-align') || 'left';
          result.contentAlign = contentAlign;
          break;
        }
        case 'background-section': {
          const bgImg = el.getAttribute('data-background-img') || '';
          const opacity = el.getAttribute('data-opacity') || 0;
          result.background.img = bgImg;
          result.background.opacity = opacity;
          break;
        }
        case 'background-section-mobile': {
          const bgImg = el.getAttribute('data-background-img') || '';
          result.background.imgMobile = bgImg;
          break;
        }

        case 'overlay-bg': {
          const color = el.getAttribute('data-color') || '#000000';
          const opacity = el.getAttribute('data-opacity') || 0.2;
          result.overlay = {
            color: color,
            opacity: opacity,
          };
          break;
        }
        case 'rating': {
          const showRating = el.getAttribute('data-show-rating') === 'true' ? true : false;
          const value = el.querySelector('[data-attribute="rating-stars"]')?.getAttribute('data-value')
            ? Number(el.querySelector('[data-attribute="rating-stars"]').getAttribute('data-value'))
            : 5;
          const text = el.querySelector('[data-attribute="rating-text"]')?.textContent.trim() || '';
          result.rating = {
            show: showRating,
            value: value,
            text: text,
          };
          break;
        }
        case 'tag-name': {
          const bg = el.getAttribute('data-background') || '';
          const showTag = el.getAttribute('data-show-tag') === 'true' ? true : false;
          const text = el.textContent.trim() || '';
          result.tag = {
            background: bg,
            show: showTag,
            text: text,
          };
          break;
        }
        case 'title-banner': {
          const showTitleBanner = el.getAttribute('data-show-banner-title') === 'true' ? true : false;
          const text = el.innerHTML.trim() || '';
          result.titleBanner = {
            show: showTitleBanner,
            text: text,
          };
          break;
        }
        case 'content-banner': {
          const showContentBanner = el.getAttribute('data-show-banner-content') === 'true' ? true : false;
          const text = el.innerHTML.trim() || '';
          result.contentBanner = {
            show: showContentBanner,
            text: text,
          };
          break;
        }
        case 'wrap-btn': {
          const showButton = el.getAttribute('data-show-btn') === 'true' ? true : false;
          const text = el.querySelector('[data-attribute="button-link"]')?.textContent.trim() || '';
          const subButton = el.querySelector('[data-attribute="sub-button"]')?.innerHTML.trim() || '';
          const link = el.querySelector('[data-attribute="button-link"]')?.getAttribute('href') || '';
          const background = el.querySelector('[data-attribute="button-link"]')?.getAttribute('data-background') || '';
          const color = el.querySelector('[data-attribute="button-link"]')?.getAttribute('data-color') || '';
          result.button = {
            show: showButton,
            text: text,
            link: link,
            background: background,
            color: color,
            subButton: subButton,
          };
          break;
        }
        case 'features': {
          const showFeatures = el.getAttribute('data-show-features') === 'true' ? true : false;
          const colPerView = el.getAttribute('data-col-per-view') ? Number(el.getAttribute('data-col-per-view')) : 4;
          const elItems = el.querySelectorAll('[data-attribute="feature-item"]');
          const items = Array.from(elItems).map(item => {
            const icon = item.querySelector('[data-attribute="icon-feature"]');
            const iconSrc = icon ? icon.getAttribute('src') : '';
            const text = item.querySelector('[data-attribute="text-feature"]');
            const textContent = text ? text.innerHTML.trim() : '';
            return {
              icon: iconSrc,
              text: textContent,
            };
          });
          result.features = {
            show: showFeatures,
            colPerView: colPerView,
            items: items,
          };
          break;
        }
      }
    });

    return result;
  },
  sectionItemsSlideB1(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Items Slide B1 Section',
      backgroundColor: '#ffffff',
      padding: {
        top: true,
        bottom: true,
      },
      header: '',
      listItem: [],
      button: {
        text: '',
        backgroundColor: '#281707',
        color: '#ffffff',
        show: true,
        link: '#',
      },
    };
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Items Slide B1 Section';
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'wrapper-container': {
          const bgColor = el.getAttribute('data-background-color') || '#ffffff';
          const paddingTop = el.getAttribute('data-top-padding') === 'true' ? true : false;
          const paddingBottom = el.getAttribute('data-bottom-padding') === 'true' ? true : false;
          result.backgroundColor = bgColor;
          result.padding = {
            top: paddingTop,
            bottom: paddingBottom,
          };
          break;
        }
        case 'header-section': {
          result.header = el.innerHTML.trim();
          break;
        }
        case 'list-item': {
          const elItems = el.querySelectorAll('[data-attribute="item"]');
          const items = Array.from(elItems).map(item => {
            const imageEl = item.querySelector('[data-attribute="image"]');
            const overlayEl = item.querySelector('[data-attribute="overlay"]');
            const textEl = item.querySelector('[data-attribute="text"]');

            const image = imageEl ? imageEl.getAttribute('src') : '';
            const overlay = {
              opacity: overlayEl ? parseFloat(overlayEl.getAttribute('data-opacity')) || 0.5 : 0.5,
              backgroundColor: overlayEl ? overlayEl.getAttribute('data-background-color') || '#000000' : '#000000',
            };
            const text = textEl ? textEl.innerHTML.trim() : '';

            return {
              image,
              overlay,
              text,
            };
          });
          result.listItem = items;
          break;
        }
        case 'button-cta': {
          const showButton = el.getAttribute('data-show-button') === 'true' ? true : false;
          const text = el.textContent.trim() || '';
          const backgroundColor = el.getAttribute('data-background-color') || '#281707';
          const color = el.getAttribute('data-color') || '#ffffff';
          const link = el.getAttribute('href') || '#';
          result.button = {
            show: showButton,
            text: text,
            backgroundColor: backgroundColor,
            color: color,
            link: link,
          };
          break;
        }
      }
    });

    return result;
  },
  sectionCardBasicB1(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Card Basic B1 Section',
      backgroundColor: '#281707',
      textColor: '#000000',
      showLeftGroup: true,
      showRightGroup: true,
      order: {
        leftGroup: 1,
        rightGroup: 2,
      },
      textContentPrimary: {
        show: true,
        text: '',
      },
      icon: {
        show: true,
        src: '',
      },
      textContentSecondary: {
        show: true,
        text: '',
      },
      padding: {
        top: true,
        bottom: true,
      },
      button: {
        text: '',
        backgroundColor: '#aa6d32',
        color: '#ffffff',
        show: true,
        link: '#',
        subBtn: '',
      },
    };
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Card Basic B1 Section';
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'wrapper-container': {
          const bgColor = el.getAttribute('data-background-color') || '#281707';
          const paddingTop = el.getAttribute('data-top-padding') === 'true' ? true : false;
          const paddingBottom = el.getAttribute('data-bottom-padding') === 'true' ? true : false;
          const textColor = el.getAttribute('data-text-color') || '#000000';
          result.backgroundColor = bgColor;
          result.padding = {
            top: paddingTop,
            bottom: paddingBottom,
          };
          result.textColor = textColor;
          break;
        }
        case 'left-group': {
          const order = el.getAttribute('data-order');
          const showLeftGroup = el.getAttribute('data-show-left-group') === 'true' ? true : false;
          result.showLeftGroup = showLeftGroup;
          result.order.leftGroup = order ? Number(order) : 1;
          break;
        }
        case 'right-group': {
          const order = el.getAttribute('data-order');
          const showRightGroup = el.getAttribute('data-show-right-group') === 'true' ? true : false;
          result.showRightGroup = showRightGroup;
          result.order.rightGroup = order ? Number(order) : 2;
          break;
        }
        case 'text-content-primary': {
          const showText = el.getAttribute('data-show-text') === 'true' ? true : false;
          const text = el.innerHTML.trim() || '';
          result.textContentPrimary = {
            show: showText,
            text: text,
          };
          break;
        }
        case 'wrap-icon-img': {
          const showIcon = el.getAttribute('data-show-icon') === 'true' ? true : false;
          const imgEl = el.querySelector('img');
          const src = imgEl ? imgEl.getAttribute('src') || '' : '';
          result.icon = {
            show: showIcon,
            src: src,
          };
          break;
        }
        case 'text-content-secondary': {
          const showText = el.getAttribute('data-show-text') === 'true' ? true : false;
          const text = el.innerHTML.trim() || '';
          result.textContentSecondary = {
            show: showText,
            text: text,
          };
          break;
        }
        case 'wrap-button': {
          const buttonLink = el.querySelector('[data-attribute="button-link"]');
          const subBtn = el.querySelector('[data-attribute="sub-btn"]');
          if (buttonLink) {
            const showButton = buttonLink.getAttribute('data-show-btn') === 'true' ? true : false;
            const text = buttonLink.textContent.trim() || '';
            const backgroundColor = buttonLink.getAttribute('data-background-color') || '#aa6d32';
            const color = buttonLink.getAttribute('data-color') || '#ffffff';
            const link = buttonLink.getAttribute('href') || '#';
            result.button = {
              show: showButton,
              text: text,
              backgroundColor: backgroundColor,
              color: color,
              link: link,
              subBtn: subBtn ? subBtn.textContent.trim() : '',
            };
          }
          break;
        }
      }
    });

    return result;
  },
  sectionCardCompareB1(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Card Compare B1 Section',
      backgroundColor: '#ffffff',
      textColor: '#000000',
      enableAnchor: false,
      padding: {
        top: true,
        bottom: true,
      },
      headerSection: {
        show: true,
        text: '',
      },
      before: {
        image: '',
        textLabel: '',
        backgroundColorLabel: '#17d4f4',
        colorLabel: '#ffffff',
      },
      after: {
        image: '',
        textLabel: '',
        backgroundColorLabel: '#17d4f4',
        colorLabel: '#ffffff',
      },
      summarySection: {
        show: true,
        text: '',
        borderColor: '#17d4f4',
        borderWidth: '1px',
        backgroundColor: '#ffffff',
      },
      button: {
        text: '',
        backgroundColor: '#aa6d32',
        color: '#ffffff',
        show: true,
        link: '#',
        subBtn: '',
      },
    };
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Card Compare B1 Section';
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'wrapper-container': {
          const bgColor = el.getAttribute('data-background-color') || '#ffffff';
          const textColor = el.getAttribute('data-text-color') || '#000000';
          const paddingTop = el.getAttribute('data-top-padding') === 'true' ? true : false;
          const paddingBottom = el.getAttribute('data-bottom-padding') === 'true' ? true : false;
          result.backgroundColor = bgColor;
          result.textColor = textColor;
          result.padding = {
            top: paddingTop,
            bottom: paddingBottom,
          };
          break;
        }
        case 'header-section': {
          const showHeader = el.getAttribute('data-show-header') === 'true' ? true : false;
          const text = el.innerHTML.trim() || '';
          result.headerSection = {
            show: showHeader,
            text: text,
          };
          break;
        }
        case 'before': {
          const imageEl = el.querySelector('[data-attribute="image-before"]');
          const textLabelEl = el.querySelector('[data-attribute="text-before"]');
          const image = imageEl ? imageEl.getAttribute('src') || '' : '';
          const textLabel = textLabelEl ? textLabelEl.textContent.trim() || '' : '';
          const backgroundColorLabel = textLabelEl
            ? textLabelEl.getAttribute('data-background') || '#17d4f4'
            : '#17d4f4';
          const colorLabel = textLabelEl ? textLabelEl.getAttribute('data-color') || '#ffffff' : '#ffffff';
          result.before = {
            image: image,
            textLabel: textLabel,
            backgroundColorLabel: backgroundColorLabel,
            colorLabel: colorLabel,
          };
          break;
        }
        case 'after': {
          const imageEl = el.querySelector('[data-attribute="image-after"]');
          const textLabelEl = el.querySelector('[data-attribute="text-after"]');
          const image = imageEl ? imageEl.getAttribute('src') || '' : '';
          const textLabel = textLabelEl ? textLabelEl.textContent.trim() || '' : '';
          const backgroundColorLabel = textLabelEl
            ? textLabelEl.getAttribute('data-background') || '#17d4f4'
            : '#17d4f4';
          const colorLabel = textLabelEl ? textLabelEl.getAttribute('data-color') || '#ffffff' : '#ffffff';
          result.after = {
            image: image,
            textLabel: textLabel,
            backgroundColorLabel: backgroundColorLabel,
            colorLabel: colorLabel,
          };
          break;
        }
        case 'summary-section': {
          const showSummary = el.getAttribute('data-show-summary') === 'true' ? true : false;
          const text = el.innerHTML.trim() || '';
          const borderColor = el.getAttribute('data-border-color') || '#17d4f4';
          const borderWidth = el.style.borderWidth || '1px';
          const backgroundColor = el.getAttribute('data-background-color') || el.style.backgroundColor || '#ffffff';
          result.summarySection = {
            show: showSummary,
            text: text,
            borderColor: borderColor,
            borderWidth: borderWidth,
            backgroundColor: backgroundColor,
          };
          break;
        }
        case 'btn-cta': {
          const showButton = el.getAttribute('data-show-btn') === 'true' ? true : false;
          const buttonLink = el.querySelector('[data-attribute="button-link"]');
          const subBtn = el.querySelector('[data-attribute="sub-btn"]');
          if (buttonLink) {
            const text = buttonLink.textContent.trim() || '';
            const backgroundColor = buttonLink.getAttribute('data-background-color') || '#aa6d32';
            const color = buttonLink.getAttribute('data-color') || '#ffffff';
            const link = buttonLink.getAttribute('href') || '#';
            result.button = {
              show: showButton,
              text: text,
              backgroundColor: backgroundColor,
              color: color,
              link: link,
              subBtn: subBtn ? subBtn.textContent.trim() : '',
            };
          }
          break;
        }
      }
    });

    return result;
  },
  sectionBannerBasicB1(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Banner Basic B1 Section',
      textColor: '#000000',
      enableAnchor: false,
      padding: {
        top: true,
        bottom: true,
      },
      overlay: {
        color: '#000000',
        opacity: 0.5,
      },
      background: {
        color: '',
        img: '',
        imgMobile: '',
        opacity: 0,
      },
      content: {
        contentAlign: 'left',
        backgroundColor: '#281707',
        title: '',
        listItem: [],
      },
    };
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Banner Basic B1 Section';
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'wrapper-container': {
          const textColor = el.getAttribute('data-text-color') || '#000000';
          const paddingTop = el.getAttribute('data-top-padding') === 'true' ? true : false;
          const paddingBottom = el.getAttribute('data-bottom-padding') === 'true' ? true : false;
          const bgColor = el.getAttribute('data-background-color') || '';
          result.textColor = textColor;
          result.padding = {
            top: paddingTop,
            bottom: paddingBottom,
          };
          result.background.color = bgColor;
          break;
        }
        case 'background-section': {
          const bgImg = el.getAttribute('data-background-img') || '';
          const opacity = el.getAttribute('data-opacity') || 0;
          result.background.img = bgImg;
          result.background.opacity = opacity;
          break;
        }
        case 'background-section-mobile': {
          const bgImg = el.getAttribute('data-background-img') || '';
          result.background.imgMobile = bgImg;
          break;
        }
        case 'overlay-bg': {
          const color = el.getAttribute('data-color') || '#000000';
          const opacity = el.getAttribute('data-opacity') || 0.5;
          result.overlay = {
            color: color,
            opacity: opacity,
          };
          break;
        }
        case 'wrap-content': {
          const bgColor = el.getAttribute('data-background-color') || '';
          const align = el.getAttribute('data-align') || 'left';
          result.content.backgroundColor = bgColor;
          result.content.contentAlign = align;
          break;
        }
        case 'content-title': {
          result.content.title = el.innerHTML.trim();
          break;
        }
        case 'item': {
          const iconEl = el.querySelector('[data-attribute="icon"]');
          const textEl = el.querySelector('[data-attribute="item-text"]');
          const icon = iconEl ? iconEl.querySelector('img')?.getAttribute('src') || '' : '';
          const text = textEl ? textEl.textContent.trim() || '' : '';
          result.content.listItem.push({
            icon: icon,
            text: text,
          });
          break;
        }
      }
    });

    return result;
  },
  sectionTableSmallB1(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Table Small B1 Section',
      textColor: '#000000',
      enableAnchor: false,
      padding: {
        top: true,
        bottom: true,
      },
      background: {
        color: '',
      },
      titleContent: '',
      table: {
        colBorder: true,
        rowBorder: true,
        borderColor: '#c1c1c1',
        borderSpacingVertical: 0,
        borderSpacingHorizontal: 0,
        borderWeight: '1px',
        html: '',
      },
    };
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Table Small B1 Section';
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'wrapper-container': {
          const textColor = el.getAttribute('data-text-color') || '#000000';
          const paddingTop = el.getAttribute('data-top-padding') === 'true' ? true : false;
          const paddingBottom = el.getAttribute('data-bottom-padding') === 'true' ? true : false;
          const bgColor = el.getAttribute('data-background-color') || '';
          result.textColor = textColor;
          result.padding = {
            top: paddingTop,
            bottom: paddingBottom,
          };
          result.background.color = bgColor;
          break;
        }
        case 'title-content': {
          result.titleContent = el.innerHTML.trim();
          break;
        }
        case 'table-add': {
          const colBorder = el.getAttribute('data-col-border') === 'true' ? true : false;
          const rowBorder = el.getAttribute('data-row-border') === 'true' ? true : false;
          const borderColor = el.getAttribute('data-border-color') || '#c1c1c1';
          const borderSpacingVertical = parseInt(el.getAttribute('data-border-spacing-vertical')) || 0;
          const borderSpacingHorizontal = parseInt(el.getAttribute('data-border-spacing-horizontal')) || 0;
          const borderWeight = el.getAttribute('data-border-weight') || '1px';
          const tableEl = el.querySelector('table');
          const tableHtml = tableEl ? tableEl.outerHTML : '';

          result.table = {
            colBorder: colBorder,
            rowBorder: rowBorder,
            borderColor: borderColor,
            borderSpacingVertical: borderSpacingVertical,
            borderSpacingHorizontal: borderSpacingHorizontal,
            borderWeight: borderWeight,
            html: tableHtml,
          };
          break;
        }
      }
    });

    return result;
  },
  sectionIconWithTextB1(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Icon With Text B1 Section',
      textColor: '#000000',
      enableAnchor: false,
      padding: {
        top: true,
        bottom: true,
      },
      background: {
        color: '',
      },
      showTitleContent: true,
      titleContent: '',
      wapperItems: {
        contentAlign: 'center',
        colPerView: 3,
        withIcon: 60,
        listItem: [],
      },
    };
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Icon With Text B1 Section';
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'wrapper-container': {
          const textColor = el.getAttribute('data-text-color') || '#000000';
          const paddingTop = el.getAttribute('data-top-padding') === 'true' ? true : false;
          const paddingBottom = el.getAttribute('data-bottom-padding') === 'true' ? true : false;
          const bgColor = el.getAttribute('data-background-color') || '';
          result.textColor = textColor;
          result.padding = {
            top: paddingTop,
            bottom: paddingBottom,
          };
          result.background.color = bgColor;
          break;
        }
        case 'title-content': {
          const showHeader = el.getAttribute('data-show-header');
          result.showTitleContent = showHeader ? showHeader === 'true' : true;
          result.titleContent = el.innerHTML.trim();
          break;
        }
        case 'list-item': {
          const contentAlign = el.getAttribute('data-align-items') || 'center';
          const colPerView = parseInt(el.getAttribute('data-col-per-view')) || 3;
          const withIcon = parseInt(el.getAttribute('data-with-icon')) || 60;
          result.wapperItems.contentAlign = contentAlign;
          result.wapperItems.colPerView = colPerView;
          result.wapperItems.withIcon = withIcon;

          const elItems = el.querySelectorAll('[data-attribute="item"]');
          const items = Array.from(elItems).map(item => {
            const imageEl = item.querySelector('[data-attribute="image-item"]');
            const image = imageEl ? imageEl.querySelector('img')?.getAttribute('src') || '' : '';

            const textEl = item.querySelector('[data-attribute="text-item"]');
            const htmlText = textEl ? textEl.innerHTML.trim() : '';

            return {
              image: image,
              htmlText: htmlText,
            };
          });
          result.wapperItems.listItem = items;
          break;
        }
      }
    });

    return result;
  },

  sectionImageWithTextBasic(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Section Image With Text Basic',
      textColor: '#000000',
      enableAnchor: false,
      padding: {
        top: true,
        bottom: true,
      },
      background: {
        color: '#ffffff',
      },
      backgroundContent: {
        color: '#fefdf0',
      },
      titleContent: {
        htmlContent: '',
        show: true,
      },
      img: {
        src: '',
        width: 200,
        show: true,
      },
      descriptionContent: '',
    };

    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Section Image With Text Basic';
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'wrapper-container': {
          const textColor = el.getAttribute('data-text-color') || '#000000';
          const paddingTop = el.getAttribute('data-top-padding') === 'true' ? true : false;
          const paddingBottom = el.getAttribute('data-bottom-padding') === 'true' ? true : false;
          const bgColor = el.getAttribute('data-background-color') || '#ffffff';
          result.textColor = textColor;
          result.padding = {
            top: paddingTop,
            bottom: paddingBottom,
          };
          result.background.color = bgColor;
          break;
        }
        case 'wrapper-content': {
          const bgColor = el.getAttribute('data-background') || '#fefdf0';
          result.backgroundContent.color = bgColor;
          break;
        }
        case 'title-content': {
          const showTitle = el.getAttribute('data-show-title');
          result.titleContent.show = showTitle ? showTitle === 'true' : true;
          result.titleContent.htmlContent = el.innerHTML.trim();
          break;
        }
        case 'wrap-img': {
          const widthImage = el.getAttribute('data-width-image') || '200px';
          const widthNum = parseInt(
            String(widthImage)
              .replace('px', '')
              .trim(),
          );
          result.img.width = Number.isFinite(widthNum) ? widthNum : 200;
          const showImg = el.getAttribute('data-show-img');
          result.img.show = showImg ? showImg === 'true' : true;
          break;
        }
        case 'image-item': {
          const src = el.getAttribute('src') || '';
          result.img.src = src;
          break;
        }
        case 'description-content': {
          result.descriptionContent = el.innerHTML.trim();
          break;
        }
      }
    });

    return result;
  },

  //hurrybox
  sectionCountdownHurryBox(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      sectionPadding: {
        topDesktop: 0,
        bottomDesktop: 0,
        topMobile: 0,
        bottomMobile: 0,
      },
    };
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';
    }
    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'left-in-stock-number': {
          result[key] = el.textContent.trim() ? Number(el.textContent.trim()) : 0;
          break;
        }
        case 'people-are-viewing-number': {
          result[key] = el.textContent.trim() ? Number(el.textContent.trim()) : 0;
          break;
        }
        case 'last-minute-sale-end-in': {
          const value = el.getAttribute('data-value');
          result[key] = value ? Number(value) : 0;
          break;
        }
        case 'section-countdown-hurry-box': {
          result['text-color'] = el.getAttribute('data-text-color') || el.style.color;
          result['background-color'] = el.getAttribute('data-background-color') || el.style.backgroundColor || '';
          result.sectionPadding.topDesktop = el.getAttribute('data-top-desktop-padding')
            ? parseInt(el.getAttribute('data-top-desktop-padding'))
            : 0;
          result.sectionPadding.bottomDesktop = el.getAttribute('data-bottom-desktop-padding')
            ? parseInt(el.getAttribute('data-bottom-desktop-padding'))
            : 0;
          result.sectionPadding.topMobile = el.getAttribute('data-top-mobile-padding')
            ? parseInt(el.getAttribute('data-top-mobile-padding'))
            : 0;
          result.sectionPadding.bottomMobile = el.getAttribute('data-bottom-mobile-padding')
            ? parseInt(el.getAttribute('data-bottom-mobile-padding'))
            : 0;
          break;
        }
        default:
          break;
      }
    });
    return result;
  },
  sectionFreestyleHurryBox(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      sectionPadding: {
        topDesktop: 0,
        bottomDesktop: 0,
        topMobile: 0,
        bottomMobile: 0,
      },
    };

    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'content': {
          result[key] = el.innerHTML.trim();
          result['text-color'] = el.getAttribute('data-text-color') || el.style.color;
          result['background-color'] = el.getAttribute('data-background-color') || el.style.backgroundColor || '';
          result.sectionPadding.topDesktop = el.getAttribute('data-top-desktop-padding')
            ? parseInt(el.getAttribute('data-top-desktop-padding'))
            : 0;
          result.sectionPadding.bottomDesktop = el.getAttribute('data-bottom-desktop-padding')
            ? parseInt(el.getAttribute('data-bottom-desktop-padding'))
            : 0;
          result.sectionPadding.topMobile = el.getAttribute('data-top-mobile-padding')
            ? parseInt(el.getAttribute('data-top-mobile-padding'))
            : 0;
          result.sectionPadding.bottomMobile = el.getAttribute('data-bottom-mobile-padding')
            ? parseInt(el.getAttribute('data-bottom-mobile-padding'))
            : 0;
          break;
        }
        default:
          break;
      }
    });

    return result;
  },
  sectionHarryboxYuri(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Hurrybox Yuri',
      'title-card': '',
      'show-title': true,
      'background-icon': '#cb6387',
      'background-color': '#ffffff',
      'text-color': '#000000',
      enableContainerPage: true,
      topPadding: true,
      bottomPadding: true,
      listItem: [],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : result.title;
    }

    const wrapperEl = doc.querySelector('[data-attribute="card-container"]');
    if (wrapperEl) {
      result['background-color'] =
        wrapperEl.getAttribute('data-background') || wrapperEl.style.backgroundColor || '#ffffff';
      result['text-color'] = wrapperEl.getAttribute('data-text-color') || wrapperEl.style.color || '#000000';
      const topPadding = wrapperEl.getAttribute('data-top-padding');
      const bottomPadding = wrapperEl.getAttribute('data-bottom-padding');
      result.topPadding = topPadding ? topPadding === 'true' : true;
      result.bottomPadding = bottomPadding ? bottomPadding === 'true' : true;
    }

    const titleCardEl = doc.querySelector('[data-attribute="title-card"]');
    if (titleCardEl) {
      const showTitle = titleCardEl.getAttribute('data-show-title');
      result['show-title'] = showTitle ? showTitle === 'true' : true;
      result['title-card'] = titleCardEl.innerHTML.trim();
    }

    const containerPageEl = doc.querySelector('[data-attribute="container-page"]');
    if (containerPageEl) {
      const enableContainerPage = containerPageEl.getAttribute('data-enable-style');
      result.enableContainerPage = enableContainerPage ? enableContainerPage === 'true' : false;
      const backgroundContainer = containerPageEl.getAttribute('data-background-container');
      result.backgroundContainer = backgroundContainer ? backgroundContainer : '#ffffff';
    }

    const listItemEl = doc.querySelector('[data-attribute="list-item"]');
    if (listItemEl) {
      result['background-icon'] =
        listItemEl.getAttribute('data-background-icon') ||
        listItemEl.style.getPropertyValue('--background-icon') ||
        '#cb6387';
    }

    const itemEls = doc.querySelectorAll('[data-attribute="item"]');
    result.listItem = Array.from(itemEls).map(itemEl => {
      const iconEl = itemEl.querySelector('[data-attribute="icon-item"]');
      const textEl = itemEl.querySelector('[data-attribute="text-item"]');
      return {
        iconItem: iconEl ? iconEl.getAttribute('src') || '' : '',
        textItem: textEl ? textEl.innerHTML.trim() : '',
      };
    });

    return result;
  },
  sectionProductReviews(htmlString, type) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');

    const dividerEl = doc.querySelector('[data-attribute="divider-primary"]');
    const dividerData = dividerEl
      ? extractDividerPrimary(dividerEl.outerHTML)
      : { show: true, maxWidth: 200, height: 6, backgroundColor: '#E0E0E0', align: 'center' };

    const accordionEl = doc.querySelector('[data-attribute="accordion-primary-title"]');
    const accordionData = accordionEl
      ? extractAccordionPrimary(accordionEl.outerHTML)
      : {
          open: true,
          title: '',
          backgroundColor: '#ffffff',
          color: '#000000',
          icon: {
            type: 'plus-minus',
            position: 'right',
            show: true,
          },
        };

    const commonData = {
      'recommend-count': 2,
      'average-rating': 5.0,
      'total-reviewers': 10,
      'load-more-background': '#000000',
      'load-more-text-color': '#ffffff',
      'card-text-color': '#000000',
      'star-color': '#f0b100',
      'body-reviews': [],
      topPadding: true,
      bottomPadding: true,
    };
    const defaultDataByType = {
      [sectionType.sectionProductReviews]: {
        ...commonData,
        title: 'Product Reviews Section',
        'title-review': '<h2><strong>Reviews</strong></h2>',
        'load-more-label': 'Load more',
        'reviews-limit': 5,
        'overview-background': '#ffffff',
        'container-background': '#f3f4f6',
        'card-background': '#ffffff',
        buttonBorderColor: '#000000',
        buttonBorderRadius: 8,
      },
      [sectionType.sectionProductReviews02]: {
        ...commonData,
        title: 'Product Reviews Section 2',
        'title-review': '<h2 style="text-align: center;"><strong>What Customers Are Saying...</strong></h2>',
        'load-more-label': 'Show more reviews',
        'reviews-limit': 6,
        'overview-background': '#ffffff',
        'container-background': '#ffffff',
        'card-background': '#ffffff',
        buttonBorderColor: '#000000',
        buttonBorderRadius: 0,
      },
      [sectionType.sectionProductReviews03]: {
        ...commonData,
        title: 'Product Reviews Section 3',
        'title-review':
          '<h2 style="text-align: center;"><strong>See What Airmoto Customers Are Saying</strong></h2><p style="text-align: center;">Over 1.5 Million Units Sold and Over 25,545+ Customer Reviews</p>',
        'load-more-label': 'Show more reviews',
        'reviews-limit': 6,
        'overview-background': '#ffffff',
        'container-background': '#ffffff',
        'card-background': '#ffffff',
        buttonBorderColor: '#000000',
        buttonBorderRadius: 8,
      },
      [sectionType.sectionProductReviews04]: {
        ...commonData,
        title: 'Product Reviews Section 4',
        'title-review': '',
        'load-more-label': 'Show more reviews',
        'reviews-limit': 5,
        'overview-background': '#ffffff',
        'container-background': '#f7f7f7',
        'card-background': '#ffffff',
        product: {
          image: '',
          name: '',
          title: '',
          enabled: true,
        },
        'load-more-background': '#ffffff',
        'load-more-text-color': '#000000',
        buttonBorderColor: '#d9d9d9',
        buttonBorderRadius: 0,
      },
      [sectionType.sectionProductReviews05]: {
        ...commonData,
        title: 'Product Reviews Section 5',
        'title-review': '',
        'load-more-label': 'Show more reviews',
        'reviews-limit': 8,
        'overview-background': '#ffffff',
        'container-background': '#ffffff',
        'card-background': '#ffffff',
        'load-more-background': '#ffffff',
        'load-more-text-color': '#000000',
        buttonBorderColor: '#d9d9d9',
        buttonBorderRadius: 0,
      },
      [sectionType.sectionProductReviews06]: {
        ...commonData,
        title: 'Product Reviews Section 6',
        'title-review': '',
        'load-more-label': 'Load more',
        'reviews-limit': 8,
        'overview-background': '#ffffff',
        'container-background': '#ffffff',
        'card-background': '#ffffff',
        'load-more-background': '#ffffff',
        'load-more-text-color': '#000000',
        buttonBorderColor: '#d9d9d9',
        buttonBorderRadius: 4,
        'rate-distribution': {
          'rate-5': commonData['total-reviewers'],
          'rate-4': 0,
          'rate-3': 0,
          'rate-2': 0,
          'rate-1': 0,
        },
      },
      [sectionType.sectionFastvaluedealReviews]: {
        ...commonData,
        title: 'Fastvaluedeal Reviews Section',
        'title-review': '',
        'load-more-label': 'Load more',
        'reviews-limit': 10,
        'overview-background': '#ffffff',
        'container-background': '#ffffff',
        'card-background': '#ffffff',
        'load-more-background': '#ffffff',
        'load-more-text-color': '#000000',
        buttonBorderColor: '#d9d9d9',
        buttonBorderRadius: 0,
        'rate-distribution': {
          'rate-5': commonData['total-reviewers'],
          'rate-4': 0,
          'rate-3': 0,
          'rate-2': 0,
          'rate-1': 0,
        },
        'star-color': '#0db793',
        'total-reviewers': 15,
        'show-title-underline': true,
        divider: {
          ...dividerData,
        },
      },
      [sectionType.sectionGatorzReviews]: {
        ...commonData,
        title: 'Gatorz Reviews',
        'title-review': '',
        'load-more-label': 'Load more',
        'reviews-limit': 8,
        'overview-background': '#ffffff',
        'container-background': '#ffffff',
        'card-background': '#ffffff',
        'load-more-background': '#ffffff',
        'load-more-text-color': '#000000',
        buttonBorderColor: '#d9d9d9',
        buttonBorderRadius: 4,
        'rate-distribution': {
          'rate-5': commonData['total-reviewers'],
          'rate-4': 0,
          'rate-3': 0,
          'rate-2': 0,
          'rate-1': 0,
        },
        divider: {
          ...dividerData,
        },
        accordion: {
          ...accordionData,
        },
      },
      [sectionType.sectionSaintbrandReviews]: {
        ...commonData,
        title: 'Saintbrand Reviews',
        'title-review': '',
        'load-more-label': 'Load more',
        'reviews-limit': 8,
        'overview-background': '#ffffff',
        'container-background': '#ffffff',
        'card-background': '#ffffff',
        'load-more-background': '#ffffff',
        'load-more-text-color': '#000000',
        buttonBorderColor: '#d9d9d9',
        buttonBorderRadius: 4,
        'rate-distribution': {
          'rate-5': commonData['total-reviewers'],
          'rate-4': 0,
          'rate-3': 0,
          'rate-2': 0,
          'rate-1': 0,
        },
      },
      [sectionType.sectionLosaprilyReviews]: {
        ...commonData,
        title: 'Losaprily Reviews',
        'title-review': '',
        'load-more-label': 'Load more',
        'reviews-limit': 10,
        'overview-background': '#ffffff',
        'container-background': '#ffffff',
        'card-background': '#ffffff',
        'load-more-background': '#ffffff',
        'load-more-text-color': '#000000',
        buttonBorderColor: '#d9d9d9',
        buttonBorderRadius: 4,
        'rate-distribution': {
          'rate-5': commonData['total-reviewers'],
          'rate-4': 0,
          'rate-3': 0,
          'rate-2': 0,
          'rate-1': 0,
        },
      },
    };

    const result = {
      'reviews-limit': defaultDataByType[type]['reviews-limit'],
      ...(type === sectionType.sectionProductReviews04 ? { product: { ...defaultDataByType[type].product } } : {}),
      ...(type === sectionType.sectionFastvaluedealReviews ? { divider: { ...defaultDataByType[type].divider } } : {}),
      ...(type === sectionType.sectionGatorzReviews
        ? { divider: { ...defaultDataByType[type].divider }, accordion: { ...defaultDataByType[type].accordion } }
        : {}),
    };

    // Extract product data for product reviews section 4
    if (type === sectionType.sectionProductReviews04) {
      const productEl = doc.querySelector('.review-product-container');
      if (productEl) {
        const productImageEl = productEl.querySelector('.review-product-image');
        const productTitleEl = productEl.querySelector('.review-product-info-title');
        const productNameEl = productEl.querySelector('.review-product-info-name');
        const enabledAttr = productEl.getAttribute('data-product-enabled');

        result.product.image = productImageEl?.getAttribute('src') || '';
        result.product.name = productNameEl?.textContent.trim() || '';
        result.product.title = productTitleEl?.textContent.trim() || '';
        result.product.enabled = enabledAttr ? enabledAttr === 'true' : true;
      }
    }

    const averageRatingEl = doc.querySelector('.rating-score');
    const totalReviewersEl = doc.querySelector('.reviewers-count');
    const sectionEl = doc.querySelector('[data-section]');
    const elements = doc.querySelectorAll('[data-attribute]');

    if (averageRatingEl) {
      result['average-rating'] =
        parseFloat(averageRatingEl.getAttribute('data-average-rating')) || defaultDataByType[type]['average-rating'];
    }

    if (totalReviewersEl) {
      result['total-reviewers'] =
        parseInt(totalReviewersEl.getAttribute('data-total-reviewers')) || defaultDataByType[type]['total-reviewers'];
    }

    const sectionTypesWithRateDistribution = [
      sectionType.sectionProductReviews06,
      sectionType.sectionGatorzReviews,
      sectionType.sectionSaintbrandReviews,
      sectionType.sectionLosaprilyReviews,
      sectionType.sectionFastvaluedealReviews,
    ];

    // Extract rate distribution for section types valid
    if (sectionTypesWithRateDistribution.includes(type)) {
      const rateItems = doc.querySelectorAll('.rate-item[data-rate-value]');
      if (rateItems && rateItems.length) {
        result['rate-distribution'] = {
          'rate-5': 0,
          'rate-4': 0,
          'rate-3': 0,
          'rate-2': 0,
          'rate-1': 0,
        };
        rateItems.forEach(item => {
          const rateValue = parseInt(item.getAttribute('data-rate-value'), 10);
          if (!rateValue || rateValue < 1 || rateValue > 5) return;
          const countEl = item.querySelector('.rate-count');
          const count = countEl ? parseInt(countEl.textContent, 10) : 0;
          result['rate-distribution'][`rate-${rateValue}`] = isNaN(count) ? 0 : count;
        });
      }
    }

    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : defaultDataByType[type]['title'];
    }
    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'product-reviews-container': {
          result['container-background'] =
            el.getAttribute('data-container-background') || defaultDataByType[type]['container-background'];
          result.topPadding = el.getAttribute('data-top-padding') === 'true' ? true : false;
          result.bottomPadding = el.getAttribute('data-bottom-padding') === 'true' ? true : false;
          result['card-background'] =
            el.getAttribute('data-card-background') || defaultDataByType[type]['card-background'];
          result['card-text-color'] =
            el.getAttribute('data-card-text-color') || defaultDataByType[type]['card-text-color'];
          result['star-color'] = el.getAttribute('data-star-color') || defaultDataByType[type]['star-color'];
          break;
        }
        case 'review-title': {
          result['title-review'] = el.innerHTML.trim();
          result['show-title-underline'] = el.getAttribute('data-show-title-underline') === 'true' ? true : false;
          break;
        }
        case 'recommendation-score': {
          result['recommend-count'] =
            parseInt(el.getAttribute('data-recommend-count')) || defaultDataByType[type]['recommend-count'];
          break;
        }
        case 'load-more-btn': {
          result['load-more-label'] = el.textContent.trim() || defaultDataByType[type]['load-more-label'];
          result['load-more-background'] =
            el.getAttribute('data-load-more-background') || defaultDataByType[type]['load-more-background'];
          result['load-more-text-color'] =
            el.getAttribute('data-load-more-text-color') || defaultDataByType[type]['load-more-text-color'];
          const limit = el.getAttribute('data-limit');
          result['reviews-limit'] = limit ? parseInt(limit) : 5;
          result.buttonBorderColor =
            el.getAttribute('data-button-border-color') || defaultDataByType[type]['buttonBorderColor'];
          result.buttonBorderRadius =
            el.getAttribute('data-button-border-radius') || defaultDataByType[type]['buttonBorderRadius'];
          break;
        }
      }
    });

    // Extract review items
    const reviewItems = doc.querySelectorAll('.review-item');
    result['body-reviews'] = Array.from(reviewItems).map(item => {
      const avatar = item.querySelector('[data-attribute="product-reviewer-avatar"]');
      const name = item.querySelector('.reviewer-name');
      const date = item.querySelector('.review-date');
      const rating = item.querySelector('.review-rating');
      const title = item.querySelector('.review-title');
      const content = item.querySelector('.review-content');

      const dateText = date ? date.textContent.trim() : new Date().toLocaleString();
      let dateValue;
      if (date && dateText) {
        const parsedDate = new Date(dateText);
        // Check if the date is valid
        if (!isNaN(parsedDate.getTime())) {
          dateValue = parsedDate.toISOString().substr(0, 10);
        } else {
          // Fallback to current date if parsing fails
          dateValue = new Date().toISOString().substr(0, 10);
        }
      } else {
        dateValue = new Date().toISOString().substr(0, 10);
      }

      // Extract review images
      const reviewImagesEl = item.querySelector('[data-attribute="review-images"]');
      let images = [];
      if (reviewImagesEl) {
        const imageItems = reviewImagesEl.querySelectorAll('.review-image-item');
        images = Array.from(imageItems).map(imageItem => {
          const img = imageItem.querySelector('img');
          return {
            src: img ? img.getAttribute('src') || '' : '',
          };
        });
      }

      return {
        avatar: avatar ? avatar.getAttribute('src') : '',
        fullName: name ? name.textContent.trim() : '',
        date: dateText,
        dateValue: dateValue,
        star: rating ? parseInt(rating.getAttribute('data-value')) || 5 : 5,
        title: title ? title.textContent.trim() : '',
        content: content ? content.innerHTML.trim() : '',
        images: images,
      };
    });

    // Sort reviews by date (newest first)
    result['body-reviews'].sort((a, b) => {
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);
      // Handle invalid dates
      if (isNaN(dateA.getTime())) return 1;
      if (isNaN(dateB.getTime())) return -1;
      return dateB.getTime() - dateA.getTime(); // Newest first
    });

    // <-- TODO: If total-reviewers is not set, Calculate rating summary from extracted reviews -->
    // const reviews = result['body-reviews']
    // if (reviews.length > 0) {
    //   const averageRating = reviews.reduce((sum, review) => sum + review.star, 0) / reviews.length
    //   result['average-rating'] = parseFloat(averageRating.toFixed(1))
    //   result['total-reviewers'] = reviews.length
    // } else {
    //   result['average-rating'] = 5.0
    //   result['total-reviewers'] = 0
    // }

    return result;
  },
  sectionSizingChartHurryBox(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: '',
      accordions: {
        listItem: [
          // {
          //   title: '',
          //   textContent: '',
          //   imageContent: '',
          //   enableImage: false,
          // },
        ],
      },
      'border-color': '#000000',
      'border-weight': '2px',
      'border-enabled': true,
      'title-color': '#000000',
      sectionPadding: {
        topDesktop: 0,
        bottomDesktop: 0,
        topMobile: 0,
        bottomMobile: 0,
      },
    };
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';
    }

    // Extract border and padding settings from card-container
    const cardContainer = doc.querySelector('[data-attribute="card-container"]');
    if (cardContainer) {
      result.sectionPadding.topDesktop = cardContainer.getAttribute('data-top-desktop-padding')
        ? parseInt(cardContainer.getAttribute('data-top-desktop-padding'))
        : 16;
      result.sectionPadding.bottomDesktop = cardContainer.getAttribute('data-bottom-desktop-padding')
        ? parseInt(cardContainer.getAttribute('data-bottom-desktop-padding'))
        : 0;
      result.sectionPadding.topMobile = cardContainer.getAttribute('data-top-mobile-padding')
        ? parseInt(cardContainer.getAttribute('data-top-mobile-padding'))
        : 16;
      result.sectionPadding.bottomMobile = cardContainer.getAttribute('data-bottom-mobile-padding')
        ? parseInt(cardContainer.getAttribute('data-bottom-mobile-padding'))
        : 0;
      const borderColor = cardContainer.getAttribute('data-border-color');
      if (borderColor) {
        result['border-color'] = borderColor;
      } else {
        const firstAccordion = doc.querySelector('[data-attribute="card-accordion"]');
        if (firstAccordion) {
          const borderStyle = firstAccordion.getAttribute('style') || '';
          const borderMatch = borderStyle.match(/border[^:]*:\s*solid\s+\d+px\s+([^;]+)/);
          if (borderMatch) {
            result['border-color'] = borderMatch[1].trim();
          }
        }
      }

      const borderWeight = cardContainer.getAttribute('data-border-weight');
      if (borderWeight) {
        result['border-weight'] = borderWeight;
      } else {
        const firstAccordion = doc.querySelector('[data-attribute="card-accordion"]');
        if (firstAccordion) {
          const borderStyle = firstAccordion.getAttribute('style') || '';
          const borderMatch = borderStyle.match(/border[^:]*:\s*solid\s+(\d+px)\s+/);
          if (borderMatch) {
            result['border-weight'] = borderMatch[1];
          }
        }
      }

      const borderEnabled = cardContainer.getAttribute('data-border-enabled');
      if (borderEnabled !== null) {
        result['border-enabled'] = borderEnabled === 'true';
      } else {
        const firstAccordion = doc.querySelector('[data-attribute="card-accordion"]');
        if (firstAccordion) {
          const borderStyle = firstAccordion.getAttribute('style') || '';
          result['border-enabled'] = !borderStyle.includes('border: none') && !borderStyle.includes('border:none');
        }
      }

      const titleColor = cardContainer.getAttribute('data-title-color');
      if (titleColor) {
        result['title-color'] = titleColor;
      } else {
        // Try to extract from first accordion title
        const firstAccordionTitle = doc.querySelector('[data-attribute="accordion-title"]');
        if (firstAccordionTitle) {
          const titleColorAttr = firstAccordionTitle.getAttribute('data-title-color');
          if (titleColorAttr) {
            result['title-color'] = titleColorAttr;
          } else {
            const titleStyle = firstAccordionTitle.getAttribute('style') || '';
            const colorMatch = titleStyle.match(/color:\s*([^;]+)/);
            if (colorMatch) {
              result['title-color'] = colorMatch[1].trim();
            }
          }
        }
      }
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'card-accordions': {
          const showAccordion = el.getAttribute('data-show-accordion');
          result.accordions.show = showAccordion ? showAccordion === 'true' : false;
          const elItems = el.querySelectorAll('[data-attribute="card-accordion"]');
          const itemsAccordions = Array.from(elItems).map(item => {
            const title = item.querySelector('[data-attribute="accordion-title"]')?.textContent.trim() || '';
            const textContent = item.querySelector('[data-attribute="accordion-text"]')?.innerHTML.trim() || '';
            const imageContent = item.querySelector('[data-attribute="image-content"]')?.getAttribute('src') || '';
            const enableImage =
              item.querySelector('[data-attribute="wrap-image"]')?.getAttribute('data-show-image') === 'true';
            return {
              title,
              textContent,
              imageContent,
              enableImage,
            };
          });
          result.accordions.listItem = itemsAccordions;
          break;
        }
      }
    });
    return result;
  },

  //order policy
  sectionGuaranteedSafeCheckout(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Safe Checkout',
      content: '',
      'text-color': '',
      'background-color': '',
      sectionPadding: {
        topDesktop: 0,
        bottomDesktop: 0,
        topMobile: 0,
        bottomMobile: 0,
      },
    };

    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Safe Checkout';
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'content': {
          result[key] = el.innerHTML.trim();
          result['text-color'] = el.getAttribute('data-text-color') || el.style.color;
          result['background-color'] = el.getAttribute('data-background-color') || el.style.backgroundColor || '';
          result.sectionPadding.topDesktop = el.getAttribute('data-top-desktop-padding')
            ? parseInt(el.getAttribute('data-top-desktop-padding'))
            : 0;
          result.sectionPadding.bottomDesktop = el.getAttribute('data-bottom-desktop-padding')
            ? parseInt(el.getAttribute('data-bottom-desktop-padding'))
            : 0;
          result.sectionPadding.topMobile = el.getAttribute('data-top-mobile-padding')
            ? parseInt(el.getAttribute('data-top-mobile-padding'))
            : 0;
          result.sectionPadding.bottomMobile = el.getAttribute('data-bottom-mobile-padding')
            ? parseInt(el.getAttribute('data-bottom-mobile-padding'))
            : 0;
          break;
        }
        default:
          break;
      }
    });

    return result;
  },
  sectionOrderInfo(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Order Info',
      'text-color': '#000000',
      'background-color': '#ffffff',
      'pagination-active-color': '#000000',
      'pagination-inactive-color': '#cccccc',
      'timeline-enabled': true,
      'timeline-ordered-text': 'Ordered',
      'timeline-shipping-text': 'Shipping',
      'timeline-delivered-text': 'Delivered',
      'timeline-shipping-days': 10,
      'timeline-delivery-days': 5,
      'accordion-enabled': true,
      'accordion-hover-color': '#f3f4f6',
      'accordion-border-color': '#e5e7eb',
      'accordion-items': [],
      'reviews-enabled': true,
      'body-review': [],
      sectionPadding: {
        topDesktop: 16,
        bottomDesktop: 0,
        topMobile: 16,
        bottomMobile: 0,
      },
    };

    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Order Info';
    }

    // Extract container colors
    const containerEl = doc.querySelector('[data-attribute="order-info"]');
    if (containerEl) {
      result['text-color'] = containerEl.getAttribute('data-text-color') || containerEl.style.color || '#000000';
      result['background-color'] =
        containerEl.getAttribute('data-background-color') || containerEl.style.backgroundColor || '#ffffff';
      result['pagination-active-color'] = containerEl.getAttribute('data-pagination-active-color') || '#000000';
      result['pagination-inactive-color'] = containerEl.getAttribute('data-pagination-inactive-color') || '#cccccc';
      result.sectionPadding.topDesktop = containerEl.getAttribute('data-top-desktop-padding')
        ? parseInt(containerEl.getAttribute('data-top-desktop-padding'))
        : 16;
      result.sectionPadding.bottomDesktop = containerEl.getAttribute('data-bottom-desktop-padding')
        ? parseInt(containerEl.getAttribute('data-bottom-desktop-padding'))
        : 0;
      result.sectionPadding.topMobile = containerEl.getAttribute('data-top-mobile-padding')
        ? parseInt(containerEl.getAttribute('data-top-mobile-padding'))
        : 16;
      result.sectionPadding.bottomMobile = containerEl.getAttribute('data-bottom-mobile-padding')
        ? parseInt(containerEl.getAttribute('data-bottom-mobile-padding'))
        : 0;
    }

    // Extract timeline data
    const timelineEl = doc.querySelector('.timeline');
    if (timelineEl) {
      // Extract timeline enabled state
      const timelineEnabled = timelineEl.getAttribute('data-timeline-enabled');
      result['timeline-enabled'] = timelineEnabled ? timelineEnabled === 'true' : true;

      // Extract shipping and delivery days
      const shippingDays = timelineEl.getAttribute('data-timeline-shipping-days');
      result['timeline-shipping-days'] = shippingDays ? parseInt(shippingDays) : 10;

      const deliveryDays = timelineEl.getAttribute('data-timeline-delivery-days');
      result['timeline-delivery-days'] = deliveryDays ? parseInt(deliveryDays) : 5;

      // Extract timeline colors
      const circleBgColor = timelineEl.getAttribute('data-timeline-circle-bg-color');
      const svgColor = timelineEl.getAttribute('data-timeline-svg-color');
      const lineColor = timelineEl.getAttribute('data-timeline-line-color');
      result['timeline-circle-bg-color'] = circleBgColor || '#000000';
      result['timeline-svg-color'] = svgColor || '#ffffff';
      result['timeline-line-color'] = lineColor || '#000000';

      const timelineSteps = timelineEl.querySelectorAll('.timeline-step');
      if (timelineSteps.length >= 3) {
        // Extract ordered text
        const orderedTextEl = timelineSteps[0].querySelector('.timeline-text p:last-child');
        if (orderedTextEl) {
          result['timeline-ordered-text'] = orderedTextEl.textContent.trim();
        }

        // Extract shipping text
        const shippingTextEl = timelineSteps[1].querySelector('.timeline-text p:last-child');
        if (shippingTextEl) {
          result['timeline-shipping-text'] = shippingTextEl.textContent.trim();
        }

        // Extract delivered text
        const deliveredTextEl = timelineSteps[2].querySelector('.timeline-text p:last-child');
        if (deliveredTextEl) {
          result['timeline-delivered-text'] = deliveredTextEl.textContent.trim();
        }
      }
    }

    // Extract accordion data
    const accordionEl = doc.querySelector('.accordion');
    if (accordionEl) {
      // Extract accordion enabled state and colors
      const accordionEnabled = accordionEl.getAttribute('data-accordion-enabled');
      result['accordion-enabled'] = accordionEnabled ? accordionEnabled === 'true' : true;

      const accordionHoverColor = accordionEl.getAttribute('data-accordion-hover-color');
      result['accordion-hover-color'] = accordionHoverColor || '#f3f4f6';

      const accordionBorderColor = accordionEl.getAttribute('data-accordion-border-color');
      result['accordion-border-color'] = accordionBorderColor || '#e5e7eb';

      const accordionItems = accordionEl.querySelectorAll('.accordion-item');
      accordionItems.forEach(item => {
        const headerEl = item.querySelector('.accordion-header');
        const contentEl = item.querySelector('.accordion-content');

        if (headerEl && contentEl) {
          const titleEl = headerEl.querySelector('.accordion-title');
          if (titleEl && contentEl) {
            const accordionItem = {
              title: titleEl.textContent.trim(),
              content: contentEl.innerHTML.trim(),
            };
            result['accordion-items'].push(accordionItem);
          }
        }
      });
    }

    // Extract reviews slider
    const reviewWrapper = doc.querySelector('.policy-review-grid-wrapper');
    if (reviewWrapper) {
      // enabled: hidden if display none
      const display = (reviewWrapper.style && reviewWrapper.style.display) || '';
      result['reviews-enabled'] = display !== 'none';

      const bodyReview = reviewWrapper.querySelector('[data-attribute="body-review"]') || reviewWrapper;
      const items = bodyReview.querySelectorAll('[data-attribute="item-review"]');
      items.forEach(el => {
        const reviewerAvatar = el.querySelector('[data-attribute="reviewer-avatar"]');
        const reviewerName = el.querySelector('[data-attribute="reviewer-name"]');
        const ratingStars = el.querySelector('[data-attribute="rating-stars"]');
        const reviewContent = el.querySelector('[data-attribute="review-content"]');

        const reviewItem = {
          avatar: reviewerAvatar ? reviewerAvatar.getAttribute('src') : '',
          name: reviewerName ? reviewerName.textContent.trim() : '',
          rating: ratingStars ? parseInt(ratingStars.getAttribute('data-value')) || 5 : 5,
          content: reviewContent ? reviewContent.innerHTML.trim() : '',
        };
        result['body-review'].push(reviewItem);
      });
    }

    return result;
  },

  sectionPolicyAccordionBasic(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Policy Accordion Basic Section',
      enableAnchor: false,
      textColor: '#000000',
      padding: {
        top: true,
        bottom: true,
      },
      'background-section': {
        color: '#ffffff',
      },
      'container-content': {
        showStyle: false,
        background: '#ffffff',
      },
      itemAccordions: {
        dataShowAccordion: true,
        listItem: [],
      },
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : result.title;
    }

    const elements = doc.querySelectorAll('[data-attribute]');
    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'card-container': {
          const background = el.getAttribute('data-background') || el.style.backgroundColor || '#ffffff';
          result['background-section'].color = background;
          const textColor = el.getAttribute('data-text-color');
          if (textColor) result.textColor = textColor;
          result.padding.top = el.getAttribute('data-top-padding') === 'true';
          result.padding.bottom = el.getAttribute('data-bottom-padding') === 'true';
          break;
        }
        case 'container-page': {
          const showStyle = el.getAttribute('data-show-style');
          result['container-content'].showStyle = showStyle ? showStyle === 'true' : false;
          const background = el.getAttribute('data-background');
          result['container-content'].background = background ? background : '#ffffff';
          break;
        }
        case 'card-accordions': {
          const showAccordion = el.getAttribute('data-show-accordion');
          result.itemAccordions.dataShowAccordion = showAccordion ? showAccordion === 'true' : true;
          const items = el.querySelectorAll('[data-attribute="card-accordion"]');
          result.itemAccordions.listItem = Array.from(items).map(item => {
            const title = item.querySelector('[data-attribute="accordion-title-text"]')?.textContent?.trim() || '';
            const answer = item.querySelector('[data-attribute="accordion-text"]')?.innerHTML?.trim() || '';
            return { title, answer };
          });
          break;
        }
        default:
          break;
      }
    });

    return result;
  },

  sectionPolicyYuriAccordion(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Policy Yuri Accordion Section',
      enableAnchor: false,
      textColor: '#000000',
      padding: {
        top: true,
        bottom: true,
      },
      'background-section': {
        color: '#ffffff',
      },
      'container-content': {
        showStyle: false,
        background: '#ffffff',
      },
      'show-title': true,
      'title-card': '',
      itemAccordions: {
        dataShowAccordion: true,
        listItem: [],
      },
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : result.title;
    }

    const elements = doc.querySelectorAll('[data-attribute]');
    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'card-container': {
          const background = el.getAttribute('data-background') || el.style.backgroundColor || '#ffffff';
          result['background-section'].color = background;
          const textColor = el.getAttribute('data-text-color');
          if (textColor) result.textColor = textColor;
          result.padding.top = el.getAttribute('data-top-padding') === 'true';
          result.padding.bottom = el.getAttribute('data-bottom-padding') === 'true';
          break;
        }
        case 'container-page': {
          const showStyle = el.getAttribute('data-show-style') || el.getAttribute('data-enable-style');
          result['container-content'].showStyle = showStyle ? showStyle === 'true' : false;
          const background =
            el.getAttribute('data-background') || el.getAttribute('data-background-container') || '#ffffff';
          result['container-content'].background = background;
          break;
        }
        case 'card-title': {
          const showTitle = el.getAttribute('data-show-title');
          result['show-title'] = showTitle ? showTitle === 'true' : true;
          result['title-card'] = el.innerHTML.trim();
          break;
        }
        case 'card-accordions': {
          const showAccordion = el.getAttribute('data-show-accordion');
          result.itemAccordions.dataShowAccordion = showAccordion ? showAccordion === 'true' : true;
          const items = el.querySelectorAll('[data-attribute="card-accordion"]');
          result.itemAccordions.listItem = Array.from(items).map(item => {
            const title = item.querySelector('[data-attribute="accordion-title-text"]')?.textContent?.trim() || '';
            const answer = item.querySelector('[data-attribute="accordion-text"]')?.innerHTML?.trim() || '';
            return { title, answer };
          });
          break;
        }
        default:
          break;
      }
    });

    return result;
  },

  sectionPolicyYuriList(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Policy Yuri List Section',
      'title-card': '',
      'show-title': true,
      'background-icon': '#cb6387',
      'background-color': '#ffffff',
      'text-color': '#000000',
      enableContainerPage: true,
      topPadding: true,
      bottomPadding: true,
      listItem: [],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : result.title;
    }

    const wrapperEl = doc.querySelector('[data-attribute="card-container"]');
    if (wrapperEl) {
      result['background-color'] =
        wrapperEl.getAttribute('data-background') || wrapperEl.style.backgroundColor || '#ffffff';
      result['text-color'] = wrapperEl.getAttribute('data-text-color') || wrapperEl.style.color || '#000000';
      const topPadding = wrapperEl.getAttribute('data-top-padding');
      const bottomPadding = wrapperEl.getAttribute('data-bottom-padding');
      result.topPadding = topPadding ? topPadding === 'true' : true;
      result.bottomPadding = bottomPadding ? bottomPadding === 'true' : true;
    }

    const titleCardEl = doc.querySelector('[data-attribute="card-title"]');
    if (titleCardEl) {
      const showTitle = titleCardEl.getAttribute('data-show-title');
      result['show-title'] = showTitle ? showTitle === 'true' : true;
      result['title-card'] = titleCardEl.innerHTML.trim();
    }

    const containerPageEl = doc.querySelector('[data-attribute="container-page"]');
    if (containerPageEl) {
      const enableContainerPage = containerPageEl.getAttribute('data-enable-style');
      result.enableContainerPage = enableContainerPage ? enableContainerPage === 'true' : false;
      const backgroundContainer = containerPageEl.getAttribute('data-background-container');
      result.backgroundContainer = backgroundContainer ? backgroundContainer : '#ffffff';
    }

    const listItemEl = doc.querySelector('[data-attribute="list-item"]');
    if (listItemEl) {
      result['background-icon'] =
        listItemEl.getAttribute('data-background-icon') ||
        listItemEl.style.getPropertyValue('--background-icon') ||
        '#cb6387';
    }

    const itemEls = doc.querySelectorAll('[data-attribute="item"]');
    result.listItem = Array.from(itemEls).map(itemEl => {
      const iconEl = itemEl.querySelector('[data-attribute="icon-item"]');
      const textEl = itemEl.querySelector('[data-attribute="text-item"]') || itemEl.querySelector('.text-right-item');
      return {
        iconItem: iconEl ? iconEl.getAttribute('src') || '' : '',
        textItem: textEl ? textEl.innerHTML.trim() : '',
      };
    });

    return result;
  },

  sectionPolicyYuriVideos(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Policy Yuri Videos Section',
      'title-card': '',
      'show-title': true,
      'background-color': '#ffffff',
      'text-color': '#000000',
      enableContainerPage: true,
      topPadding: true,
      bottomPadding: true,
      listItem: [],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : result.title;
    }

    const wrapperEl = doc.querySelector('[data-attribute="card-container"]');
    if (wrapperEl) {
      result['background-color'] =
        wrapperEl.getAttribute('data-background') || wrapperEl.style.backgroundColor || '#ffffff';
      result['text-color'] = wrapperEl.getAttribute('data-text-color') || wrapperEl.style.color || '#000000';
      const topPadding = wrapperEl.getAttribute('data-top-padding');
      const bottomPadding = wrapperEl.getAttribute('data-bottom-padding');
      result.topPadding = topPadding ? topPadding === 'true' : true;
      result.bottomPadding = bottomPadding ? bottomPadding === 'true' : true;
    }

    const titleCardEl = doc.querySelector('[data-attribute="card-title"]');
    if (titleCardEl) {
      const showTitle = titleCardEl.getAttribute('data-show-title');
      result['show-title'] = showTitle ? showTitle === 'true' : true;
      result['title-card'] = titleCardEl.innerHTML.trim();
    }

    const containerPageEl = doc.querySelector('[data-attribute="container-page"]');
    if (containerPageEl) {
      const enableContainerPage = containerPageEl.getAttribute('data-enable-style');
      result.enableContainerPage = enableContainerPage ? enableContainerPage === 'true' : false;
      const backgroundContainer = containerPageEl.getAttribute('data-background-container');
      result.backgroundContainer = backgroundContainer ? backgroundContainer : '#ffffff';
    }

    const itemEls = doc.querySelectorAll('[data-attribute="item"]');
    result.listItem = Array.from(itemEls).map(itemEl => {
      const wrapVideoEl = itemEl.querySelector('[data-attribute="wrap-video"]');
      const wrapImageEl = itemEl.querySelector('[data-attribute="wrap-image"]');
      const videoEl = itemEl.querySelector('[data-attribute="video-item"]');
      const imageEl = wrapImageEl?.querySelector('img') || itemEl.querySelector('[data-attribute="image-item"]');
      const videoSrc = videoEl ? videoEl.getAttribute('src') || '' : '';
      const imageSrc = imageEl ? imageEl.getAttribute('src') || '' : '';
      const showVideo = wrapVideoEl ? wrapVideoEl.getAttribute('data-show-video') : null;
      const showImage = wrapImageEl ? wrapImageEl.getAttribute('data-show-image') : null;
      let mediaType = 'video';

      if (showImage === 'true') {
        mediaType = 'image';
      } else if (showVideo === 'true') {
        mediaType = 'video';
      } else if (imageSrc && !videoSrc) {
        mediaType = 'image';
      }

      return {
        mediaType,
        videoItem: mediaType === 'video' ? videoSrc : '',
        imageItem: mediaType === 'image' ? imageSrc : '',
      };
    });

    return result;
  },

  sectionPolicyYuriReivew(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Policy Yuri Reivew Section',
      'title-card': '',
      'show-title': true,
      'background-color': '#ffffff',
      'text-color': '#000000',
      enableContainerPage: true,
      topPadding: true,
      bottomPadding: true,
      settingItem: {},
      listItem: [],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : result.title;
    }

    const wrapperEl = doc.querySelector('[data-attribute="card-container"]');
    if (wrapperEl) {
      result['background-color'] =
        wrapperEl.getAttribute('data-background') || wrapperEl.style.backgroundColor || '#ffffff';
      result['text-color'] = wrapperEl.getAttribute('data-text-color') || wrapperEl.style.color || '#000000';
      const topPadding = wrapperEl.getAttribute('data-top-padding');
      const bottomPadding = wrapperEl.getAttribute('data-bottom-padding');
      result.topPadding = topPadding ? topPadding === 'true' : true;
      result.bottomPadding = bottomPadding ? bottomPadding === 'true' : true;
    }

    const titleCardEl = doc.querySelector('[data-attribute="card-title"]');
    if (titleCardEl) {
      const showTitle = titleCardEl.getAttribute('data-show-title');
      result['show-title'] = showTitle ? showTitle === 'true' : true;
      result['title-card'] = titleCardEl.innerHTML.trim();
    }

    const containerPageEl = doc.querySelector('[data-attribute="container-page"]');
    if (containerPageEl) {
      const enableContainerPage = containerPageEl.getAttribute('data-enable-style');
      result.enableContainerPage = enableContainerPage ? enableContainerPage === 'true' : false;
      const backgroundContainer = containerPageEl.getAttribute('data-background-container');
      result.backgroundContainer = backgroundContainer ? backgroundContainer : '#ffffff';
    }

    const groupSliderEl = doc.querySelector('[data-attribute="slider"]');
    if (groupSliderEl) {
      const enableBackgroundItem = groupSliderEl.getAttribute('data-enable-background');
      result.settingItem.enableBackgroundItem = enableBackgroundItem ? enableBackgroundItem === 'true' : false;
      result.settingItem.bgStart = groupSliderEl.getAttribute('data-bg-start') || '#fff5f9';
      result.settingItem.bgEnd = groupSliderEl.getAttribute('data-bg-end') || '#ffffff';
      result.settingItem.mainColorItem = groupSliderEl.getAttribute('data-main-color-item') || '#cb6387';
    }

    const itemEls = doc.querySelectorAll('[data-attribute="item"]');
    result.listItem = Array.from(itemEls).map(itemEl => {
      const avatarEl = itemEl.querySelector('[data-attribute="avatar"]');
      const nameEl = itemEl.querySelector('[data-attribute="name-reviewer"]');
      const starsEl = itemEl.querySelector('[data-attribute="stars-review"]');
      const contentEl = itemEl.querySelector('[data-attribute="content-review"]');
      const starsValue = parseInt(starsEl?.getAttribute('data-value') || '5', 10);

      return {
        avatar: avatarEl ? avatarEl.getAttribute('src') || '' : '',
        nameReviewer: nameEl ? nameEl.textContent.trim() : '',
        starsReview: Number.isNaN(starsValue) ? 5 : Math.min(Math.max(starsValue, 1), 5),
        contentReview: contentEl ? contentEl.innerHTML.trim() : '',
      };
    });

    return result;
  },

  sectionTextWithButton(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Text with Button',
      enableAnchor: false,
      textColor: '#000000',
      padding: {
        top: true,
        bottom: true,
      },
      'background-section': {
        color: '#ffffff',
      },
      'container-content': {
        showStyle: false,
        background: '#ffffff',
      },
      titleCard: {
        show: true,
        content: '',
      },
      btnCard: {
        show: true,
        text: '',
        url: '#',
        background: '#214a88',
        color: '#ffffff',
      },
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : result.title;
    }

    const elements = doc.querySelectorAll('[data-attribute]');
    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'card-container': {
          const background = el.getAttribute('data-background') || '#ffffff';
          result['background-section'].color = background;
          const textColor = el.getAttribute('data-text-color') || el.getAttribute('data-color') || '#000000';
          result.textColor = textColor;
          result.padding.top = el.getAttribute('data-top-padding') === 'true';
          result.padding.bottom = el.getAttribute('data-bottom-padding') === 'true';
          break;
        }
        case 'container-page': {
          const showStyle = el.getAttribute('data-show-style');
          result['container-content'].showStyle = showStyle ? showStyle === 'true' : false;
          const background = el.getAttribute('data-background');
          result['container-content'].background = background ? background : '#ffffff';
          break;
        }
        case 'title-card': {
          const showTitle = el.getAttribute('data-show-title');
          result.titleCard.show = showTitle !== 'false';
          result.titleCard.content = el.innerHTML.trim();
          break;
        }
        case 'btn-card': {
          const showBtn = el.getAttribute('data-show-btn');
          result.btnCard.show = showBtn !== 'false';
          result.btnCard.text = el.textContent.trim();
          result.btnCard.url = el.getAttribute('href') || '#';
          result.btnCard.background = el.getAttribute('data-background') || '#214a88';
          result.btnCard.color = el.getAttribute('data-color') || '#ffffff';
          break;
        }
        default:
          break;
      }
    });

    return result;
  },

  sectionFaqVital(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'FAQ Vital Section',
      enableAnchor: false,
      textColor: '#07476e',
      padding: {
        top: true,
        bottom: true,
      },
      'background-section': {
        color: '#9cdbe8',
      },
      'container-content': {
        showStyle: false,
        background: '#ffffff',
      },
      leftCard: {
        order: 1,
      },
      titleCardLeft: {
        show: true,
        content: '',
      },
      highlightGroup: {
        show: true,
        content: '',
        background: '#daecf0',
      },
      btnCardLeft: {
        show: true,
        text: '',
        url: '#',
        color: '#214a88',
      },
      rightCard: {
        order: 2,
      },
      itemAccordions: {
        dataShowAccordion: true,
        listItem: [],
      },
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : result.title;
    }

    const elements = doc.querySelectorAll('[data-attribute]');
    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'card-container': {
          const background = el.getAttribute('data-background') || '#9cdbe8';
          result['background-section'].color = background;
          result.textColor = el.getAttribute('data-text-color') || el.getAttribute('data-color') || '#07476e';
          result.padding.top = el.getAttribute('data-top-padding') === 'true';
          result.padding.bottom = el.getAttribute('data-bottom-padding') === 'true';
          break;
        }
        case 'container-page': {
          const showStyle = el.getAttribute('data-show-style');
          result['container-content'].showStyle = showStyle ? showStyle === 'true' : false;
          result['container-content'].background = el.getAttribute('data-background') || '#ffffff';
          break;
        }
        case 'card-left': {
          result.leftCard.order = parseInt(el.style.order || el.getAttribute('data-order') || '1', 10) || 1;
          break;
        }
        case 'title-card-left': {
          result.titleCardLeft.show = el.getAttribute('data-show') !== 'false';
          result.titleCardLeft.content = el.innerHTML.trim();
          break;
        }
        case 'hight-light-group': {
          result.highlightGroup.show = el.getAttribute('data-show') !== 'false';
          result.highlightGroup.content = el.innerHTML.trim();
          result.highlightGroup.background = el.getAttribute('data-hl-background') || '#daecf0';
          break;
        }
        case 'btn-card-left': {
          result.btnCardLeft.show = el.getAttribute('data-show') !== 'false';
          const textEl = el.querySelector('[data-attribute="text-btn"]');
          result.btnCardLeft.text = textEl ? textEl.textContent.trim() : el.textContent.trim();
          result.btnCardLeft.url = el.getAttribute('href') || '#';
          result.btnCardLeft.color = el.getAttribute('data-color') || '#214a88';
          break;
        }
        case 'card-right': {
          result.rightCard.order = parseInt(el.style.order || el.getAttribute('data-order') || '2', 10) || 2;
          break;
        }
        case 'card-accordions': {
          result.itemAccordions.dataShowAccordion = el.getAttribute('data-show-accordion') !== 'false';
          const items = el.querySelectorAll('[data-attribute="card-accordion"]');
          result.itemAccordions.listItem = Array.from(items).map(item => {
            const title = item.querySelector('[data-attribute="accordion-title-text"]')?.textContent?.trim() || '';
            const answer = item.querySelector('[data-attribute="accordion-text"]')?.innerHTML?.trim() || '';
            return { title, answer };
          });
          break;
        }
        default:
          break;
      }
    });

    return result;
  },

  sectionCardVitalSlider(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Card Vital Slider',
      enableAnchor: false,
      textColor: '#000000',
      padding: {
        top: true,
        bottom: true,
      },
      'background-section': {
        color: '#ffffff',
      },
      'container-content': {
        showStyle: false,
        background: '#ffffff',
      },
      slider: {
        colPerView: 4,
        spaceBetween: 16,
        itemBackground: '#ffffff',
        itemDesBackground: '#daecf0',
      },
      'title-card': {
        showTitle: true,
        html: `<h2>Lorem ipsum dolor sit amet</h2>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et
            dolore magna aliqua.</p>`,
      },
      listItem: [],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : result.title;
    }

    const elements = doc.querySelectorAll('[data-attribute]');
    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'card-container': {
          const background = el.getAttribute('data-background') || '#ffffff';
          result['background-section'].color = background;
          result.textColor = el.getAttribute('data-text-color') || el.getAttribute('data-color') || '#000000';
          result.padding.top = el.getAttribute('data-top-padding') === 'true';
          result.padding.bottom = el.getAttribute('data-bottom-padding') === 'true';
          break;
        }
        case 'container-page': {
          const showStyle = el.getAttribute('data-show-style');
          result['container-content'].showStyle = showStyle ? showStyle === 'true' : false;
          result['container-content'].background = el.getAttribute('data-background') || '#ffffff';
          break;
        }
        case 'list-item': {
          result.slider.colPerView = parseInt(el.getAttribute('data-col-per-view') || '4', 10) || 4;
          result.slider.spaceBetween = parseInt(el.getAttribute('data-space-between') || '16', 10) || 16;
          result.slider.itemBackground = el.getAttribute('data-item-background') || '#ffffff';
          result.slider.itemDesBackground = el.getAttribute('data-item-des-background') || '#daecf0';
          el.querySelectorAll('[data-attribute="item"]').forEach(item => {
            const img = item.querySelector('[data-attribute="image-item"]');
            const desc = item.querySelector('[data-attribute="description-item"]');
            result.listItem.push({
              image: img ? img.getAttribute('src') || '' : '',
              description: desc ? desc.innerHTML.trim() : '',
              descriptionPadding: desc ? desc.getAttribute('data-padding') !== 'false' : true,
            });
          });
          break;
        }
        case 'title-card': {
          result['title-card'] = {
            showTitle: el.getAttribute('data-show-title') !== 'false',
            html: el.innerHTML.trim(),
          };
          break;
        }
        default:
          break;
      }
    });

    return result;
  },

  sectionCardVitalSlider02(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Card Vital Slider 02',
      enableAnchor: false,
      textColor: '#000000',
      padding: {
        top: true,
        bottom: true,
      },
      'background-section': {
        color: '#ffffff',
      },
      'container-content': {
        showStyle: false,
        background: '#ffffff',
      },
      'title-card': {
        showTitle: true,
        html: '<h2 style="text-align: center;">Lorem ipsum dolor, sit</h2>',
      },
      slider: {
        colPerView: 3,
        spaceBetween: 16,
        itemBackground: '#ffffff',
        itemContentBackground: '#daecf0',
        itemContentBackgroundHover: '#214a88',
        itemContentTextColor: '#214a88',
        itemContentTextColorHover: '#ffffff',
      },
      listItem: [],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : result.title;
    }

    const elements = doc.querySelectorAll('[data-attribute]');
    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'card-container': {
          const background = el.getAttribute('data-background') || '#ffffff';
          result['background-section'].color = background;
          result.textColor = el.getAttribute('data-text-color') || el.getAttribute('data-color') || '#000000';
          result.padding.top = el.getAttribute('data-top-padding') === 'true';
          result.padding.bottom = el.getAttribute('data-bottom-padding') === 'true';
          break;
        }
        case 'container-page': {
          const showStyle = el.getAttribute('data-show-style');
          result['container-content'].showStyle = showStyle ? showStyle === 'true' : false;
          result['container-content'].background = el.getAttribute('data-background') || '#ffffff';
          break;
        }
        case 'list-item': {
          result.slider.colPerView = parseInt(el.getAttribute('data-col-per-view') || '3', 10) || 3;
          result.slider.spaceBetween = parseInt(el.getAttribute('data-space-between') || '16', 10) || 16;
          result.slider.itemBackground = el.getAttribute('data-item-background') || '#ffffff';
          result.slider.itemContentBackground = el.getAttribute('data-item-content-background') || '#daecf0';
          result.slider.itemContentBackgroundHover = el.getAttribute('data-item-content-background-hover') || '#214a88';
          result.slider.itemContentTextColor = el.getAttribute('data-item-content-text-color') || '#214a88';
          result.slider.itemContentTextColorHover = el.getAttribute('data-item-content-text-color-hover') || '#ffffff';

          el.querySelectorAll('[data-attribute="item"]').forEach(item => {
            const imgDecor = item.querySelector('[data-attribute="img-decor-item"]');
            const contentTitleEl = item.querySelector('[data-attribute="title-item"]');
            const contentDescEl = item.querySelector('[data-attribute="description-item"]');

            result.listItem.push({
              imageDecor: imgDecor ? imgDecor.getAttribute('src') || '' : '',
              titleItemHtml: contentTitleEl ? contentTitleEl.innerHTML.trim() : '',
              descriptionItemHtml: contentDescEl ? contentDescEl.innerHTML.trim() : '',
            });
          });
          break;
        }
        case 'title-card': {
          result['title-card'] = {
            showTitle: el.getAttribute('data-show-title') !== 'false',
            html: el.innerHTML.trim(),
          };
          break;
        }
        default:
          break;
      }
    });

    return result;
  },

  sectionCardVitalSurround(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Card Vital Surround',
      enableAnchor: false,
      textColor: '#000000',
      padding: {
        top: true,
        bottom: true,
      },
      'background-section': {
        color: '#ffffff',
      },
      'container-content': {
        showStyle: false,
        background: '#ffffff',
      },
      'title-card': {
        showTitle: true,
        html: '<h2 style="text-align: center;">Lorem ipsum dolor, sit</h2>',
      },
      mainItemImage: '',
      listItem: [],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : result.title;
    }

    const elements = doc.querySelectorAll('[data-attribute]');
    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'card-container': {
          const background = el.getAttribute('data-background') || '#ffffff';
          result['background-section'].color = background;
          result.textColor = el.getAttribute('data-text-color') || el.getAttribute('data-color') || '#000000';
          result.padding.top = el.getAttribute('data-top-padding') === 'true';
          result.padding.bottom = el.getAttribute('data-bottom-padding') === 'true';
          break;
        }
        case 'container-page': {
          const showStyle = el.getAttribute('data-show-style');
          result['container-content'].showStyle = showStyle ? showStyle === 'true' : false;
          result['container-content'].background = el.getAttribute('data-background') || '#ffffff';
          break;
        }
        case 'title-card': {
          result['title-card'] = {
            showTitle: el.getAttribute('data-show-title') !== 'false',
            html: el.innerHTML.trim(),
          };
          break;
        }
        case 'img-main-item': {
          result.mainItemImage = el.getAttribute('src') || '';
          break;
        }
        case 'list-item': {
          el.querySelectorAll('[data-attribute="item-surround"]').forEach(itemEl => {
            const imgEl = itemEl.querySelector('[data-attribute="img-item"]');
            const textEl = itemEl.querySelector('[data-attribute="text-item"]');
            result.listItem.push({
              image: imgEl ? imgEl.getAttribute('src') || '' : '',
              text: textEl ? textEl.innerHTML.trim() : '',
            });
          });
          break;
        }
        default:
          break;
      }
    });

    return result;
  },

  sectionCardVitalTab(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Card Vital Tab',
      enableAnchor: false,
      textColor: '#000000',
      padding: {
        top: true,
        bottom: true,
      },
      'background-section': {
        color: '#ffffff',
      },
      'container-content': {
        showStyle: false,
        background: '#ffffff',
      },
      'title-card': {
        showTitle: true,
        html: '<h2 style="text-align: center;">Lorem ipsum dolor, sit</h2>',
      },
      leftHighlight: '#eff6f9',
      leftCardTitle: 'Start glowing in as little as 7 days',
      rightCardImage: '',
      colorTabHeader: '#214a88',
      colorTabHeaderHover: '#ffffff',
      bgTabHeaderHover: '#214a88',
      rightCardLayoutPosition: 1,
      leftCardLayoutPosition: 2,
      listTab: [],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : result.title;
    }

    const cardRoot = doc.querySelector('[data-attribute="card-container"]');
    if (cardRoot) {
      result['background-section'].color = cardRoot.getAttribute('data-background') || '#ffffff';
      result.textColor = cardRoot.getAttribute('data-text-color') || cardRoot.getAttribute('data-color') || '#000000';
      result.padding.top = cardRoot.getAttribute('data-top-padding') === 'true';
      result.padding.bottom = cardRoot.getAttribute('data-bottom-padding') === 'true';
    }

    const elContainerPage = doc.querySelector('[data-attribute="container-page"]');
    if (elContainerPage) {
      const showStyle = elContainerPage.getAttribute('data-show-style');
      result['container-content'].showStyle = showStyle ? showStyle === 'true' : false;
      result['container-content'].background = elContainerPage.getAttribute('data-background') || '#ffffff';
    }

    const pageContainer = doc.querySelector('[data-attribute="container-page"] .container');
    if (pageContainer) {
      const outerTitle = pageContainer.querySelector(':scope > [data-attribute="title-card"]');
      if (outerTitle) {
        result['title-card'] = {
          showTitle: outerTitle.getAttribute('data-show-title') !== 'false',
          html: outerTitle.innerHTML.trim(),
        };
      }
    }

    const leftCard = doc.querySelector('[data-attribute="left-card"]');
    if (leftCard) {
      const hl = leftCard.getAttribute('data-highlight-left-card');
      if (hl) result.leftHighlight = hl;
    }

    const innerLeftTitle = doc.querySelector('[data-attribute="left-card"] > [data-attribute="title-card"]');
    if (innerLeftTitle) {
      result.leftCardTitle = innerLeftTitle.innerHTML.trim();
    }

    const imgRight = doc.querySelector('[data-attribute="image-right-card"]');
    if (imgRight) {
      result.rightCardImage = imgRight.getAttribute('src') || '';
    }

    const rightCardEl = doc.querySelector('[data-attribute="right-card"]');
    const leftCardEl = doc.querySelector('[data-attribute="left-card"]');
    if (rightCardEl) {
      const ro = rightCardEl.getAttribute('data-order') || rightCardEl.style.order;
      result.rightCardLayoutPosition = ro ? parseInt(ro, 10) : 1;
    }
    if (leftCardEl) {
      const lo = leftCardEl.getAttribute('data-order') || leftCardEl.style.order;
      result.leftCardLayoutPosition = lo ? parseInt(lo, 10) : 2;
    }

    const listTabHeader = doc.querySelector('[data-attribute="list-tab-header"]');
    const elTabContent = doc.querySelector('[data-attribute="list-tab-content"]');
    if (listTabHeader && elTabContent) {
      result.colorTabHeader = listTabHeader.getAttribute('data-color-tab-header') || result.colorTabHeader;
      result.colorTabHeaderHover =
        listTabHeader.getAttribute('data-color-tab-header-hover') || result.colorTabHeaderHover;
      result.bgTabHeaderHover = listTabHeader.getAttribute('data-bg-tab-header-hover') || result.bgTabHeaderHover;

      const elItems = listTabHeader.querySelectorAll('[data-attribute="tab-header-item"]');
      result.listTab = Array.from(elItems).map(item => {
        const tabIndex = item.getAttribute('data-tab');
        const contentEl = elTabContent.querySelector(`[data-tab="${tabIndex}"]`);
        const titleTab = contentEl?.querySelector('[data-attribute="title-tab-content"]');
        const footTab = contentEl?.querySelector('[data-attribute="foot-tab-content"]');
        return {
          title: item.textContent.trim(),
          titleContent: titleTab ? titleTab.innerHTML.trim() : '',
          footContent: footTab ? footTab.innerHTML.trim() : '',
        };
      });
    }

    return result;
  },

  sectionReviewInfiniteMarquee(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {};

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Review Infinite Marquee Section';
    }

    const headerEl = doc.querySelector('.review-infinite-marquee-header');
    if (headerEl) {
      result.showHeader = headerEl.getAttribute('data-show') === 'true' ? true : false;
    }

    const tagEl = doc.querySelector('.review-infinite-marquee-tag');
    if (tagEl) {
      result.showTag = tagEl.getAttribute('data-show') === 'true' ? true : false;
      result.tagContent = tagEl.textContent.trim();
    }

    const titleEl = doc.querySelector('[data-attribute="review-infinite-marquee-title"]');
    if (titleEl) {
      result['review-title'] = titleEl.innerHTML.trim();
    }

    const ratingValueEl = doc.querySelector('[data-attribute="review-infinite-marquee-rating-value"]');
    if (ratingValueEl) {
      result['rating-value'] = parseFloat(ratingValueEl.textContent.trim()) || 5;
    }

    const descriptionEl = doc.querySelector('[data-attribute="review-infinite-marquee-description"]');
    if (descriptionEl) {
      result['description'] = descriptionEl.textContent.trim();
    }

    // Extract color attributes
    const wrapperEl = doc.querySelector('.review-infinite-marquee-container-wrapper');
    if (wrapperEl) {
      result['background-color'] =
        wrapperEl.getAttribute('data-background-color') || wrapperEl.style.backgroundColor || '';
      result['text-color'] = wrapperEl.getAttribute('data-text-color') || wrapperEl.style.color || '';
      result.topPadding = wrapperEl.getAttribute('data-top-padding') === 'true';
      result.bottomPadding = wrapperEl.getAttribute('data-bottom-padding') === 'true';
      result.enableRating = wrapperEl.getAttribute('data-enable-rating') === 'true' ? true : false;
      result.imageSize = wrapperEl.getAttribute('data-image-size') || 'large';
      result.containerStyle = wrapperEl.getAttribute('data-container-style') === 'true' ? true : false;
    }

    result['review-images'] = [];
    const listEl = doc.querySelector('[data-attribute="review-infinite-marquee-list"]');
    if (listEl) {
      // Only select original items (not clones)
      const originalItems = listEl.querySelectorAll(
        '[data-attribute="review-infinite-marquee-item"][data-original="true"]',
      );

      let itemsToProcess = originalItems;
      if (originalItems.length === 0) {
        itemsToProcess = listEl.querySelectorAll(
          '[data-attribute="review-infinite-marquee-item"].marquee-item-original',
        );
      }

      if (itemsToProcess.length === 0) {
        const allItems = listEl.querySelectorAll('[data-attribute="review-infinite-marquee-item"]');
        const maxOriginalItems = Math.min(20, allItems.length);
        itemsToProcess = Array.from(allItems).slice(0, maxOriginalItems);
      }

      Array.from(itemsToProcess).forEach(el => {
        const avatarEl = el.querySelector('[data-attribute="review-infinite-marquee-item-avatar"]');
        if (avatarEl) {
          result['review-images'].push({
            avatar: avatarEl.getAttribute('src') || '',
          });
        }
      });
    }

    return result;
  },

  sectionCollapsibleProductGrid(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');

    const result = {
      title: '',
      'section-text-color': '#000000',
      'section-background-color': '#ffffff',
      'card-text-color': '#000000',
      'card-background-color': '#ffffff',
      'section-description': '',
      'see-more-text': 'see more',
      'see-less-text': 'see less',
      'grid-items': [],
      topPadding: true,
      bottomPadding: true,
    };

    // title from section
    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : '';
    }

    // section container styles and see more/less labels
    const sectionContainer = doc.querySelector('[data-attribute="section-container"]');
    if (sectionContainer) {
      const sectionTextColor = sectionContainer.getAttribute('data-text-color') || sectionContainer.style.color;
      const sectionBgColor =
        sectionContainer.getAttribute('data-background-color') || sectionContainer.style.backgroundColor;
      const seeMoreText = sectionContainer.getAttribute('data-see-more-text');
      const seeLessText = sectionContainer.getAttribute('data-see-less-text');

      if (sectionTextColor) result['section-text-color'] = sectionTextColor;
      if (sectionBgColor) result['section-background-color'] = sectionBgColor;
      if (seeMoreText) result['see-more-text'] = seeMoreText;
      if (seeLessText) result['see-less-text'] = seeLessText;
      const topPadding = sectionContainer.getAttribute('data-top-padding');
      result.topPadding = topPadding ? topPadding === 'true' : true;
      const bottomPadding = sectionContainer.getAttribute('data-bottom-padding');
      result.bottomPadding = bottomPadding ? bottomPadding === 'true' : true;
    }

    // section description
    const sectionDescription = doc.querySelector('[data-attribute="section-description"]');
    if (sectionDescription) {
      result['section-description'] = sectionDescription.innerHTML.trim();
    }

    // grid items and card colors
    const gridItemsContainer = doc.querySelector('[data-attribute="grid-items-container"]');
    if (gridItemsContainer) {
      const gridItems = gridItemsContainer.querySelectorAll('[data-attribute="grid-item"]');

      // Try to infer card colors from the first item
      const firstItem = gridItems[0];
      if (firstItem) {
        const cardTextColor = firstItem.getAttribute('data-card-text-color') || firstItem.style.color;
        const cardBgColor = firstItem.getAttribute('data-card-background-color') || firstItem.style.backgroundColor;
        if (cardTextColor) result['card-text-color'] = cardTextColor;
        if (cardBgColor) result['card-background-color'] = cardBgColor;
      }

      result['grid-items'] = Array.from(gridItems).map(item => {
        const imgEl = item.querySelector('[data-attribute="item-image"]');
        const titleEl = item.querySelector('[data-attribute="item-title"]');
        const contentEl = item.querySelector('[data-attribute="item-content"]');
        return {
          image: imgEl ? imgEl.getAttribute('src') || '' : '',
          title: titleEl ? titleEl.textContent.trim() : '',
          content: contentEl ? contentEl.innerHTML.trim() : '',
        };
      });
    }

    // section visible title (if exists) can fallback to sectionEl title
    const sectionTitleEl = doc.querySelector('[data-attribute="section-title"]');
    if (!result.title && sectionTitleEl) {
      result.title = sectionTitleEl.textContent.trim();
    }

    return result;
  },

  sectionCardMediaSlider(htmlString, type) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const defaultDesktopSlides = type === sectionType.sectionCardMediaSlider02 ? 2 : 3;
    const result = {
      title: '',
      'card-container': '',
      header: {
        show: false,
        content: '',
      },
      btnPlayVideo: {
        background: '#000000',
        color: '#FFFFFF',
      },
      'pagination-active-color': '#000000',
      'pagination-inactive-color': '#cccccc',
      breakpoints: {
        mobile: {
          slidesPerView: 1,
        },
        tablet: {
          slidesPerView: 2,
        },
        desktop: {
          slidesPerView: defaultDesktopSlides,
        },
      },
      listItem: [],
      topPadding: true,
      bottomPadding: true,
    };

    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';

      // Extract breakpoints from section element
      const mobileSlides = sectionEl.getAttribute('data-breakpoint-mobile-slides');
      const tabletSlides = sectionEl.getAttribute('data-breakpoint-tablet-slides');
      const desktopSlides = sectionEl.getAttribute('data-breakpoint-desktop-slides');

      // Handle new format (mobile, tablet, desktop)
      if (mobileSlides) {
        result.breakpoints.mobile = {
          slidesPerView: parseInt(mobileSlides, 10) || 1,
        };
      }
      if (tabletSlides) {
        result.breakpoints.tablet = {
          slidesPerView: parseInt(tabletSlides, 10) || 2,
        };
      }
      if (desktopSlides) {
        result.breakpoints.desktop = {
          slidesPerView: parseInt(desktopSlides, 10) || defaultDesktopSlides,
        };
      }

      // Handle migration from old format (breakpoint1/2/3 with width)
      const bp1Slides = sectionEl.getAttribute('data-breakpoint1-slides');
      const bp2Slides = sectionEl.getAttribute('data-breakpoint2-slides');
      const bp3Slides = sectionEl.getAttribute('data-breakpoint3-slides');

      if (bp1Slides && !mobileSlides) {
        result.breakpoints.mobile = {
          slidesPerView: parseInt(bp1Slides, 10) || 1,
        };
      }
      if (bp2Slides && !tabletSlides) {
        result.breakpoints.tablet = {
          slidesPerView: parseInt(bp2Slides, 10) || 2,
        };
      }
      if (bp3Slides && !desktopSlides) {
        result.breakpoints.desktop = {
          slidesPerView: parseInt(bp3Slides, 10) || defaultDesktopSlides,
        };
      }
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'card-container': {
          const background = el.getAttribute('data-background');
          result[key] = background ? background : '#ffffff';
          const paginationActiveColor = el.getAttribute('data-pagination-active-color');
          result['pagination-active-color'] = paginationActiveColor ? paginationActiveColor : '#000000';
          const paginationInactiveColor = el.getAttribute('data-pagination-inactive-color');
          result['pagination-inactive-color'] = paginationInactiveColor ? paginationInactiveColor : '#cccccc';
          const topPadding = el.getAttribute('data-top-padding');
          result.topPadding = topPadding ? topPadding === 'true' : true;
          const bottomPadding = el.getAttribute('data-bottom-padding');
          result.bottomPadding = bottomPadding ? bottomPadding === 'true' : true;
          break;
        }
        case 'card-header': {
          result.header.content = el.innerHTML.trim();
          result.header.show = el.getAttribute('data-show') === 'true' ? true : false;
          break;
        }
        case 'list-item': {
          const bgPlayVideo = el.getAttribute('data-bg-play-video');
          const colorPlayVideo = el.getAttribute('data-color-play-video');
          result.btnPlayVideo = {
            background: bgPlayVideo ? bgPlayVideo : '#000000',
            color: colorPlayVideo ? colorPlayVideo : '#FFFFFF',
          };
          el.querySelectorAll('[data-attribute="item"]').forEach(item => {
            const videoElement = item.querySelector('[data-attribute="card-video"]');
            const imageElement = item.querySelector('[data-attribute="card-image"]');

            // Determine type based on what exists
            let type = 'video';
            let video = '';
            let image = '';
            let objectFit = 'cover'; // default

            if (imageElement) {
              type = 'image';
              image = imageElement.getAttribute('src') || '';
              // Extract object-fit from style attribute
              const style = imageElement.getAttribute('style') || '';
              const objectFitMatch = style.match(/object-fit:\s*([^;]+)/);
              if (objectFitMatch) {
                objectFit = objectFitMatch[1].trim();
              }
            }

            if (videoElement) {
              type = 'video';
              video = videoElement.getAttribute('src') || '';
            }

            // If both exist, prefer image (newer feature)
            if (imageElement && videoElement) {
              type = 'image';
            }

            result.listItem.push({
              type: type,
              video: video,
              image: image,
              objectFit: objectFit,
            });
          });
          break;
        }
        default:
          break;
      }
    });

    return result;
  },

  sectionCardMediaSlider03(htmlString, type) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const defaultDesktopSlides = type === sectionType.sectionCardMediaSlider02 ? 2 : 3;
    const result = {
      title: '',
      'background-color': '#F9F9F9',
      'card-item-background-color': '#ffffff',
      header: {
        show: false,
        content: '',
      },
      'pagination-active-color': '#000000',
      'pagination-inactive-color': '#cccccc',
      breakpoints: {
        mobile: {
          slidesPerView: 1,
        },
        tablet: {
          slidesPerView: 2,
        },
        desktop: {
          slidesPerView: defaultDesktopSlides,
        },
      },
      listItem: [],
      topPadding: true,
      bottomPadding: true,
    };

    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';

      // Extract breakpoints from section element
      const mobileSlides = sectionEl.getAttribute('data-breakpoint-mobile-slides');
      const tabletSlides = sectionEl.getAttribute('data-breakpoint-tablet-slides');
      const desktopSlides = sectionEl.getAttribute('data-breakpoint-desktop-slides');

      // Handle new format (mobile, tablet, desktop)
      if (mobileSlides) {
        result.breakpoints.mobile = {
          slidesPerView: parseInt(mobileSlides, 10) || 1,
        };
      }
      if (tabletSlides) {
        result.breakpoints.tablet = {
          slidesPerView: parseInt(tabletSlides, 10) || 2,
        };
      }
      if (desktopSlides) {
        result.breakpoints.desktop = {
          slidesPerView: parseInt(desktopSlides, 10) || defaultDesktopSlides,
        };
      }

      // Handle migration from old format (breakpoint1/2/3 with width)
      const bp1Slides = sectionEl.getAttribute('data-breakpoint1-slides');
      const bp2Slides = sectionEl.getAttribute('data-breakpoint2-slides');
      const bp3Slides = sectionEl.getAttribute('data-breakpoint3-slides');

      if (bp1Slides && !mobileSlides) {
        result.breakpoints.mobile = {
          slidesPerView: parseInt(bp1Slides, 10) || 1,
        };
      }
      if (bp2Slides && !tabletSlides) {
        result.breakpoints.tablet = {
          slidesPerView: parseInt(bp2Slides, 10) || 2,
        };
      }
      if (bp3Slides && !desktopSlides) {
        result.breakpoints.desktop = {
          slidesPerView: parseInt(bp3Slides, 10) || defaultDesktopSlides,
        };
      }
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'card-container': {
          const background = el.getAttribute('data-background-color');
          result['background-color'] = background ? background : '#F9F9F9';
          const paginationActiveColor = el.getAttribute('data-pagination-active-color');
          result['pagination-active-color'] = paginationActiveColor ? paginationActiveColor : '#000000';
          const paginationInactiveColor = el.getAttribute('data-pagination-inactive-color');
          result['pagination-inactive-color'] = paginationInactiveColor ? paginationInactiveColor : '#cccccc';
          const topPadding = el.getAttribute('data-top-padding');
          result.topPadding = topPadding ? topPadding === 'true' : true;
          const bottomPadding = el.getAttribute('data-bottom-padding');
          result.bottomPadding = bottomPadding ? bottomPadding === 'true' : true;
          const cardItemBackgroundColor = el.getAttribute('data-card-item-background-color');
          result['card-item-background-color'] = cardItemBackgroundColor ? cardItemBackgroundColor : '#ffffff';
          break;
        }
        case 'card-header': {
          result.header.content = el.innerHTML.trim();
          result.header.show = el.getAttribute('data-show') === 'true' ? true : false;
          break;
        }
        case 'list-item': {
          el.querySelectorAll('[data-attribute="item"]').forEach(item => {
            const videoElement = item.querySelector('[data-attribute="card-video"]');
            const imageElement = item.querySelector('[data-attribute="card-image"]');
            const contentElement = item.querySelector('.wrap-item-content');

            // Determine type based on what exists
            let type = 'image';
            let video = '';
            let image = '';

            if (imageElement) {
              type = 'image';
              image = imageElement.getAttribute('src') || '';
            }

            if (videoElement) {
              type = 'video';
              video = videoElement.getAttribute('src') || '';
            }

            // If both exist, prefer image (newer feature)
            if (imageElement && videoElement) {
              type = 'image';
            }

            result.listItem.push({
              type: type,
              video: video,
              image: image,
              content: contentElement ? contentElement.innerHTML.trim() : '',
            });
          });
          break;
        }
        default:
          break;
      }
    });

    return result;
  },

  sectionCardStepInstructions(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    // Get section title
    const sectionEl = container.querySelector('[data-section]');
    const title = sectionEl ? sectionEl.getAttribute('data-title') : 'Card Step Instructions';
    const enableAnchor = sectionEl ? sectionEl.getAttribute('data-enable-anchor') === 'true' : false;

    // Extract breakpoints from section element
    const mobileSlides = sectionEl ? sectionEl.getAttribute('data-breakpoint-mobile-slides') : null;
    const tabletSlides = sectionEl ? sectionEl.getAttribute('data-breakpoint-tablet-slides') : null;
    const desktopSlides = sectionEl ? sectionEl.getAttribute('data-breakpoint-desktop-slides') : null;

    const cardStepInstructionsEl = container.querySelector('.card-step-instructions');

    const paginationActiveColor = cardStepInstructionsEl
      ? cardStepInstructionsEl.getAttribute('data-pagination-active-color')
      : '#000000';
    const paginationInactiveColor = cardStepInstructionsEl
      ? cardStepInstructionsEl.getAttribute('data-pagination-inactive-color')
      : '#cccccc';

    const backgroundColor = cardStepInstructionsEl
      ? cardStepInstructionsEl.getAttribute('data-background') || cardStepInstructionsEl.style.backgroundColor || ''
      : '';

    // Get card container
    const cardContainer = container.querySelector('[data-attribute="card-container"]');

    // Get steps title
    const stepsTitleEl = container.querySelector('[data-attribute="steps-title"]');
    const stepsTitle = stepsTitleEl ? stepsTitleEl.innerHTML.trim() : 'How Does It Work?';

    // Get text color from container or step-number
    let textColor = cardContainer
      ? cardContainer.getAttribute('data-text-color') || cardContainer.style.color || ''
      : '';

    // Fallback: try to get from first step-number if container doesn't have it
    if (!textColor) {
      const firstStepNumber = container.querySelector('.step-number');
      if (firstStepNumber) {
        textColor = firstStepNumber.style.color || firstStepNumber.style.borderColor || '#000000';
      }
    }

    if (!textColor) {
      textColor = '#000000';
    }

    // Get all step items
    const stepsGrid = [];
    const cardItems = container.querySelectorAll('.card-item');

    cardItems.forEach(item => {
      const imageEl = item.querySelector('.step-image img');
      const contentEl = item.querySelector('.step-content');

      stepsGrid.push({
        image: imageEl ? imageEl.getAttribute('src') : '',
        content: contentEl ? contentEl.innerHTML.trim() : '',
      });
    });

    return {
      enableAnchor,
      title: title,
      ['steps-title']: stepsTitle,
      ['steps-grid']: stepsGrid,
      ['text-color']: textColor,
      ['background-color']: backgroundColor,
      paginationActiveColor: paginationActiveColor || '#000000',
      paginationInactiveColor: paginationInactiveColor || '#cccccc',
      topPadding: cardStepInstructionsEl.getAttribute('data-top-padding') === 'true' ? true : false,
      bottomPadding: cardStepInstructionsEl.getAttribute('data-bottom-padding') === 'true' ? true : false,
      breakpoints: {
        mobile: {
          slidesPerView: parseInt(mobileSlides, 10) || 1,
        },
        tablet: {
          slidesPerView: parseInt(tabletSlides, 10) || 2,
        },
        desktop: {
          slidesPerView: parseInt(desktopSlides, 10) || 3,
        },
      },
    };
  },
  sectionPurchaseIncentive(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');

    const result = {};

    // Get section element
    const sectionEl = doc.querySelector('.purchase-incentive-wrapper');
    const sectionContentEl = doc.querySelector('.purchase-incentive');

    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      result['title'] = sectionEl.getAttribute('data-title') || 'Section Purchase Incentive';
      result['background-color'] = rgbToHex(sectionEl.style.backgroundColor) || '#ffffff';
      result['text-color'] = rgbToHex(sectionEl.style.color) || '#000000';
      result['section-content-position'] = sectionEl.getAttribute('data-content-position') || 'center';
    }

    if (sectionContentEl) {
      result.topPadding = sectionContentEl.getAttribute('data-top-padding') === 'true' ? true : false;
      result.bottomPadding = sectionContentEl.getAttribute('data-bottom-padding') === 'true' ? true : false;
    }

    // Get wrap-sale-item paragraphs
    const wrapSaleItems = doc.querySelectorAll('.wrap-sale-item p');
    if (wrapSaleItems[0]) {
      result['sale-text-1'] = wrapSaleItems[0].textContent.trim();
      result['sale-text-1-show'] = sectionEl.getAttribute('data-sale-text-1-show') === 'true' ? true : false;
    }
    if (wrapSaleItems[1]) {
      result['sale-text-2'] = wrapSaleItems[1].textContent.trim();
      result['sale-text-2-show'] = sectionEl.getAttribute('data-sale-text-2-show') === 'true' ? true : false;
    }

    // Get button element
    const btnOrderNow = doc.querySelector('.btn-order-now');
    if (btnOrderNow) {
      result['button-text'] = btnOrderNow.textContent.trim();
      result['button-text-color'] = rgbToHex(btnOrderNow.style.color) || '#ffffff';
      result['button-bg-color'] = rgbToHex(btnOrderNow.style.backgroundColor) || '#5ca605';
    }

    // Get wrap-guarantee-item paragraphs
    const wrapGuaranteeItems = doc.querySelectorAll('.wrap-guarantee-item p');
    if (wrapGuaranteeItems[0]) {
      result['guarantee-text-1'] = wrapGuaranteeItems[0].textContent.trim();
      result['guarantee-text-1-show'] = sectionEl.getAttribute('data-guarantee-text-1-show') === 'true' ? true : false;
    }
    if (wrapGuaranteeItems[1]) {
      result['guarantee-text-2'] = wrapGuaranteeItems[1].textContent.trim();
      result['guarantee-text-2-show'] = sectionEl.getAttribute('data-guarantee-text-2-show') === 'true' ? true : false;
    }

    return result;
  },
  sectionSocialMedia(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Social Media Section',
      socialMediaTitle: `<h2 style="text-align: center">It's Going Viral on Social Media</h2>`,
      posts: [],
      colors: {
        backgroundColor: '#ffffff',
        postWrapperBackgroundColor: '#f0f2f5',
        postBackgroundColor: '#ffffff',
        postTextColor: '#000000',
        commentBackgroundColor: '#f0f2f5',
        commentTextColor: '#000000',
        borderColor: '#e5e7eb',
      },
    };
    const container = doc.querySelector('[data-section]');
    if (container) {
      result.title = container.getAttribute('data-title') || result.title;
    }
    const sectionEl = doc.querySelector('.social-media-wrapper');
    if (sectionEl) {
      result.socialMediaTitle = sectionEl.querySelector('.social-media-title').innerHTML.trim() || result.title;

      result.colors.backgroundColor = rgbToHex(sectionEl.style.backgroundColor) || result.colors.backgroundColor;

      const firstPostWrapper = sectionEl.querySelector('.post-item-wrapper');
      if (firstPostWrapper) {
        result.colors.postWrapperBackgroundColor =
          rgbToHex(firstPostWrapper.style.backgroundColor) || result.colors.postWrapperBackgroundColor;

        const firstPostItem = firstPostWrapper.querySelector('.post-item');
        if (firstPostItem) {
          result.colors.postBackgroundColor =
            rgbToHex(firstPostItem.style.backgroundColor) || result.colors.postBackgroundColor;
        }

        const firstPostContent = firstPostWrapper.querySelector('.post-content');
        if (firstPostContent) {
          result.colors.postTextColor = rgbToHex(firstPostContent.style.color) || result.colors.postTextColor;
        }

        // Get border color from reaction button wrapper
        const firstReactionButtonWrapper = firstPostWrapper.querySelector('.post-reaction-button-wrapper');
        if (firstReactionButtonWrapper) {
          result.colors.borderColor =
            rgbToHex(firstReactionButtonWrapper.style.borderTopColor) ||
            rgbToHex(firstReactionButtonWrapper.style.borderBottomColor) ||
            result.colors.borderColor;
        }

        // Get comment colors from first comment header
        const firstCommentHeader = firstPostWrapper.querySelector('.post-comment-content-header');
        if (firstCommentHeader) {
          result.colors.commentBackgroundColor =
            rgbToHex(firstCommentHeader.style.backgroundColor) || result.colors.commentBackgroundColor;

          result.colors.commentTextColor = rgbToHex(firstCommentHeader.style.color) || result.colors.commentTextColor;
        }
      }

      sectionEl.querySelectorAll('.post-item-wrapper').forEach(item => {
        result.posts.push({
          createdAt: item.querySelector('.post-author-time-text').textContent.trim() || '',
          content: item.querySelector('.post-content').textContent.trim() || '',
          author: {
            name: item.querySelector('.post-author-name').textContent.trim() || '',
            avatar: item.querySelector('.post-author-avatar img').getAttribute('src') || '',
          },
          commentCount: item.querySelector('.post-reaction-comments-count-number').textContent.trim() || '0',
          reactionCount: item.querySelector('.post-reaction-likes-count').textContent.trim() || '0',
          comments: Array.from(item.querySelectorAll('.post-comment-item')).map(comment => {
            return {
              content: comment.querySelector('.post-comment-content-header-text').textContent.trim() || '',
              author: {
                name: comment.querySelector('.post-comment-content-header-name').textContent.trim() || '',
                avatar: comment.querySelector('.post-comment-avatar img').getAttribute('src') || '',
              },
              createdAt: comment.querySelector('.post-comment-content-footer-time').textContent.trim() || '',
            };
          }),
        });
      });
    }
    return result;
  },
  sectionFeaturedOffer(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Featured Offer Section',
      featuredOfferTitle: '',
      buttonText: 'GET 50% OFF →',
      buttonShow: true,
      imagePosition: 'left',
      buttonPosition: 'center',
      image: '',
      imageShow: true,
      contentHeader: '',
      contentFooter: '',
      colors: {
        backgroundColor: '#ffffff',
        borderColor: '#707071',
        backgroundColorContent: '#FEFDEA',
        backgroundColorCard: '#ffffff',
        buttonBackgroundColor: '#90CF5B',
        buttonTextColor: '#ffffff',
      },
      topPadding: true,
      bottomPadding: true,
    };
    const container = doc.querySelector('[data-section]');
    if (container) {
      result.title = container.getAttribute('data-title') || result.title;
    }
    const sectionEl = doc.querySelector('.featured-offer-wrapper');
    if (sectionEl) {
      result.featuredOfferTitle = sectionEl.querySelector('.featured-offer-title').innerHTML.trim();
      result.colors.backgroundColor = rgbToHex(sectionEl.style.backgroundColor) || result.colors.backgroundColor;
      result.topPadding = sectionEl.getAttribute('data-top-padding') === 'true' ? true : false;
      result.bottomPadding = sectionEl.getAttribute('data-bottom-padding') === 'true' ? true : false;
    }

    const cardWrapperEl = sectionEl.querySelector('.featured-offer-card-wrapper');
    if (cardWrapperEl) {
      result.colors.backgroundColorContent =
        rgbToHex(cardWrapperEl.style.backgroundColor) || result.colors.backgroundColorContent;
    }

    const cardEl = sectionEl.querySelector('.featured-offer-card');
    if (cardEl) {
      result.colors.borderColor = rgbToHex(cardEl.style.borderColor) || result.colors.borderColor;
      result.colors.backgroundColorCard = rgbToHex(cardEl.style.backgroundColor) || result.colors.backgroundColorCard;

      const imagePosition = cardEl.getAttribute('data-image-position');

      if (imagePosition) {
        result.imagePosition = imagePosition;
      }
    }

    const buttonEl = sectionEl.querySelector('.featured-offer-card-content-button-wrapper');
    if (buttonEl) {
      result.colors.buttonBackgroundColor =
        rgbToHex(buttonEl.style.backgroundColor) || result.colors.buttonBackgroundColor;
      result.colors.buttonTextColor = rgbToHex(buttonEl.style.color) || result.colors.buttonTextColor;

      result.buttonShow = buttonEl.getAttribute('data-show-btn') === 'true' ? true : false;
      result.buttonText = buttonEl.textContent.trim();
      result.buttonPosition = buttonEl.getAttribute('data-button-position');
    }

    const buttonAnimationEl = sectionEl.querySelector('.featured-offer-card-content-button');
    if (buttonAnimationEl) {
      result.buttonAnimation = buttonAnimationEl.getAttribute('data-button-animation-show') === 'true' ? true : false;
    }

    const imageEl = sectionEl.querySelector('.featured-offer-card-image img');
    if (imageEl) {
      result.image = imageEl.getAttribute('src') || '';
    }

    const imageShowEl = sectionEl.querySelector('.featured-offer-card-image');
    if (imageShowEl) {
      result.imageShow = imageShowEl.getAttribute('data-image-show') === 'true' ? true : false;
    }

    const contentHeaderEl = sectionEl.querySelector('.featured-offer-card-content-header');
    if (contentHeaderEl) {
      result.contentHeader = contentHeaderEl.innerHTML.trim();
    }

    const contentFooterEl = sectionEl.querySelector('.featured-offer-card-content-footer');
    if (contentFooterEl) {
      result.contentFooter = contentFooterEl.innerHTML.trim();
    }

    return result;
  },
  sectionPost(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: '',
      postTitle: '',
      breadcrumb: 'Toy > Family Gift Toys > Kid & Pet Interactive Toys',
      author: {
        name: 'Elysia F.',
        avatar: 'https://cdn.latteprint.com/latte/2025-08-22/1755856692811-79.jpg',
      },
      summary: {
        text: '',
        backgroundColor: '#EAFDD7',
        textColor: '#000000',
      },
      content: '',
      createdAt: '12/12/2025',
      colors: {
        backgroundColor: '#ffffff',
        textColor: '#000000',
        borderColor: '#e5e7eb',
      },
      topPadding: true,
      bottomPadding: true,
    };
    const container = doc.querySelector('[data-section]');
    if (container) {
      result.title = container.getAttribute('data-title') || result.title;
    }

    const postWrapperEl = doc.querySelector('.post-wrapper');
    if (postWrapperEl) {
      result.colors.backgroundColor = rgbToHex(postWrapperEl.style.backgroundColor) || result.colors.backgroundColor;
      result.topPadding = postWrapperEl.getAttribute('data-top-padding') === 'true';
      result.bottomPadding = postWrapperEl.getAttribute('data-bottom-padding') === 'true';
    }

    const postBreadcrumbEl = doc.querySelector('.post-breadcrumb');
    if (postBreadcrumbEl) {
      result.breadcrumb = postBreadcrumbEl.textContent.trim();
      result.colors.textColor = rgbToHex(postBreadcrumbEl.style.color) || result.colors.textColor;
    }

    const postTitleEl = doc.querySelector('.post-title');
    if (postTitleEl) {
      result.postTitle = postTitleEl.innerHTML.trim();
    }

    const postAuthorDividerEl = doc.querySelector('.post-author-divider');
    if (postAuthorDividerEl) {
      result.colors.borderColor = rgbToHex(postAuthorDividerEl.style.backgroundColor) || result.colors.borderColor;
    }

    const postAuthorAvatarEl = doc.querySelector('.post-author-avatar');
    if (postAuthorAvatarEl) {
      const img = postAuthorAvatarEl.querySelector('img');
      if (img) {
        result.author.avatar = img.getAttribute('src') || '';
      }
    }

    const postAuthorTimeEl = doc.querySelector('.post-author-time');
    if (postAuthorTimeEl) {
      result.createdAt = postAuthorTimeEl.textContent.trim() || '';
    }

    const postAuthorNameEl = doc.querySelector('.post-author-name');
    if (postAuthorNameEl) {
      result.author.name = postAuthorNameEl.textContent.trim() || '';
    }

    const postSummaryEl = doc.querySelector('.post-summary');
    if (postSummaryEl) {
      result.summary.text = postSummaryEl.innerHTML.trim();
      result.summary.textColor = rgbToHex(postSummaryEl.style.color) || result.summary.textColor;
      result.summary.backgroundColor = rgbToHex(postSummaryEl.style.backgroundColor) || result.summary.backgroundColor;
    }

    const postContentEl = doc.querySelector('.post-content');
    if (postContentEl) {
      result.content = postContentEl.innerHTML.trim();
    }

    return result;
  },

  sectionCardReview(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Card Review Section',
      review: {
        image: '',
        text: '',
        name: '',
        position: 'left',
        show: true,
      },
      rating: 5,
      ratingShow: true,
      content: '',
      list: [],
      footer: '',
      colors: {
        backgroundColor: '',
        backgroundColorContent: '#EAFDD7',
        cardBackgroundColor: '#FFFFFF',
        cardTextColor: '#000000',
      },
      topPadding: true,
      bottomPadding: true,
    };

    const container = doc.querySelector('[data-section]');
    if (container) {
      result.title = container.getAttribute('data-title') || result.title;
    }

    const wrapper = doc.querySelector('.card-review-wrapper');
    if (wrapper) {
      result.topPadding = wrapper.getAttribute('data-top-padding') === 'true';
      result.bottomPadding = wrapper.getAttribute('data-bottom-padding') === 'true';
      result.colors.backgroundColor = rgbToHex(wrapper.style.backgroundColor) || result.colors.backgroundColor;
    }

    // Extract left side review
    const reviewContainer = doc.querySelector('.card-review-container');
    if (reviewContainer) {
      result.review.position = reviewContainer.getAttribute('data-position') || 'left';
      result.colors.backgroundColorContent =
        rgbToHex(reviewContainer.style.backgroundColor) || result.colors.backgroundColorContent;
    }

    const reviewLeft = doc.querySelector('.card-review-left');
    if (reviewLeft) {
      result.colors.cardBackgroundColor =
        rgbToHex(reviewLeft.style.backgroundColor) || result.colors.cardBackgroundColor;
      result.review.show = reviewLeft.getAttribute('data-review-show') !== 'false';
    }

    const reviewImage = doc.querySelector('.card-review-image img');
    if (reviewImage) {
      result.review.image = reviewImage.getAttribute('src') || '';
    }

    const reviewText = doc.querySelector('.card-review-text');
    if (reviewText) {
      result.review.text = reviewText.innerHTML.trim();
    }

    const reviewName = doc.querySelector('.card-review-name');
    if (reviewName) {
      result.review.name = reviewName.textContent.trim();
      result.colors.cardTextColor = rgbToHex(reviewName.style.color) || result.colors.cardTextColor;
    }

    // Extract rating
    const ratingStars = doc.querySelector('.card-review-wrap-stars');
    if (ratingStars) {
      const fullStars = ratingStars.getAttribute('data-full-stars');
      result.rating = fullStars ? parseFloat(fullStars) : 5;
      result.ratingShow = ratingStars.getAttribute('data-rating-show') !== 'false';
    }

    // Extract content (title and description)
    const content = doc.querySelector('.card-review-content');
    if (content) {
      result.content = content.innerHTML.trim();
    }

    // Extract list items
    const listItems = doc.querySelectorAll('.card-review-item');
    result.list = [];
    listItems.forEach(item => {
      const img = item.querySelector('.card-review-item-image img');
      const text = item.querySelector('.card-review-item-text');
      result.list.push({
        image: img ? img.getAttribute('src') || '' : '',
        text: text ? text.innerHTML.trim() : '',
      });
    });

    // Extract footer
    const footer = doc.querySelector('.card-review-footer');
    if (footer) {
      result.footer = footer.innerHTML.trim();
    }

    return result;
  },

  sectionCardReview02(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Card Review Section 02',
      image: {
        url: '',
        position: 'left',
        show: true,
        ratingText: '4.8 Rating From 52,427+',
      },
      rating: 5,
      ratingShow: true,
      content: '',
      list: [],
      footer: '',
      colors: {
        backgroundColor: '#3CB54B',
        textColor: '#ffffff',
        buttonTextColor: '#000000',
        buttonBackgroundColor: '#FACC15',
        buttonIconBackground: '#eab308',
      },
      button: {
        text: 'ORDER NOW AND SAVE!',
        show: true,
        animationShow: true,
      },
      topPadding: true,
      bottomPadding: true,
    };

    const container = doc.querySelector('[data-section]');
    if (container) {
      result.title = container.getAttribute('data-title') || result.title;
    }

    const wrapper = doc.querySelector('.card-review-wrapper');
    if (wrapper) {
      result.topPadding = wrapper.getAttribute('data-top-padding') === 'true';
      result.bottomPadding = wrapper.getAttribute('data-bottom-padding') === 'true';
      result.colors.backgroundColor =
        wrapper.style.getPropertyValue('--background-color') || result.colors.backgroundColor;
      result.colors.textColor = wrapper.style.getPropertyValue('--text-color') || result.colors.textColor;
      result.colors.buttonTextColor =
        wrapper.style.getPropertyValue('--button-text-color') || result.colors.buttonTextColor;
      result.colors.buttonBackgroundColor =
        wrapper.style.getPropertyValue('--button-background-color') || result.colors.buttonBackgroundColor;
      result.colors.buttonIconBackground =
        wrapper.style.getPropertyValue('--button-icon-background') || result.colors.buttonIconBackground;
      result.button.show = wrapper.getAttribute('data-button-show') === 'true' ? true : false;
      result.button.animationShow = wrapper.getAttribute('data-button-animation-show') === 'true' ? true : false;
    }

    const buttonEl = wrapper.querySelector('.card-review-button');
    if (buttonEl) {
      result.button.text = buttonEl.textContent.trim();
    }

    // Extract left side review
    const reviewContainer = doc.querySelector('.card-review-container');
    if (reviewContainer) {
      result.image.position = reviewContainer.getAttribute('data-position') || 'left';
    }

    const reviewLeft = doc.querySelector('.card-review-left');
    if (reviewLeft) {
      result.image.show = reviewLeft.getAttribute('data-review-show') !== 'false';
    }

    const reviewImage = doc.querySelector('.card-review-image img');
    if (reviewImage) {
      result.image.url = reviewImage.getAttribute('src') || '';
    }

    // Extract rating
    const ratingStars = doc.querySelector('.card-review-wrap-stars');
    if (ratingStars) {
      const fullStars = ratingStars.getAttribute('data-full-stars');
      result.rating = fullStars ? parseFloat(fullStars) : 5;
      result.ratingShow = ratingStars.getAttribute('data-rating-show') !== 'false';
    }
    const ratingText = doc.querySelector('.card-review-rating-text');
    if (ratingText) {
      result.ratingText = ratingText.textContent.trim();
    }

    // Extract content (title and description)
    const content = doc.querySelector('.card-review-content');
    if (content) {
      result.content = content.innerHTML.trim();
    }

    // Extract list items
    const listItems = doc.querySelectorAll('.card-review-item');
    result.list = [];
    listItems.forEach(item => {
      const img = item.querySelector('.card-review-item-image img');
      const text = item.querySelector('.card-review-item-text');
      result.list.push({
        image: img ? img.getAttribute('src') || '' : '',
        text: text ? text.innerHTML.trim() : '',
      });
    });

    // Extract footer
    const footer = doc.querySelector('.card-review-footer');
    if (footer) {
      result.footer = footer.innerHTML.trim();
    }

    return result;
  },

  sectionCardMedia(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Card Review Section 03',
      reviewTitle: 'Protect Your Family From the Silent Killer',
      media: {
        url: '',
        video: '',
        type: 'image',
        position: 'left',
        show: true,
      },
      content: '',
      customerReview: {
        avatar: '',
        name: '',
        content: '',
        rating: 5,
      },
      list: [],
      featureListEnable: true,
      itemImageWidthDesktop: 30,
      itemImageWidthMobile: 30,
      itemImageHeightDesktop: 30,
      itemImageHeightMobile: 30,
      footer: '',
      colors: {
        backgroundColor: '#ffffff',
        textColor: '#000000',
        buttonTextColor: '#ffffff',
        buttonBackgroundColor: '#DD1D1D',
      },
      button: {
        text: 'GET 50% OFF TODAY ONLY!',
        show: true,
        borderRadius: 8,
        minWidth: 400,
      },
    };

    const container = doc.querySelector('[data-section]');
    if (container) {
      result.title = container.getAttribute('data-title') || result.title;
    }

    const wrapper = doc.querySelector('.card-review-wrapper');
    if (wrapper) {
      result.colors.backgroundColor =
        wrapper.style.getPropertyValue('--background-color') || result.colors.backgroundColor;
      result.colors.textColor = wrapper.style.getPropertyValue('--text-color') || result.colors.textColor;
      result.colors.buttonTextColor =
        wrapper.style.getPropertyValue('--button-text-color') || result.colors.buttonTextColor;
      result.colors.buttonBackgroundColor =
        wrapper.style.getPropertyValue('--button-background-color') || result.colors.buttonBackgroundColor;
      const buttonShowAttr = wrapper.getAttribute('data-button-show');
      if (buttonShowAttr !== null) {
        result.button.show = buttonShowAttr === 'true';
      }
      result.media.position = wrapper.getAttribute('data-image-position') || 'left';
      result.topPadding = wrapper.getAttribute('data-top-padding') === 'true';
      result.bottomPadding = wrapper.getAttribute('data-bottom-padding') === 'true';
      const featureListEnableAttr = wrapper.getAttribute('data-feature-list-enable');
      if (featureListEnableAttr !== null) {
        result.featureListEnable = featureListEnableAttr === 'true';
      }

      const parseImageSize = (attr, cssVar, fallback) => {
        const attrValue = wrapper.getAttribute(attr);
        if (attrValue !== null && attrValue !== '') {
          const parsed = Number(attrValue);
          if (!Number.isNaN(parsed)) return parsed;
        }
        const varValue = wrapper.style.getPropertyValue(cssVar);
        if (varValue) {
          const parsed = Number(
            String(varValue)
              .replace('px', '')
              .trim(),
          );
          if (!Number.isNaN(parsed)) return parsed;
        }
        return fallback;
      };

      result.itemImageWidthDesktop = parseImageSize('data-item-image-width-desktop', '--item-image-width-desktop', 30);
      result.itemImageWidthMobile = parseImageSize('data-item-image-width-mobile', '--item-image-width-mobile', 30);
      result.itemImageHeightDesktop = parseImageSize(
        'data-item-image-height-desktop',
        '--item-image-height-desktop',
        30,
      );
      result.itemImageHeightMobile = parseImageSize('data-item-image-height-mobile', '--item-image-height-mobile', 30);
    }

    const reviewTitleEl = doc.querySelector('.card-review-title');
    if (reviewTitleEl) {
      result.reviewTitle = reviewTitleEl.innerHTML.trim();
    }

    const buttonContainerEl = doc.querySelector('.card-review-button-container');
    if (buttonContainerEl) {
      const minWidthAttr = buttonContainerEl.getAttribute('data-button-min-width');
      const minWidthVar = buttonContainerEl.style.getPropertyValue('--button-min-width');
      const minWidthInline = buttonContainerEl.style.minWidth;
      const minWidthSource = minWidthAttr || minWidthVar || minWidthInline;
      const minWidth = Number(
        String(minWidthSource)
          .replace('px', '')
          .trim(),
      );
      if (!Number.isNaN(minWidth) && minWidth > 0) {
        result.button.minWidth = minWidth;
      }
    }

    const buttonEl = doc.querySelector('.card-review-button');
    if (buttonEl) {
      const buttonTextEl = buttonEl.querySelector('.card-review-button-text');
      if (buttonTextEl) {
        result.button.text = buttonTextEl.textContent.trim();
      } else {
        result.button.text = buttonEl.textContent.trim();
      }

      const buttonRadiusValue = buttonEl.getAttribute('data-button-border-radius') || buttonEl.style.borderRadius || '';
      const parsedRadius = Number(
        String(buttonRadiusValue)
          .replace('px', '')
          .trim(),
      );
      if (!Number.isNaN(parsedRadius) && parsedRadius >= 0) {
        result.button.borderRadius = parsedRadius;
      }
    }

    const reviewLeft = doc.querySelector('.card-review-left');
    if (reviewLeft) {
      result.media.show = reviewLeft.getAttribute('data-review-show') !== 'false';
    }

    const reviewVideo = doc.querySelector('.card-review-image video');
    const reviewImage = doc.querySelector('.card-review-image img');
    if (reviewVideo) {
      result.media.type = 'video';
      const source = reviewVideo.querySelector('source');
      result.media.video = source ? source.getAttribute('src') || '' : reviewVideo.getAttribute('src') || '';
    } else if (reviewImage) {
      result.media.type = 'image';
      result.media.url = reviewImage.getAttribute('src') || '';
    }

    // Extract content (title and description)
    const content = doc.querySelector('.card-review-content');
    if (content) {
      result.content = content.innerHTML.trim();
    }

    // Extract list items
    const listItems = doc.querySelectorAll('.card-review-item');
    result.list = [];
    listItems.forEach(item => {
      const img = item.querySelector('.card-review-item-image img');
      const text = item.querySelector('.card-review-item-text');
      result.list.push({
        image: img ? img.getAttribute('src') || '' : '',
        text: text ? text.innerHTML.trim() : '',
      });
    });

    // Extract footer
    const footer = doc.querySelector('.card-review-footer');
    if (footer) {
      result.footer = footer.innerHTML.trim();
    }

    // Extract customer review
    const customerReview = doc.querySelector('.card-review-customer');
    if (customerReview) {
      result.customerReview.avatar =
        customerReview.querySelector('.card-review-customer-image img').getAttribute('src') || '';
      result.customerReview.name = customerReview.querySelector('.card-review-customer-name').innerHTML.trim();
      result.customerReview.content = customerReview.querySelector('.card-review-customer-content').innerHTML.trim();
      result.customerReview.rating =
        customerReview.querySelector('.card-review-wrap-stars').getAttribute('data-full-stars') || 5;
      result.customerReview.enable = customerReview.getAttribute('data-customer-review-enable') !== 'false';
    }

    return result;
  },

  sectionCardKeyFeatures(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Key Features',
      header: '',
      items: [],
      colors: {
        backgroundColor: '#ffffff',
      },
      topPadding: true,
      bottomPadding: true,
    };

    const container = doc.querySelector('[data-section]');
    if (container) {
      result.title = container.getAttribute('data-title') || result.title;
    }

    const wrapper = doc.querySelector('.key-features-wrapper');
    if (wrapper) {
      result.colors.backgroundColor =
        wrapper.style.getPropertyValue('--data-background-color') || result.colors.backgroundColor;
      result.topPadding = wrapper.getAttribute('data-top-padding') === 'true';
      result.bottomPadding = wrapper.getAttribute('data-bottom-padding') === 'true';
    }

    const headerEl = doc.querySelector('.key-features-header');
    if (headerEl) {
      result.header = headerEl.innerHTML.trim();
    }

    const itemNodes = doc.querySelectorAll('.key-feature-card');
    itemNodes.forEach(card => {
      const imageEl = card.querySelector('.key-feature-image img');
      const contentEl = card.querySelector('.key-feature-content');

      result.items.push({
        image: imageEl ? imageEl.getAttribute('src') : '',
        content: contentEl ? contentEl.innerHTML.trim() : '',
      });
    });

    return result;
  },

  sectionCardStep(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Card Step Section',
      stepTitle: '',
      image: {
        url: '',
      },
      steps: [],
      colors: {
        backgroundColor: '#ffffff',
        numberColor: '#90cf5b',
        borderColor: '#BCBCBC',
      },
      topPadding: true,
      bottomPadding: true,
    };

    const container = doc.querySelector('[data-section]');
    if (container) {
      result.title = container.getAttribute('data-title') || result.title;
      result.enableAnchor = container.getAttribute('data-enable-anchor') === 'true';
    }

    const wrapper = doc.querySelector('.card-step-wrapper');
    if (wrapper) {
      result.topPadding = wrapper.getAttribute('data-top-padding') === 'true';
      result.bottomPadding = wrapper.getAttribute('data-bottom-padding') === 'true';
    }

    // Extract image and position
    const cardContainer = doc.querySelector('.card-step-container');
    if (cardContainer) {
      result.image.position = cardContainer.getAttribute('data-position') || 'left';
    }

    const imageEl = doc.querySelector('.card-step-image img');
    if (imageEl) {
      result.image.url = imageEl.getAttribute('src') || '';
    }

    const stepTitleEl = doc.querySelector('.card-step-description');
    if (stepTitleEl) {
      result.stepTitle = stepTitleEl.innerHTML.trim();
    }

    // Extract steps
    const stepItems = doc.querySelectorAll('.card-step-item');
    result.steps = Array.from(stepItems).map(item => {
      const numberEl = item.querySelector('.card-step-item-number');
      const contentEl = item.querySelector('.card-step-item-text');
      return {
        number: numberEl ? numberEl.textContent.trim() : '01',
        content: contentEl ? contentEl.innerHTML.trim() : '',
      };
    });

    const wrapperEl = container.querySelector('.card-step-wrapper');
    if (wrapperEl) {
      result.colors.backgroundColor = rgbToHex(wrapperEl.style.backgroundColor) || result.colors.backgroundColor;
    }

    const numberEl = container.querySelector('.card-step-item-number');
    if (numberEl) {
      result.colors.numberColor = rgbToHex(numberEl.style.color) || result.colors.numberColor;
      result.colors.borderColor = rgbToHex(numberEl.style.borderColor) || result.colors.borderColor;
    }

    return result;
  },
  sectionTableBenefitsComparison(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: '',
      backgroundColor: '',
      titleContent: '',
      tableBenefitsComparison: '',
      borderColor: '#e5e7eb',
      headerBorderEnabled: false,
      topPadding: true,
      bottomPadding: true,
    };
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';
    }
    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'wrapper-container': {
          result['topPadding'] = el.getAttribute('data-top-padding') === 'true' ? true : false;
          result['bottomPadding'] = el.getAttribute('data-bottom-padding') === 'true' ? true : false;
          result['borderColor'] = el.getAttribute('data-border-color') || '#e5e7eb';
          result['headerBorderEnabled'] = el.getAttribute('data-header-border-enabled') === 'true' ? true : false;
          break;
        }
        case 'wrapper-content': {
          const backgroundColor =
            rgbToHex(el.getAttribute('data-background-color')) || rgbToHex(el.style.backgroundColor) || '';
          result['backgroundColor'] = backgroundColor ? backgroundColor : '';
          break;
        }
        case 'title-content': {
          result['titleContent'] = el.innerHTML.trim();
          break;
        }
        case 'table-benefits-comparison': {
          result['tableBenefitsComparison'] = el.innerHTML.trim();
          break;
        }
        default:
          break;
      }
    });
    return result;
  },
  sectionSocialComment(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: '',
      socialCommentTitle: '',
      comments: [],
      colors: {
        backgroundColor: '#ffffff',
        textColor: '#000000',
        authorNameColor: '#3b5998',
        actionColor: '#2563eb',
        replyBorderColor: '#9ca3af',
        textareaBorderColor: '#D9D9D9',
      },
      topPadding: true,
      bottomPadding: true,
    };
    const container = doc.querySelector('[data-section]');
    if (container) {
      result.title = container.getAttribute('data-title') || result.title;
    }

    const socialCommentWrapperEl = doc.querySelector('.social-comment-wrapper');
    if (socialCommentWrapperEl) {
      result.colors = {
        backgroundColor:
          socialCommentWrapperEl.style.getPropertyValue('--background-color') || result.colors?.backgroundColor,
        textColor: socialCommentWrapperEl.style.getPropertyValue('--text-color') || result.colors?.textColor,
        authorNameColor:
          socialCommentWrapperEl.style.getPropertyValue('--author-name-color') || result.colors?.authorNameColor,
        actionColor: socialCommentWrapperEl.style.getPropertyValue('--action-color') || result.colors?.actionColor,
        replyBorderColor:
          socialCommentWrapperEl.style.getPropertyValue('--reply-border-color') || result.colors?.replyBorderColor,
        textareaBorderColor:
          socialCommentWrapperEl.style.getPropertyValue('--textarea-border-color') ||
          result.colors?.textareaBorderColor,
      };
      result.topPadding = socialCommentWrapperEl.getAttribute('data-top-padding') === 'true';
      result.bottomPadding = socialCommentWrapperEl.getAttribute('data-bottom-padding') === 'true';
    }

    const socialCommentTitle = doc.querySelector('.social-comment-title');
    if (socialCommentTitle) {
      result.socialCommentTitle = socialCommentTitle.innerHTML.trim();
    }

    const commentElements = container.querySelectorAll('.comment-item[data-comment-id]');

    commentElements.forEach(commentEl => {
      const getText = (selector, el = commentEl) => el.querySelector(selector)?.textContent.trim() || '';

      const getAttr = (selector, attr, el = commentEl) => el.querySelector(selector)?.getAttribute(attr) || '';

      const commentId = commentEl.getAttribute('data-comment-id');

      const commentItem = {
        id: commentId,
        author: {
          name: getText('.comment-author-name'),
          avatar: getAttr('.comment-avatar img', 'src'),
        },
        content: getText('.comment-content'),
        likesCount: getText('.comment-action-reaction span'),
        createdAt: getText('.comment-date'),
        replies: [],
      };

      // extract replies of this comment
      const replyElements = commentEl.querySelectorAll(`.comment-replies .comment-item[data-parent-id="${commentId}"]`);

      replyElements.forEach(replyEl => {
        commentItem.replies.push({
          id: replyEl.getAttribute('data-reply-id') || null,
          parentId: replyEl.getAttribute('data-parent-id'),
          author: {
            name: getText('.comment-author-name', replyEl),
            avatar: getAttr('.comment-avatar img', 'src', replyEl),
          },
          content: getText('.comment-content', replyEl),
          likesCount: getText('.comment-action-reaction span', replyEl),
          createdAt: getText('.comment-date', replyEl),
        });
      });

      result.comments.push(commentItem);
    });
    return result;
  },
  sectionCardFeature(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Card Feature Section',
      media: {
        image: '',
        video: '',
        type: 'image', // image, video
        position: 'left',
        show: true,
      },
      content: '',
      list: [],
      footer: '',
      colors: {
        backgroundColor: '#ffffff',
      },
      topPadding: true,
      bottomPadding: true,
    };

    const container = doc.querySelector('[data-section]');
    if (container) {
      result.title = container.getAttribute('data-title') || result.title;
    }

    const wrapper = doc.querySelector('.card-feature-wrapper');
    if (wrapper) {
      result.topPadding = wrapper.getAttribute('data-top-padding') === 'true';
      result.bottomPadding = wrapper.getAttribute('data-bottom-padding') === 'true';
      result.colors.backgroundColor = rgbToHex(wrapper.style.backgroundColor) || result.colors.backgroundColor;
      result.media.position = wrapper.getAttribute('data-position') || 'left';
      result.media.show = wrapper.getAttribute('data-show-media') !== 'false';
    }

    // Extract left side media (image or video)
    const featureVideo = doc.querySelector('.card-feature-image video');
    const featureImage = doc.querySelector('.card-feature-image img');
    if (featureVideo) {
      result.media.type = 'video';
      const source = featureVideo.querySelector('source');
      result.media.video = source ? source.getAttribute('src') || '' : featureVideo.getAttribute('src') || '';
    } else if (featureImage) {
      result.media.type = 'image';
      result.media.image = featureImage.getAttribute('src') || '';
    }

    // Extract content (title and description)
    const content = doc.querySelector('.card-feature-content');
    if (content) {
      result.content = content.innerHTML.trim();
    }

    // Extract list items
    const listItems = doc.querySelectorAll('.card-feature-item');
    result.list = [];
    listItems.forEach(item => {
      const img = item.querySelector('.card-feature-item-image img');
      const text = item.querySelector('.card-feature-item-text');
      result.list.push({
        image: img ? img.getAttribute('src') || '' : '',
        text: text ? text.innerHTML.trim() : '',
      });
    });

    // Extract footer
    const footer = doc.querySelector('.card-feature-footer');
    if (footer) {
      result.footer = footer.innerHTML.trim();
    }

    return result;
  },
  sectionReviewGridSection03(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Review Grid Section 03',
      textColor: '#000000',
      enableAnchor: false,
      padding: {
        top: true,
        bottom: true,
      },
      background: {
        color: '#ffffff',
      },
      wrapItems: {
        backgroundItem: '#ded4d4',
        listItem: [],
      },
    };
    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      result.enableAnchor = sectionEl.getAttribute('data-enable-anchor') === 'true';
      result.title = sectionEl.getAttribute('data-title') || result.title;
    }

    const wrapper = doc.querySelector('[data-attribute="wrapper-container"]');
    if (wrapper) {
      result.textColor = wrapper.getAttribute('data-text-color') || result.textColor;
      result.background.color = wrapper.getAttribute('data-background-color') || result.background.color;
      result.padding.top = wrapper.getAttribute('data-top-padding') === 'true';
      result.padding.bottom = wrapper.getAttribute('data-bottom-padding') === 'true';
    }

    const wrapItemsEl = doc.querySelector('[data-attribute="wrap-items"]');
    if (wrapItemsEl) {
      result.wrapItems.backgroundItem =
        wrapItemsEl.getAttribute('data-background-item') || result.wrapItems.backgroundItem;
      const itemReviews = wrapItemsEl.querySelectorAll('[data-attribute="item-review"]');
      itemReviews.forEach(item => {
        const userNameEl = item.querySelector('[data-attribute="user-name"]');
        const wrapVerifiedEl = item.querySelector('[data-attribute="wrap-verified"]');
        const ratingStarsEl = item.querySelector('[data-attribute="rating-stars"]');
        const titleReviewEl = item.querySelector('[data-attribute="title-review"]');
        const descriptionReviewEl = item.querySelector('[data-attribute="description-review"]');
        result.wrapItems.listItem.push({
          valueStart: ratingStarsEl ? parseInt(ratingStarsEl.getAttribute('data-value')) || 5 : 5,
          showRating: ratingStarsEl ? ratingStarsEl.getAttribute('data-show-rating') === 'true' : true,
          userName: userNameEl ? userNameEl.textContent.trim() : '',
          verifiedColor: wrapVerifiedEl ? wrapVerifiedEl.getAttribute('data-color') || '#66CEAA' : '#66CEAA',
          titleReview: titleReviewEl ? titleReviewEl.textContent.trim() : '',
          descriptionReview: descriptionReviewEl ? descriptionReviewEl.textContent.trim() : '',
        });
      });
    }

    return result;
  },
  sectionFaqCard(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: '',
      colors: {
        backgroundContainer: '',
        backgroundFaqItem: '',
        textFaqItem: '',
        backgroudCard: '',
        borderFaqItem: '',
      },
      titleFaq: '',
      layout: 'left',
      cardImage: '',
      cardContent: '',
      listItem: [],
      topPadding: true,
      bottomPadding: true,
      containerFullWidth: false,
    };
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';
    }
    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'faq-grid-container-fluid': {
          result.colors.backgroundContainer = el.getAttribute('data-background') || '#ffffff';
          result.colors.backgroudCard = el.getAttribute('data-background-card') || '#F7F8F9';
          result.topPadding = el.getAttribute('data-top-padding') === 'true' ? true : false;
          result.bottomPadding = el.getAttribute('data-bottom-padding') === 'true' ? true : false;
          result.containerFullWidth = el.getAttribute('data-container-full-width') === 'true' ? true : false;
          break;
        }
        case 'title-faq-grid': {
          result['titleFaq'] = el.innerHTML.trim();
          break;
        }
        case 'faq-grid-content': {
          result['layout'] = el.getAttribute('data-layout') || 'left';
          break;
        }
        case 'card-info-img': {
          result['cardImage'] = el.getAttribute('src') || '';
          break;
        }
        case 'card-info-text': {
          result['cardContent'] = el.innerHTML.trim();
          break;
        }
        case 'list-item': {
          const elWrapItem = el.querySelectorAll('[data-attribute="item-wapper"]');
          result.colors.backgroundFaqItem = el.getAttribute('data-background-faq-item') || '#F7F8F9';
          result.colors.textFaqItem = el.getAttribute('data-text-faq-item-color') || '#000000';
          result.colors.borderFaqItem = el.getAttribute('data-border-faq-item') || '#e5e7eb';
          elWrapItem.forEach(elItem => {
            const elQuestion = elItem.querySelector('[data-attribute="title-item-question"]');
            const elAnswer = elItem.querySelector('[data-attribute="answer-content"]');
            const elImage =
              elItem.querySelector('[data-attribute="item-image"]') || elItem.querySelector('.item-question-image img');
            const question = elQuestion ? elQuestion.textContent.trim() : '';
            const answer = elAnswer ? elAnswer.innerHTML.trim() : '';
            result['listItem'].push({
              image: elImage ? elImage.getAttribute('src') || '' : '',
              question: question,
              answer: answer,
            });
          });
          break;
        }
        default:
          break;
      }
    });
    return result;
  },
  sectionBannerMedia(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: '',
      titleBannerMedia: '',
      colors: {
        playIconBackground: '',
        playIconColor: '',
        headerTitleColor: '',
        overlayColor: '',
      },
      padding: {
        top: true,
        bottom: true,
      },
      imageBackground: {
        mobile: '',
        desktop: '',
      },
      videoUrl: '',
      overlayOpacity: 0,
    };
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Banner Media Section';
    }
    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'banner-media-title': {
          result.titleBannerMedia = el.innerHTML.trim();
          result.colors.headerTitleColor = el.getAttribute('data-header-title-color') || '#ffffff';
          break;
        }
        case 'banner-media-wrapper': {
          result.padding.top = el.getAttribute('data-top-padding') === 'true' ? true : false;
          result.padding.bottom = el.getAttribute('data-bottom-padding') === 'true' ? true : false;
          result.imageBackground.desktop = el.getAttribute('data-image-background-desktop') || '';
          result.imageBackground.mobile = el.getAttribute('data-image-background-mobile') || '';
          break;
        }
        case 'banner-media-play-icon': {
          result.colors.playIconBackground = el.getAttribute('play-icon-background') || '#ffffff';
          result.colors.playIconColor = el.getAttribute('play-icon-color') || '#000000';
          result.videoUrl = el.getAttribute('data-video-url') || '';
          break;
        }
        case 'banner-media-overlay': {
          result.colors.overlayColor = el.getAttribute('data-overlay-color') || '#000000';
          result.overlayOpacity = parseFloat(el.getAttribute('data-overlay-opacity')) || 0;
          break;
        }
        default:
          break;
      }
    });
    return result;
  },
  sectionCardMultiToolYuri(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Card Multi Tool Yuri Section',
      enableAnchor: false,
      topPadding: true,
      bottomPadding: true,
      background: '#FFFFFF',
      textColor: '#000000',
      enableContainerPage: false,
      backgroundContainer: '#FFFFFF',
      leftCard: {
        order: '1',
        centerY: false,
      },
      rightCard: {
        order: '2',
        mediaType: 'video',
        image: '',
        video: '',
      },
      showTitle: true,
      titleCard: '',
      boxListItem: {
        show: true,
        background: '#ffffff33',
        color: '#ffffff',
        listItem: [],
      },
      pillListItem: {
        show: true,
        background: '#ffffff',
        color: '#000000',
        listItem: [],
      },
      decorBottomShow: true,
      decorBottomColor: '#ffffff',
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      const title = sectionEl.getAttribute('data-title');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      result.title = title ? title : result.title;
    }

    const cardContainer = doc.querySelector('[data-attribute="card-container"]');
    if (cardContainer) {
      result.topPadding = cardContainer.getAttribute('data-top-padding') === 'true';
      result.bottomPadding = cardContainer.getAttribute('data-bottom-padding') === 'true';
      result.background = cardContainer.getAttribute('data-background') || '#FFFFFF';
      result.textColor = cardContainer.getAttribute('data-text-color') || '#000000';
    }

    const containerPage = doc.querySelector('[data-attribute="container-page"]');
    if (containerPage) {
      result.enableContainerPage = containerPage.getAttribute('data-enable-style') === 'true';
      result.backgroundContainer = containerPage.getAttribute('data-background-container') || '#FFFFFF';
    }

    const leftCard = doc.querySelector('[data-attribute="left-card"]');
    if (leftCard) {
      result.leftCard.order = leftCard.getAttribute('data-order') || result.leftCard.order;
      result.leftCard.centerY = leftCard.getAttribute('data-center-y') === 'true';
    }

    const rightCard = doc.querySelector('[data-attribute="right-card"]');
    if (rightCard) {
      result.rightCard.order = rightCard.getAttribute('data-order') || result.rightCard.order;
    }

    const titleCard = doc.querySelector('[data-attribute="title-card"]');
    if (titleCard) {
      result.showTitle = titleCard.getAttribute('data-show-title') !== 'false';
      result.titleCard = titleCard.innerHTML.trim();
    }

    const boxListItem = doc.querySelector('[data-attribute="box-list-item"]');
    if (boxListItem) {
      result.boxListItem.show = boxListItem.getAttribute('data-show') !== 'false';
      result.boxListItem.background = boxListItem.getAttribute('data-background-box') || '#ffffff33';
      result.boxListItem.color = boxListItem.getAttribute('data-color-box') || '#ffffff';
      const items = boxListItem.querySelectorAll('[data-attribute="item-on-box"]');
      result.boxListItem.listItem = Array.from(items).map(item => ({
        iconItem: item.querySelector('[data-attribute="icon-item"]')?.getAttribute('src') || '',
        head: item.querySelector('[data-attribute="head-item"]')?.innerHTML.trim() || '',
        content: item.querySelector('[data-attribute="content-item"]')?.innerHTML.trim() || '',
      }));
    }

    const pillListItem = doc.querySelector('[data-attribute="pill-list-item"]');
    if (pillListItem) {
      result.pillListItem.show = pillListItem.getAttribute('data-show') !== 'false';
      result.pillListItem.background = pillListItem.getAttribute('data-background-pill') || '#ffffff';
      result.pillListItem.color = pillListItem.getAttribute('data-color-pill') || '#000000';
      const items = pillListItem.querySelectorAll('[data-attribute="pill-item"]');
      result.pillListItem.listItem = Array.from(items).map(item => ({
        iconItem: item.querySelector('[data-attribute="icon-item"]')?.getAttribute('src') || '',
        text: item.querySelector('[data-attribute="text-item"]')?.innerHTML.trim() || '',
      }));
    }

    const videoCard = doc.querySelector('[data-attribute="video-card"]');
    const imageCard = doc.querySelector('[data-attribute="image-card"]');
    const videoEl = doc.querySelector('[data-attribute="video-card"] [data-attribute="video"]');
    const imageEl = doc.querySelector('[data-attribute="image-card"] [data-attribute="image"]');

    result.rightCard.video = videoEl?.getAttribute('src') || '';
    result.rightCard.image = imageEl?.getAttribute('src') || '';

    if (imageCard?.getAttribute('data-show') === 'true') {
      result.rightCard.mediaType = 'image';
    } else if (videoCard?.getAttribute('data-show') === 'true') {
      result.rightCard.mediaType = 'video';
    } else if (result.rightCard.image) {
      result.rightCard.mediaType = 'image';
    } else {
      result.rightCard.mediaType = 'video';
    }

    if (result.rightCard.mediaType === 'image') {
      result.rightCard.video = '';
    } else {
      result.rightCard.image = '';
    }

    const decorBottom = doc.querySelector('[data-attribute="decor-bottom"]');
    if (decorBottom) {
      result.decorBottomShow = decorBottom.getAttribute('data-show') !== 'false';
      result.decorBottomColor = decorBottom.getAttribute('data-color') || '#ffffff';
    }

    return result;
  },
  sectionCardMultiTool(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Card Multi Tool Section',
      enableAnchor: false,
      textColor: '#000000',
      padding: {
        top: true,
        bottom: true,
      },
      'background-section': {
        color: '#ffffff',
      },
      'container-content': {
        showStyle: false,
        background: '#ffffff',
      },
      leftCard: {
        order: '2',
        centerY: false,
        enableBorder: true,
        colorBorder: '#d4dceb',
      },
      rightCard: {
        order: '1',
        mediaType: 'video',
        img: '',
        video: '',
      },
      reted: {
        showRating: false,
        ratingStars: 4,
        ratingText: '',
        ratingTextColor: '#000000',
      },
      cardContent: '',
      itemAccordions: {
        dataShowAccordion: true,
        listItem: [],
      },
      'images-small': {
        show: true,
        listItem: [],
      },
      'videos-small': {
        show: false,
        listItem: [],
      },
      itemWithIcon: {
        show: true,
        listItem: [],
      },
      btnCard: {
        showBtn: true,
        backgroundColor: '#d4c4a8',
        color: '#ffffff',
        text: '',
        url: '#',
      },
    };

    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : result.title;
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'card-container': {
          const background = el.getAttribute('data-background') || el.style.backgroundColor || '#ffffff';
          result['background-section'].color = background;
          result.padding.top = el.getAttribute('data-top-padding') === 'true';
          result.padding.bottom = el.getAttribute('data-bottom-padding') === 'true';
          break;
        }
        case 'container-page': {
          const showStyle = el.getAttribute('data-show-style');
          result['container-content'].showStyle = showStyle ? showStyle === 'true' : false;
          const background = el.getAttribute('data-background');
          result['container-content'].background = background ? background : '#ffffff';
          break;
        }
        case 'card-item-content': {
          const order = el.getAttribute('data-order');
          const styleCenterY = el.getAttribute('data-style-center-y');
          result.leftCard.order = order ? String(order) : result.leftCard.order;
          result.leftCard.centerY = styleCenterY ? styleCenterY === 'true' : false;
          const enableBorder = el.getAttribute('data-enable-border');
          result.leftCard.enableBorder = enableBorder ? enableBorder === 'true' : true;
          const borderColor = el.getAttribute('data-border-color');
          if (borderColor) {
            result.leftCard.colorBorder = borderColor;
          } else {
            const borderStyle = el.getAttribute('style') || '';
            const match = borderStyle.match(/border:\s*[^;]*\s+(#[0-9a-fA-F]{3,8}|rgb\([^)]+\)|[a-zA-Z]+)\s*;?/);
            if (match) result.leftCard.colorBorder = match[1];
          }
          break;
        }
        case 'card-item-image': {
          const order = el.getAttribute('data-order');
          result.rightCard.order = order ? String(order) : result.rightCard.order;
          const showVideo = el.querySelector('[data-attribute="wrap-video"]')?.getAttribute('data-show-video');
          const showImg = el.querySelector('[data-attribute="wrap-img"]')?.getAttribute('data-show-img');
          const img = el.querySelector('[data-attribute="wrap-img"] img');
          const video = el.querySelector('[data-attribute="card-video"]');
          result.rightCard.img = img?.getAttribute('src') || '';
          result.rightCard.video = video?.getAttribute('src') || '';
          if (showVideo != null) {
            result.rightCard.mediaType = showVideo === 'true' ? 'video' : 'image';
          } else if (showImg != null) {
            result.rightCard.mediaType = showImg === 'true' ? 'image' : 'video';
          } else if (result.rightCard.video) {
            result.rightCard.mediaType = 'video';
          } else if (result.rightCard.img) {
            result.rightCard.mediaType = 'image';
          }
          break;
        }
        case 'wrap-img': {
          const img = el.querySelector('img');
          if (img) {
            result.rightCard.img = img.getAttribute('src') || result.rightCard.img;
          }
          break;
        }
        case 'card-video': {
          result.rightCard.video = el.getAttribute('src') || result.rightCard.video;
          break;
        }
        case 'card-rated-row': {
          const showRating = el.getAttribute('data-show-rating');
          result.reted.showRating = showRating ? showRating === 'true' : false;
          break;
        }
        case 'rating-stars': {
          const value = el.getAttribute('data-value');
          result.reted.ratingStars = value ? Number(value) : result.reted.ratingStars;
          break;
        }
        case 'rating-text': {
          const textColor = el.getAttribute('data-text-color');
          result.reted.ratingTextColor = textColor ? textColor : result.reted.ratingTextColor;
          result.textColor = result.reted.ratingTextColor || result.textColor;
          result.reted.ratingText = el.textContent.trim();
          break;
        }
        case 'card-content': {
          result.cardContent = el.innerHTML.trim();
          const textColor = el.getAttribute('data-text-color');
          result.textColor = textColor ? textColor : result.textColor;
          break;
        }
        case 'card-accordions': {
          const showAccordion = el.getAttribute('data-show-accordion');
          result.itemAccordions.dataShowAccordion = showAccordion ? showAccordion === 'true' : true;
          const elItems = el.querySelectorAll('[data-attribute="card-accordion"]');
          result.itemAccordions.listItem = Array.from(elItems).map(item => {
            const title = item.querySelector('[data-attribute="accordion-title-text"]')?.textContent.trim() || '';
            const answer = item.querySelector('[data-attribute="accordion-text"]')?.innerHTML.trim() || '';
            return { title, answer };
          });
          break;
        }
        case 'card-btn-row': {
          const showBtn = el.getAttribute('data-show-btn');
          result.btnCard.showBtn = showBtn ? showBtn === 'true' : false;
          break;
        }
        case 'images-small': {
          const show = el.getAttribute('data-show-imgsmall');
          result['images-small'].show = show ? show === 'true' : true;
          const items = el.querySelectorAll('.item-img');
          result['images-small'].listItem = Array.from(items).map(item => {
            const img = item.querySelector('[data-attribute="image-small"]');
            const videoSource = item.querySelector('[data-attribute="video-small"]');
            const videoSrc = videoSource?.getAttribute('src')?.trim() || '';
            const iconWrap = item.querySelector('[data-attribute="data-icon-small"]');
            const iconImg = iconWrap?.querySelector('img');

            const iSrc = img?.getAttribute('src')?.trim() || '';
            const hasImg = !!img;
            const hasVideo = !!videoSource;

            let mediaType = 'image';
            if (hasVideo && !hasImg) {
              mediaType = 'video';
            } else if (hasImg && !hasVideo) {
              mediaType = 'image';
            } else if (hasImg && hasVideo) {
              mediaType = videoSrc && !iSrc ? 'video' : 'image';
            }

            return {
              mediaType,
              img: mediaType === 'image' ? iSrc : '',
              video: mediaType === 'video' ? videoSrc : '',
              showIcon: iconWrap ? iconWrap.getAttribute('data-show-icon') !== 'false' : true,
              icon: iconImg?.getAttribute('src') || '',
            };
          });
          break;
        }
        case 'videos-small': {
          const show = el.getAttribute('data-show-videosmall');
          result['videos-small'].show = show ? show === 'true' : false;
          const videos = el.querySelectorAll('[data-attribute="video-small"]');
          result['videos-small'].listItem = Array.from(videos).map(video => ({
            video: video.getAttribute('src') || '',
          }));
          break;
        }
        case 'wrap-item-with-icon': {
          const show = el.getAttribute('data-show-item-with-icon');
          result.itemWithIcon.show = show ? show === 'true' : true;
          const items = el.querySelectorAll('[data-attribute="item-with-icon"]');
          result.itemWithIcon.listItem = Array.from(items).map(item => {
            const icon = item.querySelector('img')?.getAttribute('src') || '';
            const title = item.querySelector('.title-icon')?.textContent?.trim() || '';
            const description = item.querySelector('.description-icon')?.textContent?.trim() || '';
            return { icon, title, description };
          });
          break;
        }
        case 'card-btn': {
          // Template mới tách text/icon: text nằm trong [data-attribute="btn-text"]
          const btnTextEl = el.querySelector('[data-attribute="btn-text"]');
          result.btnCard.text = (btnTextEl ? btnTextEl.textContent : el.textContent).trim();
          result.btnCard.backgroundColor = el.getAttribute('data-background') || el.style.backgroundColor || '#d4c4a8';
          result.btnCard.color = el.getAttribute('data-color') || el.style.color || '#ffffff';
          result.btnCard.url = el.getAttribute('href') || '#';
          break;
        }
        default:
          break;
      }
    });

    if (result.rightCard.mediaType === 'image') {
      result.rightCard.video = '';
    } else {
      result.rightCard.img = '';
    }

    return result;
  },
  sectionCardMultiToolDouble(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    const result = {
      title: 'Card Multi Tool Double Section',
      enableAnchor: false,
      textColor: '#000000',
      padding: {
        top: true,
        bottom: true,
      },
      'background-section': {
        color: '#ffffff',
      },
      'container-content': {
        showStyle: false,
        background: '#ffffff',
      },
      wrapCards: {
        listItem: [],
      },
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : result.title;
    }

    const cardContainer = container?.querySelector('[data-attribute="card-container"]');
    if (cardContainer) {
      const background =
        cardContainer.getAttribute('data-background') || cardContainer.style.backgroundColor || '#ffffff';
      result['background-section'].color = background;
      result.padding.top = cardContainer.getAttribute('data-top-padding') === 'true';
      result.padding.bottom = cardContainer.getAttribute('data-bottom-padding') === 'true';
    }

    const elContainerPage = container?.querySelector('[data-attribute="container-page"]');
    if (elContainerPage) {
      const showStyle = elContainerPage.getAttribute('data-show-style');
      result['container-content'].showStyle = showStyle ? showStyle === 'true' : false;
      const background = elContainerPage.getAttribute('data-background');
      result['container-content'].background = background ? background : '#ffffff';
    }

    const slideEls = container?.querySelectorAll('[data-attribute="item-card-double"]') || [];
    slideEls.forEach(slideEl => {
      const leftCardEl = slideEl.querySelector('[data-attribute="card-item-content"]');
      const rightCardEl = slideEl.querySelector('[data-attribute="card-item-image"]');

      const elRatedRow = slideEl.querySelector('[data-attribute="card-rated-row"]');
      const elStars = slideEl.querySelector('[data-attribute="rating-stars"]');
      const elRatingText = slideEl.querySelector('[data-attribute="rating-text"]');
      const elCardContent = slideEl.querySelector('[data-attribute="card-content"]');
      const elAccordions = slideEl.querySelector('[data-attribute="card-accordions"]');
      const elImagesSmall = slideEl.querySelector('[data-attribute="images-small"]');
      const elItemWithIcon = slideEl.querySelector('[data-attribute="wrap-item-with-icon"]');
      const elBtnRow = slideEl.querySelector('[data-attribute="card-btn-row"]');
      const elBtn = slideEl.querySelector('[data-attribute="card-btn"]');
      const elSurveyCard = slideEl.querySelector('[data-attribute="card-survay"]');

      const ratingStarsRaw = elStars?.getAttribute('data-value');
      const ratingStars = ratingStarsRaw != null && ratingStarsRaw !== '' ? Number(ratingStarsRaw) : 4;

      const cardItem = {
        leftCard: {
          order: leftCardEl?.getAttribute('data-order') ?? '1',
          centerY: leftCardEl ? leftCardEl.getAttribute('data-style-center-y') === 'true' : false,
          enableBorder: leftCardEl ? leftCardEl.getAttribute('data-enable-border') === 'true' : true,
          colorBorder: leftCardEl?.getAttribute('data-border-color') || '#d4dceb',
        },
        rightCard: {
          order: rightCardEl?.getAttribute('data-order') ?? '2',
          // Template recently switched from <img> to <video><source data-attribute="card-video" src="...">.
          // Keep fallback for older HTML that still uses <img>.
          video:
            rightCardEl?.querySelector('[data-attribute="card-video"]')?.getAttribute('src') ||
            rightCardEl?.querySelector('[data-attribute="wrap-img"] img')?.getAttribute('src') ||
            '',
        },
        reted: {
          showRating: elRatedRow ? elRatedRow.getAttribute('data-show-rating') === 'true' : false,
          ratingStars: Number.isFinite(ratingStars) ? ratingStars : 4,
          ratingText: elRatingText?.textContent?.trim() || '',
          ratingTextColor: elRatingText?.getAttribute('data-text-color') || elRatingText?.style?.color || '#000000',
        },
        cardContent: elCardContent?.innerHTML?.trim() || '',
        itemAccordions: {
          dataShowAccordion: elAccordions ? elAccordions.getAttribute('data-show-accordion') === 'true' : true,
          listItem: [],
        },
        'images-small': {
          show: elImagesSmall ? elImagesSmall.getAttribute('data-show-imgsmall') === 'true' : true,
          listItem: [],
        },
        itemWithIcon: {
          show: elItemWithIcon ? elItemWithIcon.getAttribute('data-show-item-with-icon') === 'true' : true,
          listItem: [],
        },
        cardSurvey: {
          show: elSurveyCard ? elSurveyCard.getAttribute('data-show-survay') === 'true' : false,
          colorPercent: elSurveyCard?.getAttribute('data-color-percent') || '#17d4f4',
          listItem: [],
        },
        btnCard: {
          showBtn: elBtnRow ? elBtnRow.getAttribute('data-show-btn') === 'true' : true,
          backgroundColor: elBtn?.getAttribute('data-background') || elBtn?.style?.backgroundColor || '#d4c4a8',
          color: elBtn?.getAttribute('data-color') || elBtn?.style?.color || '#ffffff',
          text:
            elBtn?.querySelector('[data-attribute="btn-text"]')?.textContent?.trim() ||
            elBtn?.textContent?.trim() ||
            '',
          url: elBtn?.getAttribute('href') || '#',
        },
      };

      const accEls = elAccordions?.querySelectorAll('[data-attribute="card-accordion"]') || [];
      cardItem.itemAccordions.listItem = Array.from(accEls).map(item => {
        const title = item.querySelector('[data-attribute="accordion-title-text"]')?.textContent?.trim() || '';
        const answer = item.querySelector('[data-attribute="accordion-text"]')?.innerHTML?.trim() || '';
        return { title, answer };
      });

      const imgEls = elImagesSmall?.querySelectorAll('[data-attribute="image-small"]') || [];
      cardItem['images-small'].listItem = Array.from(imgEls).map(img => ({ img: img.getAttribute('src') || '' }));

      const iconEls = elItemWithIcon?.querySelectorAll('[data-attribute="item-with-icon"]') || [];
      cardItem.itemWithIcon.listItem = Array.from(iconEls).map(item => ({
        icon: item.querySelector('img')?.getAttribute('src') || '',
        title: item.querySelector('.title-icon')?.textContent?.trim() || '',
        description: item.querySelector('.description-icon')?.textContent?.trim() || '',
      }));

      const surveyItems = elSurveyCard?.querySelectorAll('[data-attribute="item-survay"]') || [];
      cardItem.cardSurvey.listItem = Array.from(surveyItems).map(item => {
        const percentEl = item.querySelector('[data-attribute="percent-survay"]');
        const descriptionEl = item.querySelector('[data-attribute="description-survay"]');
        const percent = percentEl ? Number(percentEl.textContent.trim()) || 0 : 0;
        const description = descriptionEl?.textContent?.trim() || '';
        return { percent, description };
      });

      result.wrapCards.listItem.push(cardItem);
    });

    // If there is at least one card, sync global text color from rating text color (common pattern).
    const firstCard = result.wrapCards.listItem[0];
    if (firstCard?.reted?.ratingTextColor) result.textColor = firstCard.reted.ratingTextColor;

    return result;
  },
  sectionMarkqueueRows(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    const result = {
      title: 'Markqueue Rows Section',
      enableAnchor: false,
      textColor: '#000000',
      padding: {
        top: false,
        bottom: false,
      },
      'background-section': {
        color: '#ffffff',
      },
      'container-content': {
        showStyle: false,
        background: '#ffffff',
      },
      container: {
        enableContainer: true,
      },
      titleMarkqueue: '',
      listRows: {
        listItem: [],
      },
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : result.title;
    }

    const cardContainer = container?.querySelector('[data-attribute="card-container"]');
    if (cardContainer) {
      const background =
        cardContainer.getAttribute('data-background') || cardContainer.style.backgroundColor || '#ffffff';
      result['background-section'].color = background;
      result.padding.top = cardContainer.getAttribute('data-top-padding') === 'true';
      result.padding.bottom = cardContainer.getAttribute('data-bottom-padding') === 'true';
      result.textColor = cardContainer.getAttribute('data-text-color') || '#000000';
    }

    const elContainerPage = container?.querySelector('[data-attribute="container-page"]');
    if (elContainerPage) {
      const showStyle = elContainerPage.getAttribute('data-show-style');
      result['container-content'].showStyle = showStyle ? showStyle === 'true' : false;
      const background = elContainerPage.getAttribute('data-background');
      result['container-content'].background = background ? background : '#ffffff';
    }

    const elContainer = container?.querySelector('[data-attribute="container"]');
    if (elContainer) {
      const enableContainer = elContainer.getAttribute('data-enable-container');
      result.container.enableContainer = enableContainer ? enableContainer === 'true' : true;
    }

    const elTitle = container?.querySelector('[data-attribute="title-markqueue"]');
    if (elTitle) result.titleMarkqueue = elTitle.innerHTML.trim();

    const rowEls = container?.querySelectorAll('[data-attribute="row-markqueue"]') || [];
    result.listRows.listItem = Array.from(rowEls).map(rowEl => {
      const imgEls = rowEl.querySelectorAll('[data-attribute="img-item"]');
      return {
        images: Array.from(imgEls).map(imgEl => ({
          image: imgEl.getAttribute('src') || '',
        })),
      };
    });

    return result;
  },
  sectionFbPost03(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    const result = {
      title: 'FB Post 03 Section',
      enableAnchor: false,
      textColor: '#000000',
      padding: {
        top: true,
        bottom: true,
      },
      'background-section': {
        color: '#f7eee7',
      },
      'container-content': {
        showStyle: false,
        background: '#ffffff',
      },
      container: {
        enableContainer: false,
      },
      titlePost: '',
      listPost: {
        colPerView: 3,
        listItem: [],
      },
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title || result.title;
    }

    const cardContainer = container?.querySelector('[data-attribute="card-container"]');
    if (cardContainer) {
      const background =
        cardContainer.getAttribute('data-background') || cardContainer.style.backgroundColor || '#f7eee7';
      result['background-section'].color = background;
      result.padding.top = cardContainer.getAttribute('data-top-padding') === 'true';
      result.padding.bottom = cardContainer.getAttribute('data-bottom-padding') === 'true';
      result.textColor = cardContainer.getAttribute('data-text-color') || '#000000';
    }

    const elContainerPage = container?.querySelector('[data-attribute="container-page"]');
    if (elContainerPage) {
      const showStyle = elContainerPage.getAttribute('data-show-style');
      result['container-content'].showStyle = showStyle ? showStyle === 'true' : false;
      const background = elContainerPage.getAttribute('data-background');
      result['container-content'].background = background || '#ffffff';
    }

    const elContainer = container?.querySelector('[data-attribute="container"]');
    if (elContainer) {
      const enableContainer = elContainer.getAttribute('data-enable-container');
      result.container.enableContainer = enableContainer ? enableContainer === 'true' : false;
    }

    const titlePostEl = container?.querySelector('[data-attribute="title-post"]');
    if (titlePostEl) result.titlePost = titlePostEl.innerHTML.trim();

    const listPostEl = container?.querySelector('[data-attribute="list-post"]');
    if (listPostEl) {
      const colPerView = Number(listPostEl.getAttribute('data-col-per-view'));
      result.listPost.colPerView = Number.isFinite(colPerView) && colPerView > 0 ? colPerView : 3;

      const itemEls = listPostEl.querySelectorAll('.wrap-item');
      result.listPost.listItem = Array.from(itemEls).map(itemEl => ({
        outherName: itemEl.querySelector('[data-attribute="user-name"]')?.textContent?.trim() || '',
        outherAvatar: itemEl.querySelector('[data-attribute="author-avatar"] img')?.getAttribute('src') || '',
        createdAt: itemEl.querySelector('[data-attribute="created-at"]')?.textContent?.trim() || '',
        postImage: itemEl.querySelector('[data-attribute="post-img"] img')?.getAttribute('src') || '',
        commentCount: itemEl.querySelector('[data-attribute="comment-count"]')?.textContent?.trim() || '0',
        reactionCount: itemEl.querySelector('[data-attribute="reaction-count"]')?.textContent?.trim() || '0',
        postText: itemEl.querySelector('[data-attribute="post-text"]')?.textContent?.trim() || '',
      }));
    }

    return result;
  },
  sectionTpla(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'TPLA Section',
      enableAnchor: false,
      textColor: '#000000',
      padding: {
        top: true,
        bottom: true,
      },
      'background-section': {
        color: '#ffffff',
        image: '',
      },
      'container-content': {
        showStyle: false,
        background: '#ffffff',
      },
      titleCard: '',
      table: {
        borderColor: '#F35C5C',
        borderWeight: '1px',
        colBorder: true,
        rowBorder: true,
        borderFull: true,
        html: '<table></table>',
      },
    };

    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : result.title;
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'card-container': {
          const background = el.getAttribute('data-background') || el.style.backgroundColor || '#ffffff';
          result['background-section'].color = background;
          result.padding.top = el.getAttribute('data-top-padding') === 'true';
          result.padding.bottom = el.getAttribute('data-bottom-padding') === 'true';
          const bgImage = el.getAttribute('data-background-image') || '';
          result['background-section'].image = bgImage;
          const textColor = el.getAttribute('data-text-color');
          if (textColor) result.textColor = textColor;
          break;
        }
        case 'container-page': {
          const showStyle = el.getAttribute('data-show-style');
          result['container-content'].showStyle = showStyle ? showStyle === 'true' : false;
          const background = el.getAttribute('data-background');
          result['container-content'].background = background ? background : '#ffffff';
          break;
        }
        case 'title-card': {
          result.titleCard = el.innerHTML.trim();
          break;
        }
        case 'table-content': {
          result.table.borderColor = el.getAttribute('data-border-color') || result.table.borderColor;
          result.table.borderWeight = el.getAttribute('data-border-weight') || result.table.borderWeight;
          const colBorder = el.getAttribute('data-col-border');
          const rowBorder = el.getAttribute('data-row-border');
          const borderFull = el.getAttribute('data-border-full');
          result.table.colBorder = colBorder ? colBorder === 'true' : result.table.colBorder;
          result.table.rowBorder = rowBorder ? rowBorder === 'true' : result.table.rowBorder;
          result.table.borderFull = borderFull ? borderFull === 'true' : result.table.borderFull;
          const tableEl = el.querySelector('table');
          result.table.html = tableEl ? tableEl.outerHTML : el.innerHTML.trim();
          break;
        }
        default:
          break;
      }
    });

    return result;
  },
  sectionReviewVital(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Review Vital Section',
      enableAnchor: false,
      titleCard: '',
      colorStar: '#214a88',
      backgroundColor: '#ffffff',
      textColor: '#000000',
      'container-page': {
        backgroundContainer: '#FFFFFF',
        showStyleContainer: false,
      },
      admin: {
        avatar: '',
        name: '',
      },
      productReview: {
        title: '',
        name: '',
        imge: '',
      },
      pageLimit: 1,
      listItemReview: [],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : result.title;
    }

    const cardContainer = doc.querySelector('[data-attribute="card-container"]');
    if (cardContainer) {
      result.backgroundColor = cardContainer.getAttribute('data-background') || '#ffffff';
      result.textColor =
        cardContainer.getAttribute('data-text-color') || cardContainer.getAttribute('data-color') || '#000000';
      result.admin.avatar = cardContainer.getAttribute('data-avatar-admin') || '';
      result.admin.name = cardContainer.getAttribute('data-name-admin') || '';
      result.productReview.imge = cardContainer.getAttribute('data-img-product-review') || '';
      result.productReview.title = cardContainer.getAttribute('data-title-product-review') || '';
      result.productReview.name = cardContainer.getAttribute('data-name-product-review') || '';
      result.pageLimit = Number(cardContainer.getAttribute('data-page-limit') || 1);

      const rawPayload = cardContainer.getAttribute('data-payload') || '[]';
      try {
        const parsed = JSON.parse(rawPayload || '[]');
        result.listItemReview = Array.isArray(parsed) ? parsed : [];
      } catch (_e) {
        result.listItemReview = [];
      }

      const styleText = cardContainer.getAttribute('style') || '';
      const colorStarMatch = styleText.match(/--color-star:\s*([^;]+)/i);
      if (colorStarMatch && colorStarMatch[1]) {
        result.colorStar = colorStarMatch[1].trim();
      }
    }

    const containerPage = doc.querySelector('[data-attribute="container-page"]');
    if (containerPage) {
      const showStyle = containerPage.getAttribute('data-show-style');
      result['container-page'].showStyleContainer = showStyle ? showStyle === 'true' : false;
      result['container-page'].backgroundContainer = containerPage.getAttribute('data-background') || '#FFFFFF';
    }

    const titleCardEl = doc.querySelector('[data-attribute="title-card"]');
    if (titleCardEl) {
      result.titleCard = titleCardEl.innerHTML.trim();
    }

    return result;
  },

  sectionReviewTitan(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Review Titan Section',
      enableAnchor: false,
      textColor: '#ffffff',
      padding: {
        top: true,
        bottom: true,
      },
      'background-section': {
        color: '#e6e6e6',
        image: '',
      },
      'container-content': {
        showStyle: false,
        background: '#ffffff',
      },
      titleCard: '',
      wrapReviews: {
        colPerView: 4,
        listItem: [],
      },
    };

    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : result.title;
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'card-container': {
          const background = el.getAttribute('data-background') || el.style.backgroundColor || '#e6e6e6';
          result['background-section'].color = background;
          result.padding.top = el.getAttribute('data-top-padding') === 'true';
          result.padding.bottom = el.getAttribute('data-bottom-padding') === 'true';
          result['background-section'].image = el.getAttribute('data-background-image') || '';
          const textColor = el.getAttribute('data-text-color');
          if (textColor) result.textColor = textColor;
          break;
        }
        case 'container-page': {
          const showStyle = el.getAttribute('data-show-style');
          result['container-content'].showStyle = showStyle ? showStyle === 'true' : false;
          const background = el.getAttribute('data-background');
          result['container-content'].background = background ? background : '#ffffff';
          break;
        }
        case 'title-card': {
          result.titleCard = el.innerHTML.trim();
          break;
        }
        case 'body-review': {
          const colPerView = el.getAttribute('data-col-per-view');
          result.wrapReviews.colPerView = colPerView ? Number(colPerView) : result.wrapReviews.colPerView;
          const items = el.querySelectorAll('[data-attribute="item-review"]');
          result.wrapReviews.listItem = Array.from(items).map(item => {
            const image = item.querySelector('[data-attribute="review-image"]')?.getAttribute('src') || '';
            const wrapStars = item.querySelector('[data-attribute="wrap-stars"]');
            const starsRaw = wrapStars?.getAttribute('data-value');
            const svgCount = wrapStars?.querySelectorAll('svg').length || 0;
            let stars = starsRaw != null && starsRaw !== '' ? Number(starsRaw) : svgCount || 5;
            if (!Number.isFinite(stars)) stars = 5;
            stars = Math.max(1, Math.min(5, stars));
            const reviewContent = item.querySelector('[data-attribute="review-content"]')?.innerHTML.trim() || '';
            const reviewName = item.querySelector('[data-attribute="review-name"]')?.textContent?.trim() || '';
            return { image, stars, reviewContent, reviewName };
          });
          break;
        }
        default:
          break;
      }
    });

    return result;
  },

  sectionGuaranteedSafeCheckout02(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Safe Checkout',
      content: '',
      colors: {
        textColor: '#000000',
        backgroundColor: '#ffffff',
        containerBackgroundColor: '#F7EEE7',
      },
      sectionPadding: {
        topDesktop: 4,
        bottomDesktop: 4,
        topMobile: 4,
        bottomMobile: 4,
      },
      image: {
        url: '',
        position: 'left',
        show: true,
        widthDesktop: 160,
        widthMobile: 70,
      },
      layout: {
        alignItems: 'center',
        borderEnabled: false,
        borderColor: '#e5e7eb',
        gap: 10,
        mobileColumn: false,
      },
      borderRadius: 4,
    };

    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Safe Checkout';
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'guaranteed-safe-checkout-section': {
          result.colors.textColor = el.getAttribute('data-text-color') || result.colors.textColor;
          result.colors.backgroundColor = el.getAttribute('data-background-color') || result.colors.backgroundColor;
          result.colors.containerBackgroundColor =
            el.getAttribute('data-container-background-color') || result.colors.containerBackgroundColor;
          result.sectionPadding.topDesktop = el.getAttribute('data-top-desktop-padding')
            ? parseInt(el.getAttribute('data-top-desktop-padding'))
            : 4;
          result.sectionPadding.bottomDesktop = el.getAttribute('data-bottom-desktop-padding')
            ? parseInt(el.getAttribute('data-bottom-desktop-padding'))
            : 4;
          result.sectionPadding.topMobile = el.getAttribute('data-top-mobile-padding')
            ? parseInt(el.getAttribute('data-top-mobile-padding'))
            : 4;
          result.sectionPadding.bottomMobile = el.getAttribute('data-bottom-mobile-padding')
            ? parseInt(el.getAttribute('data-bottom-mobile-padding'))
            : 4;
          result.image.position = el.getAttribute('data-image-position') || result.image.position;
          result.borderRadius = el.getAttribute('data-container-border-radius')
            ? parseInt(el.getAttribute('data-container-border-radius'))
            : result.borderRadius;
          break;
        }
        case 'guaranteed-safe-checkout-content': {
          result.content = el.innerHTML.trim();
          break;
        }
        case 'guaranteed-safe-checkout-container': {
          result.layout.alignItems = el.getAttribute('data-container-align-items') || result.layout.alignItems;
          result.layout.borderEnabled = el.getAttribute('data-container-border-enabled') === 'true';
          result.layout.borderColor = el.getAttribute('data-container-border-color') || result.layout.borderColor;
          result.layout.gap = el.getAttribute('data-container-gap')
            ? parseInt(el.getAttribute('data-container-gap'))
            : result.layout.gap;
          result.layout.mobileColumn = el.getAttribute('data-mobile-column') === 'true';
          break;
        }
        case 'guaranteed-safe-checkout-image': {
          const img = el.querySelector('img');
          if (img) {
            result.image.url = img.getAttribute('src') || '';
          }
          result.image.show = el.getAttribute('data-show-image') !== 'false';
          result.image.widthDesktop = el.getAttribute('data-image-width-desktop')
            ? parseInt(el.getAttribute('data-image-width-desktop'))
            : result.image.widthDesktop;
          result.image.widthMobile = el.getAttribute('data-image-width-mobile')
            ? parseInt(el.getAttribute('data-image-width-mobile'))
            : result.image.widthMobile;
          break;
        }
        default:
          break;
      }
    });

    return result;
  },
  sectionFreestyleOrderPolicy(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Freestyle Order Policy',
      content: '',
      'text-color': '#000000',
      'background-color': '#ffffff',
      sectionPadding: {
        topDesktop: 4,
        bottomDesktop: 4,
        topMobile: 4,
        bottomMobile: 4,
      },
    };

    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Safe Checkout';
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'content': {
          result[key] = el.innerHTML.trim();
          result['text-color'] = el.getAttribute('data-text-color') || el.style.color || '#000000';
          result['background-color'] =
            el.getAttribute('data-background-color') || el.style.backgroundColor || '#ffffff ';
          result.sectionPadding.topDesktop = el.getAttribute('data-top-desktop-padding')
            ? parseInt(el.getAttribute('data-top-desktop-padding'))
            : 4;
          result.sectionPadding.bottomDesktop = el.getAttribute('data-bottom-desktop-padding')
            ? parseInt(el.getAttribute('data-bottom-desktop-padding'))
            : 4;
          result.sectionPadding.topMobile = el.getAttribute('data-top-mobile-padding')
            ? parseInt(el.getAttribute('data-top-mobile-padding'))
            : 4;
          result.sectionPadding.bottomMobile = el.getAttribute('data-bottom-mobile-padding')
            ? parseInt(el.getAttribute('data-bottom-mobile-padding'))
            : 4;
          break;
        }
        default:
          break;
      }
    });

    return result;
  },
  sectionTrustBadge(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Trust Badge Section',
      'trust-badge-score': '',
      'brand-content': '',
      'trust-image-1': '',
      'trust-image-2': '',
      'trust-image-3': '',
      'background-color': '#ffffff',
      'container-background-color': '#ffffff',
      'trust-badge-score-bg-color': 'f5f5f5',
      'trust-badge-score-color': '#000000',
      'border-color': '#e0e0e0',
      sectionPadding: {
        topDesktop: 4,
        bottomDesktop: 4,
        topMobile: 4,
        bottomMobile: 4,
      },
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Trust Badge Section';
    }

    const elements = doc.querySelectorAll('[data-attribute]');
    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'trust-badge-section': {
          const style = el.style;
          result['background-color'] = style.getPropertyValue('--background-color') || '#ffffff';
          result['container-background-color'] = style.getPropertyValue('--container-background-color') || '#ffffff';
          result['trust-badge-score-bg-color'] = style.getPropertyValue('--trust-badge-score-bg-color') || 'f5f5f5';
          result['trust-badge-score-color'] = style.getPropertyValue('--trust-badge-score-color') || '#000000';
          result['border-color'] = style.getPropertyValue('--border-color') || '#e0e0e0';
          result.sectionPadding.topDesktop = parseInt(style.getPropertyValue('--padding-top-desktop')) || 4;
          result.sectionPadding.bottomDesktop = parseInt(style.getPropertyValue('--padding-bottom-desktop')) || 4;
          result.sectionPadding.topMobile = parseInt(style.getPropertyValue('--padding-top-mobile')) || 4;
          result.sectionPadding.bottomMobile = parseInt(style.getPropertyValue('--padding-bottom-mobile')) || 4;
          break;
        }
        case 'trust-badge-score': {
          result['trust-badge-score'] = el.innerHTML.trim();
          break;
        }
        case 'brand-content': {
          result['brand-content'] = el.innerHTML.trim();
          break;
        }
        case 'trust-image-1': {
          result['trust-image-1'] = el.getAttribute('src') || '';
          break;
        }
        case 'trust-image-2': {
          result['trust-image-2'] = el.getAttribute('src') || '';
          break;
        }
        case 'trust-image-3': {
          result['trust-image-3'] = el.getAttribute('src') || '';
          break;
        }
        default:
          break;
      }
    });

    return result;
  },
  sectionCardCompareProduct(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Card Compare Product',
      header: '',
      leftMedia: { url: '', video: '', type: 'image' },
      rightMedia: { url: '', video: '', type: 'image' },
      vsBox: { text: 'VS.', backgroundColor: '#121212', textColor: '#ffffff' },
      badPosition: 'right',
      compareList: [],
      colors: {
        backgroundColor: '#f7eee7',
        textColor: '#000000',
        goodBackgroundColor: '#4dc61c',
        goodTextColor: '#ffffff',
        badBackgroundColor: '#f3f3f3',
        badTextColor: '#000000',
      },
      containerFullWidth: false,
      topPadding: true,
      bottomPadding: true,
    };

    const container = doc.querySelector('[data-section]');
    if (container) {
      result.title = container.getAttribute('data-title') || result.title;
    }

    const wrapper = doc.querySelector('.card-compare-product-wrapper');
    if (wrapper) {
      result.colors.backgroundColor =
        wrapper.style.getPropertyValue('--background-color') || result.colors.backgroundColor;
      result.colors.textColor = wrapper.style.getPropertyValue('--text-color') || result.colors.textColor;
      result.colors.goodBackgroundColor =
        wrapper.style.getPropertyValue('--good-bg-color') || result.colors.goodBackgroundColor;
      result.colors.goodTextColor = wrapper.style.getPropertyValue('--good-text-color') || result.colors.goodTextColor;
      result.colors.badBackgroundColor =
        wrapper.style.getPropertyValue('--bad-bg-color') || result.colors.badBackgroundColor;
      result.colors.badTextColor = wrapper.style.getPropertyValue('--bad-text-color') || result.colors.badTextColor;

      result.vsBox.backgroundColor = wrapper.style.getPropertyValue('--vs-bg-color') || result.vsBox.backgroundColor;
      result.vsBox.textColor = wrapper.style.getPropertyValue('--vs-text-color') || result.vsBox.textColor;

      result.topPadding = wrapper.getAttribute('data-top-padding') !== 'false';
      result.bottomPadding = wrapper.getAttribute('data-bottom-padding') !== 'false';
      result.badPosition = wrapper.getAttribute('data-bad-position') || 'right';
      result.containerFullWidth = wrapper.getAttribute('data-container-full-width') !== 'false';
    }

    const headerEl = doc.querySelector('.card-compare-product-title');
    if (headerEl) {
      result.header = headerEl.innerHTML.trim();
    }

    const vsTextEl = doc.querySelector('.card-compare-product-image-text');
    if (vsTextEl) {
      result.vsBox.text = vsTextEl.textContent.trim();
    }

    const leftEl = doc.querySelector('.card-compare-product-image-left');
    if (leftEl) {
      const leftVideo = leftEl.querySelector('video');
      const leftImg = leftEl.querySelector('img');
      if (leftVideo) {
        result.leftMedia.type = 'video';
        const source = leftVideo.querySelector('source');
        result.leftMedia.video = source ? source.getAttribute('src') || '' : leftVideo.getAttribute('src') || '';
      } else if (leftImg) {
        result.leftMedia.type = 'image';
        result.leftMedia.url = leftImg.getAttribute('src') || '';
      }
    }

    const rightEl = doc.querySelector('.card-compare-product-image-right');
    if (rightEl) {
      const rightVideo = rightEl.querySelector('video');
      const rightImg = rightEl.querySelector('img');
      if (rightVideo) {
        result.rightMedia.type = 'video';
        const source = rightVideo.querySelector('source');
        result.rightMedia.video = source ? source.getAttribute('src') || '' : rightVideo.getAttribute('src') || '';
      } else if (rightImg) {
        result.rightMedia.type = 'image';
        result.rightMedia.url = rightImg.getAttribute('src') || '';
      }
    }

    const items = doc.querySelectorAll('.card-compare-functionality-item');
    result.compareList = [];
    items.forEach(item => {
      const goodTextEl = item.querySelector('.card-compare-functionality-good-text');
      const badTextEl = item.querySelector('.card-compare-functionality-bad-text');
      result.compareList.push({
        goodText: goodTextEl ? goodTextEl.textContent.trim() : '',
        badText: badTextEl ? badTextEl.textContent.trim() : '',
      });
    });

    return result;
  },
  sectionFaqGrid05(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: '',
      colors: {
        backgroundContainer: '',
        backgroundFaqItem: '',
        backgroundFaqItemContent: '',
        textFaqItem: '',
      },
      titleFaq: '',
      listItem: [
        // {
        //   background: '',
        //   backgroundContent: '',
        //   question: '',
        //   lineColor: '',
        //   answer: ''
        // }
      ],
      topPadding: true,
      bottomPadding: true,
      containerFullWidth: true,
      showSeparator: false,
      showLineColor: true,
    };
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';
    }
    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'faq-grid-container-fluid': {
          result.colors.backgroundContainer = el.getAttribute('data-background') || '#ffffff';
          result.topPadding = el.getAttribute('data-top-padding') === 'true' ? true : false;
          result.bottomPadding = el.getAttribute('data-bottom-padding') === 'true' ? true : false;
          result.containerFullWidth = el.getAttribute('data-container-full-width') === 'true' ? true : false;
          result.showSeparator = el.getAttribute('data-show-separator') === 'true' ? true : false;
          result.showLineColor = el.getAttribute('data-show-line-color') === 'true' ? true : false;
          break;
        }
        case 'title-faq-grid': {
          result['titleFaq'] = el.innerHTML.trim();
          break;
        }
        case 'list-item': {
          const elWrapItem = el.querySelectorAll('[data-attribute="item-wapper"]');
          result.colors.backgroundFaqItem = el.getAttribute('data-background-faq-item') || '#EBEBEB';
          result.colors.backgroundFaqItemContent = el.getAttribute('data-background-faq-item-content') || '#FFFFFF';
          result.colors.textFaqItem = el.getAttribute('data-text-faq-item-color') || '#000000';
          elWrapItem.forEach(elItem => {
            const elQuestion = elItem.querySelector('[data-attribute="title-item-question"]');
            const elAnswer = elItem.querySelector('[data-attribute="answer-content"]');
            const question = elQuestion ? elQuestion.textContent.trim() : '';
            const answer = elAnswer ? elAnswer.innerHTML.trim() : '';
            const lineColor =
              elItem.querySelector('[data-attribute="item-question-line"]').getAttribute('data-line-color') ||
              '#3b866a';
            result['listItem'].push({
              question: question,
              answer: answer,
              lineColor: lineColor,
            });
          });
          break;
        }
        default:
          break;
      }
    });
    return result;
  },
  sectionItemsGrid03(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Items Grid Section 03',
      enableAnchor: false,
      backgroundColor: '#ffffff',
      textColor: '#000000',
      cardBackgroundColor: '#14A16C',
      cardTextColor: '#ffffff',
      titleContent: '',
      listItem: [],
      topPadding: true,
      bottomPadding: true,
      containerFullWidth: false,
      itemsPerRow: {
        mobile: 2,
        desktop: 4,
      },
      backgroundImage: false,
      cardBorderRadius: 12,
      itemImageWidthMobile: 60,
      itemImageWidthDesktop: 60,
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      result.enableAnchor = sectionEl.getAttribute('data-enable-anchor') === 'true';
      const title = sectionEl.getAttribute('data-title');
      result.title = title || result.title;
    }

    const elements = doc.querySelectorAll('[data-attribute]');
    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'items-grid-wrapper': {
          result.backgroundColor = el.getAttribute('data-background-color') || '#ffffff';
          result.textColor = el.getAttribute('data-text-color') || '#000000';
          result.topPadding = el.getAttribute('data-top-padding') === 'true';
          result.bottomPadding = el.getAttribute('data-bottom-padding') === 'true';
          result.cardBackgroundColor = el.getAttribute('data-card-background-color') || '#14A16C';
          result.cardTextColor = el.getAttribute('data-card-text-color') || '#ffffff';
          result.backgroundImage = el.getAttribute('data-background-image') === 'true' ? true : false;
          result.cardBorderRadius = el.getAttribute('data-card-border-radius');
          result.itemImageWidthMobile = el.getAttribute('data-item-image-width-mobile')
            ? Number(el.getAttribute('data-item-image-width-mobile'))
            : 60;
          result.itemImageWidthDesktop = el.getAttribute('data-item-image-width-desktop')
            ? Number(el.getAttribute('data-item-image-width-desktop'))
            : 60;
          break;
        }
        case 'items-grid-content': {
          result.containerFullWidth = el.getAttribute('data-container-full-width') === 'true' ? true : false;
          break;
        }
        case 'title-content': {
          result.titleContent = el.innerHTML.trim();
          break;
        }
        case 'list-item': {
          result.itemsPerRow.mobile = el.getAttribute('data-items-per-row-mobile')
            ? Number(el.getAttribute('data-items-per-row-mobile'))
            : 2;
          result.itemsPerRow.desktop = el.getAttribute('data-items-per-row-desktop')
            ? Number(el.getAttribute('data-items-per-row-desktop'))
            : 4;
          const elItems = el.querySelectorAll('[data-attribute="item"]');
          result.listItem = Array.from(elItems).map(item => {
            const elImage = item.querySelector('[data-attribute="image-item"]');
            const imgSrc = elImage ? elImage.getAttribute('src') : '';
            const textEl = item.querySelector('[data-attribute="text-item"]');
            const htmlText = textEl ? textEl.innerHTML.trim() : '';
            return { image: imgSrc, htmlText };
          });
          break;
        }
        default:
          break;
      }
    });
    return result;
  },
  sectionItemsGrid04(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Items Grid Section 03',
      enableAnchor: false,
      backgroundColor: '#f2f2f2',
      textColor: '#000000',
      cardBackgroundColor: '#f2f2f2',
      cardTextColor: '#000000',
      titleContent: '',
      listItem: [],
      topPadding: true,
      bottomPadding: true,
      containerFullWidth: false,
      itemsPerRow: {
        mobile: 1,
        desktop: 1,
      },
      cardBorderRadius: 0,
      itemsGridListWidth: 85,
      itemImageWidthDesktop: 110,
      itemImageWidthMobile: 110,
      showNumber: false,
      image: {
        show: false,
        position: 'left',
        url: '',
      },
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      result.enableAnchor = sectionEl.getAttribute('data-enable-anchor') === 'true';
      const title = sectionEl.getAttribute('data-title');
      result.title = title || result.title;
    }

    const elements = doc.querySelectorAll('[data-attribute]');
    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'items-grid-wrapper': {
          result.backgroundColor = el.getAttribute('data-background-color') || '#f2f2f2';
          result.textColor = el.getAttribute('data-text-color') || '#000000';
          result.topPadding = el.getAttribute('data-top-padding') === 'true';
          result.bottomPadding = el.getAttribute('data-bottom-padding') === 'true';
          result.cardBackgroundColor = el.getAttribute('data-card-background-color') || '#f2f2f2';
          result.cardTextColor = el.getAttribute('data-card-text-color') || '#000000';
          result.cardBorderRadius = el.getAttribute('data-card-border-radius');
          result.itemImageWidthDesktop = el.getAttribute('data-item-image-width-desktop')
            ? Number(el.getAttribute('data-item-image-width-desktop'))
            : 110;
          result.itemImageWidthMobile = el.getAttribute('data-item-image-width-mobile')
            ? Number(el.getAttribute('data-item-image-width-mobile'))
            : 110;
          result.showNumber = el.getAttribute('data-show-number') === 'true' ? true : false;
          result.itemsGridListWidth = el.getAttribute('data-items-grid-list-width')
            ? Number(el.getAttribute('data-items-grid-list-width'))
            : 85;
          result.image.show = el.getAttribute('data-image-show') === 'true' ? true : false;
          result.image.position = el.getAttribute('data-image-position') || 'left';
          break;
        }
        case 'items-grid-content': {
          result.containerFullWidth = el.getAttribute('data-container-full-width') === 'true' ? true : false;
          break;
        }
        case 'title-content': {
          result.titleContent = el.innerHTML.trim();
          break;
        }
        case 'items-grid-image': {
          const imgEl = el.querySelector('[data-attribute="items-grid-image-inner"]');
          result.image.url = imgEl ? imgEl.getAttribute('src') : '';
          break;
        }
        case 'items-grid-list': {
          result.itemsPerRow.mobile = el.getAttribute('data-items-per-row-mobile')
            ? Number(el.getAttribute('data-items-per-row-mobile'))
            : 1;
          result.itemsPerRow.desktop = el.getAttribute('data-items-per-row-desktop')
            ? Number(el.getAttribute('data-items-per-row-desktop'))
            : 1;
          const elItems = el.querySelectorAll('[data-attribute="items-grid-item"]');
          result.listItem = Array.from(elItems).map(item => {
            const elImage = item.querySelector('[data-attribute="image-item"]');
            const imgSrc = elImage ? elImage.getAttribute('src') : '';
            const textEl = item.querySelector('[data-attribute="text-item"]');
            const htmlText = textEl ? textEl.innerHTML.trim() : '';
            const numberEl = item.querySelector('[data-attribute="number-item"]');
            const number = numberEl ? numberEl.textContent.trim() : '';
            return { image: imgSrc, htmlText, number };
          });
          break;
        }
        default:
          break;
      }
    });
    return result;
  },
  sectionReviewGrid04(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Review Grid Section 04',
      reviewHeader: '',
      reviewsList: [],
      topPadding: true,
      bottomPadding: true,
      colors: {
        backgroundColor: '#ffffff',
        textColor: '#000000',
        primaryColor: '#14a16c',
        reviewsListBackgroundColor: '#f5f6f7',
      },
      button: {
        readMoreText: 'read more',
        showLessText: 'show less',
        loadMoreText: 'Load More',
        textColor: '#ffffff',
        borderRadius: 24,
        textLineClamp: 2,
        pageSize: 4,
      },
      tag: {
        backgroundColor: '#ebeced',
        textColor: '#000000',
        activeTextColor: '#ffffff',
        borderRadius: 0,
        show: true,
      },
      itemsPerRow: {
        mobile: 1,
        desktop: 2,
      },
      avatar: {
        desktopSize: 200,
        mobileSize: 150,
        showBorder: true,
      },
    };
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Review Grid Section 04';
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'review-grid-wrapper': {
          result.topPadding = el.getAttribute('data-top-padding') === 'true' ? true : false;
          result.bottomPadding = el.getAttribute('data-bottom-padding') === 'true' ? true : false;
          result.colors.backgroundColor = el.getAttribute('data-background-color');
          result.colors.textColor = el.getAttribute('data-text-color');
          result.colors.primaryColor = el.getAttribute('data-primary-color');
          result.colors.reviewsListBackgroundColor = el.getAttribute('data-reviews-list-background-color');
          result.avatar.showBorder = el.getAttribute('data-show-avatar-border') === 'true' ? true : false;

          result.tag.backgroundColor = el.getAttribute('data-tag-background-color');
          result.tag.textColor = el.getAttribute('data-tag-text-color');
          result.tag.activeTextColor = el.getAttribute('data-tag-active-text-color');
          result.tag.borderRadius = el.getAttribute('data-tag-border-radius');
          result.tag.show = el.getAttribute('data-show-tags') === 'true' ? true : false;

          result.button.textLineClamp = Number(el.getAttribute('data-text-line-clamp'));
          result.button.textColor = el.getAttribute('data-button-text-color');
          result.button.borderRadius = el.getAttribute('data-button-border-radius');
          result.button.pageSize = Number(el.getAttribute('data-page-size')) || 4;

          result.itemsPerRow.mobile = el.getAttribute('data-items-per-row-mobile')
            ? Number(el.getAttribute('data-items-per-row-mobile'))
            : 1;
          result.itemsPerRow.desktop = el.getAttribute('data-items-per-row-desktop')
            ? Number(el.getAttribute('data-items-per-row-desktop'))
            : 2;

          result.avatar.desktopSize = el.getAttribute('data-avatar-size-desktop')
            ? Number(el.getAttribute('data-avatar-size-desktop'))
            : 200;
          result.avatar.mobileSize = el.getAttribute('data-avatar-size-mobile')
            ? Number(el.getAttribute('data-avatar-size-mobile'))
            : 150;

          break;
        }
        case 'review-header': {
          result.reviewHeader = el.innerHTML.trim();
          break;
        }
        case 'review-tags': {
          const elTags = el.querySelectorAll('[data-attribute="review-tag-item"]');
          result.tag.options = Array.from(elTags, tag => {
            const value = tag.textContent
              .toLowerCase()
              .trim()
              .replace(/\s+/g, '-');
            if (value === 'all') return null;

            return {
              text: tag.textContent.trim(),
              value,
            };
          }).filter(Boolean);
          break;
        }
        case 'load-more-button': {
          result.button.loadMoreText = el.textContent.trim();
          break;
        }
        case 'read-more-button': {
          result.button.readMoreText = el.textContent.trim();
          break;
        }
        case 'show-less-button': {
          result.button.showLessText = el.textContent.trim();
          break;
        }
        case 'review-grid-item': {
          const reviewerAvatar = el.querySelector('[data-attribute="reviewer-avatar"]');
          const reviewerName = el.querySelector('[data-attribute="reviewer-name"]');
          const reviewContent = el.querySelector('[data-attribute="review-content"]');
          const reviewTitle = el.querySelector('[data-attribute="review-title"]');
          const reviewTag = el.getAttribute('data-tag');

          const reviewItem = {
            avatar: reviewerAvatar ? reviewerAvatar.getAttribute('src') : '',
            name: reviewerName ? reviewerName.textContent.trim() : '',
            content: reviewContent ? reviewContent.textContent.trim() : '',
            title: reviewTitle ? reviewTitle.textContent.trim() : '',
            tag: reviewTag
              ? reviewTag
                  .toLowerCase()
                  .trim()
                  .replace(/\s+/g, '-')
              : '',
          };
          result.reviewsList.push(reviewItem);
          break;
        }
      }
    });

    return result;
  },

  sectionReviewGrid05(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: '',
      topPadding: true,
      bottomPadding: true,
      titleHeader: '',
      breakpoints: {
        mobile: {
          slidesPerView: 1,
        },
        tablet: {
          slidesPerView: 2,
        },
        desktop: {
          slidesPerView: 2,
        },
      },
      listItem: [],
      colors: {
        backgroundColor: '',
        textColor: '',
        starColor: '',
        paginationActiveColor: '',
        paginationInactiveColor: '',
      },
      containerWidth: 75,
      showRating: true,
    };

    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';

      // Extract breakpoints from section element
      const mobileSlides = sectionEl.getAttribute('data-breakpoint-mobile-slides');
      const tabletSlides = sectionEl.getAttribute('data-breakpoint-tablet-slides');
      const desktopSlides = sectionEl.getAttribute('data-breakpoint-desktop-slides');

      // Handle new format (mobile, tablet, desktop)
      if (mobileSlides) {
        result.breakpoints.mobile = {
          slidesPerView: parseInt(mobileSlides, 10) || 1,
        };
      }
      if (tabletSlides) {
        result.breakpoints.tablet = {
          slidesPerView: parseInt(tabletSlides, 10) || 2,
        };
      }
      if (desktopSlides) {
        result.breakpoints.desktop = {
          slidesPerView: parseInt(desktopSlides, 10) || 2,
        };
      }

      // Handle migration from old format (breakpoint1/2/3 with width)
      const bp1Slides = sectionEl.getAttribute('data-breakpoint1-slides');
      const bp2Slides = sectionEl.getAttribute('data-breakpoint2-slides');
      const bp3Slides = sectionEl.getAttribute('data-breakpoint3-slides');

      if (bp1Slides && !mobileSlides) {
        result.breakpoints.mobile = {
          slidesPerView: parseInt(bp1Slides, 10) || 1,
        };
      }
      if (bp2Slides && !tabletSlides) {
        result.breakpoints.tablet = {
          slidesPerView: parseInt(bp2Slides, 10) || 2,
        };
      }
      if (bp3Slides && !desktopSlides) {
        result.breakpoints.desktop = {
          slidesPerView: parseInt(bp3Slides, 10) || 2,
        };
      }
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'card-container': {
          result.colors.backgroundColor = el.getAttribute('data-background-color') || '#F9F9F9';
          result.colors.textColor = el.getAttribute('data-text-color') || '#000000';
          result.colors.starColor = el.getAttribute('data-star-color') || '#14a16c';
          result.colors.paginationActiveColor = el.getAttribute('data-pagination-active-color') || '#000000';
          result.colors.paginationInactiveColor = el.getAttribute('data-pagination-inactive-color') || '#cccccc';
          result.topPadding = el.getAttribute('data-top-padding') === 'true' ? true : false;
          result.bottomPadding = el.getAttribute('data-bottom-padding') === 'true' ? true : false;
          result.containerWidth = el.getAttribute('data-container-width')
            ? Number(el.getAttribute('data-container-width'))
            : 75;
          result.showRating = el.getAttribute('data-show-rating') === 'true' ? true : false;
          break;
        }
        case 'card-header': {
          result.titleHeader = el.innerHTML.trim();
          break;
        }
        case 'list-item': {
          el.querySelectorAll('[data-attribute="item"]').forEach(item => {
            const videoElement = item.querySelector('[data-attribute="card-video"]');
            const imageElement = item.querySelector('[data-attribute="card-image"]');
            const contentElement = item.querySelector('.wrap-item-content');
            const ratingStars = item.querySelector('[data-attribute="rating-stars"]');

            // Determine type based on what exists
            let type = 'image';
            let video = '';
            let image = '';

            if (imageElement) {
              type = 'image';
              image = imageElement.getAttribute('src') || '';
            }

            if (videoElement) {
              type = 'video';
              video = videoElement.getAttribute('src') || '';
            }

            // If both exist, prefer image (newer feature)
            if (imageElement && videoElement) {
              type = 'image';
            }

            result.listItem.push({
              type: type,
              video: video,
              image: image,
              content: contentElement ? contentElement.innerHTML.trim() : '',
              rating: ratingStars ? Number(ratingStars.getAttribute('data-value')) : 5,
            });
          });
          break;
        }
        default:
          break;
      }
    });

    return result;
  },

  sectionCardBasic(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Card Basic Section',
      enableAnchor: false,
      colors: {
        backgroundColor: '#14A16C',
        textColor: '#ffffff',
      },
      content: '',
      topPadding: true,
      bottomPadding: true,
      image: {
        position: 'left',
        width: 30,
        url: '',
      },
    };

    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Card Basic Section';
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'card-basic-wrapper': {
          result.colors.backgroundColor = el.getAttribute('data-background-color') || '#14A16C';
          result.colors.textColor = el.getAttribute('data-text-color') || '#000000';
          result.topPadding = el.getAttribute('data-top-padding') === 'true' ? true : false;
          result.bottomPadding = el.getAttribute('data-bottom-padding') === 'true' ? true : false;
          result.image.position = el.getAttribute('data-image-position') || 'left';
          result.image.width = Number(el.getAttribute('data-image-width')) || 30;
          result.image.url = el.getAttribute('data-image-url') || '';
          break;
        }

        case 'card-basic-content-text': {
          result.content = el.innerHTML.trim();
          break;
        }
        case 'card-basic-image-inner': {
          result.image.url = el.getAttribute('src') || '';
          break;
        }

        default:
          break;
      }
    });

    return result;
  },

  sectionItemsGridMedia(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: '',
      titleItemsGridMedia: '',
      colors: {
        backgroundColor: '#ffffff',
        textColor: '#000000',
      },
      padding: {
        top: true,
        bottom: true,
      },
      mediaItems: [
        {
          url: '',
          content: '',
        },
      ],
      itemsPerRow: {
        mobile: 1,
        desktop: 2,
      },
      videoHeight: 315,
    };

    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Items Grid Media Section';
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'items-grid-media-wrapper': {
          result.colors.backgroundColor = el.getAttribute('data-background-color') || '#ffffff';
          result.colors.textColor = el.getAttribute('data-text-color') || '#000000';
          result.padding.top = el.getAttribute('data-top-padding') === 'true' ? true : false;
          result.padding.bottom = el.getAttribute('data-bottom-padding') === 'true' ? true : false;
          result.itemsPerRow.mobile = el.getAttribute('data-items-per-row-mobile')
            ? Number(el.getAttribute('data-items-per-row-mobile'))
            : 1;
          result.itemsPerRow.desktop = el.getAttribute('data-items-per-row-desktop')
            ? Number(el.getAttribute('data-items-per-row-desktop'))
            : 2;
          result.videoHeight = el.getAttribute('data-video-height')
            ? Number(el.getAttribute('data-video-height'))
            : 315;
          break;
        }

        case 'items-grid-media-header': {
          result.titleItemsGridMedia = el.innerHTML.trim();
          break;
        }

        case 'items-grid-media-list': {
          const elItems = el.querySelectorAll('[data-attribute="items-grid-media-item"]');
          result.mediaItems = Array.from(elItems).map(item => {
            const elVideo = item.querySelector('[data-attribute="items-grid-media-item-video-inner"]');
            const video = elVideo ? elVideo.getAttribute('src') : '';
            const elContent = item.querySelector('[data-attribute="items-grid-media-item-content"]');
            const content = elContent ? elContent.innerHTML.trim() : '';
            return { url: video, content: content };
          });
          break;
        }

        default:
          break;
      }
    });

    return result;
  },

  sectionCardStepInstructions02(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Card Step Instructions 02 Section',
      enableAnchor: false,
      colors: {
        backgroundColor: '#ffffff',
        textColor: '#000000',
        oddBackgroundColor: '#14a16c',
        oddTextColor: '#ffffff',
        evenBackgroundColor: '#e1e1e1',
        evenTextColor: '#000000',
      },
      header: '',
      topPadding: true,
      bottomPadding: true,
      items: [
        {
          title: '',
          content: '',
          image: '',
        },
      ],
      itemsPerRow: {
        mobile: 1,
        desktop: 4,
      },
      itemImageHeight: 150,
    };

    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Card Step Instructions 02 Section';
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'card-step-instructions-wrapper': {
          result.colors.backgroundColor = el.getAttribute('data-background-color') || '#ffffff';
          result.colors.textColor = el.getAttribute('data-text-color') || '#000000';
          result.colors.oddBackgroundColor = el.getAttribute('data-odd-background') || '#14a16c';
          result.colors.oddTextColor = el.getAttribute('data-odd-text-color') || '#ffffff';
          result.colors.evenBackgroundColor = el.getAttribute('data-even-background') || '#e1e1e1';
          result.colors.evenTextColor = el.getAttribute('data-even-text-color') || '#000000';
          result.topPadding = el.getAttribute('data-top-padding') === 'true' ? true : false;
          result.bottomPadding = el.getAttribute('data-bottom-padding') === 'true' ? true : false;
          result.itemsPerRow.mobile = el.getAttribute('data-items-per-row-mobile')
            ? Number(el.getAttribute('data-items-per-row-mobile'))
            : 1;
          result.itemsPerRow.desktop = el.getAttribute('data-items-per-row-desktop')
            ? Number(el.getAttribute('data-items-per-row-desktop'))
            : 4;
          result.itemImageHeight = el.getAttribute('data-item-image-height')
            ? Number(el.getAttribute('data-item-image-height'))
            : 150;
          break;
        }

        case 'card-step-instructions-header': {
          result.header = el.innerHTML.trim();
          break;
        }

        case 'card-step-instructions-list': {
          const elItems = el.querySelectorAll('[data-attribute="card-step-instructions-item"]');
          result.items = Array.from(elItems).map(item => {
            const elTitle = item.querySelector('[data-attribute="card-step-instructions-item-title"]');
            const title = elTitle ? elTitle.innerHTML.trim() : '';
            const elContent = item.querySelector('[data-attribute="card-step-instructions-item-content"]');
            const content = elContent ? elContent.innerHTML.trim() : '';
            const elImage = item.querySelector('[data-attribute="card-step-instructions-item-image-inner"]');
            const image = elImage ? elImage.getAttribute('src') : '';
            return { title: title, content: content, image: image };
          });
          break;
        }

        default:
          break;
      }
    });

    return result;
  },

  sectionBannerBasic(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Banner Basic Section',
      enableAnchor: false,
      topPadding: true,
      bottomPadding: true,
      backgroundColor: '#ffffff',
      card1: {
        image: '',
        text: 'At the heart of it all, we lead with purpose.',
        backgroundColor: '#01ae74',
        textColor: '#ffffff',
        button: {
          text: 'LEARN MORE',
          textColor: '#ffffff',
          backgroundColor: '#464646',
          radius: 5,
        },
      },
      card2: {
        image: '',
      },
      card3: {
        image: '',
        text: 'Stripe Climate member.',
        backgroundColor: '#efefef',
        textColor: '#6d6d6d',
      },
      card4: {
        image: '',
        backgroundColor: '#464646',
      },
    };

    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Card Step Instructions 02 Section';
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'banner-basic-wrapper': {
          result.backgroundColor = el.getAttribute('data-background-color') || '#ffffff';
          result.topPadding = el.getAttribute('data-top-padding') === 'true' ? true : false;
          result.bottomPadding = el.getAttribute('data-bottom-padding') === 'true' ? true : false;
          result.card1.image = el.getAttribute('data-card-1-image') || '';
          result.card1.text = el.getAttribute('data-card-1-text') || '';
          result.card1.backgroundColor = el.getAttribute('data-card-1-background-color') || '#01ae74';
          result.card1.textColor = el.getAttribute('data-card-1-text-color') || '#ffffff';
          result.card1.button.text = el.getAttribute('data-card-1-button-text') || 'LEARN MORE';
          result.card1.button.textColor = el.getAttribute('data-card-1-button-text-color') || '#ffffff';
          result.card1.button.backgroundColor = el.getAttribute('data-card-1-button-background-color') || '#464646';
          result.card1.button.radius = Number(el.getAttribute('data-card-1-button-radius')) || 5;
          result.card2.image = el.getAttribute('data-card-2-image') || '';
          result.card3.image = el.getAttribute('data-card-3-image') || '';
          result.card3.text = el.getAttribute('data-card-3-text') || 'Stripe Climate member.';
          result.card3.backgroundColor = el.getAttribute('data-card-3-background-color') || '#efefef';
          result.card3.textColor = el.getAttribute('data-card-3-text-color') || '#6d6d6d';
          result.card4.image = el.getAttribute('data-card-4-image') || '';
          result.card4.backgroundColor = el.getAttribute('data-card-4-background-color') || '#464646';
          break;
        }

        case 'banner-basic-card-1-image-inner': {
          result.card1.image = el.getAttribute('src') || '';
          break;
        }

        case 'banner-basic-card-1-text': {
          result.card1.text = el.innerHTML.trim();
          break;
        }

        case 'banner-basic-card-1-button': {
          result.card1.button.text = el.innerHTML.trim();
          break;
        }

        case 'banner-basic-card-2-image-inner': {
          result.card2.image = el.getAttribute('src') || '';
          break;
        }

        case 'banner-basic-card-3-image-inner': {
          result.card3.image = el.getAttribute('src') || '';
          break;
        }

        case 'banner-basic-card-3-text': {
          result.card3.text = el.innerHTML.trim();
          break;
        }

        case 'banner-basic-card-4-image-inner': {
          result.card4.image = el.getAttribute('src') || '';
          break;
        }

        default:
          break;
      }
    });

    return result;
  },

  sectionFreestyleInfo(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Freestyle Info Section',
      enableAnchor: false,
      colors: {
        backgroundColor: '#ffffff',
        textColor: '#000000',
        tableHeaderBackgroundColor: '#14a16c',
        tableHeaderTextColor: '#ffffff',
        tableOldRowBackgroundColor: '#d6dad9',
        tableOldRowTextColor: '#000000',
      },
      productFacts: '',
      directionForUse: '',
      table: '',
      image: {
        url1: '',
        url2: '',
        enable: true,
      },
      topPadding: true,
      bottomPadding: true,
    };

    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');

    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Card Step Instructions 02 Section';
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'freestyle-info-wrapper': {
          result.colors.backgroundColor = el.getAttribute('data-background-color') || '#ffffff';
          result.colors.textColor = el.getAttribute('data-text-color') || '#000000';
          result.colors.tableHeaderBackgroundColor = el.getAttribute('data-table-header-background-color') || '#14a16c';
          result.colors.tableHeaderTextColor = el.getAttribute('data-table-header-text-color') || '#ffffff';
          result.colors.tableOldRowBackgroundColor =
            el.getAttribute('data-table-old-row-background-color') || '#d6dad9';
          result.colors.tableOldRowTextColor = el.getAttribute('data-table-old-row-text-color') || '#000000';
          result.topPadding = el.getAttribute('data-top-padding') === 'true' ? true : false;
          result.bottomPadding = el.getAttribute('data-bottom-padding') === 'true' ? true : false;
          break;
        }

        case 'freestyle-info-product-facts': {
          result.productFacts = el.innerHTML.trim();
          break;
        }

        case 'freestyle-info-direction-for-use': {
          result.directionForUse = el.innerHTML.trim();
          break;
        }

        case 'freestyle-info-table': {
          result.table = el.innerHTML.trim();
          break;
        }

        case 'freestyle-info-image-1-inner': {
          result.image.url1 = el.getAttribute('src') || '';
          break;
        }

        case 'freestyle-info-image-2-inner': {
          result.image.url2 = el.getAttribute('src') || '';
          break;
        }

        default:
          break;
      }
    });

    return result;
  },

  sectionFaqGrid06(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: '',
      colors: {
        backgroundContainer: '',
        backgroundFaqItem: '',
        textFaqItem: '',
        borderFaqItem: '',
      },
      titleFaq: '',
      listItem: [
        // {
        //   background: '',
        //   question: '',
        //   answer: ''
        // }
      ],
      topPadding: true,
      bottomPadding: true,
      containerFullWidth: false,
    };
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';
    }
    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'faq-grid-container-fluid': {
          result.colors.backgroundContainer = el.getAttribute('data-background') || '#ffffff';
          result.topPadding = el.getAttribute('data-top-padding') === 'true' ? true : false;
          result.bottomPadding = el.getAttribute('data-bottom-padding') === 'true' ? true : false;
          result.containerFullWidth = el.getAttribute('data-container-full-width') === 'true' ? true : false;
          break;
        }
        case 'title-faq-grid': {
          result['titleFaq'] = el.innerHTML.trim();
          break;
        }
        case 'list-item': {
          const elWrapItem = el.querySelectorAll('[data-attribute="item-wapper"]');
          result.colors.backgroundFaqItem = el.getAttribute('data-background-faq-item') || '';
          result.colors.textFaqItem = el.getAttribute('data-text-faq-item-color') || '#000000';
          result.colors.borderFaqItem = el.getAttribute('data-border-faq-item') || '#e5e5e5';
          elWrapItem.forEach(elItem => {
            const elQuestion = elItem.querySelector('[data-attribute="title-item-question"]');
            const elAnswer = elItem.querySelector('[data-attribute="answer-content"]');
            const question = elQuestion ? elQuestion.textContent.trim() : '';
            const answer = elAnswer ? elAnswer.innerHTML.trim() : '';
            result['listItem'].push({
              question: question,
              answer: answer,
            });
          });
          break;
        }
        default:
          break;
      }
    });
    return result;
  },

  sectionMoneyBackGuarantee(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const result = {
      title: 'Money Back Guarantee Section',
      header: '',
      footer: '',
      button: {
        text: 'CLAIM NOW',
        borderRadius: 40,
        textColor: '#ffffff',
        backgroundColor: '#181b1d',
      },
      colors: {
        backgroundColor: '#ffffff',
        containerBackgroundColor: '#cb6387',
        textColor: '#ffffff',
      },
      topPadding: true,
      bottomPadding: true,
    };

    const elements = doc.querySelectorAll('[data-attribute]');
    const container = doc.querySelector('[data-section]');
    if (container) {
      result.title = container.getAttribute('data-title') || result.title;
    }

    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'money-back-guarantee-wrapper': {
          result.topPadding = el.getAttribute('data-top-padding') === 'true' ? true : false;
          result.bottomPadding = el.getAttribute('data-bottom-padding') === 'true' ? true : false;
          result.button.borderRadius = Number(el.getAttribute('data-button-border-radius')) || 40;
          result.containerFullWidth = el.getAttribute('data-container-full-width') === 'true' ? true : false;

          result.colors.backgroundColor = el.getAttribute('data-background-color') || '#ffffff';
          result.colors.containerBackgroundColor = el.getAttribute('data-container-background-color') || '#cb6387';
          result.colors.textColor = el.getAttribute('data-text-color') || '#ffffff';

          result.button.textColor = el.getAttribute('data-button-text-color') || '#ffffff';
          result.button.backgroundColor = el.getAttribute('data-button-background-color') || '#181b1d';
          result.button.borderRadius = Number(el.getAttribute('data-button-border-radius')) || 40;
          break;
        }
        case 'money-back-guarantee-header': {
          result.header = el.innerHTML.trim();
          break;
        }
        case 'money-back-guarantee-footer': {
          result.footer = el.innerHTML.trim();
          break;
        }
        case 'money-back-guarantee-button': {
          result.button.text = el.textContent.trim();
          break;
        }
      }
    });

    return result;
  },

  sectionBannerFastvaluedeal(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const wrapButtonEl = doc.querySelector('[data-attribute="wrap-button"]');
    const buttonData = wrapButtonEl ? extractButtonBasic(wrapButtonEl.outerHTML) : {};

    const result = {
      ...containerResult,
      titleBanner: {
        show: true,
        content: '',
      },
      keyFeatures: {
        show: true,
        items: [],
      },
      imgSmallBanner: {
        show: true,
        src: '',
        maxWidthSmall: 430,
      },
      button: { ...buttonData },
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const titleBannerEl = doc.querySelector('[data-attribute="title-banner"]');
    if (titleBannerEl) {
      result.titleBanner.show = titleBannerEl.getAttribute('data-show') !== 'false';
      result.titleBanner.content = titleBannerEl.innerHTML.trim();
    }

    const keyFeaturesEl = doc.querySelector('[data-attribute="key-features"]');
    if (keyFeaturesEl) {
      result.keyFeatures.show = keyFeaturesEl.getAttribute('data-show') !== 'false';
      const itemEls = keyFeaturesEl.querySelectorAll('[data-attribute="key-feature-item"]');
      result.keyFeatures.items = Array.from(itemEls).map(itemEl => ({
        icon: itemEl.querySelector('[data-attribute="key-feature-item-icon-image"]')?.getAttribute('src') || '',
        content: itemEl.querySelector('[data-attribute="key-feature-item-content"]')?.innerHTML.trim() || '',
      }));
    }

    const imgSmallBannerEl = doc.querySelector('[data-attribute="img-small-banner"]');
    if (imgSmallBannerEl) {
      result.imgSmallBanner.show = imgSmallBannerEl.getAttribute('data-show') !== 'false';
      result.imgSmallBanner.maxWidthSmall =
        Number(imgSmallBannerEl.getAttribute('data-max-width-small')) || result.imgSmallBanner.maxWidthSmall;
      result.imgSmallBanner.src =
        imgSmallBannerEl.querySelector('[data-attribute="img-small-banner-image"]')?.getAttribute('src') || '';
    }

    return result;
  },

  sectionCardBannerRivoneed(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const wrapButtonEl = doc.querySelector('[data-attribute="wrap-button"]');
    const buttonData = wrapButtonEl ? extractButtonBasic(wrapButtonEl.outerHTML) : {};

    const result = {
      ...containerResult,
      bannerImage: {
        useBannerMobile: true,
        bannerDesktop: '',
        bannerMobile: '',
      },
      wrapContent: {
        widthContent: 1200,
        paddingTop: 40,
        paddingBottom: 40,
      },
      tags: {
        show: true,
        backgroundColorTag: '#ffffff23',
        borderRadius: 10,
        borderColor: '#ffffff',
        textColorTag: '#ffffff',
        items: [],
      },
      textContent: {
        show: true,
        content: '',
      },
      pills: {
        show: true,
        background: '#ffffff',
        color: '#000000',
        items: [],
      },
      button: { ...buttonData },
      rating: {
        show: true,
        value: 4,
        text: '',
      },
      smallImages: {
        show: true,
        items: [],
      },
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const wrapBannerEl = doc.querySelector('[data-attribute="wrap-banner"]');
    if (wrapBannerEl) {
      result.bannerImage.useBannerMobile = wrapBannerEl.getAttribute('data-use-banner-mobile') !== 'false';
      result.bannerImage.bannerDesktop =
        wrapBannerEl.querySelector('[data-attribute="banner-desktop-img"]')?.getAttribute('src') || '';
      result.bannerImage.bannerMobile =
        wrapBannerEl.querySelector('[data-attribute="banner-mobile-img"]')?.getAttribute('src') || '';
    }

    const wrapContentEl = doc.querySelector('[data-attribute="wrap-content"]');
    if (wrapContentEl) {
      result.wrapContent.widthContent =
        Number(wrapContentEl.getAttribute('data-width-content')) || result.wrapContent.widthContent;
      result.wrapContent.paddingTop =
        Number(wrapContentEl.getAttribute('data-padding-top')) || result.wrapContent.paddingTop;
      result.wrapContent.paddingBottom =
        Number(wrapContentEl.getAttribute('data-padding-bottom')) || result.wrapContent.paddingBottom;
    }

    const listTagEl = doc.querySelector('[data-attribute="list-tag"]');
    if (listTagEl) {
      result.tags.show = listTagEl.getAttribute('data-show') !== 'false';
      result.tags.backgroundColorTag =
        listTagEl.getAttribute('data-background-color-tag') || result.tags.backgroundColorTag;
      result.tags.textColorTag = listTagEl.getAttribute('data-text-color-tag') || result.tags.textColorTag;
      result.tags.borderRadius = Number(listTagEl.getAttribute('data-border-radius')) || result.tags.borderRadius;
      result.tags.borderColor = listTagEl.getAttribute('data-border-color') || result.tags.borderColor;
      result.tags.items = Array.from(listTagEl.querySelectorAll('[data-attribute="text-tag-item"]')).map(itemEl => ({
        text: itemEl.textContent.trim(),
      }));
    }

    const textContentEl = doc.querySelector('[data-attribute="text-content"]');
    if (textContentEl) {
      result.textContent.show = textContentEl.getAttribute('data-show') !== 'false';
      result.textContent.content = textContentEl.innerHTML.trim();
    }

    const listPillEl = doc.querySelector('[data-attribute="list-pill"]');
    if (listPillEl) {
      result.pills.show = listPillEl.getAttribute('data-show') !== 'false';
      result.pills.background = listPillEl.getAttribute('data-background-pill') || result.pills.background;
      result.pills.color = listPillEl.getAttribute('data-color-pill') || result.pills.color;
      result.pills.items = Array.from(listPillEl.querySelectorAll('.item-pill')).map(itemEl => ({
        icon: itemEl.querySelector('[data-attribute="icon-pill-item"]')?.getAttribute('src') || '',
        text: itemEl.querySelector('[data-attribute="text-pill-item"]')?.textContent.trim() || '',
      }));
    }

    const listSmallImageEl = doc.querySelector('[data-attribute="list-small-image"]');
    if (listSmallImageEl) {
      result.smallImages.show = listSmallImageEl.getAttribute('data-show') !== 'false';
      result.smallImages.items = Array.from(
        listSmallImageEl.querySelectorAll('[data-attribute="small-image-item"]'),
      ).map(itemEl => {
        const imgEl = itemEl.querySelector('[data-attribute="small-image-img"]') || itemEl.querySelector('img');
        return {
          href: itemEl.getAttribute('data-href') || itemEl.getAttribute('href') || '#',
          src: imgEl?.getAttribute('src') || '',
          alt: imgEl?.getAttribute('alt') || '',
        };
      });
    }

    const blockRatingEl = doc.querySelector('[data-attribute="block-rating"]');
    if (blockRatingEl) {
      result.rating.show = blockRatingEl.getAttribute('data-show') !== 'false';
      const starsEl = blockRatingEl.querySelector('[data-attribute="stars"]');
      if (starsEl) {
        result.rating.value = Number(starsEl.getAttribute('data-value')) || 4;
      }
      const ratingTextEl = blockRatingEl.querySelector('.rating-text');
      if (ratingTextEl) {
        result.rating.text = ratingTextEl.textContent.trim();
      }
    } else {
      result.rating.show = false;
    }

    return result;
  },

  sectionCardBanner02Rivoneed(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const dividerEl = doc.querySelector('[data-attribute="divider-primary"]');
    const dividerData = dividerEl
      ? extractDividerPrimary(dividerEl.outerHTML)
      : { show: true, maxWidth: 48, height: 4, backgroundColor: '#ffffff4d', align: 'left' };
    const wrapButtonEl = doc.querySelector('[data-attribute="wrap-button"]');
    const buttonData = wrapButtonEl ? extractButtonBasic(wrapButtonEl.outerHTML) : {};

    const result = {
      ...containerResult,
      banner: {
        useBannerMobile: true,
        desktop: '',
        mobile: '',
      },
      wrapContent: {
        widthContent: 625,
      },
      heading: {
        show: true,
        content: '',
      },
      divider: { ...dividerData },
      description: {
        show: true,
        content: '',
      },
      smallImage: {
        show: true,
        src: '',
        alt: '',
      },
      button: { ...buttonData },
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const wrapBannerEl = doc.querySelector('[data-attribute="wrap-banner"]');
    if (wrapBannerEl) {
      result.banner.useBannerMobile = wrapBannerEl.getAttribute('data-use-banner-mobile') !== 'false';
      result.banner.desktop =
        wrapBannerEl.querySelector('[data-attribute="banner-desktop-img"]')?.getAttribute('src') || '';
      result.banner.mobile =
        wrapBannerEl.querySelector('[data-attribute="banner-mobile-img"]')?.getAttribute('src') || '';
    }

    const wrapContentEl = doc.querySelector('[data-attribute="wrap-content"]');
    if (wrapContentEl) {
      result.wrapContent.widthContent =
        Number(wrapContentEl.getAttribute('data-width-content')) || result.wrapContent.widthContent;
    }

    const headingEl = doc.querySelector('[data-attribute="heading-content"]');
    if (headingEl) {
      result.heading.show = headingEl.getAttribute('data-show') !== 'false';
      result.heading.content = headingEl.innerHTML.trim();
    }

    const descriptionEl = doc.querySelector('[data-attribute="description-content"]');
    if (descriptionEl) {
      result.description.show = descriptionEl.getAttribute('data-show') !== 'false';
      result.description.content = descriptionEl.innerHTML.trim();
    }

    const smallImageEl = doc.querySelector('[data-attribute="wrap-image-small"]');
    if (smallImageEl) {
      const imageEl = smallImageEl.querySelector('[data-attribute="image-small"]');
      result.smallImage.show = smallImageEl.getAttribute('data-show') !== 'false';
      result.smallImage.src = imageEl?.getAttribute('src') || '';
      result.smallImage.alt = imageEl?.getAttribute('alt') || '';
    }

    return result;
  },

  sectionCardSatelliteRivoneed(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const wrapButtonEl = doc.querySelector('[data-attribute="wrap-button"]');
    const buttonData = wrapButtonEl ? extractButtonBasic(wrapButtonEl.outerHTML) : {};

    const result = {
      ...containerResult,
      cardTitle: {
        show: true,
        content: '',
      },
      mainMedia: {
        type: 'video',
        videoSrc: '',
        imageSrc: '',
        imageAlt: '',
      },
      items: [],
      button: { ...buttonData },
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const cardTitleEl = doc.querySelector('[data-attribute="card-title"]');
    if (cardTitleEl) {
      result.cardTitle.show = cardTitleEl.getAttribute('data-show') !== 'false';
      result.cardTitle.content = cardTitleEl.innerHTML.trim();
    }

    const mainEl = doc.querySelector('[data-attribute="main-satellite"]');
    if (mainEl) {
      const useVideo = mainEl.getAttribute('data-use-video') !== 'false';
      result.mainMedia.type = useVideo ? 'video' : 'image';
      const videoEl = mainEl.querySelector('[data-attribute="video-satellite"]');
      const imageEl = mainEl.querySelector('[data-attribute="img-satellite"]');
      result.mainMedia.videoSrc = videoEl?.getAttribute('src') || '';
      result.mainMedia.imageSrc = imageEl?.getAttribute('src') || '';
      result.mainMedia.imageAlt = imageEl?.getAttribute('alt') || '';
    }

    const itemEls = doc.querySelectorAll('[data-attribute="wrap-list-small"] [data-attribute="item-small"]');
    result.items = Array.from(itemEls)
      .slice(0, 4)
      .map(itemEl => {
        const overlayOpacity = Number(itemEl.getAttribute('data-overlay-opacity'));
        const imageEl = itemEl.querySelector('[data-attribute="img-small"]');
        return {
          overlayOpacity: Number.isNaN(overlayOpacity) ? 0 : overlayOpacity,
          content: itemEl.querySelector('[data-attribute="text-content"]')?.innerHTML.trim() || '',
          imageSrc: imageEl?.getAttribute('src') || '',
          imageAlt: imageEl?.getAttribute('alt') || '',
        };
      });

    return result;
  },

  sectionCardWithSliderRivoneed(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const result = {
      ...containerResult,
      cardTitle: {
        show: true,
        content: '',
      },
      contentCard: {
        width: 549,
        align: 'left',
      },
      slides: [],
      benefits: [],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const cardTitleEl = doc.querySelector('[data-attribute="card-title"]');
    if (cardTitleEl) {
      result.cardTitle.show = cardTitleEl.getAttribute('data-show') !== 'false';
      result.cardTitle.content = cardTitleEl.innerHTML.trim();
    }

    const wrapContentCardEl = doc.querySelector('[data-attribute="wrap-content-card"]');
    if (wrapContentCardEl) {
      result.contentCard.width = Number(wrapContentCardEl.getAttribute('data-width')) || result.contentCard.width;
      result.contentCard.align = wrapContentCardEl.getAttribute('data-align') || result.contentCard.align;
    }

    const slideEls = doc.querySelectorAll('[data-attribute="list-item"] [data-attribute="item-slide"]');
    result.slides = Array.from(slideEls).map(itemEl => {
      const wrapItemSlideEl = itemEl.querySelector('[data-attribute="wrap-item-slide"]');
      const overlayOpacity = Number(wrapItemSlideEl.getAttribute('data-overlay-opacity'));
      const imageEl = itemEl.querySelector('[data-attribute="image-item"]');
      return {
        image: imageEl?.getAttribute('src') || '',
        alt: imageEl?.getAttribute('alt') || '',
        title: itemEl.querySelector('[data-attribute="title-item"]')?.innerHTML.trim() || '',
        overlayOpacity: Number.isNaN(overlayOpacity) ? 0 : overlayOpacity,
      };
    });

    const benefitEls = doc.querySelectorAll('[data-attribute="wrap-benefis"] [data-attribute="item-benefit"]');
    result.benefits = Array.from(benefitEls).map(itemEl => {
      const imageEl = itemEl.querySelector('.icon-item-benefit img');
      return {
        icon: imageEl?.getAttribute('src') || '',
        alt: imageEl?.getAttribute('alt') || '',
        content: itemEl.querySelector('.text-item-benefit')?.innerHTML.trim() || '',
      };
    });

    return result;
  },

  sectionCardGridItemRivoneed(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const wrapButtonEl = doc.querySelector('[data-attribute="wrap-button"]');
    const buttonData = wrapButtonEl ? extractButtonBasic(wrapButtonEl.outerHTML) : {};

    const result = {
      ...containerResult,
      cardTitle: {
        show: true,
        content: '',
      },
      list: {
        paddingItem: false,
        borderRadiusItem: 20,
        backgroundColorItem: '#ffffff',
      },
      items: [],
      button: { ...buttonData },
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const cardTitleEl = doc.querySelector('[data-attribute="card-title"]');
    if (cardTitleEl) {
      result.cardTitle.show = cardTitleEl.getAttribute('data-show') !== 'false';
      result.cardTitle.content = cardTitleEl.innerHTML.trim();
    }

    const listItemEl = doc.querySelector('[data-attribute="list-item"]');
    if (listItemEl) {
      result.list.paddingItem = listItemEl.getAttribute('data-padding-item') === 'true';
      result.list.borderRadiusItem =
        Number(listItemEl.getAttribute('data-border-radius-item')) || result.list.borderRadiusItem;
      result.list.backgroundColorItem =
        listItemEl.getAttribute('data-background-color-item') || result.list.backgroundColorItem;
    }

    const itemEls = doc.querySelectorAll('[data-attribute="list-item"] [data-attribute="item-grid"]');
    result.items = Array.from(itemEls).map(itemEl => {
      const imageEl = itemEl.querySelector('[data-attribute="image-item"]');
      return {
        image: imageEl?.getAttribute('src') || '',
        alt: imageEl?.getAttribute('alt') || '',
        content: itemEl.querySelector('[data-attribute="text-item"]')?.innerHTML.trim() || '',
      };
    });

    return result;
  },

  sectionCardSliderRivoneed(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const wrapButtonEl = doc.querySelector('[data-attribute="wrap-button"]');
    const buttonData = wrapButtonEl ? extractButtonBasic(wrapButtonEl.outerHTML) : {};

    const result = {
      ...containerResult,
      cardTitle: {
        show: true,
        content: '',
      },
      slides: [],
      button: { ...buttonData },
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const cardTitleEl = doc.querySelector('[data-attribute="card-title"]');
    if (cardTitleEl) {
      result.cardTitle.show = cardTitleEl.getAttribute('data-show') !== 'false';
      result.cardTitle.content = cardTitleEl.innerHTML.trim();
    }

    const slideEls = doc.querySelectorAll('[data-attribute="list-item"] [data-attribute="item-slide"]');
    result.slides = Array.from(slideEls).map(itemEl => {
      const imageEl = itemEl.querySelector('[data-attribute="image-item"]');
      return {
        image: imageEl?.getAttribute('src') || '',
        alt: imageEl?.getAttribute('alt') || '',
        content: itemEl.querySelector('[data-attribute="title-item"]')?.innerHTML.trim() || '',
      };
    });

    return result;
  },

  sectionMarqueeRivoneed(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const result = {
      ...containerResult,
      cardTitle: {
        show: true,
        content: '',
      },
      marquee: {
        widthItem: 320,
        gapItem: 15,
        borderRadiusItem: 10,
        colorBorderItem: '#ff0000',
        speedMarquee: 20,
      },
      items: [],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const cardTitleEl = doc.querySelector('[data-attribute="card-title"]');
    if (cardTitleEl) {
      result.cardTitle.show = cardTitleEl.getAttribute('data-show') !== 'false';
      result.cardTitle.content = cardTitleEl.innerHTML.trim();
    }

    const blockMarqueeEl = doc.querySelector('[data-attribute="block-marquee"]');
    if (blockMarqueeEl) {
      result.marquee.widthItem = Number(blockMarqueeEl.getAttribute('data-width-item')) || result.marquee.widthItem;
      result.marquee.gapItem = Number(blockMarqueeEl.getAttribute('data-gap-item')) || result.marquee.gapItem;
      result.marquee.borderRadiusItem =
        Number(blockMarqueeEl.getAttribute('data-border-radius-item')) || result.marquee.borderRadiusItem;
      result.marquee.colorBorderItem =
        blockMarqueeEl.getAttribute('data-color-border-item') || result.marquee.colorBorderItem;
      result.marquee.speedMarquee =
        Number(blockMarqueeEl.getAttribute('data-speed-marquee')) || result.marquee.speedMarquee;
    }

    const itemEls = doc.querySelectorAll('[data-attribute="list-item"] [data-attribute="item-marquee"]');
    result.items = Array.from(itemEls).map(itemEl => {
      const imageEl = itemEl.querySelector('[data-attribute="image-item"]');
      const opacityOverlayAttr = itemEl.getAttribute('data-opacity-overlay');
      return {
        image: imageEl?.getAttribute('src') || '',
        alt: imageEl?.getAttribute('alt') || '',
        content: itemEl.querySelector('[data-attribute="content-item"]')?.innerHTML.trim() || '',
        overlay: {
          color: itemEl.getAttribute('data-color-overlay') || '#000000',
          opacity: opacityOverlayAttr !== null ? Number(opacityOverlayAttr) : 0.1,
        },
      };
    });

    return result;
  },

  sectionCardBasicRivoneed(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const result = {
      ...containerResult,
      leftCard: {
        order: 1,
        colorBorder: '#ffffff',
      },
      rightCard: {
        order: 2,
        image: '',
        alt: '',
      },
      titleContent: '',
      items: [],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const leftCardEl = doc.querySelector('[data-attribute="left-card"]');
    if (leftCardEl) {
      result.leftCard.order = Number(leftCardEl.getAttribute('data-order')) || result.leftCard.order;
      result.leftCard.colorBorder = leftCardEl.getAttribute('data-color-border') || result.leftCard.colorBorder;
    }

    const rightCardEl = doc.querySelector('[data-attribute="right-card"]');
    if (rightCardEl) {
      result.rightCard.order = Number(rightCardEl.getAttribute('data-order')) || result.rightCard.order;
    }

    const titleContentEl = doc.querySelector('[data-attribute="title-content"]');
    if (titleContentEl) {
      result.titleContent = titleContentEl.innerHTML.trim();
    }

    const imageEl = doc.querySelector('[data-attribute="image-card"]');
    if (imageEl) {
      result.rightCard.image = imageEl.getAttribute('src') || '';
      result.rightCard.alt = imageEl.getAttribute('alt') || '';
    }

    const itemEls = doc.querySelectorAll('[data-attribute="list-item"] [data-attribute="item"]');
    result.items = Array.from(itemEls).map(itemEl => ({
      label: itemEl.querySelector('[data-attribute="label-item"]')?.textContent.trim() || '',
      value: itemEl.querySelector('[data-attribute="value-item"]')?.textContent.trim() || '',
    }));

    return result;
  },

  sectionCardBadgeRivoneed(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const result = {
      ...containerResult,
      cardTitle: {
        show: true,
        content: '',
      },
      items: [],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const cardTitleEl = doc.querySelector('[data-attribute="card-title"]');
    if (cardTitleEl) {
      result.cardTitle.show = cardTitleEl.getAttribute('data-show') !== 'false';
      result.cardTitle.content = cardTitleEl.innerHTML.trim();
    }

    const itemEls = doc.querySelectorAll('[data-attribute="list-item"] [data-attribute="item"]');
    result.items = Array.from(itemEls).map(itemEl => {
      const iconEl = itemEl.querySelector('[data-attribute="icon-item"]');
      return {
        icon: iconEl?.getAttribute('src') || '',
        alt: iconEl?.getAttribute('alt') || '',
        content: itemEl.querySelector('[data-attribute="content-item"]')?.innerHTML.trim() || '',
      };
    });

    return result;
  },

  sectionCardFaqRivoneed(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const wrapButtonEl = doc.querySelector('[data-attribute="wrap-button"]');
    const buttonData = wrapButtonEl ? extractButtonBasic(wrapButtonEl.outerHTML) : {};

    const result = {
      ...containerResult,
      cardTitle: {
        show: true,
        content: '',
      },
      accordion: {
        show: true,
      },
      button: { ...buttonData },
      items: [],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const cardTitleEl = doc.querySelector('[data-attribute="card-title"]');
    if (cardTitleEl) {
      result.cardTitle.show = cardTitleEl.getAttribute('data-show') !== 'false';
      result.cardTitle.content = cardTitleEl.innerHTML.trim();
    }

    const cardAccordionsEl = doc.querySelector('[data-attribute="card-accordions"]');
    if (cardAccordionsEl) {
      result.accordion.show = cardAccordionsEl.getAttribute('data-show-accordion') !== 'false';
    }

    const accordionEls = doc.querySelectorAll('[data-attribute="card-accordion"]');
    result.items = Array.from(accordionEls).map(itemEl => ({
      question: itemEl.querySelector('[data-attribute="accordion-title-text"]')?.textContent.trim() || '',
      answer: itemEl.querySelector('[data-attribute="accordion-text"]')?.innerHTML.trim() || '',
    }));

    return result;
  },

  sectionCardBannerGatorz(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const result = {
      ...containerResult,
      cardImage: {
        src: '',
        alt: 'Image',
        showOverlay: true,
        overlayOpacity: 0.2,
      },
      cardContent: {
        show: true,
        position: 'left',
        maxWidth: 750,
        content: '',
      },
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const imageEl = doc.querySelector('[data-attribute="card-image-src"]');
    if (imageEl) {
      result.cardImage.src = imageEl.getAttribute('src') || '';
      result.cardImage.alt = imageEl.getAttribute('alt') || '';
    }

    const cardImageEl = doc.querySelector('[data-attribute="card-image"]');
    if (cardImageEl) {
      const overlayOpacity = Number(cardImageEl.getAttribute('data-overlay-opacity'));
      result.cardImage.showOverlay = cardImageEl.getAttribute('data-show-overlay') !== 'false';
      result.cardImage.overlayOpacity = Number.isNaN(overlayOpacity) ? result.cardImage.overlayOpacity : overlayOpacity;
    }

    const cardContentEl = doc.querySelector('[data-attribute="card-content"]');
    if (cardContentEl) {
      result.cardContent.show = cardContentEl.getAttribute('data-show') !== 'false';
      result.cardContent.position = cardContentEl.getAttribute('data-position') || 'left';
      result.cardContent.maxWidth = Number(cardContentEl.getAttribute('data-max-width')) || result.cardContent.maxWidth;
      result.cardContent.content = cardContentEl.innerHTML.trim();
    }

    return result;
  },

  sectionCardGatorzCustom(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const result = {
      ...containerResult,
      containerGatorz: {
        paddingLeft: true,
        paddingRight: true,
      },
      layout: {
        useCustomWidthImg: true,
        widthImg: 50,
        gap: 32,
        centerY: true,
      },
      leftCard: {
        order: 1,
      },
      rightCard: {
        order: 2,
      },
      content: '',
      image: {
        src: '',
        alt: '',
      },
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const containerGatorzEl = doc.querySelector('[data-attribute="container-gatorz"]');
    if (containerGatorzEl) {
      result.containerGatorz.paddingLeft = containerGatorzEl.getAttribute('data-padding-left') === 'true';
      result.containerGatorz.paddingRight = containerGatorzEl.getAttribute('data-padding-right') === 'true';
    }

    const wrapCardEl = doc.querySelector('[data-attribute="wrap-card"]');
    if (wrapCardEl) {
      result.layout.useCustomWidthImg = wrapCardEl.getAttribute('data-use-custom-width-img') !== 'false';
      result.layout.widthImg = Number(wrapCardEl.getAttribute('data-width-img')) || result.layout.widthImg;
      result.layout.gap = Number(wrapCardEl.getAttribute('data-gap')) || result.layout.gap;
      result.layout.centerY = wrapCardEl.getAttribute('data-center-y') !== 'false';
    }

    const leftCardEl = doc.querySelector('[data-attribute="left-card"]');
    if (leftCardEl) {
      result.leftCard.order = Number(leftCardEl.getAttribute('data-order')) || result.leftCard.order;
    }

    const rightCardEl = doc.querySelector('[data-attribute="right-card"]');
    if (rightCardEl) {
      result.rightCard.order = Number(rightCardEl.getAttribute('data-order')) || result.rightCard.order;
    }

    const contentEl = doc.querySelector('[data-attribute="wrap-content"]');
    if (contentEl) {
      result.content = contentEl.innerHTML.trim();
    }

    const imageEl = doc.querySelector('[data-attribute="card-image"]');
    if (imageEl) {
      result.image.src = imageEl.getAttribute('src') || '';
      result.image.alt = imageEl.getAttribute('alt') || '';
    }

    return result;
  },

  sectionCardGatorzGridItem(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const result = {
      ...containerResult,
      cardTitle: {
        show: true,
        content: '',
      },
      items: [],
      note: {
        show: true,
        content: '',
      },
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const cardTitleEl = doc.querySelector('[data-attribute="card-title"]');
    if (cardTitleEl) {
      result.cardTitle.show = cardTitleEl.getAttribute('data-show') !== 'false';
      result.cardTitle.content = cardTitleEl.innerHTML.trim();
    }

    const itemEls = doc.querySelectorAll('[data-attribute="list-item"] [data-attribute="item"]');
    result.items = Array.from(itemEls).map(itemEl => {
      const iconEl = itemEl.querySelector('[data-attribute="icon-item"]');
      const textEl = itemEl.querySelector('[data-attribute="text-item"]');
      return {
        icon: iconEl?.getAttribute('src') || '',
        alt: iconEl?.getAttribute('alt') || '',
        content: textEl?.innerHTML.trim() || '',
      };
    });

    const noteEl = doc.querySelector('[data-attribute="text-note"]');
    if (noteEl) {
      result.note.show = noteEl.getAttribute('data-show') !== 'false';
      result.note.content = noteEl.innerHTML.trim();
    }

    return result;
  },

  sectionCardFastvaluedealTitleImg(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const result = {
      ...containerResult,
      cardTitle: {
        show: true,
        content: '',
      },
      wrapImages: {
        useMobileImage: true,
        maxWidth: 900,
        align: 'center',
        imageDesktop: '',
        imageMobile: '',
      },
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const cardTitleEl = doc.querySelector('[data-attribute="card-title"]');
    if (cardTitleEl) {
      result.cardTitle.show = cardTitleEl.getAttribute('data-show') !== 'false';
      result.cardTitle.content = cardTitleEl.innerHTML.trim();
    }

    const wrapImagesEl = doc.querySelector('[data-attribute="wrap-images"]');
    if (wrapImagesEl) {
      result.wrapImages.useMobileImage = wrapImagesEl.getAttribute('data-use-mobile-image') !== 'false';
      result.wrapImages.maxWidth = Number(wrapImagesEl.getAttribute('data-max-width')) || result.wrapImages.maxWidth;
      result.wrapImages.align = wrapImagesEl.getAttribute('data-align') || 'center';
      result.wrapImages.imageDesktop =
        wrapImagesEl.querySelector('[data-attribute="image-desktop"]')?.getAttribute('src') || '';
      result.wrapImages.imageMobile =
        wrapImagesEl.querySelector('[data-attribute="image-mobile"]')?.getAttribute('src') || '';
    }

    return result;
  },

  sectionSliderFastvaluedeal01(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const dividerEl = doc.querySelector('[data-attribute="divider-primary"]');
    const dividerData = dividerEl
      ? extractDividerPrimary(dividerEl.outerHTML)
      : { show: true, maxWidth: 200, height: 6, backgroundColor: '#E0E0E0', align: 'center' };

    const result = {
      ...containerResult,
      cardTitle: {
        show: true,
        content: '',
      },
      divider: { ...dividerData },
      cardSummary: {
        show: true,
        content: '',
      },
      slider: {
        colPerView: 4,
        spaceBetween: 20,
      },
      items: [],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const cardTitleEl = doc.querySelector('[data-attribute="card-title"]');
    if (cardTitleEl) {
      result.cardTitle.show = cardTitleEl.getAttribute('data-show') !== 'false';
      result.cardTitle.content = cardTitleEl.innerHTML.trim();
    }

    const cardSummaryEl = doc.querySelector('[data-attribute="card-summary"]');
    if (cardSummaryEl) {
      result.cardSummary.show = cardSummaryEl.getAttribute('data-show') !== 'false';
      result.cardSummary.content = cardSummaryEl.innerHTML.trim();
    }

    const listItemEl = doc.querySelector('[data-attribute="list-item"]');
    if (listItemEl) {
      result.slider.colPerView = parseInt(listItemEl.getAttribute('data-col-per-view') || '4', 10) || 4;
      result.slider.spaceBetween = parseInt(listItemEl.getAttribute('data-space-between') || '20', 10) || 20;
      listItemEl.querySelectorAll('[data-attribute="item"]').forEach(item => {
        const img = item.querySelector('[data-attribute="image-item"]');
        const content = item.querySelector('[data-attribute="content-item"]');
        result.items.push({
          image: img ? img.getAttribute('src') || '' : '',
          content: content ? content.innerHTML.trim() : '',
        });
      });
    }

    return result;
  },

  sectionFastvaluedealCountdown(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const wrapButtonEl = doc.querySelector('[data-attribute="wrap-button"]');
    const buttonData = wrapButtonEl ? extractButtonBasic(wrapButtonEl.outerHTML) : {};

    const result = {
      ...containerResult,
      button: { ...buttonData },
      productImage: {
        show: true,
        src: '',
        position: 'left',
      },
      info: {
        title: '',
        policy: {
          moneyBack: '',
          fastShipping: '',
          support: '',
        },
        ratingImage: '',
        timer: {
          text: 'Ending Soon:',
          time: 10, // minutes
        },
      },
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const fvdCountdownContentEl = doc.querySelector('[data-attribute="fvd-countdown-content"]');
    if (fvdCountdownContentEl) {
      result.productImage.position = fvdCountdownContentEl.getAttribute('data-image-position') || 'left';
      result.productImage.show = fvdCountdownContentEl.getAttribute('data-image-show') !== 'false';
    }

    const productImageEl = doc.querySelector('[data-attribute="fvd-countdown__image"]');
    if (productImageEl) {
      result.productImage.src =
        productImageEl.querySelector('[data-attribute="fvd-countdown__image-img"]')?.getAttribute('src') || '';
    }

    const infoTitleEl = doc.querySelector('[data-attribute="fvd-countdown__title"]');
    if (infoTitleEl) {
      result.info.title = infoTitleEl.innerHTML.trim();
    }

    const policyMoneyBackEl = doc.querySelector('[data-attribute="fvd-countdown__policy-item-money-back"]');
    if (policyMoneyBackEl) {
      result.info.policy.moneyBack = policyMoneyBackEl.textContent.trim();
    }

    const policyFastShippingEl = doc.querySelector('[data-attribute="fvd-countdown__policy-item-fast-shipping"]');
    if (policyFastShippingEl) {
      result.info.policy.fastShipping = policyFastShippingEl.textContent.trim();
    }

    const policySupportEl = doc.querySelector('[data-attribute="fvd-countdown__policy-item-support"]');
    if (policySupportEl) {
      result.info.policy.support = policySupportEl.textContent.trim();
    }

    const ratingImageEl = doc.querySelector('[data-attribute="fvd-countdown__rating-img"]');
    if (ratingImageEl) {
      result.info.ratingImage = ratingImageEl.getAttribute('src') || '';
    }

    const timerCountdownTextEl = doc.querySelector('[data-attribute="fvd-countdown__timer-countdown-text"]');
    if (timerCountdownTextEl) {
      result.info.timer.text = timerCountdownTextEl.textContent.trim();
    }

    const timerCountdownTimeEl = doc.querySelector('[data-attribute="fvd-countdown__timer-countdown-time"]');
    if (timerCountdownTimeEl) {
      result.info.timer.time = Number(timerCountdownTimeEl.getAttribute('data-time')) || result.info.timer.time;
    }

    return result;
  },

  sectionFastvaluedealFaq(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const dividerEl = doc.querySelector('[data-attribute="divider-primary"]');
    const dividerData = dividerEl
      ? extractDividerPrimary(dividerEl.outerHTML)
      : { show: true, maxWidth: 200, height: 6, backgroundColor: '#E0E0E0', align: 'center' };

    const result = {
      ...containerResult,
      title: '',
      colors: {
        backgroundFaqItem: '',
        textFaqItem: '',
      },
      titleFaq: '',
      listItem: [
        // {
        //   background: '',
        //   question: '',
        //   answer: ''
        // }
      ],
      containerFullWidth: false,
      divider: { ...dividerData },
    };
    const elements = doc.querySelectorAll('[data-attribute]');
    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title ? title : 'Freestyle';
    }
    elements.forEach(el => {
      const key = el.getAttribute('data-attribute');
      switch (key) {
        case 'faq-grid-container': {
          result.containerFullWidth = el.getAttribute('data-container-full-width') === 'true' ? true : false;
          break;
        }
        case 'title-faq-grid': {
          result['titleFaq'] = el.innerHTML.trim();
          break;
        }
        case 'list-item': {
          const elWrapItem = el.querySelectorAll('[data-attribute="item-wapper"]');
          result.colors.backgroundFaqItem = el.getAttribute('data-background-faq-item') || '#FFFFFF';
          result.colors.textFaqItem = el.getAttribute('data-text-faq-item-color') || '#000000';
          elWrapItem.forEach(elItem => {
            const elQuestion = elItem.querySelector('[data-attribute="title-item-question"]');
            const elAnswer = elItem.querySelector('[data-attribute="answer-content"]');
            const question = elQuestion ? elQuestion.textContent.trim() : '';
            const answer = elAnswer ? elAnswer.innerHTML.trim() : '';
            result['listItem'].push({
              question: question,
              answer: answer,
            });
          });
          break;
        }
        default:
          break;
      }
    });
    return result;
  },

  sectionFastvaluedealMoneyBackGuarantee(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const result = {
      ...containerResult,
      image: {
        src: '',
        position: 'left',
      },
      content: '',
      backgroundContentColor: '#0130E2',
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const contentEl = doc.querySelector('[data-attribute="fvd-mbg-content"]');
    if (contentEl) {
      result.image.position = contentEl.getAttribute('data-image-position') || 'left';
      result.backgroundContentColor = contentEl.getAttribute('data-background-content-color') || '#0130E2';
    }

    const imageEl = doc.querySelector('[data-attribute="fvd-mbg__image-img"]');
    if (imageEl) {
      result.image.src = imageEl.getAttribute('src') || '';
    }

    const textEl = doc.querySelector('[data-attribute="fvd-mbg__text"]');
    if (textEl) {
      result.content = textEl.innerHTML.trim();
    }

    return result;
  },

  sectionFastvaluedealReviewer(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const result = {
      ...containerResult,
      image: {
        src: '',
        position: 'left',
      },
      content: '',
      quotes: {
        start: {
          show: true,
          src: '',
        },
        end: {
          show: true,
          src: '',
        },
      },
      author: {
        name: '',
        signature: {
          show: true,
          src: '',
        },
      },
      backgroundContentColor: '#F6F8FF',
      borderColor: '#E5E7EB',
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const contentEl = doc.querySelector('[data-attribute="fvd-reviewer-content"]');
    if (contentEl) {
      result.image.position = contentEl.getAttribute('data-image-position') || 'left';
      result.backgroundContentColor = contentEl.getAttribute('data-background-content-color') || '#F6F8FF';
      result.borderColor = contentEl.getAttribute('data-border-color') || '#E5E7EB';
    }

    const imageEl = doc.querySelector('[data-attribute="fvd-reviewer__image-img"]');
    if (imageEl) {
      result.image.src = imageEl.getAttribute('src') || '';
    }

    const textEl = doc.querySelector('[data-attribute="fvd-reviewer__text"]');
    if (textEl) {
      result.content = textEl.innerHTML.trim();
    }

    const authorNameEl = doc.querySelector('[data-attribute="fvd-reviewer__author-name"]');
    if (authorNameEl) {
      result.author.name = authorNameEl.textContent.trim();
    }

    const signatureEl = doc.querySelector('[data-attribute="fvd-reviewer__author-signature"]');
    if (signatureEl) {
      result.author.signature.show = signatureEl.getAttribute('data-show') !== 'false';
      result.author.signature.src = signatureEl.getAttribute('src') || '';
    }

    const quoteStartImgEl = doc.querySelector('[data-attribute="fvd-reviewer__info-quote-start-img"]');
    if (quoteStartImgEl) {
      result.quotes.start.show = quoteStartImgEl.getAttribute('data-show') !== 'false';
      result.quotes.start.src = quoteStartImgEl.getAttribute('src') || '';
    }

    const quoteEndImgEl = doc.querySelector('[data-attribute="fvd-reviewer__info-quote-end-img"]');
    if (quoteEndImgEl) {
      result.quotes.end.show = quoteEndImgEl.getAttribute('data-show') !== 'false';
      result.quotes.end.src = quoteEndImgEl.getAttribute('src') || '';
    }

    return result;
  },

  sectionFastvaluedealCta(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const wrapButtonEl = doc.querySelector('[data-attribute="wrap-button"]');
    const buttonData = wrapButtonEl ? extractButtonBasic(wrapButtonEl.outerHTML) : {};

    const result = {
      ...containerResult,
      button: { ...buttonData },
      logo: {
        src: '',
      },
      rating: {
        avatarsImage: '',
        starsImage: '',
        text: '4.7 Average Rating',
      },
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const logoImgEl = doc.querySelector('[data-attribute="fvd-cta__logo-img"]');
    if (logoImgEl) {
      result.logo.src = logoImgEl.getAttribute('src') || '';
    }

    const avatarsImgEl = doc.querySelector('[data-attribute="fvd-cta__avatars-img"]');
    if (avatarsImgEl) {
      result.rating.avatarsImage = avatarsImgEl.getAttribute('src') || '';
    }

    const starsImgEl = doc.querySelector('[data-attribute="fvd-cta__stars-img"]');
    if (starsImgEl) {
      result.rating.starsImage = starsImgEl.getAttribute('src') || '';
    }

    const ratingTextEl = doc.querySelector('[data-attribute="fvd-cta__rating-text"]');
    if (ratingTextEl) {
      result.rating.text = ratingTextEl.textContent.trim();
    }

    return result;
  },

  sectionFastvaluedealCardBasic(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const sectionTitleWrapEl = doc.querySelector('[data-attribute="fvd-card-basic__section-title-wrap"]');
    const headerDividerEl = sectionTitleWrapEl?.querySelector('[data-attribute="divider-primary"]');
    const headerDividerData = headerDividerEl
      ? extractDividerPrimary(headerDividerEl.outerHTML)
      : { show: true, maxWidth: 90, height: 6, backgroundColor: '#5B04DE', align: 'center' };

    const leftEl = doc.querySelector('[data-attribute="fvd-card-basic__left"]');
    const contextDividerEl = leftEl?.querySelector('[data-attribute="divider-primary"]');
    const contextDividerData = contextDividerEl
      ? extractDividerPrimary(contextDividerEl.outerHTML)
      : { show: true, maxWidth: 90, height: 6, backgroundColor: '#5B04DE', align: 'left' };

    const result = {
      ...containerResult,
      sectionTitle: {
        show: false,
        content: '',
      },
      layout: {
        gridRatio: '2fr-1fr',
      },
      context: {
        title: '',
        text: '',
      },
      dividerHeader: { ...headerDividerData },
      dividerContext: { ...contextDividerData },
      features: {
        show: true,
        backgroundColor: '#0130E2',
        textColor: '#FFFFFF',
        items: [],
      },
      sideImage: {
        show: true,
        src: '',
        position: 'right',
      },
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const contentEl = doc.querySelector('[data-attribute="fvd-card-basic-content"]');
    if (contentEl) {
      result.layout.gridRatio = contentEl.getAttribute('data-grid-ratio') || '2fr-1fr';
      result.sideImage.position = contentEl.getAttribute('data-image-position') || 'right';
      result.sideImage.show = contentEl.getAttribute('data-image-show') !== 'false';
      result.features.show = contentEl.getAttribute('data-features-show') !== 'false';
    }

    if (sectionTitleWrapEl) {
      result.sectionTitle.show = sectionTitleWrapEl.getAttribute('data-show') !== 'false';
      const sectionTitleEl = sectionTitleWrapEl.querySelector('[data-attribute="fvd-card-basic__section-title"]');
      if (sectionTitleEl) {
        result.sectionTitle.content = sectionTitleEl.innerHTML.trim();
      }
    }

    const contextTitleEl = doc.querySelector('[data-attribute="fvd-card-basic__context-title"]');
    if (contextTitleEl) {
      result.context.title = contextTitleEl.innerHTML.trim();
    }

    const contextTextEl = doc.querySelector('[data-attribute="fvd-card-basic__context-text"]');
    if (contextTextEl) {
      result.context.text = contextTextEl.innerHTML.trim();
    }

    const sideImageEl = doc.querySelector('[data-attribute="fvd-card-basic__side-image-img"]');
    if (sideImageEl) {
      result.sideImage.src = sideImageEl.getAttribute('src') || '';
    }

    const featuresEl = doc.querySelector('[data-attribute="fvd-card-basic__features"]');
    if (featuresEl) {
      const firstItemEl = featuresEl.querySelector('[data-attribute="fvd-card-basic__feature-item"]');
      result.features.backgroundColor =
        featuresEl.getAttribute('data-background-color') ||
        firstItemEl?.getAttribute('data-background-color') ||
        '#0130E2';
      result.features.textColor =
        featuresEl.getAttribute('data-text-color') || firstItemEl?.getAttribute('data-text-color') || '#FFFFFF';

      featuresEl.querySelectorAll('[data-attribute="fvd-card-basic__feature-item"]').forEach(itemEl => {
        const contentEl = itemEl.querySelector('[data-attribute="fvd-card-basic__feature-content"]');
        const imageWrapEl = itemEl.querySelector('[data-attribute="fvd-card-basic__feature-image-wrap"]');
        const imageEl = itemEl.querySelector('[data-attribute="fvd-card-basic__feature-image"]');
        result.features.items.push({
          content: contentEl ? contentEl.innerHTML.trim() : '',
          image: {
            show: imageWrapEl ? imageWrapEl.getAttribute('data-show') !== 'false' : true,
            src: imageEl ? imageEl.getAttribute('src') || '' : '',
          },
        });
      });
    }

    return result;
  },

  sectionFastvaluedealCardStep(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const headerEl = doc.querySelector('[data-attribute="fvd-card-step__header"]');
    const dividerEl = headerEl?.querySelector('[data-attribute="divider-primary"]');
    const dividerData = dividerEl
      ? extractDividerPrimary(dividerEl.outerHTML)
      : { show: true, maxWidth: 90, height: 6, backgroundColor: '#5B04DE', align: 'center' };

    const result = {
      ...containerResult,
      header: {
        title: '',
        description: '',
      },
      divider: { ...dividerData },
      grid: {
        columns: 3,
        gap: 20,
        stepNumber: {
          backgroundColor: '#ffffff',
          textColor: '#0130E2',
        },
      },
      steps: [],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const titleEl = doc.querySelector('[data-attribute="fvd-card-step__title"]');
    if (titleEl) {
      result.header.title = titleEl.innerHTML.trim();
    }

    const descriptionEl = doc.querySelector('[data-attribute="fvd-card-step__description"]');
    if (descriptionEl) {
      result.header.description = descriptionEl.innerHTML.trim();
    }

    const gridEl = doc.querySelector('[data-attribute="fvd-card-step__grid"]');
    if (gridEl) {
      result.grid.columns = parseInt(gridEl.getAttribute('data-columns'), 10) || 3;
      result.grid.gap = parseInt(gridEl.getAttribute('data-gap'), 10) || 20;
      result.grid.stepNumber.backgroundColor = gridEl.getAttribute('data-step-number-bg') || '#ffffff';
      result.grid.stepNumber.textColor = gridEl.getAttribute('data-step-number-color') || '#0130E2';
    }

    doc.querySelectorAll('[data-attribute="fvd-card-step__item"]').forEach(itemEl => {
      const stepNumberEl = itemEl.querySelector('[data-attribute="fvd-card-step__step-number"]');
      const stepImageEl = itemEl.querySelector('[data-attribute="fvd-card-step__step-image"]');
      const contentIconEl = itemEl.querySelector('[data-attribute="fvd-card-step__content-icon"]');
      const contentTitleEl = itemEl.querySelector('[data-attribute="fvd-card-step__content-title"]');
      const contentDescriptionEl = itemEl.querySelector('[data-attribute="fvd-card-step__content-description"]');

      if (!gridEl?.getAttribute('data-step-number-bg') && stepNumberEl && result.steps.length === 0) {
        result.grid.stepNumber.backgroundColor =
          stepNumberEl.getAttribute('data-background-color') || result.grid.stepNumber.backgroundColor;
        result.grid.stepNumber.textColor =
          stepNumberEl.getAttribute('data-text-color') || result.grid.stepNumber.textColor;
      }

      result.steps.push({
        stepNumber: {
          text: stepNumberEl ? stepNumberEl.textContent.trim() : '',
        },
        stepImage: {
          src: stepImageEl ? stepImageEl.getAttribute('src') || '' : '',
        },
        content: {
          iconSrc: contentIconEl ? contentIconEl.getAttribute('src') || '' : '',
          title: contentTitleEl ? contentTitleEl.innerHTML.trim() : '',
          description: contentDescriptionEl ? contentDescriptionEl.innerHTML.trim() : '',
        },
      });
    });

    return result;
  },

  sectionFastvaluedealCompareBenefits(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const topHeaderEl = doc.querySelector('[data-attribute="fvd-compare-benefits__top-header"]');
    const dividerLeftEl = topHeaderEl?.querySelector(
      '[data-attribute="fvd-compare-benefits__top-divider-left"] [data-attribute="divider-primary"]',
    );
    const dividerRightEl = topHeaderEl?.querySelector(
      '[data-attribute="fvd-compare-benefits__top-divider-right"] [data-attribute="divider-primary"]',
    );
    const dividerLeftData = dividerLeftEl
      ? extractDividerPrimary(dividerLeftEl.outerHTML)
      : { show: true, maxWidth: 100, height: 2, backgroundColor: '#FFFFFF', align: 'right' };
    const dividerRightData = dividerRightEl
      ? extractDividerPrimary(dividerRightEl.outerHTML)
      : { show: true, maxWidth: 100, height: 2, backgroundColor: '#FFFFFF', align: 'left' };

    const result = {
      ...containerResult,
      top: {
        backgroundColor: '#0130E2',
        textColor: '#FFFFFF',
        title: '',
      },
      dividerLeft: { ...dividerLeftData },
      dividerRight: { ...dividerRightData },
      features: {
        columns: 6,
        items: [],
      },
      compare: {
        without: { content: '' },
        with: { content: '', highlightBorderColor: '#0130E2' },
      },
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const topEl = doc.querySelector('[data-attribute="fvd-compare-benefits__top"]');
    if (topEl) {
      result.top.backgroundColor = topEl.getAttribute('data-background-color') || '#0130E2';
      result.top.textColor = topEl.getAttribute('data-text-color') || '#FFFFFF';
    }

    const topTitleEl = doc.querySelector('[data-attribute="fvd-compare-benefits__top-title"]');
    if (topTitleEl) {
      result.top.title = topTitleEl.innerHTML.trim();
    }

    const featuresEl = doc.querySelector('[data-attribute="fvd-compare-benefits__features"]');
    if (featuresEl) {
      result.features.columns = parseInt(featuresEl.getAttribute('data-columns'), 10) || 6;

      featuresEl.querySelectorAll('[data-attribute="fvd-compare-benefits__feature-item"]').forEach(itemEl => {
        const textEl = itemEl.querySelector('[data-attribute="fvd-compare-benefits__feature-text"]');
        const imageEl = itemEl.querySelector('[data-attribute="fvd-compare-benefits__feature-image"]');
        result.features.items.push({
          text: textEl ? textEl.innerHTML.trim() : '',
          image: {
            src: imageEl ? imageEl.getAttribute('src') || '' : '',
          },
        });
      });
    }

    const withoutContentEl = doc.querySelector('[data-attribute="fvd-compare-benefits__box-without-content"]');
    if (withoutContentEl) {
      result.compare.without.content = withoutContentEl.innerHTML.trim();
    }

    const withBoxEl = doc.querySelector('[data-attribute="fvd-compare-benefits__box-with"]');
    const withContentEl = doc.querySelector('[data-attribute="fvd-compare-benefits__box-with-content"]');
    if (withBoxEl) {
      result.compare.with.highlightBorderColor = withBoxEl.getAttribute('data-highlight-border') || '#0130E2';
    }
    if (withContentEl) {
      result.compare.with.content = withContentEl.innerHTML.trim();
    }

    return result;
  },

  sectionFastvaluedealTable(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const dividerEl = doc.querySelector('[data-attribute="fvd-table__divider"] [data-attribute="divider-primary"]');
    const dividerData = dividerEl
      ? extractDividerPrimary(dividerEl.outerHTML)
      : { show: true, maxWidth: 80, height: 4, backgroundColor: '#5b04de', align: 'center' };

    const result = {
      ...containerResult,
      header: {
        title: '',
      },
      divider: { ...dividerData },
      table: {
        borderColor: '#ebeced',
        borderWeight: '1px',
        colBorder: true,
        rowBorder: true,
        borderFull: false,
        html: '<table></table>',
      },
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const titleEl = doc.querySelector('[data-attribute="fvd-table__title"]');
    if (titleEl) {
      result.header.title = titleEl.innerHTML.trim();
    }

    const tableContentEl = doc.querySelector('[data-attribute="table-content"]');
    if (tableContentEl) {
      result.table.borderColor = tableContentEl.getAttribute('data-border-color') || result.table.borderColor;
      result.table.borderWeight = tableContentEl.getAttribute('data-border-weight') || result.table.borderWeight;
      const colBorder = tableContentEl.getAttribute('data-col-border');
      const rowBorder = tableContentEl.getAttribute('data-row-border');
      const borderFull = tableContentEl.getAttribute('data-border-full');
      result.table.colBorder = colBorder ? colBorder === 'true' : result.table.colBorder;
      result.table.rowBorder = rowBorder ? rowBorder === 'true' : result.table.rowBorder;
      result.table.borderFull = borderFull ? borderFull === 'true' : result.table.borderFull;
      const tableEl = tableContentEl.querySelector('table');
      result.table.html = tableEl ? tableEl.outerHTML : tableContentEl.innerHTML.trim();
    }

    return result;
  },

  sectionGatorzYoutube(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const result = {
      ...containerResult,
      videoUrl: '',
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const iframeEl = doc.querySelector('[data-attribute="gatorz-youtube__iframe"]');
    if (iframeEl) {
      result.videoUrl = iframeEl.getAttribute('data-youtube-url') || iframeEl.getAttribute('src') || '';
    }

    return result;
  },

  sectionGatorzCompareImage(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const result = {
      ...containerResult,
      header: {
        html: '',
      },
      image: {
        left: '',
        right: '',
        initialPercent: 50,
      },
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const headerEl = doc.querySelector('[data-attribute="gatorz-compare-image__header"]');
    if (headerEl) {
      result.header.html = headerEl.innerHTML.trim();
    }

    const imageLeftEl = doc.querySelector('[data-attribute="gatorz-compare-image__image-left"]');
    if (imageLeftEl) {
      result.image.left = imageLeftEl.getAttribute('src') || '';
    }

    const imageRightEl = doc.querySelector('[data-attribute="gatorz-compare-image__image-right"]');
    if (imageRightEl) {
      result.image.right = imageRightEl.getAttribute('src') || '';
    }

    const sliderEl = doc.querySelector('[data-attribute="gatorz-compare-image__slider"]');
    if (sliderEl) {
      const initialPercent = Number(sliderEl.getAttribute('data-initial-percent'));
      if (Number.isFinite(initialPercent) && initialPercent > 0) {
        result.image.initialPercent = initialPercent;
      }
    }

    return result;
  },

  sectionGatorzSupport(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const dividerEl = doc.querySelector('[data-attribute="divider-primary"]');
    const dividerData = dividerEl
      ? extractDividerPrimary(dividerEl.outerHTML)
      : { show: true, maxWidth: 9999, height: 1, backgroundColor: '#C3C3C3', align: 'center' };

    const wrapEl = doc.querySelector('[data-attribute="gatorz-support-content"]');
    const accordionEl = wrapEl?.querySelector('[data-attribute="accordion-primary-title"]');
    const accordionData = accordionEl
      ? extractAccordionPrimary(accordionEl.outerHTML)
      : {
          open: false,
          title: '',
          backgroundColor: '#ffffff',
          color: '#000000',
          icon: {
            type: 'plus-minus',
            position: 'right',
            show: true,
          },
        };

    const result = {
      ...containerResult,
      accordion: { ...accordionData },
      divider: { ...dividerData },
      links: [],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const linkEls = doc.querySelectorAll('[data-attribute="gatorz-support__link-item"]');
    result.links = Array.from(linkEls).map(el => {
      const href = el.getAttribute('href') || '';
      const dataUrl = el.getAttribute('data-url') || '';
      const url = dataUrl || (href && href !== 'javascript:void(0)' ? href : '');

      return {
        label: el.textContent.trim(),
        url,
        openInNewTab: el.getAttribute('data-open-new-tab') === 'true',
      };
    });

    return result;
  },

  sectionGatorzFrameSpecs(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const dividerEl = doc.querySelector('[data-attribute="divider-primary"]');
    const dividerData = dividerEl
      ? extractDividerPrimary(dividerEl.outerHTML)
      : { show: true, maxWidth: 9999, height: 3, backgroundColor: '#C3C3C3', align: 'center' };

    const wrapEl = doc.querySelector('[data-attribute="gatorz-frame-specs-content"]');
    const accordionEl = wrapEl?.querySelector('[data-attribute="accordion-primary-title"]');
    const accordionData = accordionEl
      ? extractAccordionPrimary(accordionEl.outerHTML)
      : {
          open: false,
          title: '<h2><strong>FRAME SPECS</strong></h2>',
          backgroundColor: '#ffffff',
          color: '#000000',
          icon: {
            type: 'plus-minus',
            position: 'right',
            show: true,
          },
        };

    const result = {
      ...containerResult,
      accordion: { ...accordionData },
      divider: { ...dividerData },
      layout: {
        useCustomWidthImg: true,
        widthImg: 50,
        gap: 32,
        centerY: true,
      },
      leftCard: {
        order: 2,
      },
      rightCard: {
        order: 1,
      },
      content: '',
      image: {
        src: '',
        alt: '',
      },
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const wrapCardEl = doc.querySelector('[data-attribute="wrap-card"]');
    if (wrapCardEl) {
      result.layout.useCustomWidthImg = wrapCardEl.getAttribute('data-use-custom-width-img') !== 'false';
      result.layout.widthImg = Number(wrapCardEl.getAttribute('data-width-img')) || result.layout.widthImg;
      result.layout.gap = Number(wrapCardEl.getAttribute('data-gap')) || result.layout.gap;
      result.layout.centerY = wrapCardEl.getAttribute('data-center-y') !== 'false';
    }

    const leftCardEl = doc.querySelector('[data-attribute="left-card"]');
    if (leftCardEl) {
      result.leftCard.order = Number(leftCardEl.getAttribute('data-order')) || result.leftCard.order;
    }

    const rightCardEl = doc.querySelector('[data-attribute="right-card"]');
    if (rightCardEl) {
      result.rightCard.order = Number(rightCardEl.getAttribute('data-order')) || result.rightCard.order;
    }

    const contentEl = doc.querySelector('[data-attribute="wrap-content"]');
    if (contentEl) {
      result.content = contentEl.innerHTML.trim();
    }

    const imageEl = doc.querySelector('[data-attribute="card-image"]');
    if (imageEl) {
      result.image.src = imageEl.getAttribute('src') || '';
      result.image.alt = imageEl.getAttribute('alt') || '';
    }

    return result;
  },

  sectionGatorzPolicy(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const result = {
      ...containerResult,
      items: [],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const itemEls = doc.querySelectorAll('[data-attribute="gatorz-policy__item"]');
    result.items = Array.from(itemEls).map(itemEl => {
      const contentEl = itemEl.querySelector('[data-attribute="gatorz-policy__item-content"]');
      return {
        content: contentEl?.innerHTML.trim() || '',
      };
    });

    return result;
  },

  sectionSaintbrandShipping(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const result = {
      ...containerResult,
      bar: {
        background: '#f6f6f6',
        borderRadius: 20,
      },
      shipping: {
        dotColor: '#22c55e',
        prefixText: 'Ships by ',
        deliveryDays: 14,
      },
      location: {
        flagUrl: 'https://flagcdn.com/w40/us.png',
        prefixText: 'Fast ',
        countryCode: 'US',
        suffixText: ' Shipping',
      },
    };

    const barEl = doc.querySelector('[data-attribute="saintbrand-shipping-bar"]');
    if (barEl) {
      result.bar.background = barEl.getAttribute('data-background') || result.bar.background;
      const borderRadius = parseInt(barEl.getAttribute('data-border-radius'), 10);
      if (!Number.isNaN(borderRadius)) {
        result.bar.borderRadius = borderRadius;
      }
    }

    const dotEl = doc.querySelector('[data-attribute="saintbrand-shipping-dot"]');
    if (dotEl) {
      result.shipping.dotColor = dotEl.getAttribute('data-dot-color') || result.shipping.dotColor;
    }

    const shipPrefixEl = doc.querySelector('[data-attribute="saintbrand-shipping-ship-prefix"]');
    if (shipPrefixEl) {
      result.shipping.prefixText = shipPrefixEl.textContent || result.shipping.prefixText;
    }

    const deliveryDaysEl = doc.querySelector('[data-attribute="saintbrand-shipping-delivery-days"]');
    if (deliveryDaysEl) {
      const deliveryDays = parseInt(deliveryDaysEl.getAttribute('data-delivery-days'), 10);
      if (!Number.isNaN(deliveryDays)) {
        result.shipping.deliveryDays = deliveryDays;
      }
    }

    const locationPrefixEl = doc.querySelector('[data-attribute="saintbrand-shipping-location-prefix"]');
    if (locationPrefixEl) {
      result.location.prefixText = locationPrefixEl.textContent || result.location.prefixText;
    }

    const locationSuffixEl = doc.querySelector('[data-attribute="saintbrand-shipping-location-suffix"]');
    if (locationSuffixEl) {
      result.location.suffixText = locationSuffixEl.textContent || result.location.suffixText;
    }

    const flagEl = doc.querySelector('[data-attribute="saintbrand-shipping-flag"]');
    if (flagEl) {
      result.location.flagUrl = flagEl.getAttribute('src') || result.location.flagUrl;
    }

    const countryCodeEl = doc.querySelector('[data-attribute="saintbrand-shipping-country-code"]');
    if (countryCodeEl) {
      result.location.countryCode = countryCodeEl.textContent.trim() || result.location.countryCode;
    }

    return result;
  },

  sectionSaintbrandInfiniteMarquee(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const result = {
      ...containerResult,
      content: '',
      items: [],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const titleEl = doc.querySelector('[data-attribute="saintbrand-infinite-marquee-title"]');
    if (titleEl) {
      result.content = titleEl.innerHTML.trim();
    }

    const marqueeContainerEl = doc.querySelector('[data-attribute="saintbrand-infinite-marquee-container"]');
    if (marqueeContainerEl) {
      const pauseOnHover = marqueeContainerEl.getAttribute('data-pause-on-hover');
      result.pauseOnHover = pauseOnHover !== 'false';
    } else {
      result.pauseOnHover = true;
    }

    let slideEls = doc.querySelectorAll('[data-attribute="saintbrand-infinite-marquee-slide"][data-original="true"]');
    if (slideEls.length === 0) {
      slideEls = doc.querySelectorAll('[data-attribute="saintbrand-infinite-marquee-slide"].marquee-item-original');
    }
    if (slideEls.length === 0) {
      const allSlides = doc.querySelectorAll('[data-attribute="saintbrand-infinite-marquee-slide"]');
      const maxSlides = Math.min(20, allSlides.length);
      slideEls = Array.from(allSlides).slice(0, maxSlides);
    }

    result.items = Array.from(slideEls).map(slideEl => {
      const imageEl =
        slideEl.querySelector('[data-attribute="saintbrand-infinite-marquee-review-image"]') ||
        slideEl.querySelector('[data-attribute="saintbrand-infinite-marquee-image-src"]');
      const reviewEl = slideEl.querySelector('[data-attribute="saintbrand-infinite-marquee-review-card"]');

      const extractReviewData = el => {
        const base = {
          image: imageEl?.getAttribute('src') || '',
          avatar: '',
          name: '',
          headline: '',
          content: '',
        };
        if (!el) return base;

        const avatarEl = el.querySelector('[data-attribute="saintbrand-infinite-marquee-review-avatar"]');
        const nameEl = el.querySelector('[data-attribute="saintbrand-infinite-marquee-review-name"]');
        const headlineEl = el.querySelector('[data-attribute="saintbrand-infinite-marquee-review-headline"]');
        const contentEl = el.querySelector('[data-attribute="saintbrand-infinite-marquee-review-content"]');

        return {
          ...base,
          avatar: avatarEl?.getAttribute('src') || '',
          name: nameEl?.textContent.trim() || '',
          headline: headlineEl?.innerHTML.trim() || '',
          content: contentEl?.textContent.trim() || '',
        };
      };

      return {
        review: extractReviewData(reviewEl),
      };
    });

    return result;
  },

  sectionSaintbrandFeaturesGrid(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const result = {
      ...containerResult,
      layout: {
        columns: 2,
        gap: 16,
      },
      items: [],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const gridEl = doc.querySelector('[data-attribute="saintbrand-features-grid"]');
    if (gridEl) {
      result.layout.columns = parseInt(gridEl.getAttribute('data-columns'), 10) || 2;
      result.layout.gap = parseInt(gridEl.getAttribute('data-gap'), 10) || 16;
    }

    const itemEls = doc.querySelectorAll('[data-attribute="saintbrand-features-grid"] [data-attribute="item"]');
    result.items = Array.from(itemEls).map(itemEl => {
      const textEl = itemEl.querySelector('[data-attribute="text-item"]');
      return {
        text: textEl?.innerHTML.trim() || '',
      };
    });

    return result;
  },

  sectionMarkqueueOrthopedic(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const result = {
      ...containerResult,
      backgroundMarkqueue: '#006196',
      textColorMarkqueue: '#ffffff',
      markqueueItems: [],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const markqueueContainerEl = doc.querySelector('[data-attribute="container-markqueue"]');
    if (markqueueContainerEl) {
      result.backgroundMarkqueue =
        markqueueContainerEl.getAttribute('data-background-markqueue') || result.backgroundMarkqueue;
      result.textColorMarkqueue =
        markqueueContainerEl.getAttribute('data-text-color-markqueue') || result.textColorMarkqueue;
    }

    const markqueueItems = doc.querySelectorAll('[data-attribute="item-markqueue"]');
    markqueueItems.forEach(item => {
      result.markqueueItems.push({
        icon: item.querySelector('[data-attribute="icon-item-markqueue"]')?.getAttribute('src') || '',
        text: item.querySelector('[data-attribute="text-item-markqueue"]')?.innerHTML.trim() || '',
      });
    });

    if (!result.markqueueItems.length) {
      result.markqueueItems.push({
        icon: '',
        text: '',
      });
    }

    return result;
  },

  sectionOrthopedicFeaturesGrid(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const result = {
      ...containerResult,
      header: '',
      backgroundContent: '#006196',
      textColorContent: '#ffffff',
      layout: {
        itemsPerRow: {
          mobile: 1,
          desktop: 4,
        },
        gap: 24,
      },
      items: [],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const headerEl = doc.querySelector('[data-attribute="orthopedic-features-grid__header"]');
    if (headerEl) {
      result.header = headerEl.innerHTML.trim();
    }

    const bodyEl = doc.querySelector('[data-attribute="orthopedic-features-grid__body"]');
    if (bodyEl) {
      result.backgroundContent = bodyEl.getAttribute('data-background') || result.backgroundContent;
      result.textColorContent = bodyEl.getAttribute('data-text-color') || result.textColorContent;
      result.layout.itemsPerRow.mobile = bodyEl.getAttribute('data-items-per-row-mobile')
        ? Number(bodyEl.getAttribute('data-items-per-row-mobile'))
        : 1;
      result.layout.itemsPerRow.desktop = bodyEl.getAttribute('data-items-per-row-desktop')
        ? Number(bodyEl.getAttribute('data-items-per-row-desktop'))
        : 4;
      result.layout.gap = bodyEl.getAttribute('data-items-gap') ? Number(bodyEl.getAttribute('data-items-gap')) : 24;
    }

    const itemEls = doc.querySelectorAll('[data-attribute="orthopedic-features-grid__item"]');
    result.items = Array.from(itemEls).map(itemEl => ({
      image: itemEl.querySelector('[data-attribute="orthopedic-features-grid__item-image"]')?.getAttribute('src') || '',
      content:
        itemEl.querySelector('[data-attribute="orthopedic-features-grid__item-content"]')?.innerHTML.trim() || '',
    }));

    if (!result.items.length) {
      result.items.push({ image: '', content: '' });
    }

    return result;
  },

  sectionOrthopedicCardFeatures(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const result = {
      ...containerResult,
      image: {
        src: '',
        position: 'left',
      },
      layout: {
        gap: 8,
      },
      backgroundContent: '#006196',
      textColorContent: '#ffffff',
      header: '',
      items: [],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const contentEl = doc.querySelector('[data-attribute="orthopedic-card-features-content"]');
    if (contentEl) {
      result.image.position = contentEl.getAttribute('data-image-position') || 'left';
      result.backgroundContent = contentEl.getAttribute('data-background') || result.backgroundContent;
      result.textColorContent = contentEl.getAttribute('data-text-color') || result.textColorContent;
      result.layout.gap = contentEl.getAttribute('data-gap') ? Number(contentEl.getAttribute('data-gap')) : 8;
    }

    const imageEl = doc.querySelector('[data-attribute="orthopedic-card-features__image-img"]');
    if (imageEl) {
      result.image.src = imageEl.getAttribute('src') || '';
    }

    const headerEl = doc.querySelector('[data-attribute="orthopedic-card-features__header"]');
    if (headerEl) {
      result.header = headerEl.innerHTML.trim();
    }

    const itemEls = doc.querySelectorAll('[data-attribute="orthopedic-card-features__item"]');
    result.items = Array.from(itemEls).map(itemEl => ({
      image: itemEl.querySelector('[data-attribute="orthopedic-card-features__item-image"]')?.getAttribute('src') || '',
      content:
        itemEl.querySelector('[data-attribute="orthopedic-card-features__item-content"]')?.innerHTML.trim() || '',
    }));

    if (!result.items.length) {
      result.items.push({ image: '', content: '' });
    }

    return result;
  },

  sectionOrthopedicCardReview(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const wrapButtonEl = doc.querySelector('[data-attribute="wrap-button"]');
    const buttonData = wrapButtonEl ? extractButtonBasic(wrapButtonEl.outerHTML) : {};

    const result = {
      ...containerResult,
      button: { ...buttonData },
      image: {
        src: '',
        position: 'right',
      },
      layout: {
        gap: 60,
      },
      rating: {
        show: true,
        text: '14,000+ Happy Customers',
      },
      titleContent: '',
      guarantee: {
        show: true,
        text: 'Try Risk Free | 30-Day Wear Test Guarantee',
        backgroundColor: '#F2F7F9',
        textColor: '#006196',
      },
      body: '',
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const contentEl = doc.querySelector('[data-attribute="orthopedic-card-review-content"]');
    if (contentEl) {
      result.image.position = contentEl.getAttribute('data-image-position') || 'right';
      result.layout.gap = contentEl.getAttribute('data-gap') ? Number(contentEl.getAttribute('data-gap')) : 60;
    }

    const imageEl = doc.querySelector('[data-attribute="orthopedic-card-review__image-img"]');
    if (imageEl) {
      result.image.src = imageEl.getAttribute('src') || '';
    }

    const ratingEl = doc.querySelector('[data-attribute="orthopedic-card-review__rating"]');
    if (ratingEl) {
      result.rating.show = ratingEl.getAttribute('data-show') !== 'false';
      const ratingTextEl = ratingEl.querySelector('[data-attribute="orthopedic-card-review__rating-text"]');
      if (ratingTextEl) {
        result.rating.text = ratingTextEl.textContent.trim();
      }
    }

    const titleEl = doc.querySelector('[data-attribute="orthopedic-card-review__title"]');
    if (titleEl) {
      result.titleContent = titleEl.innerHTML.trim();
    }

    const guaranteeEl = doc.querySelector('[data-attribute="orthopedic-card-review__guarantee"]');
    if (guaranteeEl) {
      result.guarantee.show = guaranteeEl.getAttribute('data-show') !== 'false';
      result.guarantee.backgroundColor = guaranteeEl.getAttribute('data-background') || '#F2F7F9';
      result.guarantee.textColor = guaranteeEl.getAttribute('data-text-color') || '#006196';
      const guaranteeTextEl = guaranteeEl.querySelector('[data-attribute="orthopedic-card-review__guarantee-text"]');
      if (guaranteeTextEl) {
        result.guarantee.text = guaranteeTextEl.textContent.trim();
      }
    }

    const bodyEl = doc.querySelector('[data-attribute="orthopedic-card-review__body"]');
    if (bodyEl) {
      result.body = bodyEl.innerHTML.trim();
    }

    return result;
  },

  sectionOrthopedicCardBasic(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const wrapButtonEl = doc.querySelector('[data-attribute="wrap-button"]');
    const buttonData = wrapButtonEl ? extractButtonBasic(wrapButtonEl.outerHTML) : {};

    const result = {
      ...containerResult,
      button: { ...buttonData },
      layout: {
        gap: 112,
      },
      images: {
        position: 'left',
        items: [{ src: '' }, { src: '' }, { src: '' }],
      },
      content: '',
      signature: {
        show: false,
        src: '',
      },
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const contentEl = doc.querySelector('[data-attribute="orthopedic-card-basic-content"]');
    if (contentEl) {
      result.images.position = contentEl.getAttribute('data-image-position') || 'left';
      result.layout.gap = contentEl.getAttribute('data-gap') ? Number(contentEl.getAttribute('data-gap')) : 80;
    }

    for (let i = 1; i <= 3; i++) {
      const imageEl = doc.querySelector(`[data-attribute="orthopedic-card-basic__image-img-${i}"]`);
      if (imageEl) {
        result.images.items[i - 1].src = imageEl.getAttribute('src') || '';
      }
    }

    const textEl = doc.querySelector('[data-attribute="orthopedic-card-basic__text"]');
    if (textEl) {
      result.content = textEl.innerHTML.trim();
    } else {
      const headerEl = doc.querySelector('[data-attribute="orthopedic-card-basic__header"]');
      const bodyEl = doc.querySelector('[data-attribute="orthopedic-card-basic__body"]');
      const parts = [];
      if (headerEl) parts.push(headerEl.innerHTML.trim());
      if (bodyEl) parts.push(bodyEl.innerHTML.trim());
      result.content = parts.join('');
    }

    const signatureEl = doc.querySelector('[data-attribute="orthopedic-card-basic__signature"]');
    if (signatureEl) {
      result.signature.show = signatureEl.getAttribute('data-show') !== 'false';
      const signatureImgEl = signatureEl.querySelector('[data-attribute="orthopedic-card-basic__signature-img"]');
      if (signatureImgEl) {
        result.signature.src = signatureImgEl.getAttribute('src') || '';
      }
    }

    return result;
  },

  sectionLosaprilyImagesGrid(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const result = {
      ...containerResult,
      images: {
        image1: '',
        image2: '',
        image3: '',
        image4: '',
        image5: '',
      },
      box: {
        icon: '',
        text: '',
        backgroundColor: '#ffffff',
        textColor: '#000000',
        iconSizeDesktop: 48,
        iconSizeMobile: 30,
        iconPosition: 'center',
      },
      containerFullWidth: false,
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const losaprilyImagesGridEl = doc.querySelector('[data-attribute="losaprily-images-grid-content"]');
    if (losaprilyImagesGridEl) {
      result.containerFullWidth = losaprilyImagesGridEl.getAttribute('data-container-full-width') !== 'false';
    }

    const imageKeys = ['image1', 'image2', 'image3', 'image4', 'image5'];
    imageKeys.forEach((key, index) => {
      const imageEl = doc.querySelector(`[data-attribute="losaprily-images-grid__image-${index + 1}"]`);
      if (imageEl) {
        result.images[key] = imageEl.getAttribute('src') || '';
      }
    });

    const boxEl = doc.querySelector('[data-attribute="losaprily-images-grid__box"]');
    if (boxEl) {
      result.box.backgroundColor = boxEl.getAttribute('data-background') || '#ffffff';
      result.box.textColor = boxEl.getAttribute('data-text-color') || '#000000';
    }

    const boxIconEl = doc.querySelector('[data-attribute="losaprily-images-grid__box-icon"]');
    if (boxIconEl) {
      result.box.icon = boxIconEl.getAttribute('src') || '';
      const iconSizeDesktop = boxIconEl.getAttribute('data-icon-size-desktop');
      if (iconSizeDesktop) {
        result.box.iconSizeDesktop = parseInt(iconSizeDesktop, 10) || 48;
      }
      const iconSizeMobile = boxIconEl.getAttribute('data-icon-size-mobile');
      if (iconSizeMobile) {
        result.box.iconSizeMobile = parseInt(iconSizeMobile, 10) || 30;
      }
      result.box.iconPosition = boxIconEl.getAttribute('data-icon-position') || 'center';
    }

    const boxTextEl = doc.querySelector('[data-attribute="losaprily-images-grid__box-text"]');
    if (boxTextEl) {
      result.box.text = boxTextEl.innerHTML.trim();
    }

    return result;
  },
  sectionCardMediaWithSliderLosaprily(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const result = {
      ...containerResult,
      gapCard: 30,
      useMedia: 'video',
      orderMedia: 1,
      orderContent: 2,
      videoCard: '',
      imageCard: '',
      titleDesContent: '',
      slides: [],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const wrapCardEl = doc.querySelector('[data-attribute="wrap-card"]');
    if (wrapCardEl) {
      result.gapCard = parseInt(
        wrapCardEl.getAttribute('data-grap-card') || wrapCardEl.style.getPropertyValue('--grap-card') || '30',
        10,
      );
    }

    const wrapMediaEl = doc.querySelector('[data-attribute="wrap-media"]');
    if (wrapMediaEl) {
      result.useMedia = wrapMediaEl.getAttribute('data-use-media') || 'video';
      result.orderMedia = parseInt(
        wrapMediaEl.getAttribute('data-order') || wrapMediaEl.style.getPropertyValue('--order-media') || '1',
        10,
      );
    }

    const videoEl = doc.querySelector('[data-attribute="video-card"]');
    if (videoEl) {
      result.videoCard = videoEl.getAttribute('src') || '';
    }

    const imageEl = doc.querySelector('[data-attribute="image-card"]');
    if (imageEl) {
      result.imageCard = imageEl.getAttribute('src') || '';
    }

    const wrapContentEl = doc.querySelector('[data-attribute="wrap-content"]');
    if (wrapContentEl) {
      result.orderContent = parseInt(
        wrapContentEl.getAttribute('data-order') || wrapContentEl.style.getPropertyValue('--order-content') || '2',
        10,
      );
    }

    const titleDesDesktopEl = doc.querySelector('[data-attribute="title-des-content-desktop"]');
    const titleDesEl = doc.querySelector('[data-attribute="title-des-content"]');
    if (titleDesDesktopEl) {
      result.titleDesContent = titleDesDesktopEl.innerHTML.trim();
    } else if (titleDesEl) {
      result.titleDesContent = titleDesEl.innerHTML.trim();
    }

    const itemElements = doc.querySelectorAll('.swiper-slide');
    itemElements.forEach(itemEl => {
      const slide = {
        image: '',
        content: '',
      };
      const imgEl = itemEl.querySelector('[data-attribute="img-item"]');
      if (imgEl) {
        slide.image = imgEl.getAttribute('src') || '';
      }
      const contentEl = itemEl.querySelector('[data-attribute="content-item"]');
      if (contentEl) {
        slide.content = contentEl.innerHTML.trim();
      }
      result.slides.push(slide);
    });

    return result;
  },

  sectionCardTabWithContentLosaprily(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const result = {
      ...containerResult,
      colorBorder: '#fe7b01',
      widthTabContentItem: 576,
      listTab: [],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const tabsHeadingEl = doc.querySelector('[data-attribute="tabs-heading"]');
    if (tabsHeadingEl) {
      result.colorBorder = tabsHeadingEl.getAttribute('data-color-border') || '#fe7b01';
    }

    const tabsContentEl = doc.querySelector('[data-attribute="tabs-content"]');
    if (tabsContentEl) {
      const widthVal = tabsContentEl.getAttribute('data-width-tab-content-item');
      result.widthTabContentItem = widthVal ? parseInt(widthVal, 10) : 576;
    }

    const headingItems = doc.querySelectorAll('[data-attribute="tab-heading-item"]');
    headingItems.forEach(headingEl => {
      const tabId = headingEl.getAttribute('data-tab') || 'tab-1';

      const tabData = {
        tabId,
        headerText: '',
        bgDesktopUrl: '',
        bgMobileUrl: '',
        useBgMobile: true,
        subTitleShow: true,
        subTitleText: '',
        titleContent: '',
        colorBenefit: '#0079eb',
        benefitsShow: true,
        benefits: [],
      };

      const headingTextEl = headingEl.querySelector('[data-attribute="tab-text-content"]');
      if (headingTextEl) {
        tabData.headerText = headingTextEl.textContent.trim();
      }

      const bgItemEl = doc.querySelector(`[data-attribute="tab-images-bg-item"][data-tab="${tabId}"]`);
      if (bgItemEl) {
        tabData.bgDesktopUrl = bgItemEl.getAttribute('data-bg-desktop-url') || '';
        tabData.bgMobileUrl = bgItemEl.getAttribute('data-bg-mobile-url') || '';
        tabData.useBgMobile = bgItemEl.getAttribute('data-use-bg-mobile') !== 'false';
      }

      const contentEl = doc.querySelector(`[data-attribute="tab-content-item"][data-tab="${tabId}"]`);
      if (contentEl) {
        const subTitleEl = contentEl.querySelector('[data-attribute="sub-title"]');
        if (subTitleEl) {
          tabData.subTitleShow = subTitleEl.getAttribute('data-show') !== 'false';
          tabData.subTitleText = subTitleEl.innerHTML.trim();
        }

        const titleTabItemEl = contentEl.querySelector('[data-attribute="title-tab-item"]');
        if (titleTabItemEl) {
          tabData.titleContent = titleTabItemEl.innerHTML.trim();
        }

        const keyBenefitsEl = contentEl.querySelector('[data-attribute="key-benefits"]');
        if (keyBenefitsEl) {
          tabData.benefitsShow = keyBenefitsEl.getAttribute('data-show') !== 'false';
          tabData.colorBenefit = keyBenefitsEl.getAttribute('data-color-benefit') || '#0079eb';

          const benefitItems = keyBenefitsEl.querySelectorAll('[data-attribute="benefit-item"]');
          benefitItems.forEach(benefitEl => {
            const iconEl = benefitEl.querySelector('[data-attribute="icon-benefit"]');
            const textEl = benefitEl.querySelector('.text-benefit');
            tabData.benefits.push({
              icon: iconEl ? iconEl.getAttribute('src') || '' : '',
              text: textEl ? textEl.textContent.trim() : '',
            });
          });
        }
      }

      result.listTab.push(tabData);
    });

    return result;
  },

  sectionLosaprilyCardBanner(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const dividerEl = doc.querySelector('[data-attribute="divider-primary"]');
    const dividerData = dividerEl
      ? extractDividerPrimary(dividerEl.outerHTML)
      : { show: true, maxWidth: 48, height: 4, backgroundColor: '#ffffff4d', align: 'left' };
    const wrapButtonEl = doc.querySelector('[data-attribute="wrap-button"]');
    const buttonData = wrapButtonEl ? extractButtonBasic(wrapButtonEl.outerHTML) : {};

    const result = {
      ...containerResult,
      banner: {
        useBannerMobile: true,
        desktop: '',
        mobile: '',
      },
      wrapContent: {
        widthContent: 625,
      },
      heading: {
        show: true,
        content: '',
      },
      divider: { ...dividerData },
      description: {
        show: true,
        content: '',
      },
      smallImage: {
        show: false,
        src: '',
        alt: '',
      },
      button: { ...buttonData },
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const wrapBannerEl = doc.querySelector('[data-attribute="wrap-banner"]');
    if (wrapBannerEl) {
      result.banner.useBannerMobile = wrapBannerEl.getAttribute('data-use-banner-mobile') !== 'false';
      result.banner.desktop =
        wrapBannerEl.querySelector('[data-attribute="banner-desktop-img"]')?.getAttribute('src') || '';
      result.banner.mobile =
        wrapBannerEl.querySelector('[data-attribute="banner-mobile-img"]')?.getAttribute('src') || '';
    }

    const wrapContentEl = doc.querySelector('[data-attribute="wrap-content"]');
    if (wrapContentEl) {
      result.wrapContent.widthContent =
        Number(wrapContentEl.getAttribute('data-width-content')) || result.wrapContent.widthContent;
    }

    const headingEl = doc.querySelector('[data-attribute="heading-content"]');
    if (headingEl) {
      result.heading.show = headingEl.getAttribute('data-show') !== 'false';
      result.heading.content = headingEl.innerHTML.trim();
    }

    const descriptionEl = doc.querySelector('[data-attribute="description-content"]');
    if (descriptionEl) {
      result.description.show = descriptionEl.getAttribute('data-show') !== 'false';
      result.description.content = descriptionEl.innerHTML.trim();
    }

    const smallImageEl = doc.querySelector('[data-attribute="wrap-image-small"]');
    if (smallImageEl) {
      const imageEl = smallImageEl.querySelector('[data-attribute="image-small"]');
      result.smallImage.show = smallImageEl.getAttribute('data-show') !== 'false';
      result.smallImage.src = imageEl?.getAttribute('src') || '';
      result.smallImage.alt = imageEl?.getAttribute('alt') || '';
    }

    return result;
  },
  sectionMarqueeShopzovya(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const result = {
      ...containerResult,
      rows: [],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const rowEls = doc.querySelectorAll('[data-attribute="row-marquee"]');
    result.rows = Array.from(rowEls).map(rowEl => {
      const gapItem = Number(rowEl.getAttribute('data-gap-item')) || 28;
      const speedAnimation = Number(rowEl.getAttribute('data-speed-animation')) || 20;
      const bgBadge = rowEl.getAttribute('data-bg-badge') || '#f7c4ce';
      const bgItem = rowEl.getAttribute('data-bg-item') || '#ffffff';
      const colorBadge = rowEl.getAttribute('data-color-badge') || '#ffffff';

      const listItemEl =
        rowEl.querySelector('.list-item:not([data-cloned-marquee="true"])') || rowEl.querySelector('.list-item');
      const items = [];
      if (listItemEl) {
        const itemEls = listItemEl.querySelectorAll('[data-attribute="marquee-item"]');
        itemEls.forEach(itemEl => {
          const avatarEl = itemEl.querySelector('[data-attribute="avatar"]');
          const ratingEl = itemEl.querySelector('[data-attribute="rating-point"]');
          const textRatingEl = itemEl.querySelector('[data-attribute="text-rating"]');
          items.push({
            avatar: avatarEl ? avatarEl.getAttribute('src') || '' : '',
            ratingPoint: ratingEl ? Number(ratingEl.getAttribute('data-value') || ratingEl.textContent.trim()) || 5 : 5,
            textRating: textRatingEl ? textRatingEl.textContent.trim() : '',
          });
        });
      }

      return {
        gapItem,
        speedAnimation,
        bgBadge,
        bgItem,
        colorBadge,
        items,
      };
    });

    return result;
  },
  sectionSowhatbuyCardBasic(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const result = {
      ...containerResult,
      layout: {
        gap: 40,
      },
      image: {
        src: '',
        position: 'left',
      },
      specification: '',
      box: {
        title: "WHAT'S IN THE BOX",
        titleBackgroundColor: '#d35400',
        titleTextColor: '#ffffff',
        items: [],
      },
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const contentEl = doc.querySelector('[data-attribute="sowhatbuy-card-basic-content"]');
    if (contentEl) {
      result.image.position = contentEl.getAttribute('data-image-position') || 'left';
      result.layout.gap = contentEl.getAttribute('data-gap') ? Number(contentEl.getAttribute('data-gap')) : 40;
    }

    const imageEl = doc.querySelector('[data-attribute="sowhatbuy-card-basic__image"]');
    if (imageEl) {
      result.image.src = imageEl.getAttribute('src') || '';
    }

    const specificationEl = doc.querySelector('[data-attribute="sowhatbuy-card-basic__specification"]');
    if (specificationEl) {
      result.specification = specificationEl.innerHTML.trim();
    }

    const boxTitleEl = doc.querySelector('[data-attribute="sowhatbuy-card-basic__box-title"]');
    if (boxTitleEl) {
      result.box.title = boxTitleEl.textContent.trim() || "WHAT'S IN THE BOX";
      result.box.titleBackgroundColor = boxTitleEl.getAttribute('data-background') || '#d35400';
      result.box.titleTextColor = boxTitleEl.getAttribute('data-text-color') || '#ffffff';
    }

    doc.querySelectorAll('[data-attribute="sowhatbuy-card-basic__box-item"]').forEach(itemEl => {
      result.box.items.push(itemEl.textContent.trim());
    });

    return result;
  },

  sectionSowhatbuyGuaranteeMarquee(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const result = {
      ...containerResult,
      header: {
        title: '',
        iconLeft: {
          show: true,
          src: '',
          sizeDesktop: 72,
          sizeMobile: 48,
        },
        iconRight: {
          show: true,
          src: '',
          sizeDesktop: 72,
          sizeMobile: 48,
        },
      },
      marquee: {
        items: [],
      },
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const titleEl = doc.querySelector('[data-attribute="sowhatbuy-guarantee-marquee__header-title"]');
    if (titleEl) {
      result.header.title = titleEl.innerHTML.trim();
    }

    const iconLeftEl = doc.querySelector('[data-attribute="sowhatbuy-guarantee-marquee__header-icon-left"]');
    if (iconLeftEl) {
      result.header.iconLeft.show = iconLeftEl.getAttribute('data-show') !== 'false';
      result.header.iconLeft.sizeDesktop = iconLeftEl.getAttribute('data-icon-size-desktop')
        ? Number(iconLeftEl.getAttribute('data-icon-size-desktop'))
        : 72;
      result.header.iconLeft.sizeMobile = iconLeftEl.getAttribute('data-icon-size-mobile')
        ? Number(iconLeftEl.getAttribute('data-icon-size-mobile'))
        : 48;
      const imgEl = iconLeftEl.querySelector('[data-attribute="sowhatbuy-guarantee-marquee__header-icon-left-img"]');
      if (imgEl) {
        result.header.iconLeft.src = imgEl.getAttribute('src') || '';
      }
    }

    const iconRightEl = doc.querySelector('[data-attribute="sowhatbuy-guarantee-marquee__header-icon-right"]');
    if (iconRightEl) {
      result.header.iconRight.show = iconRightEl.getAttribute('data-show') !== 'false';
      result.header.iconRight.sizeDesktop = iconRightEl.getAttribute('data-icon-size-desktop')
        ? Number(iconRightEl.getAttribute('data-icon-size-desktop'))
        : 72;
      result.header.iconRight.sizeMobile = iconRightEl.getAttribute('data-icon-size-mobile')
        ? Number(iconRightEl.getAttribute('data-icon-size-mobile'))
        : 48;
      const imgEl = iconRightEl.querySelector('[data-attribute="sowhatbuy-guarantee-marquee__header-icon-right-img"]');
      if (imgEl) {
        result.header.iconRight.src = imgEl.getAttribute('src') || '';
      }
    }

    doc.querySelectorAll('[data-attribute="sowhatbuy-guarantee-marquee__marquee-item"]').forEach(itemEl => {
      const iconEl = itemEl.querySelector('[data-attribute="sowhatbuy-guarantee-marquee__marquee-item-icon"]');
      const textEl = itemEl.querySelector('[data-attribute="sowhatbuy-guarantee-marquee__marquee-item-text"]');
      result.marquee.items.push({
        icon: iconEl?.getAttribute('src') || '',
        text: textEl?.textContent.trim() || '',
      });
    });

    if (!result.marquee.items.length) {
      result.marquee.items.push({ text: '', icon: '' });
    }

    return result;
  },

  sectionSowhatbuyFeatureSlider(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const sliderWrapEl = doc.querySelector('[data-attribute="sowhatbuy-features-slider__slider-wrap"]');
    const wrapButtonEl = sliderWrapEl?.querySelector('[data-attribute="wrap-button"]');
    const buttonData = wrapButtonEl ? extractButtonBasic(wrapButtonEl.outerHTML) : {};

    const result = {
      ...containerResult,
      header: {
        title: '',
      },
      items: [],
      button: { ...buttonData },
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const titleEl = doc.querySelector('[data-attribute="sowhatbuy-features-slider__title"]');
    if (titleEl) {
      result.header.title = titleEl.innerHTML.trim();
    }

    const tabEls = doc.querySelectorAll('[data-attribute="sowhatbuy-features-slider__tab"]');
    const slideEls = doc.querySelectorAll('[data-attribute="sowhatbuy-features-slider__slide"]');

    slideEls.forEach((slideEl, index) => {
      const tabEl = tabEls[index];
      const imageEl = slideEl.querySelector('[data-attribute="sowhatbuy-features-slider__card-image"]');
      const titleCardEl = slideEl.querySelector('[data-attribute="sowhatbuy-features-slider__card-title"]');
      const descriptionEl = slideEl.querySelector('[data-attribute="sowhatbuy-features-slider__card-description"]');

      result.items.push({
        tabLabel: tabEl?.textContent.trim() || '',
        image: imageEl?.getAttribute('src') || '',
        title: titleCardEl?.textContent.trim() || '',
        description: descriptionEl?.textContent.trim() || '',
      });
    });

    if (!result.items.length) {
      result.items.push({
        tabLabel: '',
        image: '',
        title: '',
        description: '',
      });
    }

    return result;
  },

  sectionSowhatbuyReward(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const result = {
      ...containerResult,
      background: {
        desktop: '',
        mobile: '',
      },
      header: {
        title: '',
        iconLeft: {
          show: true,
          src: '',
        },
        iconRight: {
          show: true,
          src: '',
        },
      },
      description: '',
      signature: {
        show: true,
        src: '',
      },
      items: [],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const contentEl = doc.querySelector('[data-attribute="sowhatbuy-reward-content"]');
    if (contentEl) {
      result.background.desktop = contentEl.getAttribute('data-background-image-desktop') || '';
      result.background.mobile = contentEl.getAttribute('data-background-image-mobile') || '';
    }

    const titleEl = doc.querySelector('[data-attribute="sowhatbuy-reward__header-title"]');
    if (titleEl) {
      result.header.title = titleEl.innerHTML.trim();
    }

    const iconLeftEl = doc.querySelector('[data-attribute="sowhatbuy-reward__header-icon-left"]');
    if (iconLeftEl) {
      result.header.iconLeft.show = iconLeftEl.getAttribute('data-show') !== 'false';
      const imgEl = iconLeftEl.querySelector('[data-attribute="sowhatbuy-reward__header-icon-left-img"]');
      if (imgEl) {
        result.header.iconLeft.src = imgEl.getAttribute('src') || '';
      }
    }

    const iconRightEl = doc.querySelector('[data-attribute="sowhatbuy-reward__header-icon-right"]');
    if (iconRightEl) {
      result.header.iconRight.show = iconRightEl.getAttribute('data-show') !== 'false';
      const imgEl = iconRightEl.querySelector('[data-attribute="sowhatbuy-reward__header-icon-right-img"]');
      if (imgEl) {
        result.header.iconRight.src = imgEl.getAttribute('src') || '';
      }
    }

    const descEl = doc.querySelector('[data-attribute="sowhatbuy-reward__desc"]');
    if (descEl) {
      result.description = descEl.innerHTML.trim();
    }

    const signatureEl = doc.querySelector('[data-attribute="sowhatbuy-reward__signature"]');
    if (signatureEl) {
      result.signature.show = signatureEl.getAttribute('data-show') !== 'false';
      const imgEl = signatureEl.querySelector('[data-attribute="sowhatbuy-reward__signature-img"]');
      if (imgEl) {
        result.signature.src = imgEl.getAttribute('src') || '';
      }
    }

    doc.querySelectorAll('[data-attribute="sowhatbuy-reward__stat-item"]').forEach(itemEl => {
      const valueEl = itemEl.querySelector('[data-attribute="sowhatbuy-reward__stat-value"]');
      const iconEl = itemEl.querySelector('[data-attribute="sowhatbuy-reward__stat-icon"]');
      const labelEl = itemEl.querySelector('[data-attribute="sowhatbuy-reward__stat-label-text"]');
      result.items.push({
        value: valueEl?.textContent.trim() || '',
        icon: iconEl?.getAttribute('src') || '',
        label: labelEl?.textContent.trim() || '',
      });
    });

    if (!result.items.length) {
      result.items.push({ value: '', icon: '', label: '' });
    }

    return result;
  },

  sectionSowhatbuyCardImage(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const result = {
      ...containerResult,
      header: '',
      tags: {
        brightness: {
          show: true,
          text: '',
          bgImage: '',
        },
        led: {
          show: true,
          text: '',
          bgImage: '',
        },
      },
      boxes: [],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const headerEl = doc.querySelector('[data-attribute="sowhatbuy-card-image__header"]');
    if (headerEl) {
      result.header = headerEl.innerHTML.trim();
    }

    const tagBrightnessEl = doc.querySelector('[data-attribute="sowhatbuy-card-image__tag-brightness"]');
    if (tagBrightnessEl) {
      result.tags.brightness.show = tagBrightnessEl.getAttribute('data-show') !== 'false';
      result.tags.brightness.bgImage = tagBrightnessEl.getAttribute('data-bg-image') || '';
      const textEl = tagBrightnessEl.querySelector('[data-attribute="sowhatbuy-card-image__tag-brightness-text"]');
      if (textEl) {
        result.tags.brightness.text = textEl.textContent.trim();
      }
    }

    const tagLedEl = doc.querySelector('[data-attribute="sowhatbuy-card-image__tag-led"]');
    if (tagLedEl) {
      result.tags.led.show = tagLedEl.getAttribute('data-show') !== 'false';
      result.tags.led.bgImage = tagLedEl.getAttribute('data-bg-image') || '';
      const textEl = tagLedEl.querySelector('[data-attribute="sowhatbuy-card-image__tag-led-text"]');
      if (textEl) {
        result.tags.led.text = textEl.textContent.trim();
      }
    }

    doc.querySelectorAll('[data-attribute="sowhatbuy-card-image__box"]').forEach(boxEl => {
      const labelEl = boxEl.querySelector('[data-attribute="sowhatbuy-card-image__box-label"]');
      result.boxes.push({
        label: labelEl?.textContent.trim() || '',
      });
    });

    if (!result.boxes.length) {
      result.boxes.push({ label: '' });
    }

    return result;
  },
  sectionCardBannerSowhatbuy(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const result = {
      ...containerResult,
      bannerImage: {
        useBannerMobile: true,
        bannerDesktop: '',
        bannerMobile: '',
      },
      wrapContent: {
        widthContent: 1000,
      },
      titleBanner: {
        content: '',
      },
      keyBenefits: {
        show: true,
        items: [],
      },
      button: {
        show: true,
        showDiscount: true,
        href: '',
        valueDiscount: '',
        text: 'Buy Now',
        showIcon: true,
        icon: '',
        bgButton: '#c75023',
        colorButton: '#ffffff',
      },
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const wrapCardEl = doc.querySelector('[data-attribute="wrap-card"]');
    if (wrapCardEl) {
      result.bannerImage.useBannerMobile = wrapCardEl.getAttribute('data-use-banner-mobile') !== 'false';
      result.bannerImage.bannerDesktop = wrapCardEl.getAttribute('data-banner-desktop') || '';
    }

    const bannerMobileImgEl = doc.querySelector('[data-attribute="banner-mobile-image"]');
    if (bannerMobileImgEl) {
      result.bannerImage.bannerMobile = bannerMobileImgEl.getAttribute('src') || '';
    }

    const wrapContentEl = doc.querySelector('[data-attribute="wrap-content"]');
    if (wrapContentEl) {
      result.wrapContent.widthContent =
        Number(wrapContentEl.getAttribute('data-width-content')?.replace('px', '')) || result.wrapContent.widthContent;
    }

    const titleBannerEl = doc.querySelector('[data-attribute="title-banner"]');
    if (titleBannerEl) {
      result.titleBanner.content = titleBannerEl.innerHTML.trim();
    }

    const listKeybenefitsEl = doc.querySelector('[data-attribute="list-keybenefits"]');
    if (listKeybenefitsEl) {
      result.keyBenefits.show = listKeybenefitsEl.getAttribute('data-show') !== 'false';
      const items = listKeybenefitsEl.querySelectorAll('[data-attribute="item-benefit"]');
      result.keyBenefits.items = Array.from(items).map(itemEl => {
        const iconEl = itemEl.querySelector('[data-attribute="icon-benefit"]');
        const textEl = itemEl.querySelector('[data-attribute="text-benefit"]');
        return {
          icon: iconEl ? iconEl.getAttribute('src') || '' : '',
          text: textEl ? textEl.innerHTML.trim() : '',
        };
      });
    }

    const btnCtaBannerEl = doc.querySelector('[data-attribute="btn-cta-banner"]');
    if (btnCtaBannerEl) {
      result.button.show = btnCtaBannerEl.getAttribute('data-show') !== 'false';
      result.button.href = btnCtaBannerEl.getAttribute('href') || '';
      result.button.showDiscount = btnCtaBannerEl.getAttribute('data-show-discount') !== 'false';
      result.button.bgButton = btnCtaBannerEl.getAttribute('data-bg-button') || '#c75023';
      result.button.colorButton = btnCtaBannerEl.getAttribute('data-color-button') || '#ffffff';

      const valueDiscountEl = btnCtaBannerEl.querySelector('[data-attribute="value-discount"]');
      if (valueDiscountEl) {
        result.button.valueDiscount = valueDiscountEl.textContent.trim();
      }

      const textBtnEl = btnCtaBannerEl.querySelector('[data-attribute="text-button"]');
      if (textBtnEl) {
        result.button.text = textBtnEl.textContent.trim();
      }

      const iconBtnEl = btnCtaBannerEl.querySelector('[data-attribute="icon-btn"]');
      if (iconBtnEl) {
        result.button.showIcon = iconBtnEl.getAttribute('data-show') !== 'false';
        const imgEl = iconBtnEl.querySelector('img');
        result.button.icon = imgEl ? imgEl.getAttribute('src') || '' : '';
      }
    }

    return result;
  },

  sectionCardItemsSowhatbuy(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const result = {
      ...containerResult,
      cardTitle: {
        show: true,
        content: '',
      },
      items: [],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const cardTitleEl = doc.querySelector('[data-attribute="card-title"]');
    if (cardTitleEl) {
      result.cardTitle.show = cardTitleEl.getAttribute('data-show') !== 'false';
      result.cardTitle.content = cardTitleEl.innerHTML.trim();
    }

    const listItemEl = doc.querySelector('[data-attribute="list-item"]');
    if (listItemEl) {
      const items = listItemEl.querySelectorAll('[data-attribute="item"]');
      result.items = Array.from(items).map(itemEl => {
        const imageEl = itemEl.querySelector('[data-attribute="image-item"]');
        const infoEl = itemEl.querySelector('[data-attribute="info-item"]');
        return {
          image: imageEl ? imageEl.getAttribute('src') || '' : '',
          alt: imageEl ? imageEl.getAttribute('alt') || '' : '',
          info: infoEl ? infoEl.innerHTML.trim() : '',
        };
      });
    }

    return result;
  },

  sectionCardCompareSowhatbuy(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const result = {
      ...containerResult,
      cardTitle: {
        show: true,
        content: '',
      },
      wrapContent: {
        bgContent: '#1c150c',
        colorText: '#ffffff',
      },
      leftCard: {
        useVideo: true,
        order: 1,
        videoSrc: '',
        imageSrc: '',
        imageAlt: '',
        benefits: [],
      },
      rightCard: {
        order: 2,
        leftCompare: {
          image: '',
          alt: '',
          title: '',
          color: '#ffffff',
          bg: '#535353',
        },
        rightCompare: {
          image: '',
          alt: '',
          title: '',
          color: '#ffffff',
          bg: '#c75023',
        },
        textCompareList: [],
      },
      button: {
        show: true,
        href: '',
        showDiscount: true,
        valueDiscount: '50',
        text: 'Buy Now',
        showIcon: true,
        icon: '',
        bgButton: '#c75023',
        colorButton: '#ffffff',
      },
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const cardTitleEl = doc.querySelector('[data-attribute="card-title"]');
    if (cardTitleEl) {
      result.cardTitle.show = cardTitleEl.getAttribute('data-show') !== 'false';
      result.cardTitle.content = cardTitleEl.innerHTML.trim();
    }

    const wrapContentEl = doc.querySelector('[data-attribute="wrap-content"]');
    if (wrapContentEl) {
      result.wrapContent.bgContent = wrapContentEl.getAttribute('data-bg-content') || result.wrapContent.bgContent;
      result.wrapContent.colorText = wrapContentEl.getAttribute('data-color-text') || result.wrapContent.colorText;
    }

    const leftCardEl = doc.querySelector('[data-attribute="left-card"]');
    if (leftCardEl) {
      const useVideoAttr = leftCardEl.getAttribute('data-use-vide') || leftCardEl.getAttribute('data-use-video');
      result.leftCard.useVideo = useVideoAttr !== 'false';
      result.leftCard.order = Number(leftCardEl.getAttribute('data-order')) || 1;

      const videoEl = leftCardEl.querySelector('video');
      if (videoEl) {
        result.leftCard.videoSrc = videoEl.getAttribute('src') || '';
      }

      const imgEl = leftCardEl.querySelector('.wrap-img img');
      if (imgEl) {
        result.leftCard.imageSrc = imgEl.getAttribute('src') || '';
        result.leftCard.imageAlt = imgEl.getAttribute('alt') || '';
      }

      const benefitItems = leftCardEl.querySelectorAll('[data-attribute="item-benefit"]');
      result.leftCard.benefits = Array.from(benefitItems).map(itemEl => {
        return {
          content: itemEl.innerHTML.trim(),
        };
      });
    }

    const rightCardEl = doc.querySelector('[data-attribute="right-card"]');
    if (rightCardEl) {
      result.rightCard.order = Number(rightCardEl.getAttribute('data-order')) || 2;

      const leftCompareEl = rightCardEl.querySelector('[data-attribute="left-compare"]');
      if (leftCompareEl) {
        const imgEl = leftCompareEl.querySelector('img');
        result.rightCard.leftCompare.image = imgEl ? imgEl.getAttribute('src') || '' : '';
        result.rightCard.leftCompare.alt = imgEl ? imgEl.getAttribute('alt') || '' : '';

        const titleEl = leftCompareEl.querySelector('[data-attribute="title-compare-left"]');
        if (titleEl) {
          result.rightCard.leftCompare.title = titleEl.textContent.trim().replace(/:$/, '');
          result.rightCard.leftCompare.color =
            titleEl.getAttribute('data-color-title-compare-left') || result.rightCard.leftCompare.color;
          result.rightCard.leftCompare.bg =
            titleEl.getAttribute('data-bg-title-compare-left') || result.rightCard.leftCompare.bg;
        }
      }

      const rightCompareEl = rightCardEl.querySelector('[data-attribute="right-compare"]');
      if (rightCompareEl) {
        const imgEl = rightCompareEl.querySelector('img');
        result.rightCard.rightCompare.image = imgEl ? imgEl.getAttribute('src') || '' : '';
        result.rightCard.rightCompare.alt = imgEl ? imgEl.getAttribute('alt') || '' : '';

        const titleEl = rightCompareEl.querySelector('[data-attribute="title-compare-right"]');
        if (titleEl) {
          result.rightCard.rightCompare.title = titleEl.textContent.trim().replace(/:$/, '');
          result.rightCard.rightCompare.color =
            titleEl.getAttribute('data-color-title-compare-right') || result.rightCard.rightCompare.color;
          result.rightCard.rightCompare.bg =
            titleEl.getAttribute('data-bg-title-compare-right') || result.rightCard.rightCompare.bg;
        }
      }

      const textCompareItems = rightCardEl.querySelectorAll('[data-attribute="item-compare-by-text"]');
      result.rightCard.textCompareList = Array.from(textCompareItems).map(itemEl => {
        const iconPrefixEl = itemEl.querySelector('[data-attribute="icon-prefix"]');
        const textCompareEl = itemEl.querySelector('[data-attribute="text-compare"]');
        const iconSuffixEl = itemEl.querySelector('[data-attribute="icon-suffix"]');
        return {
          iconPrefix: iconPrefixEl ? iconPrefixEl.getAttribute('src') || '' : '',
          text: textCompareEl ? textCompareEl.textContent.trim() : '',
          iconSuffix: iconSuffixEl ? iconSuffixEl.getAttribute('src') || '' : '',
        };
      });
    }

    const btnCtaBannerEl = doc.querySelector('[data-attribute="btn-cta-banner"]');
    if (btnCtaBannerEl) {
      result.button.show = btnCtaBannerEl.getAttribute('data-show') !== 'false';
      result.button.href = btnCtaBannerEl.getAttribute('href') || '';
      result.button.showDiscount = btnCtaBannerEl.getAttribute('data-show-discount') !== 'false';
      result.button.bgButton = btnCtaBannerEl.getAttribute('data-bg-button') || '#c75023';
      result.button.colorButton = btnCtaBannerEl.getAttribute('data-color-button') || '#ffffff';

      const valueDiscountEl = btnCtaBannerEl.querySelector('[data-attribute="value-discount"]');
      if (valueDiscountEl) {
        result.button.valueDiscount = valueDiscountEl.textContent.trim();
      }

      const textBtnEl = btnCtaBannerEl.querySelector('[data-attribute="text-button"]');
      if (textBtnEl) {
        result.button.text = textBtnEl.textContent.trim();
      }

      const iconBtnEl = btnCtaBannerEl.querySelector('[data-attribute="icon-btn"]');
      if (iconBtnEl) {
        result.button.showIcon = iconBtnEl.getAttribute('data-show') !== 'false';
        const imgEl = iconBtnEl.querySelector('img');
        result.button.icon = imgEl ? imgEl.getAttribute('src') || '' : '';
      }
    }

    return result;
  },

  sectionTryherReviewGrid(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const result = {
      ...containerResult,
      header: '',
      breakpoints: {
        mobile: { slidesPerView: 1 },
        tablet: { slidesPerView: 3 },
        desktop: { slidesPerView: 5 },
      },
      starColor: '#FF6099',
      arrowColor: '#FF6099',
      cardBorderColor: '#1F1F1F',
      cardBgColor: '#FFFFFF',
      cardTextColor: '#000000',
      containerFullWidth: true,
      listItem: [],
    };

    const rootEl = doc.querySelector('[data-attribute="tryher-review-grid"]');
    const headerEl = doc.querySelector('[data-attribute="tryher-review-grid__header"]');
    if (rootEl) {
      result.starColor = rootEl.getAttribute('data-star-color') || '#FF6099';
      result.arrowColor = rootEl.getAttribute('data-arrow-color') || '#FF6099';
      result.cardBorderColor = rootEl.getAttribute('data-card-border-color') || '#1F1F1F';
      result.cardBgColor = rootEl.getAttribute('data-card-background-color') || '#FFFFFF';
      result.cardTextColor = rootEl.getAttribute('data-card-text-color') || '#000000';

      result.containerFullWidth = rootEl.getAttribute('data-container-full-width') === 'true' ? true : false;

      result.breakpoints.mobile.slidesPerView = Number(rootEl.getAttribute('data-breakpoint-mobile-slides')) || 1;
      result.breakpoints.tablet.slidesPerView = Number(rootEl.getAttribute('data-breakpoint-tablet-slides')) || 3;
      result.breakpoints.desktop.slidesPerView = Number(rootEl.getAttribute('data-breakpoint-desktop-slides')) || 5;
    }
    if (headerEl) result.header = headerEl.innerHTML.trim();

    doc.querySelectorAll('[data-attribute="tryher-review-grid__item"]').forEach(itemEl => {
      const imageEl = itemEl.querySelector('[data-attribute="tryher-review-grid__image"]');
      const starsEl = itemEl.querySelector('[data-attribute="tryher-review-grid__stars"]');
      const contentEl = itemEl.querySelector('[data-attribute="tryher-review-grid__content"]');
      result.listItem.push({
        image: imageEl ? imageEl.getAttribute('src') || '' : '',
        rating: starsEl ? Number(starsEl.getAttribute('data-value')) || 0 : 5,
        content: contentEl ? contentEl.innerHTML.trim() : '',
      });
    });

    return result;
  },

  sectionTryherTimeline(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const result = {
      ...containerResult,
      header: '',
      cardBgColor: '#FFF7FC',
      cardTextColor: '#1F1F1F',
      cardBorderColor: '#1F1F1F',
      lineColor: '#f96da3',
      lineBorderColor: '#1F1F1F',
      listItem: [],
    };
    const rootEl = doc.querySelector('[data-attribute="tryher-timeline"]');
    const headerEl = doc.querySelector('[data-attribute="tryher-timeline__header"]');
    if (rootEl) {
      result.cardBgColor = rootEl.getAttribute('data-card-background-color') || result.cardBgColor;
      result.cardTextColor = rootEl.getAttribute('data-card-text-color') || result.cardTextColor;
      result.cardBorderColor = rootEl.getAttribute('data-card-border-color') || result.cardBorderColor;
      result.lineColor = rootEl.getAttribute('data-line-color') || result.lineColor;
      result.lineBorderColor = rootEl.getAttribute('data-line-border-color') || result.lineBorderColor;
    }
    if (headerEl) result.header = headerEl.innerHTML.trim();
    doc.querySelectorAll('[data-attribute="tryher-timeline__item"]').forEach(itemEl => {
      const titleEl = itemEl.querySelector('[data-attribute="tryher-timeline__label"]');
      const cardEl = itemEl.querySelector('[data-attribute="tryher-timeline__card"]');
      result.listItem.push({
        title: titleEl ? titleEl.innerHTML.trim() : '',
        content: cardEl ? cardEl.innerHTML.trim() : '',
      });
    });
    return result;
  },
  sectionTryherCardCompare(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const result = {
      ...containerResult,
      header: '',
      goodImage: '',
      badImage: '',
      vsText: 'VS',
      badPosition: 'right',
      cardBorderColor: '#FF6099',
      cardTextColor: '#000000',
      cardBackgroundColor: '#FFFFFF',
      listItem: [],
      containerFullWidth: true,
    };
    const rootEl = doc.querySelector('[data-attribute="tryher-card-compare"]');
    const headerEl = doc.querySelector('[data-attribute="tryher-card-compare__header"]');
    if (rootEl) {
      result.badPosition = rootEl.getAttribute('data-bad-position') || result.badPosition;
      result.cardBorderColor = rootEl.getAttribute('data-card-border-color') || result.cardBorderColor;
      result.cardTextColor = rootEl.getAttribute('data-card-text-color') || result.cardTextColor;
      result.cardBackgroundColor = rootEl.getAttribute('data-card-background-color') || result.cardBackgroundColor;
    }
    if (headerEl) result.header = headerEl.innerHTML.trim();
    const goodImageEl = doc.querySelector('[data-attribute="tryher-card-compare__good-image"]');
    const badImageEl = doc.querySelector('[data-attribute="tryher-card-compare__bad-image"]');
    const vsEl = doc.querySelector('[data-attribute="tryher-card-compare__vs"]');
    if (goodImageEl) result.goodImage = goodImageEl.getAttribute('src') || '';
    if (badImageEl) result.badImage = badImageEl.getAttribute('src') || '';
    if (vsEl) result.vsText = vsEl.textContent.trim();
    doc.querySelectorAll('[data-attribute="tryher-card-compare__item"]').forEach(itemEl => {
      const goodEl = itemEl.querySelector('[data-attribute="tryher-card-compare__good"] div:last-child');
      const badEl = itemEl.querySelector('[data-attribute="tryher-card-compare__bad"] div:last-child');
      result.listItem.push({
        good: goodEl ? goodEl.textContent.trim() : '',
        bad: badEl ? badEl.textContent.trim() : '',
      });
    });
    return result;
  },
  sectionTryherCardBasic(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const result = {
      ...containerResult,
      header: { show: true, content: '' },
      content: { html: '', backgroundColor: '#FFFFFF', textColor: '#000000' },
      image: { src: '', position: 'right' },
      buttonPosition: 'center',
      button: {},
      borderColor: '#000000',
    };
    const rootEl = doc.querySelector('[data-attribute="tryher-card-basic"]');
    const headerEl = doc.querySelector('[data-attribute="tryher-card-basic__header"]');
    const contentBoxEl = doc.querySelector('[data-attribute="tryher-card-basic__content-box"]');
    const contentEl = doc.querySelector('[data-attribute="tryher-card-basic__content"]');
    const imageEl = doc.querySelector('[data-attribute="tryher-card-basic__image"]');
    const buttonWrapEl = doc.querySelector('[data-attribute="tryher-card-basic__button"]');
    const buttonEl = doc.querySelector('[data-attribute="wrap-button"]');

    if (rootEl) {
      result.image.position = rootEl.getAttribute('data-image-position') || result.image.position;
      result.containerFullWidth = rootEl.getAttribute('data-container-full-width') === 'true' ? true : false;
      result.borderColor = rootEl.getAttribute('data-border-color') || result.borderColor;
    }
    if (headerEl) {
      result.header.show = headerEl.getAttribute('data-show') !== 'false';
      result.header.content = headerEl.innerHTML.trim();
    }
    if (contentBoxEl) {
      result.content.backgroundColor =
        contentBoxEl.getAttribute('data-background-color') || result.content.backgroundColor;
      result.content.textColor = contentBoxEl.getAttribute('data-text-color') || result.content.textColor;
    }
    if (contentEl) result.content.html = contentEl.innerHTML.trim();
    if (imageEl) result.image.src = imageEl.getAttribute('src') || '';
    if (buttonWrapEl) result.buttonPosition = buttonWrapEl.getAttribute('data-position') || result.buttonPosition;
    if (buttonEl) result.button = extractButtonBasic(buttonEl.outerHTML);

    return result;
  },

  sectionTryherGridPercent(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const result = {
      ...containerResult,
      header: '',
      breakpoints: {
        mobile: { slidesPerView: 1.5 },
        tablet: { slidesPerView: 3 },
        desktop: { slidesPerView: 3 },
      },
      percentLineColor: '#FF6099',
      percentTextColor: '#FFFFFF',
      cardBgColor: '#FFFFFF',
      cardTextColor: '#000000',
      containerFullWidth: false,
      listItem: [],
    };

    const rootEl = doc.querySelector('[data-attribute="tryher-grid-percent"]');
    const headerEl = doc.querySelector('[data-attribute="tryher-grid-percent__header"]');
    if (rootEl) {
      result.percentLineColor = rootEl.getAttribute('data-percent-line-color') || result.percentLineColor;
      result.percentTextColor = rootEl.getAttribute('data-percent-text-color') || result.percentTextColor;
      result.cardBgColor = rootEl.getAttribute('data-card-background-color') || result.cardBgColor;
      result.cardTextColor = rootEl.getAttribute('data-card-text-color') || result.cardTextColor;
      result.containerFullWidth = rootEl.getAttribute('data-container-full-width') === 'true';
      result.breakpoints.mobile.slidesPerView =
        Number(rootEl.getAttribute('data-breakpoint-mobile-slides')) || result.breakpoints.mobile.slidesPerView;
      result.breakpoints.tablet.slidesPerView =
        Number(rootEl.getAttribute('data-breakpoint-tablet-slides')) || result.breakpoints.tablet.slidesPerView;
      result.breakpoints.desktop.slidesPerView =
        Number(rootEl.getAttribute('data-breakpoint-desktop-slides')) || result.breakpoints.desktop.slidesPerView;
    }
    if (headerEl) result.header = headerEl.innerHTML.trim();

    doc.querySelectorAll('[data-attribute="tryher-grid-percent__item"]').forEach(itemEl => {
      const imageEl = itemEl.querySelector('[data-attribute="tryher-grid-percent__image"]');
      const percentEl = itemEl.querySelector('[data-attribute="tryher-grid-percent__percent"]');
      const contentEl = itemEl.querySelector('[data-attribute="tryher-grid-percent__content"]');
      result.listItem.push({
        image: imageEl ? imageEl.getAttribute('src') || '' : '',
        percent: percentEl ? Number(percentEl.getAttribute('data-value')) || 0 : 0,
        content: contentEl ? contentEl.innerHTML.trim() : '',
      });
    });

    return result;
  },

  sectionImageWithTextCol1(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const wrapButtonEl = doc.querySelector('[data-attribute="wrap-button"]');
    const buttonData = wrapButtonEl ? extractButtonBasic(wrapButtonEl.outerHTML) : {};

    const result = {
      ...containerResult,
      cardTitle: {
        show: true,
        content: '',
      },
      cardImage: {
        src: '',
      },
      button: { ...buttonData },
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const cardTitleEl = doc.querySelector('[data-attribute="card-title"]');
    if (cardTitleEl) {
      result.cardTitle.show = cardTitleEl.getAttribute('data-show') !== 'false';
      result.cardTitle.content = cardTitleEl.innerHTML.trim();
    }

    const cardImageEl = doc.querySelector('[data-attribute="card-image"]');
    if (cardImageEl) {
      result.cardImage.src = cardImageEl.getAttribute('src') || '';
    }

    return result;
  },

  sectionSideBySideGridIcon(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const wrapButtonEl = doc.querySelector('[data-attribute="wrap-button"]');
    const buttonData = wrapButtonEl ? extractButtonBasic(wrapButtonEl.outerHTML) : {};

    const result = {
      ...containerResult,
      cardTitle: { show: true, content: '' },
      leftCard: { src: '' },
      rightCard: { title: '', description: '' },
      listIcons: [],
      button: { ...buttonData },
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      result.enableAnchor = sectionEl.getAttribute('data-enable-anchor') === 'true';
    }

    const cardTitleEl = doc.querySelector('[data-attribute="card-title"]');
    if (cardTitleEl) {
      result.cardTitle.show = cardTitleEl.getAttribute('data-show') !== 'false';
      result.cardTitle.content = cardTitleEl.innerHTML.trim();
    }

    const leftCardEl = doc.querySelector('[data-attribute="left-card"] img');
    if (leftCardEl) {
      result.leftCard.src = leftCardEl.getAttribute('src') || '';
    }

    const textRightEl = doc.querySelector('[data-attribute="text-right-card"]');
    if (textRightEl) {
      result.rightCard.title = textRightEl.innerHTML.trim() || '';
    }

    const itemIconEls = doc.querySelectorAll('[data-attribute="list-icon"] [data-attribute="item-icon"]');
    result.listIcons = Array.from(itemIconEls).map(itemEl => {
      const useIconSvg = itemEl.getAttribute('data-use-icon-svg') === 'true';
      return {
        useIconSvg: useIconSvg,
        icon: itemEl.querySelector('[data-attribute="icon"]')?.getAttribute('src') || '',
        iconSvg: itemEl.querySelector('[data-attribute="wrap-icon-svg"]')?.innerHTML.trim() || '',
        text: itemEl.querySelector('[data-attribute="text-item"]')?.textContent || '',
      };
    });

    return result;
  },

  sectionLeonieandcoReviewGrid(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const result = {
      ...containerResult,
      header: '',
      starColor: '#00B979',
      tabHeaderColor: '#772647',
      contentBackground: '#fcf8f5',
      listItem: [],
    };

    const rootEl = doc.querySelector('[data-attribute="leonieandco-review-grid"]');
    const headerEl = doc.querySelector('[data-attribute="leonieandco-review-grid__header"]');
    if (rootEl) {
      result.starColor = rootEl.getAttribute('data-star-color') || result.starColor;
      result.tabHeaderColor = rootEl.getAttribute('data-tab-header-color') || result.tabHeaderColor;
      result.contentBackground = rootEl.getAttribute('data-content-background') || result.contentBackground;
    }
    if (headerEl) result.header = headerEl.innerHTML.trim();

    const tabEls = doc.querySelectorAll('[data-attribute="leonieandco-review-grid__tab"]');
    doc.querySelectorAll('[data-attribute="leonieandco-review-grid__item"]').forEach((itemEl, index) => {
      const tabEl = tabEls[index];
      const imageEl = itemEl.querySelector('[data-attribute="leonieandco-review-grid__image"]');
      const starsEl = itemEl.querySelector('[data-attribute="leonieandco-review-grid__stars"]');
      const valueEl = itemEl.querySelector('[data-attribute="leonieandco-review-grid__value"]');
      result.listItem.push({
        header: tabEl ? tabEl.textContent.trim() : '',
        image: imageEl ? imageEl.getAttribute('src') || '' : '',
        rating: starsEl ? Math.max(1, Math.min(5, Number(starsEl.getAttribute('data-value')) || 5)) : 5,
        value: valueEl ? valueEl.innerHTML.trim() : '',
      });
    });

    return result;
  },

  sectionCedrowFreetypeContent(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const wrapButtonEl = doc.querySelector('[data-attribute="wrap-button"]');
    const buttonData = wrapButtonEl ? extractButtonBasic(wrapButtonEl.outerHTML) : {};

    const result = {
      ...containerResult,
      pills: [],
      sectionContent: '',
      button: { ...buttonData },
      pillStyles: {
        borderRadius: '10px',
        borderBackground: '#ffffff33',
        textColorPill: '#ffffff',
        backgroundColorPill: '#ffffff1a',
      },
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      result.enableAnchor = sectionEl.getAttribute('data-enable-anchor') === 'true';
    }

    const wrapPillEl = doc.querySelector('[data-attribute="wrap-pill"]');
    if (wrapPillEl) {
      result.showPills = wrapPillEl.getAttribute('data-show') !== 'false';
      const styles = wrapPillEl.getAttribute('style') || '';
      const borderRadiusMatch = styles.match(/--border-radius\s*:\s*([^;]+)/);
      const borderBgMatch = styles.match(/--border-background\s*:\s*([^;]+)/);
      const textColorMatch = styles.match(/--text-color-pill\s*:\s*([^;]+)/);
      const bgColorMatch = styles.match(/--background-color-pill\s*:\s*([^;]+)/);

      if (borderRadiusMatch) {
        const radiusValue = borderRadiusMatch[1].trim().replace(/px/, '');
        result.pillStyles.borderRadius = parseInt(radiusValue) || 10;
      }
      if (borderBgMatch) result.pillStyles.borderBackground = borderBgMatch[1].trim();
      if (textColorMatch) result.pillStyles.textColorPill = textColorMatch[1].trim();
      if (bgColorMatch) result.pillStyles.backgroundColorPill = bgColorMatch[1].trim();
    }

    const pillEls = doc.querySelectorAll('[data-attribute="pill-item"]');
    result.pills = Array.from(pillEls).map(pillEl => {
      const iconEl = pillEl.querySelector('[data-attribute="icon-pill"]');
      const contentEl = pillEl.querySelector('[data-attribute="content-pill"]');
      return {
        icon: iconEl?.getAttribute('src') || '',
        content: contentEl?.textContent.trim() || '',
      };
    });

    const sectionContentEl = doc.querySelector('[data-attribute="section-content"]');
    if (sectionContentEl) {
      result.sectionContent = sectionContentEl.innerHTML.trim();
    }

    return result;
  },

  sectionCardCedrowWithTab(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const result = {
      ...containerResult,
      cardTitle: { show: true, content: '' },
      colorTabHeader: '#214a88',
      colorTabHeaderHover: '#ffffff',
      bgTabHeaderHover: '#214a88',
      listTab: [],
    };

    const cardTitleEl = doc.querySelector('[data-attribute="card-title"]');
    if (cardTitleEl) {
      result.cardTitle.show = cardTitleEl.getAttribute('data-show') !== 'false';
      result.cardTitle.content = cardTitleEl.innerHTML.trim();
    }

    const listTabHeaderEl = doc.querySelector('[data-attribute="list-tab-header"]');
    if (listTabHeaderEl) {
      result.colorTabHeader = listTabHeaderEl.getAttribute('data-color-tab-header') || '#214a88';
      result.colorTabHeaderHover = listTabHeaderEl.getAttribute('data-color-tab-header-hover') || '#ffffff';
      result.bgTabHeaderHover = listTabHeaderEl.getAttribute('data-bg-tab-header-hover') || '#214a88';
    }

    const headerItems = doc.querySelectorAll('[data-attribute="tab-header-item"]');
    headerItems.forEach(headerEl => {
      const tabId = headerEl.getAttribute('data-tab') || 'tab-1';

      const tabData = {
        tabId,
        headerLabel: headerEl.textContent.trim(),
        headingContent: '',
        listChildItemShow: true,
        childItems: [],
        rightImage: '',
        button: {},
      };

      const contentEl = doc.querySelector(`[data-attribute="tab-content-item"][data-tab="${tabId}"]`);
      if (contentEl) {
        const textHeaderEl = contentEl.querySelector('[data-attribute="text-header-item"]');
        if (textHeaderEl) {
          tabData.headingContent = textHeaderEl.innerHTML.trim();
        }

        const listChildItemEl = contentEl.querySelector('[data-attribute="list-child-item"]');
        if (listChildItemEl) {
          tabData.listChildItemShow = listChildItemEl.getAttribute('data-show') !== 'false';
          const childItemEls = listChildItemEl.querySelectorAll('.child-item');
          childItemEls.forEach(childEl => {
            const iconEl = childEl.querySelector('[data-attribute="icon-child-item"]');
            const textEl = childEl.querySelector('[data-attribute="text-child-item"]');
            tabData.childItems.push({
              icon: iconEl ? iconEl.getAttribute('src') || '' : '',
              text: textEl ? textEl.textContent.trim() : '',
            });
          });
        }

        const rightImageEl = contentEl.querySelector('[data-attribute="right-image"]');
        if (rightImageEl) {
          tabData.rightImage = rightImageEl.getAttribute('src') || '';
        }

        const wrapButtonEl = contentEl.querySelector('[data-attribute="wrap-button"]');
        tabData.button = wrapButtonEl ? extractButtonBasic(wrapButtonEl.outerHTML) : {};
      }

      result.listTab.push(tabData);
    });

    return result;
  },

  sectionCardCedrowSideBySide(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const wrapButtonEl = doc.querySelector('[data-attribute="wrap-button"]');
    const buttonData = wrapButtonEl ? extractButtonBasic(wrapButtonEl.outerHTML) : {};

    const result = {
      ...containerResult,
      mediaType: 'video',
      mediaPosition: 'left',
      centerY: true,
      video: { src: '' },
      image: { src: '' },
      headingText: { show: true, content: '' },
      ratingBlock: {
        show: true,
        colorText: '#000000',
        backgroundColor: '#f9fbff',
        items: [],
      },
      button: { ...buttonData },
    };

    const wrapImgWithTextEl = doc.querySelector('[data-attribute="wrap-img-with-text"]');
    if (wrapImgWithTextEl) {
      result.mediaPosition = wrapImgWithTextEl.getAttribute('data-media-position') || 'left';
      result.centerY = wrapImgWithTextEl.getAttribute('data-center-y') !== 'false';
    }

    const leftCardMediaEl = doc.querySelector('[data-attribute="left-card-media"]');
    if (leftCardMediaEl) {
      result.mediaType = leftCardMediaEl.getAttribute('data-media-type') || 'video';
    }

    const videoEl = doc.querySelector('[data-attribute="video"]');
    if (videoEl) {
      result.video.src = videoEl.getAttribute('src') || '';
    }

    const imageEl = doc.querySelector('[data-attribute="image"]');
    if (imageEl) {
      result.image.src = imageEl.getAttribute('src') || '';
    }

    const headingTextEl = doc.querySelector('[data-attribute="heading-text"]');
    if (headingTextEl) {
      result.headingText.show = headingTextEl.getAttribute('data-show') !== 'false';
      result.headingText.content = headingTextEl.innerHTML.trim();
    }

    const ratingBlockEl = doc.querySelector('[data-attribute="block-social-rating"]');
    if (ratingBlockEl) {
      result.ratingBlock.show = ratingBlockEl.getAttribute('data-show') !== 'false';
      result.ratingBlock.colorText = ratingBlockEl.getAttribute('data-color-item-social') || '#000000';
      result.ratingBlock.backgroundColor = ratingBlockEl.getAttribute('data-background-item-social') || '#f9fbff';

      const socialItems = ratingBlockEl.querySelectorAll('[data-attribute="social-item"]');
      socialItems.forEach(itemEl => {
        const imageSocialEl = itemEl.querySelector('[data-attribute="image-social"]');
        const titleEl = itemEl.querySelector('[data-attribute="title-social"]');
        const ratingTextEl = itemEl.querySelector('[data-attribute="rating-text"]');
        const starEl = itemEl.querySelector('[data-attribute="star-rating"]');
        const imageEl = imageSocialEl ? imageSocialEl.querySelector('img') : null;

        result.ratingBlock.items.push({
          platformName: titleEl ? titleEl.textContent.trim() : '',
          showImage: imageSocialEl ? imageSocialEl.getAttribute('data-show') !== 'false' : false,
          imageSrc: imageEl ? imageEl.getAttribute('src') || '' : '',
          ratingText: ratingTextEl ? ratingTextEl.textContent.trim() : '',
          stars: starEl ? Number(starEl.getAttribute('data-value')) || 5 : 5,
        });
      });
    }

    return result;
  },

  sectionCardCedrowWithTabel(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const wrapButtonEl = doc.querySelector('[data-attribute="wrap-button"]');
    const buttonData = wrapButtonEl ? extractButtonBasic(wrapButtonEl.outerHTML) : {};

    const result = {
      ...containerResult,
      cardTitle: { show: true, content: '' },
      tableEditor: { content: '' },
      button: { ...buttonData },
    };

    const cardTitleEl = doc.querySelector('[data-attribute="card-title"]');
    if (cardTitleEl) {
      result.cardTitle.show = cardTitleEl.getAttribute('data-show') !== 'false';
      result.cardTitle.content = cardTitleEl.innerHTML.trim();
    }

    const tableEditorEl = doc.querySelector('[data-attribute="table-editor"]');
    if (tableEditorEl) {
      result.tableEditor.content = tableEditorEl.innerHTML.trim();
    }

    return result;
  },
  sectionCardCedrowBenefitsPolicy(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const result = {
      ...containerResult,
      blocksBenefits: {
        useBorder: true,
        colorBorder: '#123123',
      },
      titleBenefits: '',
      blockCompare: {
        show: true,
        before: {
          backgroundColor: '#fff5f5',
          textColor: '#6b7280',
          title: '',
          items: [],
        },
        vs: {
          backgroundColor: '#00374c',
          textColor: '#ffffff',
        },
        after: {
          backgroundColor: '#f3f7fe',
          textColor: '#6b7280',
          title: '',
          items: [],
        },
      },
      blockFeature: {
        show: false,
        items: [],
      },
      blockFeatureWithIndex: {
        show: true,
        backgroundColor: '#eef2f3',
        indexColor: '#094a59',
        items: [],
      },
      textHint: {
        show: true,
        backgroundColor: '#f3f7fe',
        textColor: '#6b7280',
        content: '',
      },
    };

    const blocksBenefitsEl = doc.querySelector('[data-attribute="blocks-benefits"]');
    if (blocksBenefitsEl) {
      result.blocksBenefits.useBorder = blocksBenefitsEl.getAttribute('data-use-border') !== 'false';
      result.blocksBenefits.colorBorder = blocksBenefitsEl.getAttribute('data-color-border') || '#123123';
    }

    const titleBenefitsEl = doc.querySelector('[data-attribute="title-benefits"]');
    if (titleBenefitsEl) result.titleBenefits = titleBenefitsEl.textContent.trim();

    const blockCompareEl = doc.querySelector('[data-attribute="block-compare"]');
    if (blockCompareEl) {
      result.blockCompare.show = blockCompareEl.getAttribute('data-show') !== 'false';

      const beforeEl = blockCompareEl.querySelector('[data-attribute="before"]');
      if (beforeEl) {
        result.blockCompare.before.backgroundColor = beforeEl.getAttribute('data-background-color-before') || '#fff5f5';
        result.blockCompare.before.textColor = beforeEl.getAttribute('data-text-color-before') || '#6b7280';
        const titleBeforeEl = beforeEl.querySelector('[data-attribute="title-before"]');
        result.blockCompare.before.title = titleBeforeEl ? titleBeforeEl.textContent.trim() : '';
        result.blockCompare.before.items = Array.from(beforeEl.querySelectorAll('[data-attribute="item-before"]')).map(
          itemEl => {
            const imgEl = itemEl.querySelector('[data-attribute="img-item-before"]');
            const textEl = itemEl.querySelector('[data-attribute="text-item-before"]');
            return {
              image: imgEl ? imgEl.getAttribute('src') || '' : '',
              text: textEl ? textEl.textContent.trim() : '',
            };
          },
        );
      }

      const vsEl = blockCompareEl.querySelector('[data-attribute="vs"]');
      if (vsEl) {
        result.blockCompare.vs.backgroundColor = vsEl.getAttribute('data-bg-color-vs') || '#00374c';
        result.blockCompare.vs.textColor = vsEl.getAttribute('data-text-color-vs') || '#ffffff';
      }

      const afterEl = blockCompareEl.querySelector('[data-attribute="after"]');
      if (afterEl) {
        result.blockCompare.after.backgroundColor = afterEl.getAttribute('data-background-color-after') || '#f3f7fe';
        result.blockCompare.after.textColor = afterEl.getAttribute('data-text-color-after') || '#6b7280';
        const titleAfterEl = afterEl.querySelector('[data-attribute="title-after"]');
        result.blockCompare.after.title = titleAfterEl ? titleAfterEl.textContent.trim() : '';
        result.blockCompare.after.items = Array.from(afterEl.querySelectorAll('[data-attribute="item-after"]')).map(
          itemEl => {
            const imgEl = itemEl.querySelector('[data-attribute="img-item-after"]');
            const textEl = itemEl.querySelector('[data-attribute="text-item-after"]');
            return {
              image: imgEl ? imgEl.getAttribute('src') || '' : '',
              text: textEl ? textEl.textContent.trim() : '',
            };
          },
        );
      }
    }

    const blockFeatureEl = doc.querySelector('[data-attribute="block-feature"]');
    if (blockFeatureEl) {
      result.blockFeature.show = blockFeatureEl.getAttribute('data-show') === 'true';
      result.blockFeature.items = Array.from(blockFeatureEl.querySelectorAll('[data-attribute="item-feature"]')).map(
        itemEl => {
          const imgEl = itemEl.querySelector('[data-attribute="img-item-feature"]');
          const textEl = itemEl.querySelector('[data-attribute="text-item-feature"]');
          return {
            image: imgEl ? imgEl.getAttribute('src') || '' : '',
            content: textEl ? textEl.innerHTML.trim() : '',
          };
        },
      );
    }

    const blockFeatureWithIndexEl = doc.querySelector('[data-attribute="block-feature-with-index"]');
    if (blockFeatureWithIndexEl) {
      result.blockFeatureWithIndex.show = blockFeatureWithIndexEl.getAttribute('data-show') !== 'false';
      result.blockFeatureWithIndex.backgroundColor = blockFeatureWithIndexEl.getAttribute('data-bg-index') || '#eef2f3';
      result.blockFeatureWithIndex.indexColor =
        blockFeatureWithIndexEl.getAttribute('data-color-text-index') || '#094a59';
      result.blockFeatureWithIndex.items = Array.from(
        blockFeatureWithIndexEl.querySelectorAll('[data-attribute="item-feature"]'),
      ).map(itemEl => {
        const indexEl = itemEl.querySelector('[data-attribute="index-item-feature"]');
        const textEl = itemEl.querySelector('[data-attribute="text-item-feature"]');
        return {
          index: indexEl ? indexEl.textContent.trim() : '',
          content: textEl ? textEl.innerHTML.trim() : '',
        };
      });
    }

    const textHintEl = doc.querySelector('[data-attribute="text-hint"]');
    if (textHintEl) {
      result.textHint.show = textHintEl.getAttribute('data-show') !== 'false';
      result.textHint.backgroundColor = textHintEl.getAttribute('data-bg-hint') || '#f3f7fe';
      result.textHint.textColor = textHintEl.getAttribute('data-text-hint') || '#6b7280';
      result.textHint.content = textHintEl.innerHTML.trim();
    }

    return result;
  },

  sectionCardCedrowGridIcons(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const result = {
      ...containerResult,
      cardTitle: {
        show: true,
        content: '',
      },
      list: {
        colPerView: 4,
      },
      items: [],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    const cardTitleEl = doc.querySelector('[data-attribute="card-title"]');
    if (cardTitleEl) {
      result.cardTitle.show = cardTitleEl.getAttribute('data-show') !== 'false';
      result.cardTitle.content = cardTitleEl.innerHTML.trim();
    }

    const listItemEl = doc.querySelector('[data-attribute="list-item"]');
    if (listItemEl) {
      result.list.colPerView = parseInt(listItemEl.getAttribute('data-col-per-view'), 10) || result.list.colPerView;
    }

    const itemEls = doc.querySelectorAll('[data-attribute="list-item"] [data-attribute="item"]');
    result.items = Array.from(itemEls).map(itemEl => {
      const imageEl = itemEl.querySelector('[data-attribute="image-item"]');
      return {
        image: imageEl?.getAttribute('src') || '',
        alt: imageEl?.getAttribute('alt') || '',
        content: itemEl.querySelector('[data-attribute="text-item"]')?.innerHTML.trim() || '',
      };
    });

    return result;
  },

  sectionUpairyTabs(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const result = {
      ...containerResult,
      header: '',
      tabHeaderColor: '#000000',
      imageBorderRadius: 9999,
      imageWidth: 296,
      imagePosition: 'left',
      listItem: [],
    };

    const rootEl = doc.querySelector("[data-attribute='upairy-tabs']");
    const headerEl = doc.querySelector("[data-attribute='upairy-tabs__header']");
    if (rootEl) {
      result.tabHeaderColor = rootEl.getAttribute('data-tab-header-color') || result.tabHeaderColor;
      const borderRadius = Number(rootEl.getAttribute('data-image-border-radius'));
      const width = Number(rootEl.getAttribute('data-image-width'));
      result.imageBorderRadius = Number.isNaN(borderRadius) ? result.imageBorderRadius : Math.max(0, borderRadius);
      result.imageWidth = Number.isNaN(width) ? result.imageWidth : Math.max(0, width);
      result.imagePosition = rootEl.getAttribute('data-image-position') === 'right' ? 'right' : 'left';
    }
    if (headerEl) result.header = headerEl.innerHTML.trim();

    const tabEls = doc.querySelectorAll("[data-attribute='upairy-tabs__tab']");
    doc.querySelectorAll("[data-attribute='upairy-tabs__item']").forEach((itemEl, index) => {
      const tabEl = tabEls[index];
      const imageEl = itemEl.querySelector("[data-attribute='upairy-tabs__image']");
      const videoEl = itemEl.querySelector("[data-attribute='upairy-tabs__video']");
      const sourceEl = videoEl ? videoEl.querySelector('source') : null;
      const valueEl = itemEl.querySelector("[data-attribute='upairy-tabs__value']");
      result.listItem.push({
        header: tabEl ? tabEl.textContent.trim() : '',
        mediaType: videoEl ? 'video' : 'image',
        image: imageEl ? imageEl.getAttribute('src') || '' : '',
        video: sourceEl ? sourceEl.getAttribute('src') || '' : videoEl ? videoEl.getAttribute('src') || '' : '',
        value: valueEl ? valueEl.innerHTML.trim() : '',
      });
    });

    return result;
  },
  sectionUpairyTimeline(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const result = {
      ...containerResult,
      header: '',
      lineColor: '#23873D',
      lineWidth: 2,
      image: { show: true, position: 'right', src: '', alt: 'Potty training progress' },
      listItem: [],
    };
    const rootEl = doc.querySelector("[data-attribute='upairy-timeline']");
    const headerEl = doc.querySelector("[data-attribute='upairy-timeline__header']");
    const imageEl = doc.querySelector("[data-attribute='upairy-timeline__image-element']");

    if (rootEl) {
      result.lineColor = rootEl.getAttribute('data-line-color') || result.lineColor;
      const lineWidth = Number(rootEl.getAttribute('data-line-width'));
      result.lineWidth = Number.isNaN(lineWidth) ? result.lineWidth : Math.max(1, lineWidth);
      result.image.show = rootEl.getAttribute('data-image-show') !== 'false';
      result.image.position = rootEl.getAttribute('data-image-position') === 'left' ? 'left' : 'right';
    }
    if (headerEl) result.header = headerEl.innerHTML.trim();
    if (imageEl) {
      result.image.src = imageEl.getAttribute('src') || '';
      result.image.alt = imageEl.getAttribute('alt') || result.image.alt;
    }
    doc.querySelectorAll("[data-attribute='upairy-timeline__item']").forEach(itemEl => {
      const contentEl = itemEl.querySelector("[data-attribute='upairy-timeline__item-content']");
      result.listItem.push({ content: contentEl ? contentEl.innerHTML.trim() : '' });
    });

    return result;
  },
  sectionUpairyCard(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const result = {
      ...containerResult,
      image: { show: true, position: 'left', src: '', alt: 'Child wearing UpAiry training underwear' },
      header: '',
      listItem: [],
      button: {},
      footer: '',
    };
    const rootEl = doc.querySelector("[data-attribute='upairy-card']");
    const imageEl = doc.querySelector("[data-attribute='upairy-card__image-element']");
    const headerEl = doc.querySelector("[data-attribute='upairy-card__header']");
    const footerEl = doc.querySelector("[data-attribute='upairy-card__footer']");
    const buttonEl = doc.querySelector("[data-attribute='upairy-card__button'] [data-attribute='wrap-button']");

    if (rootEl) {
      result.image.show = rootEl.getAttribute('data-image-show') !== 'false';
      result.image.position = rootEl.getAttribute('data-image-position') === 'right' ? 'right' : 'left';
    }
    if (imageEl) {
      result.image.src = imageEl.getAttribute('src') || '';
      result.image.alt = imageEl.getAttribute('alt') || result.image.alt;
    }
    if (headerEl) result.header = headerEl.innerHTML.trim();
    if (footerEl) result.footer = footerEl.innerHTML.trim();
    if (buttonEl) result.button = extractButtonBasic(buttonEl.outerHTML);
    doc.querySelectorAll("[data-attribute='upairy-card__item']").forEach(itemEl => {
      result.listItem.push({
        title: itemEl.querySelector("[data-attribute='upairy-card__item-title']")?.innerHTML.trim() || '',
        description: itemEl.querySelector("[data-attribute='upairy-card__item-description']")?.innerHTML.trim() || '',
      });
    });

    return result;
  },
  sectionUpairyCompareCard(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const defaultCard = type => ({
      image: { src: '', alt: type === 'good' ? 'UpAiry training underwear' : 'Disposable diaper' },
      title: '',
      items: [],
      backgroundColor: type === 'good' ? '#4D903F' : '#EAEAEA',
      titleColor: type === 'good' ? '#FFFFFF' : '#242424',
      itemBackgroundColor: '#FFFFFF',
      itemTextColor: '#242424',
    });
    const extractCard = type => {
      const card = defaultCard(type);
      const cardEl = doc.querySelector(`[data-attribute='upairy-compare-card__${type}']`);
      const imageEl = doc.querySelector(`[data-attribute='upairy-compare-card__${type}-image']`);
      const titleEl = doc.querySelector(`[data-attribute='upairy-compare-card__${type}-title']`);

      if (cardEl) {
        card.backgroundColor = cardEl.getAttribute('data-card-background-color') || card.backgroundColor;
        card.titleColor = cardEl.getAttribute('data-title-color') || card.titleColor;
        card.itemBackgroundColor = cardEl.getAttribute('data-item-background-color') || card.itemBackgroundColor;
        card.itemTextColor = cardEl.getAttribute('data-item-text-color') || card.itemTextColor;
      }
      if (imageEl) {
        card.image.src = imageEl.getAttribute('src') || '';
        card.image.alt = imageEl.getAttribute('alt') || card.image.alt;
      }
      if (titleEl) card.title = titleEl.innerHTML.trim();
      doc.querySelectorAll(`[data-attribute='upairy-compare-card__${type}-item']`).forEach(itemEl => {
        card.items.push(itemEl.innerHTML.trim());
      });
      return card;
    };
    const result = {
      ...containerResult,
      image: { show: true, position: 'left', src: '', alt: 'Child wearing UpAiry training underwear' },
      header: '',
      good: extractCard('good'),
      bad: extractCard('bad'),
      button: {},
      footer: '',
    };
    const rootEl = doc.querySelector("[data-attribute='upairy-compare-card']");
    const imageEl = doc.querySelector("[data-attribute='upairy-compare-card__image-element']");
    const headerEl = doc.querySelector("[data-attribute='upairy-compare-card__header']");
    const footerEl = doc.querySelector("[data-attribute='upairy-compare-card__footer']");
    const buttonEl = doc.querySelector("[data-attribute='upairy-compare-card__button'] [data-attribute='wrap-button']");

    if (rootEl) {
      result.image.show = rootEl.getAttribute('data-image-show') !== 'false';
      result.image.position = rootEl.getAttribute('data-image-position') === 'right' ? 'right' : 'left';
    }
    if (imageEl) {
      result.image.src = imageEl.getAttribute('src') || '';
      result.image.alt = imageEl.getAttribute('alt') || result.image.alt;
    }
    if (headerEl) result.header = headerEl.innerHTML.trim();
    if (footerEl) result.footer = footerEl.innerHTML.trim();
    if (buttonEl) result.button = extractButtonBasic(buttonEl.outerHTML);

    return result;
  },
  sectionKonfortifyFb(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    const result = {
      title: 'Konfortify FB Section',
      enableAnchor: false,
      textColor: '#000000',
      padding: {
        top: true,
        bottom: true,
      },
      'background-section': {
        color: '#ffffff',
      },
      'container-content': {
        showStyle: false,
        background: '#ffffff',
      },
      container: {
        enableContainer: false,
      },
      titlePost: '',
      showTitlePost: false,
      listPost: {
        colPerView: 3,
        listItem: [],
      },
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
      const title = sectionEl.getAttribute('data-title');
      result.title = title || result.title;
    }

    const cardContainer = container?.querySelector('[data-attribute="card-container"]');
    if (cardContainer) {
      const background =
        cardContainer.getAttribute('data-background') || cardContainer.style.backgroundColor || '#ffffff';
      result['background-section'].color = background;
      result.padding.top = cardContainer.getAttribute('data-top-padding') === 'true';
      result.padding.bottom = cardContainer.getAttribute('data-bottom-padding') === 'true';
      result.textColor = cardContainer.getAttribute('data-text-color') || '#000000';
    }

    const elContainerPage = container?.querySelector('[data-attribute="container-page"]');
    if (elContainerPage) {
      const showStyle = elContainerPage.getAttribute('data-show-style');
      result['container-content'].showStyle = showStyle ? showStyle === 'true' : false;
      const background = elContainerPage.getAttribute('data-background');
      result['container-content'].background = background || '#ffffff';
    }

    const elContainer = container?.querySelector('[data-attribute="container"]');
    if (elContainer) {
      const enableContainer = elContainer.getAttribute('data-enable-container');
      result.container.enableContainer = enableContainer ? enableContainer === 'true' : false;
    }

    const titlePostEl = container?.querySelector('[data-attribute="title-post"]');
    if (titlePostEl) {
      result.titlePost = titlePostEl.innerHTML.trim();
      result.showTitlePost = titlePostEl.getAttribute('data-show') !== 'false';
    }

    const listPostEl = container?.querySelector('[data-attribute="list-post"]');
    if (listPostEl) {
      const colPerView = Number(listPostEl.getAttribute('data-col-per-view'));
      result.listPost.colPerView = Number.isFinite(colPerView) && colPerView > 0 ? colPerView : 3;

      const itemEls = listPostEl.querySelectorAll('.wrap-item');
      result.listPost.listItem = Array.from(itemEls).map(itemEl => ({
        outherName: itemEl.querySelector('[data-attribute="user-name"]')?.textContent?.trim() || '',
        outherAvatar: itemEl.querySelector('[data-attribute="author-avatar"] img')?.getAttribute('src') || '',
        createdAt: itemEl.querySelector('[data-attribute="created-at"]')?.textContent?.trim() || '',
        postImage: itemEl.querySelector('[data-attribute="post-img"] img')?.getAttribute('src') || '',
        commentCount: itemEl.querySelector('[data-attribute="comment-count"]')?.textContent?.trim() || '0',
        reactionCount: itemEl.querySelector('[data-attribute="reaction-count"]')?.textContent?.trim() || '0',
        postText: itemEl.querySelector('[data-attribute="post-text"]')?.textContent?.trim() || '',
      }));
    }

    return result;
  },
  sectionKonfortifyCardBasic(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const result = {
      ...containerResult,
      content: { html: '', backgroundColor: '#E2ECFD', textColor: '#000000' },
      image: { show: true, src: '', position: 'left' },
      button: {},
    };
    const rootEl = doc.querySelector('[data-attribute="konfortify-card-basic"]');
    const contentBoxEl = doc.querySelector('[data-attribute="konfortify-card-basic__content-box"]');
    const contentEl = doc.querySelector('[data-attribute="konfortify-card-basic__content"]');
    const mediaEl = doc.querySelector('[data-attribute="konfortify-card-basic__media"]');
    const imageEl = doc.querySelector('[data-attribute="konfortify-card-basic__image"]');
    const buttonEl = doc.querySelector('[data-attribute="wrap-button"]');

    if (rootEl) {
      result.image.position = rootEl.getAttribute('data-image-position') || result.image.position;
      result.image.show = rootEl.getAttribute('data-image-show') !== 'false';
    }
    if (mediaEl) result.image.show = mediaEl.getAttribute('data-show') !== 'false';
    if (contentBoxEl) {
      result.content.backgroundColor =
        contentBoxEl.getAttribute('data-background-color') || result.content.backgroundColor;
      result.content.textColor = contentBoxEl.getAttribute('data-text-color') || result.content.textColor;
    }
    if (contentEl) result.content.html = contentEl.innerHTML.trim();
    if (imageEl) result.image.src = imageEl.getAttribute('src') || '';
    if (buttonEl) result.button = extractButtonBasic(buttonEl.outerHTML);

    return result;
  },
  sectionKonfortifyBanner(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const result = {
      ...containerResult,
      content: { html: '', backgroundColor: '#E2ECFD', textColor: '#000000' },
      image: { show: true, src: '', position: 'right', showShapeCurved: true },
      button: {},
    };
    const rootEl = doc.querySelector('[data-attribute="konfortify-banner"]');
    const contentBoxEl = doc.querySelector('[data-attribute="konfortify-banner__content-box"]');
    const contentEl = doc.querySelector('[data-attribute="konfortify-banner__content"]');
    const mediaEl = doc.querySelector('[data-attribute="konfortify-banner__media"]');
    const imageEl = doc.querySelector('[data-attribute="konfortify-banner__image"]');
    const buttonEl = doc.querySelector('[data-attribute="wrap-button"]');

    if (rootEl) {
      result.image.position = rootEl.getAttribute('data-image-position') === 'left' ? 'left' : 'right';
      result.image.show = rootEl.getAttribute('data-image-show') !== 'false';
    }
    if (mediaEl) {
      result.image.show = mediaEl.getAttribute('data-show') !== 'false';
      result.image.showShapeCurved = mediaEl.getAttribute('data-shape-curved-show') !== 'false';
    }
    if (contentBoxEl) {
      result.content.backgroundColor =
        contentBoxEl.getAttribute('data-background-color') || result.content.backgroundColor;
      result.content.textColor = contentBoxEl.getAttribute('data-text-color') || result.content.textColor;
    }
    if (contentEl) result.content.html = contentEl.innerHTML.trim();
    if (imageEl) result.image.src = imageEl.getAttribute('src') || '';
    if (buttonEl) result.button = extractButtonBasic(buttonEl.outerHTML);

    return result;
  },
  sectionKonfortifyReviewGrid(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const result = {
      ...containerResult,
      headerTitle: '',
      rating: { value: 5 },
      starColor: '#39CA41',
      listItem: [],
    };

    const rootEl = doc.querySelector('[data-attribute="konfortify-review-grid"]');
    const headerTitleEl = doc.querySelector('[data-attribute="konfortify-review-grid__header-title"]');
    const ratingValueEl = doc.querySelector('[data-attribute="konfortify-review-grid__rating-value"]');

    if (rootEl) result.starColor = rootEl.getAttribute('data-star-color') || result.starColor;
    if (headerTitleEl) result.headerTitle = headerTitleEl.innerHTML.trim();
    if (ratingValueEl) result.rating.value = Number(ratingValueEl.textContent.trim()) || result.rating.value;

    doc.querySelectorAll('[data-attribute="konfortify-review-grid__item"]').forEach(itemEl => {
      const titleEl = itemEl.querySelector('[data-attribute="konfortify-review-grid__item-title"]');
      const contentEl = itemEl.querySelector('[data-attribute="konfortify-review-grid__item-content"]');
      const avatarEl = itemEl.querySelector('[data-attribute="konfortify-review-grid__item-avatar"]');
      const fullNameEl = itemEl.querySelector('[data-attribute="konfortify-review-grid__item-full-name"]');
      const starsEl = itemEl.querySelector('[data-attribute="konfortify-review-grid__item-stars"]');
      result.listItem.push({
        title: titleEl?.textContent.trim() || '',
        content: contentEl?.textContent.trim() || '',
        avatar: avatarEl?.getAttribute('src') || '',
        fullName: fullNameEl?.textContent.trim() || '',
        rating: Number(starsEl?.getAttribute('data-value')) || 5,
      });
    });

    return result;
  },
  sectionFurnitureshopBanner(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const wrapButtonEl = doc.querySelector('[data-attribute="wrap-button"]');
    const buttonData = wrapButtonEl ? extractButtonBasic(wrapButtonEl.outerHTML) : {};
    const result = {
      ...containerResult,
      button: { ...buttonData },
      tags: { deepGloss: '', ceramic: '' },
      content: { headline: '' },
    };

    const deepGlossEl = doc.querySelector('[data-attribute="furnitureshop-banner__tag"]');
    if (deepGlossEl) result.tags.deepGloss = deepGlossEl.textContent.trim();
    const ceramicEl = doc.querySelector('[data-attribute="furnitureshop-banner__ceramic"]');
    if (ceramicEl) result.tags.ceramic = ceramicEl.textContent.trim();
    const headlineEl = doc.querySelector('[data-attribute="furnitureshop-banner__headline"]');
    if (headlineEl) result.content.headline = headlineEl.innerHTML.trim();

    return result;
  },
  sectionFurnitureshopCardStep(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const result = {
      ...containerResult,
      header: { title: '', description: '' },
      media: { show: true, position: 'left', type: 'video', videoSrc: '', imageSrc: '' },
      steps: [],
    };

    const titleEl = doc.querySelector('[data-attribute="furnitureshop-card-step__title"]');
    const descriptionEl = doc.querySelector('[data-attribute="furnitureshop-card-step__description"]');
    if (titleEl) result.header.title = titleEl.innerHTML.trim();
    if (descriptionEl) result.header.description = descriptionEl.innerHTML.trim();

    const mediaEl = doc.querySelector('[data-attribute="furnitureshop-card-step__media"]');
    if (mediaEl) {
      result.media.show = mediaEl.getAttribute('data-show') !== 'false';
      result.media.position = mediaEl.getAttribute('data-position') || 'left';
      result.media.type = mediaEl.getAttribute('data-media-type') || 'video';
      const videoEl = mediaEl.querySelector('[data-attribute="furnitureshop-card-step__video-source"]');
      const imageEl = mediaEl.querySelector('[data-attribute="furnitureshop-card-step__media-image-inner"]');
      result.media.videoSrc = videoEl?.getAttribute('src') || '';
      result.media.imageSrc = imageEl?.getAttribute('src') || '';
    }

    doc.querySelectorAll('[data-attribute="furnitureshop-card-step__item"]').forEach(itemEl => {
      const imageEl = itemEl.querySelector('[data-attribute="furnitureshop-card-step__item-image"]');
      const descriptionItemEl = itemEl.querySelector('[data-attribute="furnitureshop-card-step__item-description"]');
      result.steps.push({
        image: imageEl?.getAttribute('src') || '',
        description: descriptionItemEl?.innerHTML.trim() || '',
      });
    });

    return result;
  },
  sectionFurnitureshopGridSlider(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const result = {
      ...containerResult,
      images: [],
      items: [],
    };

    doc.querySelectorAll('[data-attribute=furnitureshop-grid-slider__image]').forEach(imageEl => {
      result.images.push(imageEl.getAttribute('src') || '');
    });

    doc.querySelectorAll('[data-attribute=furnitureshop-grid-slider__item]').forEach(itemEl => {
      const imageEl = itemEl.querySelector('[data-attribute=furnitureshop-grid-slider__item-image]');
      const textEl = itemEl.querySelector('[data-attribute=furnitureshop-grid-slider__item-text]');
      result.items.push({
        image: imageEl?.getAttribute('src') || '',
        text: textEl?.textContent.trim() || '',
      });
    });

    return result;
  },
  sectionFurnitureshopGridSlider02(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const wrapButtonEl = doc.querySelector('[data-attribute="wrap-button"]');
    const buttonData = wrapButtonEl ? extractButtonBasic(wrapButtonEl.outerHTML) : {};
    const result = {
      ...containerResult,
      header: { title: '', description: '' },
      slides: [],
      button: { ...buttonData },
    };

    const titleEl = doc.querySelector('[data-attribute="furnitureshop-grid-slider-02__title"]');
    const descriptionEl = doc.querySelector('[data-attribute="furnitureshop-grid-slider-02__description"]');
    if (titleEl) result.header.title = titleEl.innerHTML.trim();
    if (descriptionEl) result.header.description = descriptionEl.innerHTML.trim();

    doc.querySelectorAll('[data-attribute="furnitureshop-grid-slider-02__slide"]').forEach(slideEl => {
      const imageEl = slideEl.querySelector('[data-attribute="furnitureshop-grid-slider-02__image"]');
      const contentEl = slideEl.querySelector('[data-attribute="furnitureshop-grid-slider-02__slide-content"]');
      result.slides.push({
        image: imageEl?.getAttribute('src') || '',
        content: contentEl?.innerHTML.trim() || '',
      });
    });

    return result;
  },
  sectionFurnitureshopSpecification(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const wrapButtonEl = doc.querySelector('[data-attribute=wrap-button]');
    const buttonData = wrapButtonEl ? extractButtonBasic(wrapButtonEl.outerHTML) : {};
    const result = {
      ...containerResult,
      content: '',
      note: '',
      image: { show: true, position: 'right', src: '', subText: '' },
      button: { ...buttonData },
    };

    const sectionEl = doc.querySelector('[data-attribute=furnitureshop-specification]');
    if (sectionEl) {
      result.image.show = sectionEl.getAttribute('data-image-show') !== 'false';
      result.image.position = sectionEl.getAttribute('data-image-position') === 'left' ? 'left' : 'right';
    }

    const contentEl = doc.querySelector('[data-attribute=furnitureshop-specification__content]');
    const noteEl = doc.querySelector('[data-attribute=furnitureshop-specification__note-content]');
    const imageEl = doc.querySelector('[data-attribute=furnitureshop-specification__image]');
    const subTextEl = doc.querySelector('[data-attribute=furnitureshop-specification__sub-text-image]');
    if (contentEl) result.content = contentEl.innerHTML.trim();
    if (noteEl) result.note = noteEl.innerHTML.trim();
    if (imageEl) result.image.src = imageEl.getAttribute('src') || '';
    if (subTextEl) result.image.subText = subTextEl.textContent.trim();

    return result;
  },
  sectionFurnitureshopCarousel(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const imageEl = doc.querySelector('[data-attribute=furnitureshop-carousel__image]');

    return {
      ...containerResult,
      image: imageEl ? imageEl.getAttribute('src') || '' : '',
    };
  },
  sectionFurnitureshopReward(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const contentEl = doc.querySelector('[data-attribute=furnitureshop-reward__content]');
    const innovationEl = doc.querySelector('[data-attribute=furnitureshop-reward__innovation]');
    const tiktokHotEl = doc.querySelector('[data-attribute=furnitureshop-reward__tiktok-hot]');

    return {
      ...containerResult,
      content: contentEl?.innerHTML.trim() || '',
      awards: {
        innovation: innovationEl?.innerHTML.trim() || '',
        tiktokHot: tiktokHotEl?.innerHTML.trim() || '',
      },
    };
  },
  sectionFurnitureshopBanner02(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const wrapButtonEl = doc.querySelector('[data-attribute=wrap-button]');
    const buttonData = wrapButtonEl ? extractButtonBasic(wrapButtonEl.outerHTML) : {};
    const result = {
      ...containerResult,
      header: { title: '', description: '', decor: '' },
      content: { logo: '' },
      items: [],
      button: { ...buttonData },
    };

    const titleEl = doc.querySelector('[data-attribute=furnitureshop-banner-02__title]');
    const descriptionEl = doc.querySelector('[data-attribute=furnitureshop-banner-02__description]');
    const decorEl = doc.querySelector('[data-attribute=furnitureshop-banner-02__decor]');
    const logoEl = doc.querySelector('[data-attribute=furnitureshop-banner-02__logo]');

    if (titleEl) result.header.title = titleEl.innerHTML.trim();
    if (descriptionEl) result.header.description = descriptionEl.innerHTML.trim();
    if (decorEl) result.header.decor = decorEl.getAttribute('src') || '';
    if (logoEl) result.content.logo = logoEl.getAttribute('src') || '';

    doc.querySelectorAll('[data-attribute=furnitureshop-banner-02__item]').forEach(itemEl => {
      const iconEl = itemEl.querySelector('[data-attribute=furnitureshop-banner-02__item-icon]');
      const textEl = itemEl.querySelector('[data-attribute=furnitureshop-banner-02__item-text]');
      result.items.push({
        icon: iconEl?.getAttribute('src') || '',
        text: textEl?.textContent.trim() || '',
      });
    });

    return result;
  },
  sectionFurnitureshopBanner03(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const result = {
      ...containerResult,
      header: { title: '', description: '', decor: '' },
      media: { show: true, type: 'video', videoSrc: '', imageSrc: '', subtext: '' },
      features: [],
    };

    const titleEl = doc.querySelector('[data-attribute=furnitureshop-banner-03__title]');
    const descriptionEl = doc.querySelector('[data-attribute=furnitureshop-banner-03__description]');
    const decorEl = doc.querySelector('[data-attribute=furnitureshop-banner-03__decor]');
    if (titleEl) result.header.title = titleEl.innerHTML.trim();
    if (descriptionEl) result.header.description = descriptionEl.innerHTML.trim();
    if (decorEl) result.header.decor = decorEl.getAttribute('src') || '';

    const mediaEl = doc.querySelector('[data-attribute=furnitureshop-banner-03__media]');
    if (mediaEl) {
      result.media.show = mediaEl.getAttribute('data-show') !== 'false';
      result.media.type = mediaEl.getAttribute('data-media-type') === 'image' ? 'image' : 'video';
      const videoEl = mediaEl.querySelector('[data-attribute=furnitureshop-banner-03__video-source]');
      const imageEl = mediaEl.querySelector('[data-attribute=furnitureshop-banner-03__media-image-inner]');
      result.media.videoSrc = videoEl?.getAttribute('src') || '';
      result.media.imageSrc = imageEl?.getAttribute('src') || '';
    }

    const subtextEl = doc.querySelector('[data-attribute=furnitureshop-banner-03__subtext]');
    if (subtextEl) result.media.subtext = subtextEl.textContent.trim();

    doc.querySelectorAll('[data-attribute=furnitureshop-banner-03__feature]').forEach(itemEl => {
      const iconEl = itemEl.querySelector('[data-attribute=furnitureshop-banner-03__feature-icon]');
      const textEl = itemEl.querySelector('[data-attribute=furnitureshop-banner-03__feature-text]');
      result.features.push({
        icon: iconEl?.getAttribute('src') || '',
        text: textEl?.textContent.trim() || '',
      });
    });

    return result;
  },
  sectionFurnitureshopFaq(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const wrapButtonEl = doc.querySelector('[data-attribute=wrap-button]');
    const buttonData = wrapButtonEl ? extractButtonBasic(wrapButtonEl.outerHTML) : {};
    const titleEl = doc.querySelector('[data-attribute=furnitureshop-faq__title]');
    const result = {
      ...containerResult,
      heading: titleEl?.innerHTML.trim() || '',
      items: [],
      button: { ...buttonData },
    };

    doc.querySelectorAll('[data-attribute=furnitureshop-faq__item]').forEach(itemEl => {
      const questionEl = itemEl.querySelector('[data-attribute=furnitureshop-faq__question]');
      const answerEl = itemEl.querySelector('[data-attribute=furnitureshop-faq__answer]');
      result.items.push({
        question: questionEl?.textContent.trim() || '',
        answer: answerEl?.innerHTML.trim() || '',
      });
    });

    return result;
  },
  sectionFeetscareListImage(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const result = {
      ...containerResult,
      cardTitle: {
        show: true,
        content: '<h2>AS SEEN IN</h2><p>Trusted by millions of users worldwide</p>',
      },
      listImages: {
        width: 100,
        items: [],
      },
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      result.enableAnchor = sectionEl.getAttribute('data-enable-anchor') === 'true';
    }

    const cardTitleEl = doc.querySelector('[data-attribute="card-title"]');
    if (cardTitleEl) {
      result.cardTitle.show = cardTitleEl.getAttribute('data-show') !== 'false';
      result.cardTitle.content = cardTitleEl.innerHTML.trim();
    }

    const listEl = doc.querySelector('[data-attribute="list-item-image"]');
    if (listEl) {
      const widthImage = listEl.getAttribute('data-width-image') || '100px';
      const widthNum = parseInt(
        String(widthImage)
          .replace('px', '')
          .trim(),
      );
      result.listImages.width = Number.isFinite(widthNum) ? widthNum : 100;

      result.listImages.items = Array.from(listEl.querySelectorAll('[data-attribute="item-image"]')).map(itemEl => {
        const imgEl = itemEl.querySelector('[data-attribute="img-item"]');
        return { image: imgEl ? imgEl.getAttribute('src') || '' : '' };
      });
    }

    return result;
  },
  sectionFeetscareListItem(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const result = {
      ...containerResult,
      cardTitle: {
        show: true,
        content: '<h2 style="text-align: center">Designed for everyday comfort</h2>',
      },
      listItem: {
        bgItem: '#ffffff',
        colorItem: '#000000',
        items: [],
      },
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      result.enableAnchor = sectionEl.getAttribute('data-enable-anchor') === 'true';
    }

    const cardTitleEl = doc.querySelector('[data-attribute="card-title"]');
    if (cardTitleEl) {
      result.cardTitle.show = cardTitleEl.getAttribute('data-show') !== 'false';
      result.cardTitle.content = cardTitleEl.innerHTML.trim();
    }

    const listEl = doc.querySelector('[data-attribute="list-item"]');
    if (listEl) {
      result.listItem.bgItem = listEl.getAttribute('data-bg-item') || '#ffffff';
      result.listItem.colorItem = listEl.getAttribute('data-color-item') || '#000000';

      result.listItem.items = Array.from(listEl.querySelectorAll('[data-attribute="item"]')).map(itemEl => ({
        content: itemEl.innerHTML.trim(),
      }));
    }

    return result;
  },
  sectionFeetscareStat(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const result = {
      ...containerResult,
      cardTitle: { show: true, content: '' },
      cardLeft: { order: 1 },
      cardRight: { order: 2, bgColor: '#ffffff', content: '' },
      listItemStat: [],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      result.enableAnchor = sectionEl.getAttribute('data-enable-anchor') === 'true';
    }

    const cardTitleEl = doc.querySelector('[data-attribute="card-title"]');
    if (cardTitleEl) {
      result.cardTitle.show = cardTitleEl.getAttribute('data-show') !== 'false';
      result.cardTitle.content = cardTitleEl.innerHTML.trim();
    }

    const cardLeftEl = doc.querySelector('[data-attribute="card-left"]');
    if (cardLeftEl) {
      const orderLeft = parseInt(cardLeftEl.getAttribute('data-order-left'));
      result.cardLeft.order = Number.isFinite(orderLeft) ? orderLeft : 1;
    }

    const cardRightEl = doc.querySelector('[data-attribute="card-right"]');
    if (cardRightEl) {
      const orderRight = parseInt(cardRightEl.getAttribute('data-order-right'));
      result.cardRight.order = Number.isFinite(orderRight) ? orderRight : 2;
      result.cardRight.bgColor = cardRightEl.getAttribute('data-bg-color-right') || '#ffffff';
    }

    const cardRightContentEl = doc.querySelector('[data-attribute="card-right-content"]');
    if (cardRightContentEl) {
      result.cardRight.content = cardRightContentEl.innerHTML.trim();
    }

    const itemStatEls = doc.querySelectorAll('[data-attribute="list-item-stat"] [data-attribute="item-stat"]');
    result.listItemStat = Array.from(itemStatEls).map(itemEl => {
      const wrapValueEl = itemEl.querySelector('[data-attribute="wrap-value-stat"]');
      const iconStatEl = itemEl.querySelector('[data-attribute="icon-stat"]');
      const useSvg = iconStatEl ? iconStatEl.getAttribute('data-use-svg') === 'true' : false;
      const showIcon = iconStatEl ? iconStatEl.getAttribute('data-show') !== 'false' : true;
      return {
        value: wrapValueEl?.querySelector('[data-attribute="value-stat"]')?.textContent.trim() || '',
        color: wrapValueEl?.getAttribute('data-color-item-stat') || '#417505',
        showIcon,
        useSvg,
        icon: !useSvg ? iconStatEl?.querySelector('img')?.getAttribute('src') || '' : '',
        iconSvg: useSvg ? iconStatEl?.querySelector('svg')?.outerHTML || '' : '',
        description: itemEl.querySelector('[data-attribute="description"]')?.innerHTML.trim() || '',
      };
    });

    return result;
  },
  sectionFeetscareSatellite(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const result = {
      ...containerResult,
      cardTitle: { show: true, content: '' },
      mainImage: { src: '' },
      listItemsSatellite: [],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      result.enableAnchor = sectionEl.getAttribute('data-enable-anchor') === 'true';
    }

    const cardTitleEl = doc.querySelector('[data-attribute="card-title"]');
    if (cardTitleEl) {
      result.cardTitle.show = cardTitleEl.getAttribute('data-show') !== 'false';
      result.cardTitle.content = cardTitleEl.innerHTML.trim();
    }

    const mainImageEl = doc.querySelector('[data-attribute="satellite-image"]');
    if (mainImageEl) {
      result.mainImage.src = mainImageEl.getAttribute('src') || '';
    }

    const parseItem = itemEl => {
      const wrapImgEl = itemEl.querySelector('[data-attribute="wrap-img-item"]');
      const useSvg = wrapImgEl ? wrapImgEl.getAttribute('data-use-svg') === 'true' : false;
      const widthImg = parseInt(wrapImgEl?.getAttribute('data-width-img'));
      return {
        bgItem: itemEl.getAttribute('data-bg-item') || '#dc9376',
        colorItem: itemEl.getAttribute('data-color-item') || '#ffffff',
        widthImg: Number.isFinite(widthImg) ? widthImg : 34,
        useSvg,
        icon: !useSvg ? wrapImgEl?.querySelector('img')?.getAttribute('src') || '' : '',
        iconSvg: useSvg ? wrapImgEl?.querySelector('svg')?.outerHTML || '' : '',
        title: itemEl.querySelector('[data-attribute="title-item"]')?.innerHTML.trim() || '',
      };
    };

    // items-left and items-right are two halves of a single list — merge back in order (left first, then right)
    const leftItemEls = doc.querySelectorAll('[data-attribute="items-left"] [data-attribute="item-satellite"]');
    const rightItemEls = doc.querySelectorAll('[data-attribute="items-right"] [data-attribute="item-satellite"]');
    result.listItemsSatellite = [...Array.from(leftItemEls).map(parseItem), ...Array.from(rightItemEls).map(parseItem)];

    return result;
  },
  sectionManchestoreCompareSlider(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const wrapButtonEl = doc.querySelector('[data-attribute=wrap-button]');
    const buttonData = wrapButtonEl ? extractButtonBasic(wrapButtonEl.outerHTML) : {};
    const result = {
      ...containerResult,
      heading: { title: '' },
      media: { type: 'video', position: 'left', video: '', image: '' },
      features: [],
      slides: [],
      button: { ...buttonData },
    };

    const rootEl = doc.querySelector('[data-attribute=manchestore-compare-slider]');
    if (rootEl) {
      result.media.type = rootEl.getAttribute('data-media-type') === 'image' ? 'image' : 'video';
      result.media.position = rootEl.getAttribute('data-media-position') === 'right' ? 'right' : 'left';
    }

    const titleEl = doc.querySelector('[data-attribute=mcs__title]');
    const videoSourceEl = doc.querySelector('[data-attribute=mcs__video-source]');
    const imageEl = doc.querySelector('[data-attribute=mcs__image]');
    if (titleEl) result.heading.title = titleEl.innerHTML.trim();
    if (videoSourceEl) result.media.video = videoSourceEl.getAttribute('src') || '';
    if (imageEl) result.media.image = imageEl.getAttribute('src') || '';

    doc.querySelectorAll('[data-attribute=mcs__feature]').forEach(itemEl => {
      const contentEl = itemEl.querySelector('[data-attribute=mcs__feature-content]');
      result.features.push({ content: contentEl?.innerHTML.trim() || '' });
    });

    doc.querySelectorAll('[data-attribute=mcs__slide]').forEach(slideEl => {
      const beforeEl = slideEl.querySelector('[data-attribute=mcs__before-image]');
      const afterEl = slideEl.querySelector('[data-attribute=mcs__after-image]');
      result.slides.push({
        before: beforeEl?.getAttribute('src') || '',
        after: afterEl?.getAttribute('src') || '',
      });
    });

    return result;
  },
  sectionManchestoreBanner(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const result = {
      ...containerResult,
      header: { title: '', description: '', dividerColor: '#FE9790' },
      video: { src: '' },
      card: { title: '', items: [] },
    };

    const titleEl = doc.querySelector('[data-attribute=manchestore-banner__title]');
    const descriptionEl = doc.querySelector('[data-attribute=manchestore-banner__description]');
    const dividerEl = doc.querySelector('[data-attribute=manchestore-banner__divider]');
    const videoSourceEl = doc.querySelector('[data-attribute=manchestore-banner__video-source]');
    const cardTitleEl = doc.querySelector('[data-attribute=manchestore-banner__card-title]');

    if (titleEl) result.header.title = titleEl.innerHTML.trim();
    if (descriptionEl) result.header.description = descriptionEl.innerHTML.trim();
    if (dividerEl) {
      result.header.dividerColor = dividerEl.getAttribute('data-color') || dividerEl.style.backgroundColor || '#FE9790';
    }
    if (videoSourceEl) result.video.src = videoSourceEl.getAttribute('src') || '';
    if (cardTitleEl) result.card.title = cardTitleEl.textContent.trim();

    doc.querySelectorAll('[data-attribute=manchestore-banner__item]').forEach(itemEl => {
      const imageEl = itemEl.querySelector('[data-attribute=manchestore-banner__item-image]');
      const textEl = itemEl.querySelector('[data-attribute=manchestore-banner__item-text]');
      result.card.items.push({
        image: imageEl?.getAttribute('src') || '',
        text: textEl?.textContent.trim() || '',
      });
    });

    return result;
  },
  sectionSofyreTabsReview(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const wrapButtonEl = doc.querySelector('[data-attribute="wrap-button"]');
    const buttonData = wrapButtonEl ? extractButtonBasic(wrapButtonEl.outerHTML) : {};

    const result = {
      ...containerResult,
      ratingSummary: {
        value: 5,
        colorStar: '#ccf46f',
        text: '',
      },
      titleTestimonial: {
        show: true,
        content: '',
      },
      tabColors: {
        colorTab: '#23372b',
        bgTabActive: '#23372b',
      },
      cardColors: {
        colorStar: '#ccf46f',
        colorVerifiedBuyer: '#365941',
        bgCardItem: '#F8F8F4',
      },
      tabs: [],
      button: { ...buttonData },
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      result.enableAnchor = sectionEl.getAttribute('data-enable-anchor') === 'true';
    }

    const ratingStarEl = doc.querySelector('[data-attribute="rating-summary-star"]');
    if (ratingStarEl) {
      result.ratingSummary.value = parseInt(ratingStarEl.getAttribute('data-value'), 10) || 5;
      result.ratingSummary.colorStar = ratingStarEl.getAttribute('data-color-star') || '#ccf46f';
    }

    const ratingTextEl = doc.querySelector('[data-attribute="rating-summary-text"]');
    if (ratingTextEl) {
      result.ratingSummary.text = ratingTextEl.textContent.trim();
    }

    const titleTestimonialEl = doc.querySelector('[data-attribute="title-testimonial"]');
    if (titleTestimonialEl) {
      result.titleTestimonial.show = titleTestimonialEl.getAttribute('data-show') !== 'false';
      result.titleTestimonial.content = titleTestimonialEl.innerHTML.trim();
    }

    const tabHeaderEl = doc.querySelector('[data-attribute="tab-header"]');
    if (tabHeaderEl) {
      result.tabColors.colorTab = tabHeaderEl.getAttribute('data-color-tab') || '#23372b';
      result.tabColors.bgTabActive = tabHeaderEl.getAttribute('data-bg-tab-active') || '#23372b';
    }

    const tabBodyEl = doc.querySelector('[data-attribute="tab-body"]');
    if (tabBodyEl) {
      result.cardColors.colorStar = tabBodyEl.getAttribute('data-color-star') || '#ccf46f';
      result.cardColors.colorVerifiedBuyer = tabBodyEl.getAttribute('data-color-verified-buyer') || '#365941';
      result.cardColors.bgCardItem = tabBodyEl.getAttribute('data-bg-card-item') || '#F8F8F4';
    }

    const tabItemEls = doc.querySelectorAll('[data-attribute="tab-item"]');
    tabItemEls.forEach(tabItemEl => {
      const tabId = tabItemEl.getAttribute('data-tab') || String(result.tabs.length + 1);
      const tabData = {
        tabId,
        label: tabItemEl.textContent.trim(),
        reviews: [],
      };

      const tabPanelEl = doc.querySelector(`[data-attribute="tab-panel"][data-tab="${tabId}"]`);
      if (tabPanelEl) {
        const reviewBodyEls = tabPanelEl.querySelectorAll('[data-attribute="review-card-body"]');
        reviewBodyEls.forEach(bodyEl => {
          const cardEl = bodyEl.closest('.review-card');
          if (!cardEl) return;

          const ratingEl = cardEl.querySelector('[data-attribute="rating"]');
          const avatarEl = cardEl.querySelector('[data-attribute="avatar"]');
          const authorNameEl = cardEl.querySelector('[data-attribute="author-name"]');
          const authorMetaEl = cardEl.querySelector('[data-attribute="author-meta"]');
          const purchaseTagEl = cardEl.querySelector('[data-attribute="purchase-tag"]');

          tabData.reviews.push({
            rating: ratingEl ? parseInt(ratingEl.getAttribute('data-value'), 10) || 5 : 5,
            bodyContent: bodyEl.innerHTML.trim(),
            avatar: avatarEl ? avatarEl.getAttribute('src') || '' : '',
            authorName: authorNameEl ? authorNameEl.textContent.trim() : '',
            authorMeta: authorMetaEl ? authorMetaEl.textContent.trim() : '',
            purchaseTag: purchaseTagEl ? purchaseTagEl.textContent.trim() : '',
          });
        });
      }

      result.tabs.push(tabData);
    });

    return result;
  },
  sectionSofyreTimeline(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const wrapButtonEl = doc.querySelector('[data-attribute=wrap-button]');
    const buttonData = wrapButtonEl ? extractButtonBasic(wrapButtonEl.outerHTML) : {};
    const result = {
      ...containerResult,
      primaryColor: '#23372B',
      header: '',
      image: { show: true, position: 'left', src: '' },
      guide: { image: '', text: '' },
      tabs: [],
      button: { ...buttonData },
    };

    const rootEl = doc.querySelector('[data-attribute=sofyre-timeline]');
    const headerEl = doc.querySelector('[data-attribute=sofyre-timeline__header]');
    const layoutEl = doc.querySelector('[data-attribute=sofyre-timeline__layout]');
    const imageEl = doc.querySelector('[data-attribute=sofyre-timeline__image]');
    const imageImgEl = doc.querySelector('[data-attribute=sofyre-timeline__image-img]');
    const guideImageEl = doc.querySelector('[data-attribute=sofyre-timeline__guide-image]');
    const guideTextEl = doc.querySelector('[data-attribute=sofyre-timeline__guide-text]');

    if (rootEl) result.primaryColor = rootEl.getAttribute('data-primary-color') || '#23372B';
    if (headerEl) result.header = headerEl.innerHTML.trim();
    if (layoutEl) {
      result.image.position = layoutEl.getAttribute('data-image-position') || 'left';
      result.image.show = layoutEl.getAttribute('data-image-show') !== 'false';
    }
    if (imageEl) result.image.show = imageEl.getAttribute('data-show') !== 'false';
    if (imageImgEl) result.image.src = imageImgEl.getAttribute('src') || '';
    if (guideImageEl) result.guide.image = guideImageEl.getAttribute('src') || '';
    if (guideTextEl) result.guide.text = guideTextEl.textContent.trim();

    doc.querySelectorAll('[data-attribute=tab-header-item]').forEach((headerItemEl, index) => {
      const tabId = headerItemEl.getAttribute('data-tab') || `sofyre-tab-${index + 1}`;
      const contentEl = doc.querySelector(`[data-attribute=tab-content-item][data-tab=${tabId}]`);
      const tab = {
        id: tabId,
        label: headerItemEl.textContent.trim(),
        tag: '',
        title: '',
        features: [],
      };

      if (contentEl) {
        const tagEl = contentEl.querySelector('[data-attribute=sofyre-timeline__tag]');
        const titleEl = contentEl.querySelector('[data-attribute=sofyre-timeline__tab-title]');
        if (tagEl) tab.tag = tagEl.textContent.trim();
        if (titleEl) tab.title = titleEl.innerHTML.trim();

        contentEl.querySelectorAll('[data-attribute=sofyre-timeline__feature]').forEach(featureEl => {
          const featureTitleEl = featureEl.querySelector('[data-attribute=sofyre-timeline__feature-title]');
          const featureContentEl = featureEl.querySelector('[data-attribute=sofyre-timeline__feature-content]');
          tab.features.push({
            title: featureTitleEl ? featureTitleEl.innerHTML.trim() : '',
            content: featureContentEl ? featureContentEl.innerHTML.trim() : '',
          });
        });
      }

      result.tabs.push(tab);
    });

    return result;
  },
  sectionSofyreIngredients(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const wrapButtonEl = doc.querySelector('[data-attribute=wrap-button]');
    const buttonData = wrapButtonEl ? extractButtonBasic(wrapButtonEl.outerHTML) : {};
    const result = {
      ...containerResult,
      header: '',
      features: [],
      button: { ...buttonData },
    };

    const headerEl = doc.querySelector('[data-attribute=sofyre-ingredients__header]');
    if (headerEl) result.header = headerEl.innerHTML.trim();

    doc.querySelectorAll('[data-attribute=sofyre-ingredients__feature]').forEach(featureEl => {
      const desktopImageEl = featureEl.querySelector('[data-attribute=sofyre-ingredients__image-desktop]');
      const mobileImageEl = featureEl.querySelector('[data-attribute=sofyre-ingredients__image-mobile]');
      const titleEl = featureEl.querySelector('[data-attribute=sofyre-ingredients__feature-title]');
      const descriptionEl = featureEl.querySelector('[data-attribute=sofyre-ingredients__description]');
      const tags = Array.from(featureEl.querySelectorAll('[data-attribute=sofyre-ingredients__tag]')).map(tagEl =>
        tagEl.textContent.trim(),
      );
      result.features.push({
        desktopImage: desktopImageEl?.getAttribute('src') || '',
        mobileImage: mobileImageEl?.getAttribute('srcset') || '',
        title: titleEl?.innerHTML.trim() || '',
        tags,
        description: descriptionEl?.innerHTML.trim() || '',
      });
    });

    return result;
  },
  sectionSofyreUserManual(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const wrapButtonEl = doc.querySelector('[data-attribute=wrap-button]');
    const buttonData = wrapButtonEl ? extractButtonBasic(wrapButtonEl.outerHTML) : {};
    const result = {
      ...containerResult,
      header: '',
      cards: [],
      recommendation: '',
      button: { ...buttonData },
    };

    const headerEl = doc.querySelector('[data-attribute=sofyre-user-manual__header]');
    const recommendationEl = doc.querySelector('[data-attribute=sofyre-user-manual__recommendation]');
    if (headerEl) result.header = headerEl.innerHTML.trim();
    if (recommendationEl) result.recommendation = recommendationEl.innerHTML.trim();

    doc.querySelectorAll('[data-attribute=sofyre-user-manual__card]').forEach(cardEl => {
      const titleEl = cardEl.querySelector('[data-attribute=sofyre-user-manual__card-title]');
      const imageEl = cardEl.querySelector('[data-attribute=sofyre-user-manual__card-image]');
      const tagEl = cardEl.querySelector('[data-attribute=sofyre-user-manual__card-tag]');
      const descriptionEl = cardEl.querySelector('[data-attribute=sofyre-user-manual__card-description]');
      result.cards.push({
        title: titleEl?.textContent.trim() || '',
        image: imageEl?.getAttribute('src') || '',
        tag: tagEl?.textContent.trim() || '',
        description: descriptionEl?.textContent.trim() || '',
      });
    });

    return result;
  },
  sectionSofyreComparison(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);
    const wrapButtonEl = doc.querySelector('[data-attribute="wrap-button"]');
    const buttonData = wrapButtonEl ? extractButtonBasic(wrapButtonEl.outerHTML) : {};

    const extractItems = cardEl => {
      const listEl = cardEl?.querySelector('[data-attribute="list-item"]');
      if (!listEl) return [];
      return Array.from(listEl.querySelectorAll('[data-attribute="item"]')).map(itemEl => {
        const iconMainEl = itemEl.querySelector('[data-attribute="icon-main"]');
        const useSvgMain = iconMainEl ? iconMainEl.getAttribute('data-use-svg') === 'true' : true;
        const iconMainImageEl = iconMainEl?.querySelector('img');
        const iconMainSvgEl = iconMainEl?.querySelector('svg');
        const iconSubEl = itemEl.querySelector('[data-attribute="icon-sub"]');
        const iconSubSvgEl = iconSubEl?.querySelector('svg');
        const textEl = itemEl.querySelector('[data-attribute="text"]');
        return {
          useSvgMain,
          iconMain: iconMainImageEl?.getAttribute('src') || '',
          iconMainSvg: iconMainSvgEl?.outerHTML || '',
          iconSub: {
            show: iconSubEl ? iconSubEl.getAttribute('data-show') !== 'false' : true,
            svg: iconSubSvgEl?.outerHTML || '',
          },
          text: textEl?.textContent.trim() || '',
        };
      });
    };

    const extractCard = selector => {
      const cardEl = doc.querySelector(selector);
      if (!cardEl) return null;
      const titleEl = cardEl.querySelector('[data-attribute="title-compare-item"]');
      return {
        colorBg: cardEl.getAttribute('data-color-bg') || '',
        colorText: cardEl.getAttribute('data-color-text') || '',
        title: titleEl?.textContent.trim() || '',
        items: extractItems(cardEl),
      };
    };

    const result = {
      ...containerResult,
      cardTitle: { show: true, content: '' },
      cardLeft: { colorBg: '#FFFFFF', colorText: '#000000', title: '', items: [] },
      cardRight: { colorBg: '#23372B', colorText: '#FFFFFF', title: '', items: [] },
      media: { src: '' },
      button: { ...buttonData },
    };

    const cardTitleEl = doc.querySelector('[data-attribute="card-title"]');
    if (cardTitleEl) {
      result.cardTitle.show = cardTitleEl.getAttribute('data-show') !== 'false';
      result.cardTitle.content = cardTitleEl.innerHTML.trim();
    }

    const cardLeftData = extractCard('[data-attribute="card-left"]');
    if (cardLeftData) result.cardLeft = { ...result.cardLeft, ...cardLeftData };

    const cardRightData = extractCard('[data-attribute="card-right"]');
    if (cardRightData) result.cardRight = { ...result.cardRight, ...cardRightData };

    const mediaImageEl = doc.querySelector('[data-attribute="comparison-section-media"] [data-attribute="image"]');
    if (mediaImageEl) result.media.src = mediaImageEl.getAttribute('src') || '';

    return result;
  },
  sectionMadamSizeCalculator(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const result = {
      ...containerResult,
      enableAnchor: false,
      title: '',
      sizeChart: null,
      iconPrefix: '',
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      const enableAnchor = sectionEl.getAttribute('data-enable-anchor');
      result.enableAnchor = enableAnchor ? enableAnchor === 'true' : false;
    }

    result.title = doc.querySelector('[data-attribute="title-size-chart"]')?.innerHTML.trim() || '';
    result.iconPrefix = doc.querySelector('[data-attribute="icon-prefix-image"]')?.getAttribute('src') || '';

    const holderEl = doc.querySelector('[data-attribute="calculator-holder"]');
    if (holderEl) {
      try {
        result.sizeChart = JSON.parse(holderEl.getAttribute('data-size-chart') || 'null');
      } catch (_e) {
        result.sizeChart = null;
      }
    }

    return result;
  },
  sectionEskiinPolicy(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const result = {
      ...containerResult,
      items: [],
    };

    const itemEls = doc.querySelectorAll('[data-attribute="list-item"] [data-attribute="item"]');
    result.items = Array.from(itemEls).map(itemEl => ({
      image: itemEl.querySelector('[data-attribute="item-image"]')?.getAttribute('src') || '',
      title: itemEl.querySelector('[data-attribute="item-title"]')?.innerHTML.trim() || '',
    }));

    return result;
  },
  sectionEskiinHurrybox(htmlString) {
    const { result: containerResult, doc } = extractContainerFuild(htmlString);

    const result = {
      ...containerResult,
      enableAnchor: false,
      colPerView: 4,
      colorBrand: '#005F2A',
      items: [],
    };

    const sectionEl = doc.querySelector('[data-section]');
    if (sectionEl) {
      result.enableAnchor = sectionEl.getAttribute('data-enable-anchor') === 'true';
    }

    const listEl = doc.querySelector('[data-attribute="list-item"]');
    if (listEl) {
      result.colPerView = parseInt(listEl.getAttribute('data-col-perview'), 10) || 4;
      result.colorBrand = listEl.getAttribute('color-brand') || '#005F2A';
    }

    const itemEls = doc.querySelectorAll('[data-attribute="list-item"] [data-attribute="item"]');
    result.items = Array.from(itemEls).map(itemEl => ({
      preText: itemEl.querySelector('[data-attribute="pre-text"]')?.textContent.trim() || '',
      price: itemEl.querySelector('[data-attribute="price"]')?.textContent.trim() || '',
      image: itemEl.querySelector('[data-attribute="image-item"]')?.getAttribute('src') || '',
      title: itemEl.querySelector('[data-attribute="title-item"]')?.innerHTML.trim() || '',
    }));

    return result;
  },
};
